/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Coworking Space CRM API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  Account,
  AccountOrderReceiptView,
  AddTaskAttachmentBody,
  AddTaskWatcherBody,
  AllocatePaymentBody,
  ApVendorRow,
  ApiKey,
  ApplyCreditNoteToPeriodBody,
  ApplyDepositToPeriodBody,
  ApplyOnAccountBody,
  ApproveSpaceFloorDesignBody,
  ApproveVendorBillBody,
  AssignRecurringBody,
  AssignTaskBody,
  AttendanceDevice,
  AttendanceRosterEntry,
  AttendanceSession,
  AttendanceSessionListResponse,
  AuthEventsResponse,
  AuthSession,
  BackfillQueueRow,
  BackfillRunResult,
  BadRequestResponse,
  BillPayment,
  BillingTodayMember,
  BookingActionReason,
  BulkLeadActionBody,
  BulkLeadActionResult,
  BulkUpdateInventoryItemStockBody,
  BulkUpdateInventoryItemStockResult,
  BundleInvoiceBody,
  BundleInvoiceResult,
  BundleReceiptBody,
  BundleReceiptResult,
  BusinessHours,
  CancelOrderBody,
  CancelTaskBody,
  ChangeInventoryPlanPriceBody,
  ChecklistProofUploadResult,
  CheckoutAttendanceSessionBody,
  CloseOrderBody,
  CloseStockDayBody,
  CommunicationLogListResponse,
  CompleteTaskBody,
  ConfirmChargesBody,
  Contact,
  ContactDetail,
  ContactDirectoryRow,
  ContactStats,
  ContactTransactions,
  ConvertLeadToAccountBody,
  ConvertLeadToAccountResponse,
  CopyTaskConfigBody,
  CopyTaskConfigResponse,
  CostCentre,
  CreateAccountBody,
  CreateApiKeyBody,
  CreateApiKeyResult,
  CreateAttendanceDeviceBody,
  CreateAttendanceSessionBody,
  CreateAttributeKeyBody,
  CreateAttributeValueBody,
  CreateBillPaymentBody,
  CreateBooking201,
  CreateBookingBody,
  CreateChargeTypeBody,
  CreateContactBody,
  CreateCostCentreBody,
  CreateDailyOrderScheduleBody,
  CreateEscalationRuleBody,
  CreateExpenseTemplateBody,
  CreateHsnCodeBody,
  CreateInfraAcquisitionBody,
  CreateInfraAcquisitionPaymentBody,
  CreateInfraAttributeKeyBody,
  CreateInfraAttributeValueBody,
  CreateInfraCategoryBody,
  CreateInfraItemBody,
  CreateInfraItemVariantBody,
  CreateInventoryCategoryBody,
  CreateInventoryItem201,
  CreateInventoryItemBody,
  CreateInventoryPlanBody,
  CreateInventoryPlanPeriodBody,
  CreateInventoryVendorBody,
  CreateItemModifierBody,
  CreateItemRecipeBody,
  CreateItemVariantBody,
  CreateLeadBody,
  CreateLedgerAccountBody,
  CreateManualCreditNoteBody,
  CreateManualJournalBody,
  CreateMemberChargeBody,
  CreateMemberEntitlementBody,
  CreateMembershipBatchBody,
  CreateMembershipBody,
  CreateOrderRefundLineBody,
  CreatePartnerReimbursementBody,
  CreatePassSaleBody,
  CreatePlanEntitlementBody,
  CreatePlanSecondaryAccessBody,
  CreateRcmDischargeBody,
  CreateResourcePricingBody,
  CreateRoutingRuleBody,
  CreateSlaPolicyBody,
  CreateSpaceFloorBody,
  CreateSpaceResourceBody,
  CreateSpaceSvgAssetBody,
  CreateSpaceWorkstationClusterBody,
  CreateSpaceWorkstationClusterResponse,
  CreateStockInBody,
  CreateStockInOrderBody,
  CreateStockInOrderCartLineInput,
  CreateStockLocationBody,
  CreateStockLocationTransferBody,
  CreateStockOutBody,
  CreateTaskBody,
  CreateTaskCategoryBody,
  CreateTaskTemplateBody,
  CreateTaskTemplateItemBody,
  CreateTdsDepositBody,
  CreateVendorBillBody,
  CreateVendorBillScheduleBody,
  CreateVendorContactBody,
  CreateVendorDocumentBody,
  CreateVendorItemPricingBody,
  CreditNote,
  DailyChecklistEntry,
  DailyOrderSchedule,
  DeleteAccount409,
  DeleteAccountMembership200,
  DeleteStockOut200,
  DeleteTaskTemplatePermanentResult,
  DepositList,
  DiscardSpaceFloorDesign200,
  Document,
  ErrorResponse,
  EscalationRule,
  EventChecklistEntry,
  ExitRenewBody,
  ExitRenewResult,
  ExpenseEntry,
  ExpenseTemplate,
  FloorDesignResponse,
  ForbiddenResponse,
  GenerateBundleInvoice422,
  GenerateExpenseDues200,
  GenerateMemberChargeReceiptBody,
  GeneratePlanPeriodReceiptBody,
  GenerateTokenBody,
  GenerateTokenResponse,
  GenerateVendorBillsResult,
  GeofenceSpace,
  GetAccountDepositsParams,
  GetAttendancePunchLogParams,
  GetAttendanceRosterParams,
  GetBusinessHoursParams,
  GetDailyChecklistParams,
  GetDailyOrdersTodayParams,
  GetEventChecklistParams,
  GetInventorySpendKpiParams,
  GetLeadsSummaryParams,
  GetLedgerAccountEntriesParams,
  GetLedgerApByVendorParams,
  GetLedgerPnlParams,
  GetLedgerTrialBalanceParams,
  GetMyTodayParams,
  GetOperationsAlertsParams,
  GetOperationsQcBudgetParams,
  GetPlanCoverageGapsParams,
  GetSpaceOccupancyParams,
  GetStaffAttendanceDayParams,
  GetStockDayCloseOverdueParams,
  GetStockDayCloseParams,
  GetStockInSummaryParams,
  GetStockLocationBalancesParams,
  HealthStatus,
  HeldDeposit,
  HoldTaskBody,
  ImportAttendanceBody,
  ImportAttendanceResponse,
  InfraAcquisition,
  InfraAcquisitionPayment,
  InfraAttributeKey,
  InfraAttributeValue,
  InfraCategory,
  InfraItem,
  InfraItemVariant,
  InventoryAttributeKey,
  InventoryAttributeValue,
  InventoryAuditLog,
  InventoryAuditLogListResponse,
  InventoryCategory,
  InventoryChargeType,
  InventoryHsnCode,
  InventoryItem,
  InventoryItemImport,
  InventoryItemImportDetail,
  InventoryItemRecipe,
  InventoryItemVariant,
  InventoryPlan,
  InventoryPlanPeriod,
  InventoryPlanPriceHistoryEntry,
  InventoryRecipeModifier,
  InventorySpendKpi,
  InventoryVendor,
  InventoryVendorDetail,
  InviteUserBody,
  Invoice,
  InvoiceListResponse,
  InvoiceReadyStatus,
  InvoiceTemplateConfig,
  InvoiceWithLineItems,
  IssuePettyCashBody,
  Lead,
  LeadDetail,
  LeadImport,
  LeadImportDetail,
  LeadsListResponse,
  LeadsSummary,
  LedgerAccount,
  LedgerConfig,
  LedgerEntry,
  LedgerLine,
  ListAccountCommunicationsParams,
  ListAccountsParams,
  ListAttendanceDevicesParams,
  ListAttendanceSessionsParams,
  ListAttributeKeysParams,
  ListAttributeValuesParams,
  ListAuthEventsParams,
  ListBillingTodayParams,
  ListChargeTypesParams,
  ListContactsParams,
  ListDailyOrderScheduleParams,
  ListEscalationRulesParams,
  ListExpenseEntriesParams,
  ListExpenseTemplatesParams,
  ListHsnCodesParams,
  ListInfraAcquisitionsParams,
  ListInfraAttributeKeysParams,
  ListInfraAttributeValuesParams,
  ListInfraCategoriesParams,
  ListInfraItemVariantsParams,
  ListInfraItemsParams,
  ListInfraWarrantyParams,
  ListInventoryAuditLogParams,
  ListInventoryCategoriesParams,
  ListInventoryItemsParams,
  ListInventoryPlanPeriodsParams,
  ListInventoryPlansParams,
  ListInventoryVendorsParams,
  ListInvoicesParams,
  ListItemModifiersParams,
  ListItemVariantsParams,
  ListLeadsParams,
  ListLedgerAccountsParams,
  ListMemberChargesParams,
  ListMemberEntitlementsParams,
  ListOrderReceiptsParams,
  ListPlanEntitlementsParams,
  ListPostingExceptionsParams,
  ListPrepaidSchedulesParams,
  ListPublicPlans200,
  ListPublicPlansParams,
  ListResourceAssignmentsParams,
  ListResourcePricingParams,
  ListRoutingRulesParams,
  ListSlaPoliciesParams,
  ListSpaceResourcesParams,
  ListSpaceWorkstationClustersParams,
  ListStockInOrdersParams,
  ListStockInParams,
  ListStockLocationTransfersParams,
  ListStockLocationsParams,
  ListStockOutParams,
  ListTaskCategoriesParams,
  ListTaskTemplatesParams,
  ListTasksParams,
  ListVendorBillSchedulesParams,
  ListVendorBillsParams,
  ListVendorItemPricingHistoryParams,
  ListVendorItemPricingParams,
  LogoutAttendanceSessionBody,
  LookupInventoryPlanPeriodParams,
  MarkChecklistItemDoneBody,
  MarkChecklistItemNaBody,
  MarkInvoicePaidBody,
  MarkPlanPeriodPaidBody,
  MarkStockOutBulkPaid200,
  MarkStockOutBulkPaidBody,
  MarkStockOutCartPaid200,
  MemberCharge,
  MemberChargeListResponse,
  MemberChargeReceiptResponse,
  MemberEntitlement,
  Membership,
  MembershipBatchResponse,
  MembershipPeriodLogEntry,
  MembershipQuote,
  MergeAccountsBody,
  NotFoundResponse,
  OccupancyView,
  OperationsAlert,
  OperationsQcBudget,
  OrderReceiptRegisterResponse,
  OverrideTaskPriorityBody,
  Payment,
  PaymentAccount,
  PlanCoverageGap,
  PlanEntitlement,
  PlanPeriodReceiptResponse,
  PlanSchedulePeriod,
  PlanScheduleResponse,
  PlanSecondaryAccess,
  PnlResponse,
  PostingException,
  PrepaidRecogniseResult,
  PrepaidSchedule,
  PublicCreateLeadBody,
  PublicCreateLeadResponse,
  PublicUpdateLeadBody,
  PublicUpsertLeadResponse,
  PunchLogEntry,
  PutFloorDesignBody,
  PutFloorDesignResponse,
  ReanchorAccountMembership200,
  ReanchorAccountMembershipBody,
  ReassignContactBody,
  ReassignContactResult,
  ReassignTaskBody,
  RecalculateResult,
  ReceiptConfig,
  RecognisePrepaidBody,
  RecordOrderDeliveryBody,
  RecordOrderPaymentBody,
  RefundList,
  RegenerateCreditNotePdfResult,
  RejectTaskChecklistItemBody,
  RejectVendorBillBody,
  ReopenStockDayBody,
  ReorderRoutingRuleBody,
  ReorderTaskTemplateItemBody,
  RequestOtpBody,
  RequestOtpResponse,
  RescheduleBookingBody,
  RescheduleTaskBody,
  ResolvePostingExceptionBody,
  ResourceAssignment,
  ResourcePricing,
  RestructureBody,
  RestructureResult,
  ResyncAttendanceResponse,
  ReverseVendorBillBody,
  RoutingRule,
  SaveStockDayCountsBody,
  ScoreRule,
  ScoreRuleBody,
  SelfServiceCharges,
  SendOrderReceiptBody,
  SendOrderReceiptResponse,
  SendProformaReceiptBody,
  SendProformaReceiptResponse,
  SetUserActiveBody,
  SettleCreditNoteBody,
  SettleDepositBody,
  SimpleSuccess,
  SlaPolicy,
  Space,
  SpaceFloor,
  SpaceResource,
  SpaceSvgAsset,
  SpaceWorkstationClusterListResponse,
  SpendPettyCashBody,
  StaffAttendanceDayEntry,
  StartProcedureBody,
  StockDayCloseOverdueResponse,
  StockDayCloseSheet,
  StockDayPosition,
  StockIn,
  StockInListResponse,
  StockInOrder,
  StockInOrderCartLine,
  StockInOrderListResponse,
  StockInOrderRefundLine,
  StockInSummary,
  StockLocation,
  StockLocationBalances,
  StockLocationTransferCreateResponse,
  StockLocationTransferListResponse,
  StockLocationsUnplaced,
  StockOut,
  StockOutInsufficientComponentError,
  StockOutListResponse,
  SundayAccessRate,
  SundayAccessToggleResult,
  SyncTodayBody,
  SyncTodayResult,
  Task,
  TaskAttachment,
  TaskCategory,
  TaskChecklistItem,
  TaskDetail,
  TaskIllegalTransitionResponse,
  TaskStaleTransitionResponse,
  TaskTemplateDetail,
  TaskTemplateItem,
  TaskWatcher,
  TodayTasks,
  ToggleMembershipSundayAccessBody,
  TrialBalanceResponse,
  UnauthorizedResponse,
  UpdateAccountBody,
  UpdateAttendanceDeviceBody,
  UpdateAttendanceSessionBody,
  UpdateAttributeKeyBody,
  UpdateAttributeValueBody,
  UpdateBackfillMappingBody,
  UpdateBusinessHoursBody,
  UpdateChargeTypeBody,
  UpdateContactBody,
  UpdateCostCentreBody,
  UpdateDailyOrderScheduleBody,
  UpdateEscalationRuleBody,
  UpdateExpenseEntryBody,
  UpdateExpenseTemplateBody,
  UpdateGeofenceBody,
  UpdateHsnCodeBody,
  UpdateInfraAcquisitionBody,
  UpdateInfraAttributeKeyBody,
  UpdateInfraAttributeValueBody,
  UpdateInfraCategoryBody,
  UpdateInfraItemBody,
  UpdateInfraItemVariantBody,
  UpdateInventoryCategoryBody,
  UpdateInventoryItemBody,
  UpdateInventoryPlanBody,
  UpdateInventoryVendorBody,
  UpdateItemModifierBody,
  UpdateItemRecipeBody,
  UpdateItemVariantBody,
  UpdateLeadBody,
  UpdateLedgerAccountBody,
  UpdateLedgerConfigBody,
  UpdateMemberChargeBody,
  UpdateMemberEntitlementBody,
  UpdateMembershipBody,
  UpdateOrderRefundLineBody,
  UpdatePeriodAmount422,
  UpdatePeriodAmountBody,
  UpdatePlanEntitlementBody,
  UpdatePlanPeriodReminderBody,
  UpdateResourcePricingBody,
  UpdateRoutingRuleBody,
  UpdateSlaPolicyBody,
  UpdateSpaceBody,
  UpdateSpaceFloorBody,
  UpdateSpaceQcBudgetBody,
  UpdateSpaceResourceBody,
  UpdateSpaceSvgAssetBody,
  UpdateSpaceWorkstationCluster200,
  UpdateSpaceWorkstationClusterBody,
  UpdateStockInBody,
  UpdateStockInOrderCartLineBody,
  UpdateStockInOrderCartLineStatusBody,
  UpdateStockInOrderHeaderBody,
  UpdateStockInOrderPaymentDetailsBody,
  UpdateStockLocationBody,
  UpdateStockOutBody,
  UpdateTaskCategoryBody,
  UpdateTaskTemplateBody,
  UpdateTaskTemplateItemBody,
  UpdateUserBody,
  UpdateVendorBillBody,
  UpdateVendorBillScheduleBody,
  UpdateVendorItemPricingBody,
  UploadChecklistProofBody,
  UploadDocumentBody,
  UploadInventoryItemsCsvBody,
  UploadLeadsCsvBody,
  UpsertSundayAccessRateBody,
  User,
  VendorBill,
  VendorBillDetail,
  VendorBillListResponse,
  VendorBillSchedule,
  VendorContact,
  VendorDocument,
  VendorItemPricing,
  VendorItemPricingHistory,
  VerifyOtpBody,
  VoidPaymentBody,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Begin WhatsApp login (alias for request-otp)
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  requestOtpBody: RequestOtpBody,
  options?: RequestInit,
): Promise<RequestOtpResponse> => {
  return customFetch<RequestOtpResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(requestOtpBody),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<RequestOtpBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<RequestOtpBody> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<RequestOtpBody> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<RequestOtpBody>;
export type LoginMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Begin WhatsApp login (alias for request-otp)
 */
export const useLogin = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<RequestOtpBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<RequestOtpBody> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Request OTP for WhatsApp number
 */
export const getRequestOtpUrl = () => {
  return `/api/auth/request-otp`;
};

export const requestOtp = async (
  requestOtpBody: RequestOtpBody,
  options?: RequestInit,
): Promise<RequestOtpResponse> => {
  return customFetch<RequestOtpResponse>(getRequestOtpUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(requestOtpBody),
  });
};

export const getRequestOtpMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestOtp>>,
    TError,
    { data: BodyType<RequestOtpBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestOtp>>,
  TError,
  { data: BodyType<RequestOtpBody> },
  TContext
> => {
  const mutationKey = ["requestOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestOtp>>,
    { data: BodyType<RequestOtpBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestOtp>>
>;
export type RequestOtpMutationBody = BodyType<RequestOtpBody>;
export type RequestOtpMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Request OTP for WhatsApp number
 */
export const useRequestOtp = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestOtp>>,
    TError,
    { data: BodyType<RequestOtpBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestOtp>>,
  TError,
  { data: BodyType<RequestOtpBody> },
  TContext
> => {
  return useMutation(getRequestOtpMutationOptions(options));
};

/**
 * @summary Verify OTP and create session
 */
export const getVerifyOtpUrl = () => {
  return `/api/auth/verify-otp`;
};

export const verifyOtp = async (
  verifyOtpBody: VerifyOtpBody,
  options?: RequestInit,
): Promise<AuthSession> => {
  return customFetch<AuthSession>(getVerifyOtpUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(verifyOtpBody),
  });
};

export const getVerifyOtpMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyOtp>>,
    TError,
    { data: BodyType<VerifyOtpBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyOtp>>,
  TError,
  { data: BodyType<VerifyOtpBody> },
  TContext
> => {
  const mutationKey = ["verifyOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyOtp>>,
    { data: BodyType<VerifyOtpBody> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyOtp>>
>;
export type VerifyOtpMutationBody = BodyType<VerifyOtpBody>;
export type VerifyOtpMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Verify OTP and create session
 */
export const useVerifyOtp = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyOtp>>,
    TError,
    { data: BodyType<VerifyOtpBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyOtp>>,
  TError,
  { data: BodyType<VerifyOtpBody> },
  TContext
> => {
  return useMutation(getVerifyOtpMutationOptions(options));
};

/**
 * @summary Get authenticated user
 */
export const getGetCurrentUserUrl = () => {
  return `/api/auth/me`;
};

export const getCurrentUser = async (options?: RequestInit): Promise<User> => {
  return customFetch<User>(getGetCurrentUserUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCurrentUserQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({
    signal,
  }) => getCurrentUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUser>>
>;
export type GetCurrentUserQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Get authenticated user
 */

export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Logout
 */
export const getLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const logout = async (options?: RequestInit): Promise<SimpleSuccess> => {
  return customFetch<SimpleSuccess>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Logout
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary List recent OTP login activity (admin only)
 */
export const getListAuthEventsUrl = (params?: ListAuthEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/auth-events?${stringifiedParams}`
    : `/api/admin/auth-events`;
};

export const listAuthEvents = async (
  params?: ListAuthEventsParams,
  options?: RequestInit,
): Promise<AuthEventsResponse> => {
  return customFetch<AuthEventsResponse>(getListAuthEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAuthEventsQueryKey = (params?: ListAuthEventsParams) => {
  return [`/api/admin/auth-events`, ...(params ? [params] : [])] as const;
};

export const getListAuthEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAuthEvents>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  params?: ListAuthEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAuthEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAuthEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuthEvents>>> = ({
    signal,
  }) => listAuthEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAuthEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAuthEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAuthEvents>>
>;
export type ListAuthEventsQueryError = ErrorType<UnauthorizedResponse | void>;

/**
 * @summary List recent OTP login activity (admin only)
 */

export function useListAuthEvents<
  TData = Awaited<ReturnType<typeof listAuthEvents>>,
  TError = ErrorType<UnauthorizedResponse | void>,
>(
  params?: ListAuthEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAuthEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAuthEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List team members (admin only)
 */
export const getListUsersUrl = () => {
  return `/api/users`;
};

export const listUsers = async (options?: RequestInit): Promise<User[]> => {
  return customFetch<User[]>(getListUsersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListUsersQueryKey = () => {
  return [`/api/users`] as const;
};

export const getListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({
    signal,
  }) => listUsers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUsers>>
>;
export type ListUsersQueryError = ErrorType<
  UnauthorizedResponse | ErrorResponse
>;

/**
 * @summary List team members (admin only)
 */

export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Invite a new team member (admin only)
 */
export const getInviteUserUrl = () => {
  return `/api/users`;
};

export const inviteUser = async (
  inviteUserBody: InviteUserBody,
  options?: RequestInit,
): Promise<User> => {
  return customFetch<User>(getInviteUserUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inviteUserBody),
  });
};

export const getInviteUserMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteUser>>,
    TError,
    { data: BodyType<InviteUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteUser>>,
  TError,
  { data: BodyType<InviteUserBody> },
  TContext
> => {
  const mutationKey = ["inviteUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteUser>>,
    { data: BodyType<InviteUserBody> }
  > = (props) => {
    const { data } = props ?? {};

    return inviteUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteUser>>
>;
export type InviteUserMutationBody = BodyType<InviteUserBody>;
export type InviteUserMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse
>;

/**
 * @summary Invite a new team member (admin only)
 */
export const useInviteUser = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteUser>>,
    TError,
    { data: BodyType<InviteUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteUser>>,
  TError,
  { data: BodyType<InviteUserBody> },
  TContext
> => {
  return useMutation(getInviteUserMutationOptions(options));
};

/**
 * @summary Change a user's role, assigned space, or bill-approval delegation (admin only)
 */
export const getUpdateUserUrl = (id: number) => {
  return `/api/users/${id}`;
};

export const updateUser = async (
  id: number,
  updateUserBody: UpdateUserBody,
  options?: RequestInit,
): Promise<User> => {
  return customFetch<User>(getUpdateUserUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserBody),
  });
};

export const getUpdateUserMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { id: number; data: BodyType<UpdateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { id: number; data: BodyType<UpdateUserBody> },
  TContext
> => {
  const mutationKey = ["updateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUser>>,
    { id: number; data: BodyType<UpdateUserBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUser(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUser>>
>;
export type UpdateUserMutationBody = BodyType<UpdateUserBody>;
export type UpdateUserMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Change a user's role, assigned space, or bill-approval delegation (admin only)
 */
export const useUpdateUser = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { id: number; data: BodyType<UpdateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { id: number; data: BodyType<UpdateUserBody> },
  TContext
> => {
  return useMutation(getUpdateUserMutationOptions(options));
};

/**
 * Toggle a member's access. Disabling blocks OTP login and rejects any live session on the next request. Cannot disable yourself or the last active admin.

 * @summary Enable or disable a team member (admin only)
 */
export const getSetUserActiveUrl = (id: number) => {
  return `/api/users/${id}/active`;
};

export const setUserActive = async (
  id: number,
  setUserActiveBody: SetUserActiveBody,
  options?: RequestInit,
): Promise<User> => {
  return customFetch<User>(getSetUserActiveUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setUserActiveBody),
  });
};

export const getSetUserActiveMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setUserActive>>,
    TError,
    { id: number; data: BodyType<SetUserActiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setUserActive>>,
  TError,
  { id: number; data: BodyType<SetUserActiveBody> },
  TContext
> => {
  const mutationKey = ["setUserActive"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setUserActive>>,
    { id: number; data: BodyType<SetUserActiveBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setUserActive(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetUserActiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof setUserActive>>
>;
export type SetUserActiveMutationBody = BodyType<SetUserActiveBody>;
export type SetUserActiveMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Enable or disable a team member (admin only)
 */
export const useSetUserActive = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setUserActive>>,
    TError,
    { id: number; data: BodyType<SetUserActiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setUserActive>>,
  TError,
  { id: number; data: BodyType<SetUserActiveBody> },
  TContext
> => {
  return useMutation(getSetUserActiveMutationOptions(options));
};

/**
 * @summary List coworking spaces
 */
export const getListSpacesUrl = () => {
  return `/api/spaces`;
};

export const listSpaces = async (options?: RequestInit): Promise<Space[]> => {
  return customFetch<Space[]>(getListSpacesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSpacesQueryKey = () => {
  return [`/api/spaces`] as const;
};

export const getListSpacesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSpaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSpaces>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSpacesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSpaces>>> = ({
    signal,
  }) => listSpaces({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSpaces>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSpacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSpaces>>
>;
export type ListSpacesQueryError = ErrorType<unknown>;

/**
 * @summary List coworking spaces
 */

export function useListSpaces<
  TData = Awaited<ReturnType<typeof listSpaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSpaces>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSpacesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update space D-25 invoice-issuer fields (admin-only)
 */
export const getUpdateSpaceUrl = (id: number) => {
  return `/api/spaces/${id}`;
};

export const updateSpace = async (
  id: number,
  updateSpaceBody: UpdateSpaceBody,
  options?: RequestInit,
): Promise<Space> => {
  return customFetch<Space>(getUpdateSpaceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSpaceBody),
  });
};

export const getUpdateSpaceMutationOptions = <
  TError = ErrorType<void | UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpace>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSpace>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceBody> },
  TContext
> => {
  const mutationKey = ["updateSpace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSpace>>,
    { id: number; data: BodyType<UpdateSpaceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSpace(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSpaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSpace>>
>;
export type UpdateSpaceMutationBody = BodyType<UpdateSpaceBody>;
export type UpdateSpaceMutationError = ErrorType<
  void | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Update space D-25 invoice-issuer fields (admin-only)
 */
export const useUpdateSpace = <
  TError = ErrorType<void | UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpace>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSpace>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceBody> },
  TContext
> => {
  return useMutation(getUpdateSpaceMutationOptions(options));
};

/**
 * @summary List leads (with filters)
 */
export const getListLeadsUrl = (params?: ListLeadsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leads?${stringifiedParams}`
    : `/api/leads`;
};

export const listLeads = async (
  params?: ListLeadsParams,
  options?: RequestInit,
): Promise<LeadsListResponse> => {
  return customFetch<LeadsListResponse>(getListLeadsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListLeadsQueryKey = (params?: ListLeadsParams) => {
  return [`/api/leads`, ...(params ? [params] : [])] as const;
};

export const getListLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLeads>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListLeadsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLeads>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLeadsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeads>>> = ({
    signal,
  }) => listLeads(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLeadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLeads>>
>;
export type ListLeadsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List leads (with filters)
 */

export function useListLeads<
  TData = Awaited<ReturnType<typeof listLeads>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListLeadsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLeads>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLeadsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new lead
 */
export const getCreateLeadUrl = () => {
  return `/api/leads`;
};

export const createLead = async (
  createLeadBody: CreateLeadBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getCreateLeadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLeadBody),
  });
};

export const getCreateLeadMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLead>>,
    TError,
    { data: BodyType<CreateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLead>>,
  TError,
  { data: BodyType<CreateLeadBody> },
  TContext
> => {
  const mutationKey = ["createLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLead>>,
    { data: BodyType<CreateLeadBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLead>>
>;
export type CreateLeadMutationBody = BodyType<CreateLeadBody>;
export type CreateLeadMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create a new lead
 */
export const useCreateLead = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLead>>,
    TError,
    { data: BodyType<CreateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLead>>,
  TError,
  { data: BodyType<CreateLeadBody> },
  TContext
> => {
  return useMutation(getCreateLeadMutationOptions(options));
};

/**
 * @summary Aggregate lead counts for the dashboard
 */
export const getGetLeadsSummaryUrl = (params?: GetLeadsSummaryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leads/summary?${stringifiedParams}`
    : `/api/leads/summary`;
};

export const getLeadsSummary = async (
  params?: GetLeadsSummaryParams,
  options?: RequestInit,
): Promise<LeadsSummary> => {
  return customFetch<LeadsSummary>(getGetLeadsSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadsSummaryQueryKey = (params?: GetLeadsSummaryParams) => {
  return [`/api/leads/summary`, ...(params ? [params] : [])] as const;
};

export const getGetLeadsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeadsSummary>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetLeadsSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadsSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeadsSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadsSummary>>> = ({
    signal,
  }) => getLeadsSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadsSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeadsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeadsSummary>>
>;
export type GetLeadsSummaryQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Aggregate lead counts for the dashboard
 */

export function useGetLeadsSummary<
  TData = Awaited<ReturnType<typeof getLeadsSummary>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetLeadsSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadsSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadsSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Apply a bulk action to multiple leads
 */
export const getBulkLeadActionUrl = () => {
  return `/api/leads/bulk`;
};

export const bulkLeadAction = async (
  bulkLeadActionBody: BulkLeadActionBody,
  options?: RequestInit,
): Promise<BulkLeadActionResult> => {
  return customFetch<BulkLeadActionResult>(getBulkLeadActionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkLeadActionBody),
  });
};

export const getBulkLeadActionMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkLeadAction>>,
    TError,
    { data: BodyType<BulkLeadActionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkLeadAction>>,
  TError,
  { data: BodyType<BulkLeadActionBody> },
  TContext
> => {
  const mutationKey = ["bulkLeadAction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkLeadAction>>,
    { data: BodyType<BulkLeadActionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkLeadAction(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkLeadActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkLeadAction>>
>;
export type BulkLeadActionMutationBody = BodyType<BulkLeadActionBody>;
export type BulkLeadActionMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Apply a bulk action to multiple leads
 */
export const useBulkLeadAction = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkLeadAction>>,
    TError,
    { data: BodyType<BulkLeadActionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkLeadAction>>,
  TError,
  { data: BodyType<BulkLeadActionBody> },
  TContext
> => {
  return useMutation(getBulkLeadActionMutationOptions(options));
};

/**
 * @summary List lead score rules
 */
export const getListScoreRulesUrl = () => {
  return `/api/score-rules`;
};

export const listScoreRules = async (
  options?: RequestInit,
): Promise<ScoreRule[]> => {
  return customFetch<ScoreRule[]>(getListScoreRulesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListScoreRulesQueryKey = () => {
  return [`/api/score-rules`] as const;
};

export const getListScoreRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listScoreRules>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listScoreRules>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListScoreRulesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listScoreRules>>> = ({
    signal,
  }) => listScoreRules({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listScoreRules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListScoreRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listScoreRules>>
>;
export type ListScoreRulesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List lead score rules
 */

export function useListScoreRules<
  TData = Awaited<ReturnType<typeof listScoreRules>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listScoreRules>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListScoreRulesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a score rule (super_admin only)
 */
export const getCreateScoreRuleUrl = () => {
  return `/api/score-rules`;
};

export const createScoreRule = async (
  scoreRuleBody: ScoreRuleBody,
  options?: RequestInit,
): Promise<ScoreRule> => {
  return customFetch<ScoreRule>(getCreateScoreRuleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(scoreRuleBody),
  });
};

export const getCreateScoreRuleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScoreRule>>,
    TError,
    { data: BodyType<ScoreRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createScoreRule>>,
  TError,
  { data: BodyType<ScoreRuleBody> },
  TContext
> => {
  const mutationKey = ["createScoreRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createScoreRule>>,
    { data: BodyType<ScoreRuleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createScoreRule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateScoreRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createScoreRule>>
>;
export type CreateScoreRuleMutationBody = BodyType<ScoreRuleBody>;
export type CreateScoreRuleMutationError = ErrorType<unknown>;

/**
 * @summary Create a score rule (super_admin only)
 */
export const useCreateScoreRule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScoreRule>>,
    TError,
    { data: BodyType<ScoreRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createScoreRule>>,
  TError,
  { data: BodyType<ScoreRuleBody> },
  TContext
> => {
  return useMutation(getCreateScoreRuleMutationOptions(options));
};

/**
 * @summary Update a score rule (super_admin only)
 */
export const getUpdateScoreRuleUrl = (id: number) => {
  return `/api/score-rules/${id}`;
};

export const updateScoreRule = async (
  id: number,
  scoreRuleBody: ScoreRuleBody,
  options?: RequestInit,
): Promise<ScoreRule> => {
  return customFetch<ScoreRule>(getUpdateScoreRuleUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(scoreRuleBody),
  });
};

export const getUpdateScoreRuleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateScoreRule>>,
    TError,
    { id: number; data: BodyType<ScoreRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateScoreRule>>,
  TError,
  { id: number; data: BodyType<ScoreRuleBody> },
  TContext
> => {
  const mutationKey = ["updateScoreRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateScoreRule>>,
    { id: number; data: BodyType<ScoreRuleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateScoreRule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateScoreRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateScoreRule>>
>;
export type UpdateScoreRuleMutationBody = BodyType<ScoreRuleBody>;
export type UpdateScoreRuleMutationError = ErrorType<unknown>;

/**
 * @summary Update a score rule (super_admin only)
 */
export const useUpdateScoreRule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateScoreRule>>,
    TError,
    { id: number; data: BodyType<ScoreRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateScoreRule>>,
  TError,
  { id: number; data: BodyType<ScoreRuleBody> },
  TContext
> => {
  return useMutation(getUpdateScoreRuleMutationOptions(options));
};

/**
 * @summary Delete a score rule (super_admin only)
 */
export const getDeleteScoreRuleUrl = (id: number) => {
  return `/api/score-rules/${id}`;
};

export const deleteScoreRule = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteScoreRuleUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteScoreRuleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteScoreRule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteScoreRule>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteScoreRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteScoreRule>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteScoreRule(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteScoreRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteScoreRule>>
>;

export type DeleteScoreRuleMutationError = ErrorType<unknown>;

/**
 * @summary Delete a score rule (super_admin only)
 */
export const useDeleteScoreRule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteScoreRule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteScoreRule>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteScoreRuleMutationOptions(options));
};

/**
 * @summary Recompute priority for all leads using current rules (super_admin only)
 */
export const getRecalculateScoresUrl = () => {
  return `/api/score-rules/recalculate`;
};

export const recalculateScores = async (
  options?: RequestInit,
): Promise<RecalculateResult> => {
  return customFetch<RecalculateResult>(getRecalculateScoresUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRecalculateScoresMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recalculateScores>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recalculateScores>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["recalculateScores"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recalculateScores>>,
    void
  > = () => {
    return recalculateScores(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecalculateScoresMutationResult = NonNullable<
  Awaited<ReturnType<typeof recalculateScores>>
>;

export type RecalculateScoresMutationError = ErrorType<unknown>;

/**
 * @summary Recompute priority for all leads using current rules (super_admin only)
 */
export const useRecalculateScores = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recalculateScores>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recalculateScores>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRecalculateScoresMutationOptions(options));
};

/**
 * @summary List API keys for the current user (super_admin sees all)
 */
export const getListApiKeysUrl = () => {
  return `/api/api-keys`;
};

export const listApiKeys = async (options?: RequestInit): Promise<ApiKey[]> => {
  return customFetch<ApiKey[]>(getListApiKeysUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListApiKeysQueryKey = () => {
  return [`/api/api-keys`] as const;
};

export const getListApiKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof listApiKeys>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listApiKeys>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListApiKeysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listApiKeys>>> = ({
    signal,
  }) => listApiKeys({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listApiKeys>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListApiKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof listApiKeys>>
>;
export type ListApiKeysQueryError = ErrorType<unknown>;

/**
 * @summary List API keys for the current user (super_admin sees all)
 */

export function useListApiKeys<
  TData = Awaited<ReturnType<typeof listApiKeys>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listApiKeys>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListApiKeysQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mint a new API key for the current user
 */
export const getCreateApiKeyUrl = () => {
  return `/api/api-keys`;
};

export const createApiKey = async (
  createApiKeyBody: CreateApiKeyBody,
  options?: RequestInit,
): Promise<CreateApiKeyResult> => {
  return customFetch<CreateApiKeyResult>(getCreateApiKeyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createApiKeyBody),
  });
};

export const getCreateApiKeyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiKey>>,
    TError,
    { data: BodyType<CreateApiKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createApiKey>>,
  TError,
  { data: BodyType<CreateApiKeyBody> },
  TContext
> => {
  const mutationKey = ["createApiKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createApiKey>>,
    { data: BodyType<CreateApiKeyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createApiKey(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createApiKey>>
>;
export type CreateApiKeyMutationBody = BodyType<CreateApiKeyBody>;
export type CreateApiKeyMutationError = ErrorType<unknown>;

/**
 * @summary Mint a new API key for the current user
 */
export const useCreateApiKey = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiKey>>,
    TError,
    { data: BodyType<CreateApiKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createApiKey>>,
  TError,
  { data: BodyType<CreateApiKeyBody> },
  TContext
> => {
  return useMutation(getCreateApiKeyMutationOptions(options));
};

/**
 * @summary Revoke an API key
 */
export const getRevokeApiKeyUrl = (id: number) => {
  return `/api/api-keys/${id}`;
};

export const revokeApiKey = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRevokeApiKeyUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRevokeApiKeyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeApiKey>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeApiKey>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["revokeApiKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeApiKey>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revokeApiKey(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeApiKey>>
>;

export type RevokeApiKeyMutationError = ErrorType<unknown>;

/**
 * @summary Revoke an API key
 */
export const useRevokeApiKey = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeApiKey>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeApiKey>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRevokeApiKeyMutationOptions(options));
};

/**
 * @summary Create a lead via the public ingestion API (Bearer API key)
 */
export const getCreatePublicLeadUrl = () => {
  return `/api/public/leads`;
};

export const createPublicLead = async (
  publicCreateLeadBody: PublicCreateLeadBody,
  options?: RequestInit,
): Promise<PublicCreateLeadResponse> => {
  return customFetch<PublicCreateLeadResponse>(getCreatePublicLeadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(publicCreateLeadBody),
  });
};

export const getCreatePublicLeadMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPublicLead>>,
    TError,
    { data: BodyType<PublicCreateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPublicLead>>,
  TError,
  { data: BodyType<PublicCreateLeadBody> },
  TContext
> => {
  const mutationKey = ["createPublicLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPublicLead>>,
    { data: BodyType<PublicCreateLeadBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPublicLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePublicLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPublicLead>>
>;
export type CreatePublicLeadMutationBody = BodyType<PublicCreateLeadBody>;
export type CreatePublicLeadMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | void
>;

/**
 * @summary Create a lead via the public ingestion API (Bearer API key)
 */
export const useCreatePublicLead = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPublicLead>>,
    TError,
    { data: BodyType<PublicCreateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPublicLead>>,
  TError,
  { data: BodyType<PublicCreateLeadBody> },
  TContext
> => {
  return useMutation(getCreatePublicLeadMutationOptions(options));
};

/**
 * If the path parameter is a numeric internal id, performs an update.
If it is an externalId that does not yet exist, performs an upsert
(creates a new lead) provided all required-on-create fields are in the body.

 * @summary Update or upsert a lead by numeric id or externalId (Bearer API key)
 */
export const getUpdatePublicLeadUrl = (idOrExternalId: string) => {
  return `/api/public/leads/${idOrExternalId}`;
};

export const updatePublicLead = async (
  idOrExternalId: string,
  publicUpdateLeadBody: PublicUpdateLeadBody,
  options?: RequestInit,
): Promise<PublicUpsertLeadResponse> => {
  return customFetch<PublicUpsertLeadResponse>(
    getUpdatePublicLeadUrl(idOrExternalId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(publicUpdateLeadBody),
    },
  );
};

export const getUpdatePublicLeadMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse | void
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePublicLead>>,
    TError,
    { idOrExternalId: string; data: BodyType<PublicUpdateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePublicLead>>,
  TError,
  { idOrExternalId: string; data: BodyType<PublicUpdateLeadBody> },
  TContext
> => {
  const mutationKey = ["updatePublicLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePublicLead>>,
    { idOrExternalId: string; data: BodyType<PublicUpdateLeadBody> }
  > = (props) => {
    const { idOrExternalId, data } = props ?? {};

    return updatePublicLead(idOrExternalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePublicLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePublicLead>>
>;
export type UpdatePublicLeadMutationBody = BodyType<PublicUpdateLeadBody>;
export type UpdatePublicLeadMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse | void
>;

/**
 * @summary Update or upsert a lead by numeric id or externalId (Bearer API key)
 */
export const useUpdatePublicLead = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse | void
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePublicLead>>,
    TError,
    { idOrExternalId: string; data: BodyType<PublicUpdateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePublicLead>>,
  TError,
  { idOrExternalId: string; data: BodyType<PublicUpdateLeadBody> },
  TContext
> => {
  return useMutation(getUpdatePublicLeadMutationOptions(options));
};

/**
 * @summary List follow-ups, callbacks, and scheduled tours in a date range for the signed-in user
 */
export const getGetMyTodayUrl = (params?: GetMyTodayParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leads/today?${stringifiedParams}`
    : `/api/leads/today`;
};

export const getMyToday = async (
  params?: GetMyTodayParams,
  options?: RequestInit,
): Promise<TodayTasks> => {
  return customFetch<TodayTasks>(getGetMyTodayUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMyTodayQueryKey = (params?: GetMyTodayParams) => {
  return [`/api/leads/today`, ...(params ? [params] : [])] as const;
};

export const getGetMyTodayQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyToday>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetMyTodayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyToday>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyTodayQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyToday>>> = ({
    signal,
  }) => getMyToday(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyToday>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyTodayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyToday>>
>;
export type GetMyTodayQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List follow-ups, callbacks, and scheduled tours in a date range for the signed-in user
 */

export function useGetMyToday<
  TData = Awaited<ReturnType<typeof getMyToday>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetMyTodayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyToday>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyTodayQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark a follow-up or callback complete for a lead
 */
export const getCompleteLeadTaskUrl = (id: number) => {
  return `/api/leads/${id}/complete-task`;
};

export const completeLeadTask = async (
  id: number,
  completeTaskBody: CompleteTaskBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getCompleteLeadTaskUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(completeTaskBody),
  });
};

export const getCompleteLeadTaskMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeLeadTask>>,
    TError,
    { id: number; data: BodyType<CompleteTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeLeadTask>>,
  TError,
  { id: number; data: BodyType<CompleteTaskBody> },
  TContext
> => {
  const mutationKey = ["completeLeadTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeLeadTask>>,
    { id: number; data: BodyType<CompleteTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return completeLeadTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteLeadTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeLeadTask>>
>;
export type CompleteLeadTaskMutationBody = BodyType<CompleteTaskBody>;
export type CompleteLeadTaskMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Mark a follow-up or callback complete for a lead
 */
export const useCompleteLeadTask = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeLeadTask>>,
    TError,
    { id: number; data: BodyType<CompleteTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeLeadTask>>,
  TError,
  { id: number; data: BodyType<CompleteTaskBody> },
  TContext
> => {
  return useMutation(getCompleteLeadTaskMutationOptions(options));
};

/**
 * @summary Snooze or reschedule a follow-up or callback to a new time
 */
export const getRescheduleLeadTaskUrl = (id: number) => {
  return `/api/leads/${id}/reschedule-task`;
};

export const rescheduleLeadTask = async (
  id: number,
  rescheduleTaskBody: RescheduleTaskBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getRescheduleLeadTaskUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rescheduleTaskBody),
  });
};

export const getRescheduleLeadTaskMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rescheduleLeadTask>>,
    TError,
    { id: number; data: BodyType<RescheduleTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rescheduleLeadTask>>,
  TError,
  { id: number; data: BodyType<RescheduleTaskBody> },
  TContext
> => {
  const mutationKey = ["rescheduleLeadTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rescheduleLeadTask>>,
    { id: number; data: BodyType<RescheduleTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return rescheduleLeadTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RescheduleLeadTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof rescheduleLeadTask>>
>;
export type RescheduleLeadTaskMutationBody = BodyType<RescheduleTaskBody>;
export type RescheduleLeadTaskMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Snooze or reschedule a follow-up or callback to a new time
 */
export const useRescheduleLeadTask = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rescheduleLeadTask>>,
    TError,
    { id: number; data: BodyType<RescheduleTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rescheduleLeadTask>>,
  TError,
  { id: number; data: BodyType<RescheduleTaskBody> },
  TContext
> => {
  return useMutation(getRescheduleLeadTaskMutationOptions(options));
};

/**
 * @summary List recent CSV import jobs
 */
export const getListLeadImportsUrl = () => {
  return `/api/imports`;
};

export const listLeadImports = async (
  options?: RequestInit,
): Promise<LeadImport[]> => {
  return customFetch<LeadImport[]>(getListLeadImportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListLeadImportsQueryKey = () => {
  return [`/api/imports`] as const;
};

export const getListLeadImportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLeadImports>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listLeadImports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLeadImportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeadImports>>> = ({
    signal,
  }) => listLeadImports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeadImports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLeadImportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLeadImports>>
>;
export type ListLeadImportsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List recent CSV import jobs
 */

export function useListLeadImports<
  TData = Awaited<ReturnType<typeof listLeadImports>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listLeadImports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLeadImportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single CSV import job with per-row errors
 */
export const getGetLeadImportUrl = (id: number) => {
  return `/api/imports/${id}`;
};

export const getLeadImport = async (
  id: number,
  options?: RequestInit,
): Promise<LeadImportDetail> => {
  return customFetch<LeadImportDetail>(getGetLeadImportUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadImportQueryKey = (id: number) => {
  return [`/api/imports/${id}`] as const;
};

export const getGetLeadImportQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeadImport>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadImport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeadImportQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadImport>>> = ({
    signal,
  }) => getLeadImport(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadImport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeadImportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeadImport>>
>;
export type GetLeadImportQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get a single CSV import job with per-row errors
 */

export function useGetLeadImport<
  TData = Awaited<ReturnType<typeof getLeadImport>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadImport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadImportQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload a CSV file of leads (text content in JSON body)
 */
export const getUploadLeadsCsvUrl = () => {
  return `/api/imports/leads`;
};

export const uploadLeadsCsv = async (
  uploadLeadsCsvBody: UploadLeadsCsvBody,
  options?: RequestInit,
): Promise<LeadImportDetail> => {
  return customFetch<LeadImportDetail>(getUploadLeadsCsvUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadLeadsCsvBody),
  });
};

export const getUploadLeadsCsvMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadLeadsCsv>>,
    TError,
    { data: BodyType<UploadLeadsCsvBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadLeadsCsv>>,
  TError,
  { data: BodyType<UploadLeadsCsvBody> },
  TContext
> => {
  const mutationKey = ["uploadLeadsCsv"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadLeadsCsv>>,
    { data: BodyType<UploadLeadsCsvBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadLeadsCsv(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadLeadsCsvMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadLeadsCsv>>
>;
export type UploadLeadsCsvMutationBody = BodyType<UploadLeadsCsvBody>;
export type UploadLeadsCsvMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Upload a CSV file of leads (text content in JSON body)
 */
export const useUploadLeadsCsv = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadLeadsCsv>>,
    TError,
    { data: BodyType<UploadLeadsCsvBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadLeadsCsv>>,
  TError,
  { data: BodyType<UploadLeadsCsvBody> },
  TContext
> => {
  return useMutation(getUploadLeadsCsvMutationOptions(options));
};

/**
 * @summary List recent inventory-item CSV import jobs
 */
export const getListInventoryItemImportsUrl = () => {
  return `/api/imports/inventory-items`;
};

export const listInventoryItemImports = async (
  options?: RequestInit,
): Promise<InventoryItemImport[]> => {
  return customFetch<InventoryItemImport[]>(getListInventoryItemImportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListInventoryItemImportsQueryKey = () => {
  return [`/api/imports/inventory-items`] as const;
};

export const getListInventoryItemImportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryItemImports>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryItemImports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryItemImportsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryItemImports>>
  > = ({ signal }) => listInventoryItemImports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryItemImports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryItemImportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryItemImports>>
>;
export type ListInventoryItemImportsQueryError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary List recent inventory-item CSV import jobs
 */

export function useListInventoryItemImports<
  TData = Awaited<ReturnType<typeof listInventoryItemImports>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryItemImports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryItemImportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload a CSV file of inventory items (text content in JSON body)
 */
export const getUploadInventoryItemsCsvUrl = () => {
  return `/api/imports/inventory-items`;
};

export const uploadInventoryItemsCsv = async (
  uploadInventoryItemsCsvBody: UploadInventoryItemsCsvBody,
  options?: RequestInit,
): Promise<InventoryItemImportDetail> => {
  return customFetch<InventoryItemImportDetail>(
    getUploadInventoryItemsCsvUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(uploadInventoryItemsCsvBody),
    },
  );
};

export const getUploadInventoryItemsCsvMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadInventoryItemsCsv>>,
    TError,
    { data: BodyType<UploadInventoryItemsCsvBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadInventoryItemsCsv>>,
  TError,
  { data: BodyType<UploadInventoryItemsCsvBody> },
  TContext
> => {
  const mutationKey = ["uploadInventoryItemsCsv"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadInventoryItemsCsv>>,
    { data: BodyType<UploadInventoryItemsCsvBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadInventoryItemsCsv(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadInventoryItemsCsvMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadInventoryItemsCsv>>
>;
export type UploadInventoryItemsCsvMutationBody =
  BodyType<UploadInventoryItemsCsvBody>;
export type UploadInventoryItemsCsvMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Upload a CSV file of inventory items (text content in JSON body)
 */
export const useUploadInventoryItemsCsv = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadInventoryItemsCsv>>,
    TError,
    { data: BodyType<UploadInventoryItemsCsvBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadInventoryItemsCsv>>,
  TError,
  { data: BodyType<UploadInventoryItemsCsvBody> },
  TContext
> => {
  return useMutation(getUploadInventoryItemsCsvMutationOptions(options));
};

/**
 * @summary Get a single inventory-item CSV import job with per-row errors
 */
export const getGetInventoryItemImportUrl = (id: number) => {
  return `/api/imports/inventory-items/${id}`;
};

export const getInventoryItemImport = async (
  id: number,
  options?: RequestInit,
): Promise<InventoryItemImportDetail> => {
  return customFetch<InventoryItemImportDetail>(
    getGetInventoryItemImportUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInventoryItemImportQueryKey = (id: number) => {
  return [`/api/imports/inventory-items/${id}`] as const;
};

export const getGetInventoryItemImportQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryItemImport>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryItemImport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventoryItemImportQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryItemImport>>
  > = ({ signal }) => getInventoryItemImport(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryItemImport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryItemImportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryItemImport>>
>;
export type GetInventoryItemImportQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get a single inventory-item CSV import job with per-row errors
 */

export function useGetInventoryItemImport<
  TData = Awaited<ReturnType<typeof getInventoryItemImport>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryItemImport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInventoryItemImportQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a lead by ID
 */
export const getGetLeadUrl = (id: number) => {
  return `/api/leads/${id}`;
};

export const getLead = async (
  id: number,
  options?: RequestInit,
): Promise<LeadDetail> => {
  return customFetch<LeadDetail>(getGetLeadUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadQueryKey = (id: number) => {
  return [`/api/leads/${id}`] as const;
};

export const getGetLeadQueryOptions = <
  TData = Awaited<ReturnType<typeof getLead>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeadQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLead>>> = ({
    signal,
  }) => getLead(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetLeadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLead>>
>;
export type GetLeadQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get a lead by ID
 */

export function useGetLead<
  TData = Awaited<ReturnType<typeof getLead>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a lead
 */
export const getUpdateLeadUrl = (id: number) => {
  return `/api/leads/${id}`;
};

export const updateLead = async (
  id: number,
  updateLeadBody: UpdateLeadBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getUpdateLeadUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateLeadBody),
  });
};

export const getUpdateLeadMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLead>>,
    TError,
    { id: number; data: BodyType<UpdateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLead>>,
  TError,
  { id: number; data: BodyType<UpdateLeadBody> },
  TContext
> => {
  const mutationKey = ["updateLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLead>>,
    { id: number; data: BodyType<UpdateLeadBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLead(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLead>>
>;
export type UpdateLeadMutationBody = BodyType<UpdateLeadBody>;
export type UpdateLeadMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Update a lead
 */
export const useUpdateLead = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLead>>,
    TError,
    { id: number; data: BodyType<UpdateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLead>>,
  TError,
  { id: number; data: BodyType<UpdateLeadBody> },
  TContext
> => {
  return useMutation(getUpdateLeadMutationOptions(options));
};

/**
 * @summary Delete a lead
 */
export const getDeleteLeadUrl = (id: number) => {
  return `/api/leads/${id}`;
};

export const deleteLead = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteLeadUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLeadMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLead>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLead>>
>;

export type DeleteLeadMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a lead
 */
export const useDeleteLead = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLead>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteLeadMutationOptions(options));
};

/**
 * Powers the Inventory Operation dashboard. Returns spend (line_total +
gst_amount) rolled up by a curated per-bucket category list, with a
previous-window comparison for the trend chip. Categories in the
Complimentary bucket: Pantry, F&B, Medical, Toiletries (backed by
"Cleaning & Toiletries"), Maintenance.

 * @summary Aggregated stock-in spend per usage-model bucket, per category, with trend
 */
export const getGetInventorySpendKpiUrl = (
  params?: GetInventorySpendKpiParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/spend-kpi?${stringifiedParams}`
    : `/api/inventory/spend-kpi`;
};

export const getInventorySpendKpi = async (
  params?: GetInventorySpendKpiParams,
  options?: RequestInit,
): Promise<InventorySpendKpi> => {
  return customFetch<InventorySpendKpi>(getGetInventorySpendKpiUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetInventorySpendKpiQueryKey = (
  params?: GetInventorySpendKpiParams,
) => {
  return [`/api/inventory/spend-kpi`, ...(params ? [params] : [])] as const;
};

export const getGetInventorySpendKpiQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventorySpendKpi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetInventorySpendKpiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventorySpendKpi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventorySpendKpiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventorySpendKpi>>
  > = ({ signal }) =>
    getInventorySpendKpi(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventorySpendKpi>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventorySpendKpiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventorySpendKpi>>
>;
export type GetInventorySpendKpiQueryError = ErrorType<unknown>;

/**
 * @summary Aggregated stock-in spend per usage-model bucket, per category, with trend
 */

export function useGetInventorySpendKpi<
  TData = Awaited<ReturnType<typeof getInventorySpendKpi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetInventorySpendKpiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventorySpendKpi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInventorySpendKpiQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List inventory categories
 */
export const getListInventoryCategoriesUrl = (
  params?: ListInventoryCategoriesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/categories?${stringifiedParams}`
    : `/api/inventory/categories`;
};

export const listInventoryCategories = async (
  params?: ListInventoryCategoriesParams,
  options?: RequestInit,
): Promise<InventoryCategory[]> => {
  return customFetch<InventoryCategory[]>(
    getListInventoryCategoriesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInventoryCategoriesQueryKey = (
  params?: ListInventoryCategoriesParams,
) => {
  return [`/api/inventory/categories`, ...(params ? [params] : [])] as const;
};

export const getListInventoryCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryCategories>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryCategoriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryCategories>>
  > = ({ signal }) =>
    listInventoryCategories(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryCategories>>
>;
export type ListInventoryCategoriesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List inventory categories
 */

export function useListInventoryCategories<
  TData = Awaited<ReturnType<typeof listInventoryCategories>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryCategoriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an inventory category (admin only)
 */
export const getCreateInventoryCategoryUrl = () => {
  return `/api/inventory/categories`;
};

export const createInventoryCategory = async (
  createInventoryCategoryBody: CreateInventoryCategoryBody,
  options?: RequestInit,
): Promise<InventoryCategory> => {
  return customFetch<InventoryCategory>(getCreateInventoryCategoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInventoryCategoryBody),
  });
};

export const getCreateInventoryCategoryMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInventoryCategory>>,
    TError,
    { data: BodyType<CreateInventoryCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInventoryCategory>>,
  TError,
  { data: BodyType<CreateInventoryCategoryBody> },
  TContext
> => {
  const mutationKey = ["createInventoryCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInventoryCategory>>,
    { data: BodyType<CreateInventoryCategoryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInventoryCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInventoryCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInventoryCategory>>
>;
export type CreateInventoryCategoryMutationBody =
  BodyType<CreateInventoryCategoryBody>;
export type CreateInventoryCategoryMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an inventory category (admin only)
 */
export const useCreateInventoryCategory = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInventoryCategory>>,
    TError,
    { data: BodyType<CreateInventoryCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInventoryCategory>>,
  TError,
  { data: BodyType<CreateInventoryCategoryBody> },
  TContext
> => {
  return useMutation(getCreateInventoryCategoryMutationOptions(options));
};

/**
 * @summary Get an inventory category by ID
 */
export const getGetInventoryCategoryUrl = (id: number) => {
  return `/api/inventory/categories/${id}`;
};

export const getInventoryCategory = async (
  id: number,
  options?: RequestInit,
): Promise<InventoryCategory> => {
  return customFetch<InventoryCategory>(getGetInventoryCategoryUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInventoryCategoryQueryKey = (id: number) => {
  return [`/api/inventory/categories/${id}`] as const;
};

export const getGetInventoryCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryCategory>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryCategory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventoryCategoryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryCategory>>
  > = ({ signal }) => getInventoryCategory(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryCategory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryCategoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryCategory>>
>;
export type GetInventoryCategoryQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get an inventory category by ID
 */

export function useGetInventoryCategory<
  TData = Awaited<ReturnType<typeof getInventoryCategory>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryCategory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInventoryCategoryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an inventory category (admin only)
 */
export const getUpdateInventoryCategoryUrl = (id: number) => {
  return `/api/inventory/categories/${id}`;
};

export const updateInventoryCategory = async (
  id: number,
  updateInventoryCategoryBody: UpdateInventoryCategoryBody,
  options?: RequestInit,
): Promise<InventoryCategory> => {
  return customFetch<InventoryCategory>(getUpdateInventoryCategoryUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInventoryCategoryBody),
  });
};

export const getUpdateInventoryCategoryMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryCategory>>,
    TError,
    { id: number; data: BodyType<UpdateInventoryCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInventoryCategory>>,
  TError,
  { id: number; data: BodyType<UpdateInventoryCategoryBody> },
  TContext
> => {
  const mutationKey = ["updateInventoryCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInventoryCategory>>,
    { id: number; data: BodyType<UpdateInventoryCategoryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInventoryCategory(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInventoryCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInventoryCategory>>
>;
export type UpdateInventoryCategoryMutationBody =
  BodyType<UpdateInventoryCategoryBody>;
export type UpdateInventoryCategoryMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Update an inventory category (admin only)
 */
export const useUpdateInventoryCategory = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryCategory>>,
    TError,
    { id: number; data: BodyType<UpdateInventoryCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInventoryCategory>>,
  TError,
  { id: number; data: BodyType<UpdateInventoryCategoryBody> },
  TContext
> => {
  return useMutation(getUpdateInventoryCategoryMutationOptions(options));
};

/**
 * @summary Delete an inventory category (admin only)
 */
export const getDeleteInventoryCategoryUrl = (id: number) => {
  return `/api/inventory/categories/${id}`;
};

export const deleteInventoryCategory = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInventoryCategoryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInventoryCategoryMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryCategory>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInventoryCategory>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInventoryCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInventoryCategory>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInventoryCategory(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInventoryCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInventoryCategory>>
>;

export type DeleteInventoryCategoryMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete an inventory category (admin only)
 */
export const useDeleteInventoryCategory = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryCategory>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInventoryCategory>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInventoryCategoryMutationOptions(options));
};

/**
 * @summary List inventory vendors
 */
export const getListInventoryVendorsUrl = (
  params?: ListInventoryVendorsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/vendors?${stringifiedParams}`
    : `/api/inventory/vendors`;
};

export const listInventoryVendors = async (
  params?: ListInventoryVendorsParams,
  options?: RequestInit,
): Promise<InventoryVendor[]> => {
  return customFetch<InventoryVendor[]>(getListInventoryVendorsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInventoryVendorsQueryKey = (
  params?: ListInventoryVendorsParams,
) => {
  return [`/api/inventory/vendors`, ...(params ? [params] : [])] as const;
};

export const getListInventoryVendorsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryVendors>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryVendorsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryVendors>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryVendorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryVendors>>
  > = ({ signal }) =>
    listInventoryVendors(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryVendors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryVendorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryVendors>>
>;
export type ListInventoryVendorsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List inventory vendors
 */

export function useListInventoryVendors<
  TData = Awaited<ReturnType<typeof listInventoryVendors>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryVendorsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryVendors>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryVendorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an inventory vendor (admin only)
 */
export const getCreateInventoryVendorUrl = () => {
  return `/api/inventory/vendors`;
};

export const createInventoryVendor = async (
  createInventoryVendorBody: CreateInventoryVendorBody,
  options?: RequestInit,
): Promise<InventoryVendor> => {
  return customFetch<InventoryVendor>(getCreateInventoryVendorUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInventoryVendorBody),
  });
};

export const getCreateInventoryVendorMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInventoryVendor>>,
    TError,
    { data: BodyType<CreateInventoryVendorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInventoryVendor>>,
  TError,
  { data: BodyType<CreateInventoryVendorBody> },
  TContext
> => {
  const mutationKey = ["createInventoryVendor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInventoryVendor>>,
    { data: BodyType<CreateInventoryVendorBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInventoryVendor(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInventoryVendorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInventoryVendor>>
>;
export type CreateInventoryVendorMutationBody =
  BodyType<CreateInventoryVendorBody>;
export type CreateInventoryVendorMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an inventory vendor (admin only)
 */
export const useCreateInventoryVendor = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInventoryVendor>>,
    TError,
    { data: BodyType<CreateInventoryVendorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInventoryVendor>>,
  TError,
  { data: BodyType<CreateInventoryVendorBody> },
  TContext
> => {
  return useMutation(getCreateInventoryVendorMutationOptions(options));
};

/**
 * @summary Get an inventory vendor by ID (includes contacts and documents)
 */
export const getGetInventoryVendorUrl = (id: number) => {
  return `/api/inventory/vendors/${id}`;
};

export const getInventoryVendor = async (
  id: number,
  options?: RequestInit,
): Promise<InventoryVendorDetail> => {
  return customFetch<InventoryVendorDetail>(getGetInventoryVendorUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInventoryVendorQueryKey = (id: number) => {
  return [`/api/inventory/vendors/${id}`] as const;
};

export const getGetInventoryVendorQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryVendor>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryVendor>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInventoryVendorQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryVendor>>
  > = ({ signal }) => getInventoryVendor(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryVendor>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryVendorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryVendor>>
>;
export type GetInventoryVendorQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get an inventory vendor by ID (includes contacts and documents)
 */

export function useGetInventoryVendor<
  TData = Awaited<ReturnType<typeof getInventoryVendor>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryVendor>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInventoryVendorQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an inventory vendor (admin only)
 */
export const getUpdateInventoryVendorUrl = (id: number) => {
  return `/api/inventory/vendors/${id}`;
};

export const updateInventoryVendor = async (
  id: number,
  updateInventoryVendorBody: UpdateInventoryVendorBody,
  options?: RequestInit,
): Promise<InventoryVendor> => {
  return customFetch<InventoryVendor>(getUpdateInventoryVendorUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInventoryVendorBody),
  });
};

export const getUpdateInventoryVendorMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryVendor>>,
    TError,
    { id: number; data: BodyType<UpdateInventoryVendorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInventoryVendor>>,
  TError,
  { id: number; data: BodyType<UpdateInventoryVendorBody> },
  TContext
> => {
  const mutationKey = ["updateInventoryVendor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInventoryVendor>>,
    { id: number; data: BodyType<UpdateInventoryVendorBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInventoryVendor(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInventoryVendorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInventoryVendor>>
>;
export type UpdateInventoryVendorMutationBody =
  BodyType<UpdateInventoryVendorBody>;
export type UpdateInventoryVendorMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Update an inventory vendor (admin only)
 */
export const useUpdateInventoryVendor = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryVendor>>,
    TError,
    { id: number; data: BodyType<UpdateInventoryVendorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInventoryVendor>>,
  TError,
  { id: number; data: BodyType<UpdateInventoryVendorBody> },
  TContext
> => {
  return useMutation(getUpdateInventoryVendorMutationOptions(options));
};

/**
 * @summary Delete (archive) an inventory vendor (admin only)
 */
export const getDeleteInventoryVendorUrl = (id: number) => {
  return `/api/inventory/vendors/${id}`;
};

export const deleteInventoryVendor = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInventoryVendorUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInventoryVendorMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryVendor>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInventoryVendor>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInventoryVendor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInventoryVendor>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInventoryVendor(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInventoryVendorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInventoryVendor>>
>;

export type DeleteInventoryVendorMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete (archive) an inventory vendor (admin only)
 */
export const useDeleteInventoryVendor = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryVendor>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInventoryVendor>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInventoryVendorMutationOptions(options));
};

/**
 * @summary Add a contact to a vendor
 */
export const getCreateVendorContactUrl = (vendorId: number) => {
  return `/api/inventory/vendors/${vendorId}/contacts`;
};

export const createVendorContact = async (
  vendorId: number,
  createVendorContactBody: CreateVendorContactBody,
  options?: RequestInit,
): Promise<VendorContact> => {
  return customFetch<VendorContact>(getCreateVendorContactUrl(vendorId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createVendorContactBody),
  });
};

export const getCreateVendorContactMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorContact>>,
    TError,
    { vendorId: number; data: BodyType<CreateVendorContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVendorContact>>,
  TError,
  { vendorId: number; data: BodyType<CreateVendorContactBody> },
  TContext
> => {
  const mutationKey = ["createVendorContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVendorContact>>,
    { vendorId: number; data: BodyType<CreateVendorContactBody> }
  > = (props) => {
    const { vendorId, data } = props ?? {};

    return createVendorContact(vendorId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVendorContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVendorContact>>
>;
export type CreateVendorContactMutationBody = BodyType<CreateVendorContactBody>;
export type CreateVendorContactMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Add a contact to a vendor
 */
export const useCreateVendorContact = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorContact>>,
    TError,
    { vendorId: number; data: BodyType<CreateVendorContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVendorContact>>,
  TError,
  { vendorId: number; data: BodyType<CreateVendorContactBody> },
  TContext
> => {
  return useMutation(getCreateVendorContactMutationOptions(options));
};

/**
 * @summary Remove a vendor contact
 */
export const getDeleteVendorContactUrl = (vendorId: number, id: number) => {
  return `/api/inventory/vendors/${vendorId}/contacts/${id}`;
};

export const deleteVendorContact = async (
  vendorId: number,
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteVendorContactUrl(vendorId, id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteVendorContactMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorContact>>,
    TError,
    { vendorId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVendorContact>>,
  TError,
  { vendorId: number; id: number },
  TContext
> => {
  const mutationKey = ["deleteVendorContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVendorContact>>,
    { vendorId: number; id: number }
  > = (props) => {
    const { vendorId, id } = props ?? {};

    return deleteVendorContact(vendorId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVendorContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVendorContact>>
>;

export type DeleteVendorContactMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Remove a vendor contact
 */
export const useDeleteVendorContact = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorContact>>,
    TError,
    { vendorId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVendorContact>>,
  TError,
  { vendorId: number; id: number },
  TContext
> => {
  return useMutation(getDeleteVendorContactMutationOptions(options));
};

/**
 * @summary Attach a document to a vendor
 */
export const getCreateVendorDocumentUrl = (vendorId: number) => {
  return `/api/inventory/vendors/${vendorId}/documents`;
};

export const createVendorDocument = async (
  vendorId: number,
  createVendorDocumentBody: CreateVendorDocumentBody,
  options?: RequestInit,
): Promise<VendorDocument> => {
  return customFetch<VendorDocument>(getCreateVendorDocumentUrl(vendorId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createVendorDocumentBody),
  });
};

export const getCreateVendorDocumentMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorDocument>>,
    TError,
    { vendorId: number; data: BodyType<CreateVendorDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVendorDocument>>,
  TError,
  { vendorId: number; data: BodyType<CreateVendorDocumentBody> },
  TContext
> => {
  const mutationKey = ["createVendorDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVendorDocument>>,
    { vendorId: number; data: BodyType<CreateVendorDocumentBody> }
  > = (props) => {
    const { vendorId, data } = props ?? {};

    return createVendorDocument(vendorId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVendorDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVendorDocument>>
>;
export type CreateVendorDocumentMutationBody =
  BodyType<CreateVendorDocumentBody>;
export type CreateVendorDocumentMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Attach a document to a vendor
 */
export const useCreateVendorDocument = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorDocument>>,
    TError,
    { vendorId: number; data: BodyType<CreateVendorDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVendorDocument>>,
  TError,
  { vendorId: number; data: BodyType<CreateVendorDocumentBody> },
  TContext
> => {
  return useMutation(getCreateVendorDocumentMutationOptions(options));
};

/**
 * @summary Remove a vendor document
 */
export const getDeleteVendorDocumentUrl = (vendorId: number, id: number) => {
  return `/api/inventory/vendors/${vendorId}/documents/${id}`;
};

export const deleteVendorDocument = async (
  vendorId: number,
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteVendorDocumentUrl(vendorId, id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteVendorDocumentMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorDocument>>,
    TError,
    { vendorId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVendorDocument>>,
  TError,
  { vendorId: number; id: number },
  TContext
> => {
  const mutationKey = ["deleteVendorDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVendorDocument>>,
    { vendorId: number; id: number }
  > = (props) => {
    const { vendorId, id } = props ?? {};

    return deleteVendorDocument(vendorId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVendorDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVendorDocument>>
>;

export type DeleteVendorDocumentMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Remove a vendor document
 */
export const useDeleteVendorDocument = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorDocument>>,
    TError,
    { vendorId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVendorDocument>>,
  TError,
  { vendorId: number; id: number },
  TContext
> => {
  return useMutation(getDeleteVendorDocumentMutationOptions(options));
};

/**
 * @summary List inventory items
 */
export const getListInventoryItemsUrl = (params?: ListInventoryItemsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/items?${stringifiedParams}`
    : `/api/inventory/items`;
};

export const listInventoryItems = async (
  params?: ListInventoryItemsParams,
  options?: RequestInit,
): Promise<InventoryItem[]> => {
  return customFetch<InventoryItem[]>(getListInventoryItemsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInventoryItemsQueryKey = (
  params?: ListInventoryItemsParams,
) => {
  return [`/api/inventory/items`, ...(params ? [params] : [])] as const;
};

export const getListInventoryItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryItems>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryItemsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryItems>>
  > = ({ signal }) => listInventoryItems(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryItems>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryItems>>
>;
export type ListInventoryItemsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List inventory items
 */

export function useListInventoryItems<
  TData = Awaited<ReturnType<typeof listInventoryItems>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryItemsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an inventory item (admin only)
 */
export const getCreateInventoryItemUrl = () => {
  return `/api/inventory/items`;
};

export const createInventoryItem = async (
  createInventoryItemBody: CreateInventoryItemBody,
  options?: RequestInit,
): Promise<CreateInventoryItem201> => {
  return customFetch<CreateInventoryItem201>(getCreateInventoryItemUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInventoryItemBody),
  });
};

export const getCreateInventoryItemMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInventoryItem>>,
    TError,
    { data: BodyType<CreateInventoryItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInventoryItem>>,
  TError,
  { data: BodyType<CreateInventoryItemBody> },
  TContext
> => {
  const mutationKey = ["createInventoryItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInventoryItem>>,
    { data: BodyType<CreateInventoryItemBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInventoryItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInventoryItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInventoryItem>>
>;
export type CreateInventoryItemMutationBody = BodyType<CreateInventoryItemBody>;
export type CreateInventoryItemMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an inventory item (admin only)
 */
export const useCreateInventoryItem = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInventoryItem>>,
    TError,
    { data: BodyType<CreateInventoryItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInventoryItem>>,
  TError,
  { data: BodyType<CreateInventoryItemBody> },
  TContext
> => {
  return useMutation(getCreateInventoryItemMutationOptions(options));
};

/**
 * Operator-driven stock-take reconciliation. Each row sets an
ABSOLUTE current_stock value on the item identified by item_code
(or numeric id). Rows that don't match an item are reported in
`errors` and skipped; everything else applies in a single
transaction. No stock-in receipt is created — this is a direct
UPDATE for the case where stock-in transactions are already on
record and only the on-hand count needs correcting.

 * @summary Bulk-overwrite current stock for many items in one call
 */
export const getBulkUpdateInventoryItemStockUrl = () => {
  return `/api/inventory/items/bulk-stock-update`;
};

export const bulkUpdateInventoryItemStock = async (
  bulkUpdateInventoryItemStockBody: BulkUpdateInventoryItemStockBody,
  options?: RequestInit,
): Promise<BulkUpdateInventoryItemStockResult> => {
  return customFetch<BulkUpdateInventoryItemStockResult>(
    getBulkUpdateInventoryItemStockUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bulkUpdateInventoryItemStockBody),
    },
  );
};

export const getBulkUpdateInventoryItemStockMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateInventoryItemStock>>,
    TError,
    { data: BodyType<BulkUpdateInventoryItemStockBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUpdateInventoryItemStock>>,
  TError,
  { data: BodyType<BulkUpdateInventoryItemStockBody> },
  TContext
> => {
  const mutationKey = ["bulkUpdateInventoryItemStock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUpdateInventoryItemStock>>,
    { data: BodyType<BulkUpdateInventoryItemStockBody> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkUpdateInventoryItemStock(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUpdateInventoryItemStockMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUpdateInventoryItemStock>>
>;
export type BulkUpdateInventoryItemStockMutationBody =
  BodyType<BulkUpdateInventoryItemStockBody>;
export type BulkUpdateInventoryItemStockMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Bulk-overwrite current stock for many items in one call
 */
export const useBulkUpdateInventoryItemStock = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateInventoryItemStock>>,
    TError,
    { data: BodyType<BulkUpdateInventoryItemStockBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkUpdateInventoryItemStock>>,
  TError,
  { data: BodyType<BulkUpdateInventoryItemStockBody> },
  TContext
> => {
  return useMutation(getBulkUpdateInventoryItemStockMutationOptions(options));
};

/**
 * @summary Get an inventory item by ID
 */
export const getGetInventoryItemUrl = (id: number) => {
  return `/api/inventory/items/${id}`;
};

export const getInventoryItem = async (
  id: number,
  options?: RequestInit,
): Promise<InventoryItem> => {
  return customFetch<InventoryItem>(getGetInventoryItemUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInventoryItemQueryKey = (id: number) => {
  return [`/api/inventory/items/${id}`] as const;
};

export const getGetInventoryItemQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryItem>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryItem>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInventoryItemQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryItem>>
  > = ({ signal }) => getInventoryItem(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryItem>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryItemQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryItem>>
>;
export type GetInventoryItemQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get an inventory item by ID
 */

export function useGetInventoryItem<
  TData = Awaited<ReturnType<typeof getInventoryItem>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryItem>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInventoryItemQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an inventory item (admin only)
 */
export const getUpdateInventoryItemUrl = (id: number) => {
  return `/api/inventory/items/${id}`;
};

export const updateInventoryItem = async (
  id: number,
  updateInventoryItemBody: UpdateInventoryItemBody,
  options?: RequestInit,
): Promise<InventoryItem> => {
  return customFetch<InventoryItem>(getUpdateInventoryItemUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInventoryItemBody),
  });
};

export const getUpdateInventoryItemMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryItem>>,
    TError,
    { id: number; data: BodyType<UpdateInventoryItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInventoryItem>>,
  TError,
  { id: number; data: BodyType<UpdateInventoryItemBody> },
  TContext
> => {
  const mutationKey = ["updateInventoryItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInventoryItem>>,
    { id: number; data: BodyType<UpdateInventoryItemBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInventoryItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInventoryItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInventoryItem>>
>;
export type UpdateInventoryItemMutationBody = BodyType<UpdateInventoryItemBody>;
export type UpdateInventoryItemMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Update an inventory item (admin only)
 */
export const useUpdateInventoryItem = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryItem>>,
    TError,
    { id: number; data: BodyType<UpdateInventoryItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInventoryItem>>,
  TError,
  { id: number; data: BodyType<UpdateInventoryItemBody> },
  TContext
> => {
  return useMutation(getUpdateInventoryItemMutationOptions(options));
};

/**
 * @summary Delete an inventory item (admin only)
 */
export const getDeleteInventoryItemUrl = (id: number) => {
  return `/api/inventory/items/${id}`;
};

export const deleteInventoryItem = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInventoryItemUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInventoryItemMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryItem>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInventoryItem>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInventoryItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInventoryItem>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInventoryItem(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInventoryItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInventoryItem>>
>;

export type DeleteInventoryItemMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete an inventory item (admin only)
 */
export const useDeleteInventoryItem = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryItem>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInventoryItem>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInventoryItemMutationOptions(options));
};

/**
 * @summary List inventory attribute keys
 */
export const getListAttributeKeysUrl = (params?: ListAttributeKeysParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/attribute-keys?${stringifiedParams}`
    : `/api/inventory/attribute-keys`;
};

export const listAttributeKeys = async (
  params?: ListAttributeKeysParams,
  options?: RequestInit,
): Promise<InventoryAttributeKey[]> => {
  return customFetch<InventoryAttributeKey[]>(getListAttributeKeysUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAttributeKeysQueryKey = (
  params?: ListAttributeKeysParams,
) => {
  return [
    `/api/inventory/attribute-keys`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAttributeKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof listAttributeKeys>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAttributeKeysParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttributeKeys>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAttributeKeysQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAttributeKeys>>
  > = ({ signal }) => listAttributeKeys(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAttributeKeys>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAttributeKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAttributeKeys>>
>;
export type ListAttributeKeysQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List inventory attribute keys
 */

export function useListAttributeKeys<
  TData = Awaited<ReturnType<typeof listAttributeKeys>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAttributeKeysParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttributeKeys>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAttributeKeysQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an attribute key (admin only)
 */
export const getCreateAttributeKeyUrl = () => {
  return `/api/inventory/attribute-keys`;
};

export const createAttributeKey = async (
  createAttributeKeyBody: CreateAttributeKeyBody,
  options?: RequestInit,
): Promise<InventoryAttributeKey> => {
  return customFetch<InventoryAttributeKey>(getCreateAttributeKeyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAttributeKeyBody),
  });
};

export const getCreateAttributeKeyMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttributeKey>>,
    TError,
    { data: BodyType<CreateAttributeKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAttributeKey>>,
  TError,
  { data: BodyType<CreateAttributeKeyBody> },
  TContext
> => {
  const mutationKey = ["createAttributeKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAttributeKey>>,
    { data: BodyType<CreateAttributeKeyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAttributeKey(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAttributeKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAttributeKey>>
>;
export type CreateAttributeKeyMutationBody = BodyType<CreateAttributeKeyBody>;
export type CreateAttributeKeyMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an attribute key (admin only)
 */
export const useCreateAttributeKey = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttributeKey>>,
    TError,
    { data: BodyType<CreateAttributeKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAttributeKey>>,
  TError,
  { data: BodyType<CreateAttributeKeyBody> },
  TContext
> => {
  return useMutation(getCreateAttributeKeyMutationOptions(options));
};

/**
 * @summary Get an attribute key by ID
 */
export const getGetAttributeKeyUrl = (id: number) => {
  return `/api/inventory/attribute-keys/${id}`;
};

export const getAttributeKey = async (
  id: number,
  options?: RequestInit,
): Promise<InventoryAttributeKey> => {
  return customFetch<InventoryAttributeKey>(getGetAttributeKeyUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAttributeKeyQueryKey = (id: number) => {
  return [`/api/inventory/attribute-keys/${id}`] as const;
};

export const getGetAttributeKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttributeKey>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAttributeKey>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAttributeKeyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttributeKey>>> = ({
    signal,
  }) => getAttributeKey(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttributeKey>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAttributeKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttributeKey>>
>;
export type GetAttributeKeyQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get an attribute key by ID
 */

export function useGetAttributeKey<
  TData = Awaited<ReturnType<typeof getAttributeKey>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAttributeKey>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAttributeKeyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an attribute key (admin only)
 */
export const getUpdateAttributeKeyUrl = (id: number) => {
  return `/api/inventory/attribute-keys/${id}`;
};

export const updateAttributeKey = async (
  id: number,
  updateAttributeKeyBody: UpdateAttributeKeyBody,
  options?: RequestInit,
): Promise<InventoryAttributeKey> => {
  return customFetch<InventoryAttributeKey>(getUpdateAttributeKeyUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAttributeKeyBody),
  });
};

export const getUpdateAttributeKeyMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttributeKey>>,
    TError,
    { id: number; data: BodyType<UpdateAttributeKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAttributeKey>>,
  TError,
  { id: number; data: BodyType<UpdateAttributeKeyBody> },
  TContext
> => {
  const mutationKey = ["updateAttributeKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAttributeKey>>,
    { id: number; data: BodyType<UpdateAttributeKeyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAttributeKey(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAttributeKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAttributeKey>>
>;
export type UpdateAttributeKeyMutationBody = BodyType<UpdateAttributeKeyBody>;
export type UpdateAttributeKeyMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update an attribute key (admin only)
 */
export const useUpdateAttributeKey = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttributeKey>>,
    TError,
    { id: number; data: BodyType<UpdateAttributeKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAttributeKey>>,
  TError,
  { id: number; data: BodyType<UpdateAttributeKeyBody> },
  TContext
> => {
  return useMutation(getUpdateAttributeKeyMutationOptions(options));
};

/**
 * @summary List HSN/SAC → GST codes
 */
export const getListHsnCodesUrl = (params?: ListHsnCodesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/hsn-codes?${stringifiedParams}`
    : `/api/inventory/hsn-codes`;
};

export const listHsnCodes = async (
  params?: ListHsnCodesParams,
  options?: RequestInit,
): Promise<InventoryHsnCode[]> => {
  return customFetch<InventoryHsnCode[]>(getListHsnCodesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListHsnCodesQueryKey = (params?: ListHsnCodesParams) => {
  return [`/api/inventory/hsn-codes`, ...(params ? [params] : [])] as const;
};

export const getListHsnCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof listHsnCodes>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListHsnCodesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHsnCodes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHsnCodesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHsnCodes>>> = ({
    signal,
  }) => listHsnCodes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHsnCodes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHsnCodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHsnCodes>>
>;
export type ListHsnCodesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List HSN/SAC → GST codes
 */

export function useListHsnCodes<
  TData = Awaited<ReturnType<typeof listHsnCodes>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListHsnCodesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHsnCodes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListHsnCodesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an HSN/SAC code (admin only)
 */
export const getCreateHsnCodeUrl = () => {
  return `/api/inventory/hsn-codes`;
};

export const createHsnCode = async (
  createHsnCodeBody: CreateHsnCodeBody,
  options?: RequestInit,
): Promise<InventoryHsnCode> => {
  return customFetch<InventoryHsnCode>(getCreateHsnCodeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createHsnCodeBody),
  });
};

export const getCreateHsnCodeMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHsnCode>>,
    TError,
    { data: BodyType<CreateHsnCodeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createHsnCode>>,
  TError,
  { data: BodyType<CreateHsnCodeBody> },
  TContext
> => {
  const mutationKey = ["createHsnCode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createHsnCode>>,
    { data: BodyType<CreateHsnCodeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createHsnCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateHsnCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createHsnCode>>
>;
export type CreateHsnCodeMutationBody = BodyType<CreateHsnCodeBody>;
export type CreateHsnCodeMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an HSN/SAC code (admin only)
 */
export const useCreateHsnCode = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHsnCode>>,
    TError,
    { data: BodyType<CreateHsnCodeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createHsnCode>>,
  TError,
  { data: BodyType<CreateHsnCodeBody> },
  TContext
> => {
  return useMutation(getCreateHsnCodeMutationOptions(options));
};

/**
 * @summary Update an HSN/SAC code (admin only)
 */
export const getUpdateHsnCodeUrl = (id: number) => {
  return `/api/inventory/hsn-codes/${id}`;
};

export const updateHsnCode = async (
  id: number,
  updateHsnCodeBody: UpdateHsnCodeBody,
  options?: RequestInit,
): Promise<InventoryHsnCode> => {
  return customFetch<InventoryHsnCode>(getUpdateHsnCodeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateHsnCodeBody),
  });
};

export const getUpdateHsnCodeMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHsnCode>>,
    TError,
    { id: number; data: BodyType<UpdateHsnCodeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHsnCode>>,
  TError,
  { id: number; data: BodyType<UpdateHsnCodeBody> },
  TContext
> => {
  const mutationKey = ["updateHsnCode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHsnCode>>,
    { id: number; data: BodyType<UpdateHsnCodeBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateHsnCode(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHsnCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHsnCode>>
>;
export type UpdateHsnCodeMutationBody = BodyType<UpdateHsnCodeBody>;
export type UpdateHsnCodeMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update an HSN/SAC code (admin only)
 */
export const useUpdateHsnCode = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHsnCode>>,
    TError,
    { id: number; data: BodyType<UpdateHsnCodeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateHsnCode>>,
  TError,
  { id: number; data: BodyType<UpdateHsnCodeBody> },
  TContext
> => {
  return useMutation(getUpdateHsnCodeMutationOptions(options));
};

/**
 * @summary Delete an HSN/SAC code (admin only)
 */
export const getDeleteHsnCodeUrl = (id: number) => {
  return `/api/inventory/hsn-codes/${id}`;
};

export const deleteHsnCode = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteHsnCodeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteHsnCodeMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHsnCode>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteHsnCode>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteHsnCode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteHsnCode>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteHsnCode(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteHsnCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteHsnCode>>
>;

export type DeleteHsnCodeMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete an HSN/SAC code (admin only)
 */
export const useDeleteHsnCode = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHsnCode>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteHsnCode>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteHsnCodeMutationOptions(options));
};

/**
 * @summary List stock-in charge types
 */
export const getListChargeTypesUrl = (params?: ListChargeTypesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/charge-types?${stringifiedParams}`
    : `/api/inventory/charge-types`;
};

export const listChargeTypes = async (
  params?: ListChargeTypesParams,
  options?: RequestInit,
): Promise<InventoryChargeType[]> => {
  return customFetch<InventoryChargeType[]>(getListChargeTypesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListChargeTypesQueryKey = (params?: ListChargeTypesParams) => {
  return [`/api/inventory/charge-types`, ...(params ? [params] : [])] as const;
};

export const getListChargeTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listChargeTypes>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListChargeTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listChargeTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListChargeTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listChargeTypes>>> = ({
    signal,
  }) => listChargeTypes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listChargeTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListChargeTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listChargeTypes>>
>;
export type ListChargeTypesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List stock-in charge types
 */

export function useListChargeTypes<
  TData = Awaited<ReturnType<typeof listChargeTypes>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListChargeTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listChargeTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListChargeTypesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a charge type (admin only)
 */
export const getCreateChargeTypeUrl = () => {
  return `/api/inventory/charge-types`;
};

export const createChargeType = async (
  createChargeTypeBody: CreateChargeTypeBody,
  options?: RequestInit,
): Promise<InventoryChargeType> => {
  return customFetch<InventoryChargeType>(getCreateChargeTypeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createChargeTypeBody),
  });
};

export const getCreateChargeTypeMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChargeType>>,
    TError,
    { data: BodyType<CreateChargeTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChargeType>>,
  TError,
  { data: BodyType<CreateChargeTypeBody> },
  TContext
> => {
  const mutationKey = ["createChargeType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChargeType>>,
    { data: BodyType<CreateChargeTypeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createChargeType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChargeTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createChargeType>>
>;
export type CreateChargeTypeMutationBody = BodyType<CreateChargeTypeBody>;
export type CreateChargeTypeMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create a charge type (admin only)
 */
export const useCreateChargeType = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChargeType>>,
    TError,
    { data: BodyType<CreateChargeTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createChargeType>>,
  TError,
  { data: BodyType<CreateChargeTypeBody> },
  TContext
> => {
  return useMutation(getCreateChargeTypeMutationOptions(options));
};

/**
 * @summary Update a charge type (admin only)
 */
export const getUpdateChargeTypeUrl = (id: number) => {
  return `/api/inventory/charge-types/${id}`;
};

export const updateChargeType = async (
  id: number,
  updateChargeTypeBody: UpdateChargeTypeBody,
  options?: RequestInit,
): Promise<InventoryChargeType> => {
  return customFetch<InventoryChargeType>(getUpdateChargeTypeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateChargeTypeBody),
  });
};

export const getUpdateChargeTypeMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChargeType>>,
    TError,
    { id: number; data: BodyType<UpdateChargeTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChargeType>>,
  TError,
  { id: number; data: BodyType<UpdateChargeTypeBody> },
  TContext
> => {
  const mutationKey = ["updateChargeType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChargeType>>,
    { id: number; data: BodyType<UpdateChargeTypeBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateChargeType(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChargeTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChargeType>>
>;
export type UpdateChargeTypeMutationBody = BodyType<UpdateChargeTypeBody>;
export type UpdateChargeTypeMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update a charge type (admin only)
 */
export const useUpdateChargeType = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChargeType>>,
    TError,
    { id: number; data: BodyType<UpdateChargeTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateChargeType>>,
  TError,
  { id: number; data: BodyType<UpdateChargeTypeBody> },
  TContext
> => {
  return useMutation(getUpdateChargeTypeMutationOptions(options));
};

/**
 * @summary Delete a charge type (admin only)
 */
export const getDeleteChargeTypeUrl = (id: number) => {
  return `/api/inventory/charge-types/${id}`;
};

export const deleteChargeType = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteChargeTypeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteChargeTypeMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChargeType>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteChargeType>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteChargeType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteChargeType>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteChargeType(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteChargeTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteChargeType>>
>;

export type DeleteChargeTypeMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a charge type (admin only)
 */
export const useDeleteChargeType = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChargeType>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteChargeType>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteChargeTypeMutationOptions(options));
};

/**
 * @summary List recurring expense templates
 */
export const getListExpenseTemplatesUrl = (
  params?: ListExpenseTemplatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/expenses/templates?${stringifiedParams}`
    : `/api/expenses/templates`;
};

export const listExpenseTemplates = async (
  params?: ListExpenseTemplatesParams,
  options?: RequestInit,
): Promise<ExpenseTemplate[]> => {
  return customFetch<ExpenseTemplate[]>(getListExpenseTemplatesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListExpenseTemplatesQueryKey = (
  params?: ListExpenseTemplatesParams,
) => {
  return [`/api/expenses/templates`, ...(params ? [params] : [])] as const;
};

export const getListExpenseTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listExpenseTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListExpenseTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listExpenseTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListExpenseTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExpenseTemplates>>
  > = ({ signal }) =>
    listExpenseTemplates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpenseTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListExpenseTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExpenseTemplates>>
>;
export type ListExpenseTemplatesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List recurring expense templates
 */

export function useListExpenseTemplates<
  TData = Awaited<ReturnType<typeof listExpenseTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListExpenseTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listExpenseTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListExpenseTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a recurring expense template
 */
export const getCreateExpenseTemplateUrl = () => {
  return `/api/expenses/templates`;
};

export const createExpenseTemplate = async (
  createExpenseTemplateBody: CreateExpenseTemplateBody,
  options?: RequestInit,
): Promise<ExpenseTemplate> => {
  return customFetch<ExpenseTemplate>(getCreateExpenseTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createExpenseTemplateBody),
  });
};

export const getCreateExpenseTemplateMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExpenseTemplate>>,
    TError,
    { data: BodyType<CreateExpenseTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createExpenseTemplate>>,
  TError,
  { data: BodyType<CreateExpenseTemplateBody> },
  TContext
> => {
  const mutationKey = ["createExpenseTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createExpenseTemplate>>,
    { data: BodyType<CreateExpenseTemplateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createExpenseTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExpenseTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createExpenseTemplate>>
>;
export type CreateExpenseTemplateMutationBody =
  BodyType<CreateExpenseTemplateBody>;
export type CreateExpenseTemplateMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create a recurring expense template
 */
export const useCreateExpenseTemplate = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExpenseTemplate>>,
    TError,
    { data: BodyType<CreateExpenseTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createExpenseTemplate>>,
  TError,
  { data: BodyType<CreateExpenseTemplateBody> },
  TContext
> => {
  return useMutation(getCreateExpenseTemplateMutationOptions(options));
};

/**
 * @summary Update an expense template
 */
export const getUpdateExpenseTemplateUrl = (id: number) => {
  return `/api/expenses/templates/${id}`;
};

export const updateExpenseTemplate = async (
  id: number,
  updateExpenseTemplateBody: UpdateExpenseTemplateBody,
  options?: RequestInit,
): Promise<ExpenseTemplate> => {
  return customFetch<ExpenseTemplate>(getUpdateExpenseTemplateUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateExpenseTemplateBody),
  });
};

export const getUpdateExpenseTemplateMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpenseTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateExpenseTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExpenseTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateExpenseTemplateBody> },
  TContext
> => {
  const mutationKey = ["updateExpenseTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExpenseTemplate>>,
    { id: number; data: BodyType<UpdateExpenseTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateExpenseTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExpenseTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExpenseTemplate>>
>;
export type UpdateExpenseTemplateMutationBody =
  BodyType<UpdateExpenseTemplateBody>;
export type UpdateExpenseTemplateMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Update an expense template
 */
export const useUpdateExpenseTemplate = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpenseTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateExpenseTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateExpenseTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateExpenseTemplateBody> },
  TContext
> => {
  return useMutation(getUpdateExpenseTemplateMutationOptions(options));
};

/**
 * @summary Delete an expense template (and its entries)
 */
export const getDeleteExpenseTemplateUrl = (id: number) => {
  return `/api/expenses/templates/${id}`;
};

export const deleteExpenseTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteExpenseTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteExpenseTemplateMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExpenseTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteExpenseTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteExpenseTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteExpenseTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteExpenseTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteExpenseTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteExpenseTemplate>>
>;

export type DeleteExpenseTemplateMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete an expense template (and its entries)
 */
export const useDeleteExpenseTemplate = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExpenseTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteExpenseTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteExpenseTemplateMutationOptions(options));
};

/**
 * @summary Generate any missing period dues for active templates (up to today)
 */
export const getGenerateExpenseDuesUrl = () => {
  return `/api/expenses/generate-dues`;
};

export const generateExpenseDues = async (
  options?: RequestInit,
): Promise<GenerateExpenseDues200> => {
  return customFetch<GenerateExpenseDues200>(getGenerateExpenseDuesUrl(), {
    ...options,
    method: "POST",
  });
};

export const getGenerateExpenseDuesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateExpenseDues>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateExpenseDues>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["generateExpenseDues"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateExpenseDues>>,
    void
  > = () => {
    return generateExpenseDues(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateExpenseDuesMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateExpenseDues>>
>;

export type GenerateExpenseDuesMutationError = ErrorType<unknown>;

/**
 * @summary Generate any missing period dues for active templates (up to today)
 */
export const useGenerateExpenseDues = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateExpenseDues>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateExpenseDues>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getGenerateExpenseDuesMutationOptions(options));
};

/**
 * @summary List expense due/paid entries
 */
export const getListExpenseEntriesUrl = (params?: ListExpenseEntriesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/expenses/entries?${stringifiedParams}`
    : `/api/expenses/entries`;
};

export const listExpenseEntries = async (
  params?: ListExpenseEntriesParams,
  options?: RequestInit,
): Promise<ExpenseEntry[]> => {
  return customFetch<ExpenseEntry[]>(getListExpenseEntriesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListExpenseEntriesQueryKey = (
  params?: ListExpenseEntriesParams,
) => {
  return [`/api/expenses/entries`, ...(params ? [params] : [])] as const;
};

export const getListExpenseEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listExpenseEntries>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListExpenseEntriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listExpenseEntries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListExpenseEntriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExpenseEntries>>
  > = ({ signal }) => listExpenseEntries(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpenseEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListExpenseEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExpenseEntries>>
>;
export type ListExpenseEntriesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List expense due/paid entries
 */

export function useListExpenseEntries<
  TData = Awaited<ReturnType<typeof listExpenseEntries>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListExpenseEntriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listExpenseEntries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListExpenseEntriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an entry (enter amount, mark paid with payment details)
 */
export const getUpdateExpenseEntryUrl = (id: number) => {
  return `/api/expenses/entries/${id}`;
};

export const updateExpenseEntry = async (
  id: number,
  updateExpenseEntryBody: UpdateExpenseEntryBody,
  options?: RequestInit,
): Promise<ExpenseEntry> => {
  return customFetch<ExpenseEntry>(getUpdateExpenseEntryUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateExpenseEntryBody),
  });
};

export const getUpdateExpenseEntryMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpenseEntry>>,
    TError,
    { id: number; data: BodyType<UpdateExpenseEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExpenseEntry>>,
  TError,
  { id: number; data: BodyType<UpdateExpenseEntryBody> },
  TContext
> => {
  const mutationKey = ["updateExpenseEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExpenseEntry>>,
    { id: number; data: BodyType<UpdateExpenseEntryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateExpenseEntry(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExpenseEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExpenseEntry>>
>;
export type UpdateExpenseEntryMutationBody = BodyType<UpdateExpenseEntryBody>;
export type UpdateExpenseEntryMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Update an entry (enter amount, mark paid with payment details)
 */
export const useUpdateExpenseEntry = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpenseEntry>>,
    TError,
    { id: number; data: BodyType<UpdateExpenseEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateExpenseEntry>>,
  TError,
  { id: number; data: BodyType<UpdateExpenseEntryBody> },
  TContext
> => {
  return useMutation(getUpdateExpenseEntryMutationOptions(options));
};

/**
 * @summary List inventory attribute values
 */
export const getListAttributeValuesUrl = (
  params?: ListAttributeValuesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/attribute-values?${stringifiedParams}`
    : `/api/inventory/attribute-values`;
};

export const listAttributeValues = async (
  params?: ListAttributeValuesParams,
  options?: RequestInit,
): Promise<InventoryAttributeValue[]> => {
  return customFetch<InventoryAttributeValue[]>(
    getListAttributeValuesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAttributeValuesQueryKey = (
  params?: ListAttributeValuesParams,
) => {
  return [
    `/api/inventory/attribute-values`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAttributeValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAttributeValues>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAttributeValuesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttributeValues>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAttributeValuesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAttributeValues>>
  > = ({ signal }) =>
    listAttributeValues(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAttributeValues>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAttributeValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAttributeValues>>
>;
export type ListAttributeValuesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List inventory attribute values
 */

export function useListAttributeValues<
  TData = Awaited<ReturnType<typeof listAttributeValues>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAttributeValuesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttributeValues>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAttributeValuesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an attribute value (admin only)
 */
export const getCreateAttributeValueUrl = () => {
  return `/api/inventory/attribute-values`;
};

export const createAttributeValue = async (
  createAttributeValueBody: CreateAttributeValueBody,
  options?: RequestInit,
): Promise<InventoryAttributeValue> => {
  return customFetch<InventoryAttributeValue>(getCreateAttributeValueUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAttributeValueBody),
  });
};

export const getCreateAttributeValueMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttributeValue>>,
    TError,
    { data: BodyType<CreateAttributeValueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAttributeValue>>,
  TError,
  { data: BodyType<CreateAttributeValueBody> },
  TContext
> => {
  const mutationKey = ["createAttributeValue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAttributeValue>>,
    { data: BodyType<CreateAttributeValueBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAttributeValue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAttributeValueMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAttributeValue>>
>;
export type CreateAttributeValueMutationBody =
  BodyType<CreateAttributeValueBody>;
export type CreateAttributeValueMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an attribute value (admin only)
 */
export const useCreateAttributeValue = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttributeValue>>,
    TError,
    { data: BodyType<CreateAttributeValueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAttributeValue>>,
  TError,
  { data: BodyType<CreateAttributeValueBody> },
  TContext
> => {
  return useMutation(getCreateAttributeValueMutationOptions(options));
};

/**
 * @summary Update an attribute value (admin only)
 */
export const getUpdateAttributeValueUrl = (id: number) => {
  return `/api/inventory/attribute-values/${id}`;
};

export const updateAttributeValue = async (
  id: number,
  updateAttributeValueBody: UpdateAttributeValueBody,
  options?: RequestInit,
): Promise<InventoryAttributeValue> => {
  return customFetch<InventoryAttributeValue>(getUpdateAttributeValueUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAttributeValueBody),
  });
};

export const getUpdateAttributeValueMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttributeValue>>,
    TError,
    { id: number; data: BodyType<UpdateAttributeValueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAttributeValue>>,
  TError,
  { id: number; data: BodyType<UpdateAttributeValueBody> },
  TContext
> => {
  const mutationKey = ["updateAttributeValue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAttributeValue>>,
    { id: number; data: BodyType<UpdateAttributeValueBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAttributeValue(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAttributeValueMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAttributeValue>>
>;
export type UpdateAttributeValueMutationBody =
  BodyType<UpdateAttributeValueBody>;
export type UpdateAttributeValueMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update an attribute value (admin only)
 */
export const useUpdateAttributeValue = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttributeValue>>,
    TError,
    { id: number; data: BodyType<UpdateAttributeValueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAttributeValue>>,
  TError,
  { id: number; data: BodyType<UpdateAttributeValueBody> },
  TContext
> => {
  return useMutation(getUpdateAttributeValueMutationOptions(options));
};

/**
 * @summary List variants for an inventory item
 */
export const getListItemVariantsUrl = (
  itemId: number,
  params?: ListItemVariantsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/items/${itemId}/variants?${stringifiedParams}`
    : `/api/inventory/items/${itemId}/variants`;
};

export const listItemVariants = async (
  itemId: number,
  params?: ListItemVariantsParams,
  options?: RequestInit,
): Promise<InventoryItemVariant[]> => {
  return customFetch<InventoryItemVariant[]>(
    getListItemVariantsUrl(itemId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListItemVariantsQueryKey = (
  itemId: number,
  params?: ListItemVariantsParams,
) => {
  return [
    `/api/inventory/items/${itemId}/variants`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListItemVariantsQueryOptions = <
  TData = Awaited<ReturnType<typeof listItemVariants>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  itemId: number,
  params?: ListItemVariantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listItemVariants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListItemVariantsQueryKey(itemId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listItemVariants>>
  > = ({ signal }) =>
    listItemVariants(itemId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!itemId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listItemVariants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListItemVariantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listItemVariants>>
>;
export type ListItemVariantsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List variants for an inventory item
 */

export function useListItemVariants<
  TData = Awaited<ReturnType<typeof listItemVariants>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  itemId: number,
  params?: ListItemVariantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listItemVariants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListItemVariantsQueryOptions(itemId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a variant for an inventory item (admin only)
 */
export const getCreateItemVariantUrl = (itemId: number) => {
  return `/api/inventory/items/${itemId}/variants`;
};

export const createItemVariant = async (
  itemId: number,
  createItemVariantBody: CreateItemVariantBody,
  options?: RequestInit,
): Promise<InventoryItemVariant> => {
  return customFetch<InventoryItemVariant>(getCreateItemVariantUrl(itemId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createItemVariantBody),
  });
};

export const getCreateItemVariantMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createItemVariant>>,
    TError,
    { itemId: number; data: BodyType<CreateItemVariantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createItemVariant>>,
  TError,
  { itemId: number; data: BodyType<CreateItemVariantBody> },
  TContext
> => {
  const mutationKey = ["createItemVariant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createItemVariant>>,
    { itemId: number; data: BodyType<CreateItemVariantBody> }
  > = (props) => {
    const { itemId, data } = props ?? {};

    return createItemVariant(itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateItemVariantMutationResult = NonNullable<
  Awaited<ReturnType<typeof createItemVariant>>
>;
export type CreateItemVariantMutationBody = BodyType<CreateItemVariantBody>;
export type CreateItemVariantMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Create a variant for an inventory item (admin only)
 */
export const useCreateItemVariant = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createItemVariant>>,
    TError,
    { itemId: number; data: BodyType<CreateItemVariantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createItemVariant>>,
  TError,
  { itemId: number; data: BodyType<CreateItemVariantBody> },
  TContext
> => {
  return useMutation(getCreateItemVariantMutationOptions(options));
};

/**
 * @summary Update a variant (admin only)
 */
export const getUpdateItemVariantUrl = (itemId: number, variantId: number) => {
  return `/api/inventory/items/${itemId}/variants/${variantId}`;
};

export const updateItemVariant = async (
  itemId: number,
  variantId: number,
  updateItemVariantBody: UpdateItemVariantBody,
  options?: RequestInit,
): Promise<InventoryItemVariant> => {
  return customFetch<InventoryItemVariant>(
    getUpdateItemVariantUrl(itemId, variantId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateItemVariantBody),
    },
  );
};

export const getUpdateItemVariantMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateItemVariant>>,
    TError,
    {
      itemId: number;
      variantId: number;
      data: BodyType<UpdateItemVariantBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateItemVariant>>,
  TError,
  { itemId: number; variantId: number; data: BodyType<UpdateItemVariantBody> },
  TContext
> => {
  const mutationKey = ["updateItemVariant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateItemVariant>>,
    { itemId: number; variantId: number; data: BodyType<UpdateItemVariantBody> }
  > = (props) => {
    const { itemId, variantId, data } = props ?? {};

    return updateItemVariant(itemId, variantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateItemVariantMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateItemVariant>>
>;
export type UpdateItemVariantMutationBody = BodyType<UpdateItemVariantBody>;
export type UpdateItemVariantMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update a variant (admin only)
 */
export const useUpdateItemVariant = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateItemVariant>>,
    TError,
    {
      itemId: number;
      variantId: number;
      data: BodyType<UpdateItemVariantBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateItemVariant>>,
  TError,
  { itemId: number; variantId: number; data: BodyType<UpdateItemVariantBody> },
  TContext
> => {
  return useMutation(getUpdateItemVariantMutationOptions(options));
};

/**
 * @summary Delete a variant (admin only)
 */
export const getDeleteItemVariantUrl = (itemId: number, variantId: number) => {
  return `/api/inventory/items/${itemId}/variants/${variantId}`;
};

export const deleteItemVariant = async (
  itemId: number,
  variantId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteItemVariantUrl(itemId, variantId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteItemVariantMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteItemVariant>>,
    TError,
    { itemId: number; variantId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteItemVariant>>,
  TError,
  { itemId: number; variantId: number },
  TContext
> => {
  const mutationKey = ["deleteItemVariant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteItemVariant>>,
    { itemId: number; variantId: number }
  > = (props) => {
    const { itemId, variantId } = props ?? {};

    return deleteItemVariant(itemId, variantId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteItemVariantMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteItemVariant>>
>;

export type DeleteItemVariantMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a variant (admin only)
 */
export const useDeleteItemVariant = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteItemVariant>>,
    TError,
    { itemId: number; variantId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteItemVariant>>,
  TError,
  { itemId: number; variantId: number },
  TContext
> => {
  return useMutation(getDeleteItemVariantMutationOptions(options));
};

/**
 * @summary List recipe components for an inventory item
 */
export const getListItemRecipesUrl = (itemId: number) => {
  return `/api/inventory/items/${itemId}/recipes`;
};

export const listItemRecipes = async (
  itemId: number,
  options?: RequestInit,
): Promise<InventoryItemRecipe[]> => {
  return customFetch<InventoryItemRecipe[]>(getListItemRecipesUrl(itemId), {
    ...options,
    method: "GET",
  });
};

export const getListItemRecipesQueryKey = (itemId: number) => {
  return [`/api/inventory/items/${itemId}/recipes`] as const;
};

export const getListItemRecipesQueryOptions = <
  TData = Awaited<ReturnType<typeof listItemRecipes>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  itemId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listItemRecipes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListItemRecipesQueryKey(itemId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listItemRecipes>>> = ({
    signal,
  }) => listItemRecipes(itemId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!itemId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listItemRecipes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListItemRecipesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listItemRecipes>>
>;
export type ListItemRecipesQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List recipe components for an inventory item
 */

export function useListItemRecipes<
  TData = Awaited<ReturnType<typeof listItemRecipes>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  itemId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listItemRecipes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListItemRecipesQueryOptions(itemId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a recipe component to an inventory item (admin only)
 */
export const getCreateItemRecipeUrl = (itemId: number) => {
  return `/api/inventory/items/${itemId}/recipes`;
};

export const createItemRecipe = async (
  itemId: number,
  createItemRecipeBody: CreateItemRecipeBody,
  options?: RequestInit,
): Promise<InventoryItemRecipe> => {
  return customFetch<InventoryItemRecipe>(getCreateItemRecipeUrl(itemId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createItemRecipeBody),
  });
};

export const getCreateItemRecipeMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createItemRecipe>>,
    TError,
    { itemId: number; data: BodyType<CreateItemRecipeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createItemRecipe>>,
  TError,
  { itemId: number; data: BodyType<CreateItemRecipeBody> },
  TContext
> => {
  const mutationKey = ["createItemRecipe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createItemRecipe>>,
    { itemId: number; data: BodyType<CreateItemRecipeBody> }
  > = (props) => {
    const { itemId, data } = props ?? {};

    return createItemRecipe(itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateItemRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createItemRecipe>>
>;
export type CreateItemRecipeMutationBody = BodyType<CreateItemRecipeBody>;
export type CreateItemRecipeMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Add a recipe component to an inventory item (admin only)
 */
export const useCreateItemRecipe = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createItemRecipe>>,
    TError,
    { itemId: number; data: BodyType<CreateItemRecipeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createItemRecipe>>,
  TError,
  { itemId: number; data: BodyType<CreateItemRecipeBody> },
  TContext
> => {
  return useMutation(getCreateItemRecipeMutationOptions(options));
};

/**
 * @summary Update a recipe component (admin only)
 */
export const getUpdateItemRecipeUrl = (itemId: number, recipeId: number) => {
  return `/api/inventory/items/${itemId}/recipes/${recipeId}`;
};

export const updateItemRecipe = async (
  itemId: number,
  recipeId: number,
  updateItemRecipeBody: UpdateItemRecipeBody,
  options?: RequestInit,
): Promise<InventoryItemRecipe> => {
  return customFetch<InventoryItemRecipe>(
    getUpdateItemRecipeUrl(itemId, recipeId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateItemRecipeBody),
    },
  );
};

export const getUpdateItemRecipeMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateItemRecipe>>,
    TError,
    { itemId: number; recipeId: number; data: BodyType<UpdateItemRecipeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateItemRecipe>>,
  TError,
  { itemId: number; recipeId: number; data: BodyType<UpdateItemRecipeBody> },
  TContext
> => {
  const mutationKey = ["updateItemRecipe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateItemRecipe>>,
    { itemId: number; recipeId: number; data: BodyType<UpdateItemRecipeBody> }
  > = (props) => {
    const { itemId, recipeId, data } = props ?? {};

    return updateItemRecipe(itemId, recipeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateItemRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateItemRecipe>>
>;
export type UpdateItemRecipeMutationBody = BodyType<UpdateItemRecipeBody>;
export type UpdateItemRecipeMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update a recipe component (admin only)
 */
export const useUpdateItemRecipe = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateItemRecipe>>,
    TError,
    { itemId: number; recipeId: number; data: BodyType<UpdateItemRecipeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateItemRecipe>>,
  TError,
  { itemId: number; recipeId: number; data: BodyType<UpdateItemRecipeBody> },
  TContext
> => {
  return useMutation(getUpdateItemRecipeMutationOptions(options));
};

/**
 * @summary Delete a recipe component (admin only)
 */
export const getDeleteItemRecipeUrl = (itemId: number, recipeId: number) => {
  return `/api/inventory/items/${itemId}/recipes/${recipeId}`;
};

export const deleteItemRecipe = async (
  itemId: number,
  recipeId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteItemRecipeUrl(itemId, recipeId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteItemRecipeMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteItemRecipe>>,
    TError,
    { itemId: number; recipeId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteItemRecipe>>,
  TError,
  { itemId: number; recipeId: number },
  TContext
> => {
  const mutationKey = ["deleteItemRecipe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteItemRecipe>>,
    { itemId: number; recipeId: number }
  > = (props) => {
    const { itemId, recipeId } = props ?? {};

    return deleteItemRecipe(itemId, recipeId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteItemRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteItemRecipe>>
>;

export type DeleteItemRecipeMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a recipe component (admin only)
 */
export const useDeleteItemRecipe = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteItemRecipe>>,
    TError,
    { itemId: number; recipeId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteItemRecipe>>,
  TError,
  { itemId: number; recipeId: number },
  TContext
> => {
  return useMutation(getDeleteItemRecipeMutationOptions(options));
};

/**
 * @summary List modifiers for an inventory item (recipe items only)
 */
export const getListItemModifiersUrl = (
  itemId: number,
  params?: ListItemModifiersParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/items/${itemId}/modifiers?${stringifiedParams}`
    : `/api/inventory/items/${itemId}/modifiers`;
};

export const listItemModifiers = async (
  itemId: number,
  params?: ListItemModifiersParams,
  options?: RequestInit,
): Promise<InventoryRecipeModifier[]> => {
  return customFetch<InventoryRecipeModifier[]>(
    getListItemModifiersUrl(itemId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListItemModifiersQueryKey = (
  itemId: number,
  params?: ListItemModifiersParams,
) => {
  return [
    `/api/inventory/items/${itemId}/modifiers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListItemModifiersQueryOptions = <
  TData = Awaited<ReturnType<typeof listItemModifiers>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  itemId: number,
  params?: ListItemModifiersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listItemModifiers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListItemModifiersQueryKey(itemId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listItemModifiers>>
  > = ({ signal }) =>
    listItemModifiers(itemId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!itemId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listItemModifiers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListItemModifiersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listItemModifiers>>
>;
export type ListItemModifiersQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List modifiers for an inventory item (recipe items only)
 */

export function useListItemModifiers<
  TData = Awaited<ReturnType<typeof listItemModifiers>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  itemId: number,
  params?: ListItemModifiersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listItemModifiers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListItemModifiersQueryOptions(
    itemId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a modifier to a recipe item (admin only)
 */
export const getCreateItemModifierUrl = (itemId: number) => {
  return `/api/inventory/items/${itemId}/modifiers`;
};

export const createItemModifier = async (
  itemId: number,
  createItemModifierBody: CreateItemModifierBody,
  options?: RequestInit,
): Promise<InventoryRecipeModifier> => {
  return customFetch<InventoryRecipeModifier>(
    getCreateItemModifierUrl(itemId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createItemModifierBody),
    },
  );
};

export const getCreateItemModifierMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createItemModifier>>,
    TError,
    { itemId: number; data: BodyType<CreateItemModifierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createItemModifier>>,
  TError,
  { itemId: number; data: BodyType<CreateItemModifierBody> },
  TContext
> => {
  const mutationKey = ["createItemModifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createItemModifier>>,
    { itemId: number; data: BodyType<CreateItemModifierBody> }
  > = (props) => {
    const { itemId, data } = props ?? {};

    return createItemModifier(itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateItemModifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof createItemModifier>>
>;
export type CreateItemModifierMutationBody = BodyType<CreateItemModifierBody>;
export type CreateItemModifierMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Add a modifier to a recipe item (admin only)
 */
export const useCreateItemModifier = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createItemModifier>>,
    TError,
    { itemId: number; data: BodyType<CreateItemModifierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createItemModifier>>,
  TError,
  { itemId: number; data: BodyType<CreateItemModifierBody> },
  TContext
> => {
  return useMutation(getCreateItemModifierMutationOptions(options));
};

/**
 * @summary Update a modifier (admin only)
 */
export const getUpdateItemModifierUrl = (
  itemId: number,
  modifierId: number,
) => {
  return `/api/inventory/items/${itemId}/modifiers/${modifierId}`;
};

export const updateItemModifier = async (
  itemId: number,
  modifierId: number,
  updateItemModifierBody: UpdateItemModifierBody,
  options?: RequestInit,
): Promise<InventoryRecipeModifier> => {
  return customFetch<InventoryRecipeModifier>(
    getUpdateItemModifierUrl(itemId, modifierId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateItemModifierBody),
    },
  );
};

export const getUpdateItemModifierMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateItemModifier>>,
    TError,
    {
      itemId: number;
      modifierId: number;
      data: BodyType<UpdateItemModifierBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateItemModifier>>,
  TError,
  {
    itemId: number;
    modifierId: number;
    data: BodyType<UpdateItemModifierBody>;
  },
  TContext
> => {
  const mutationKey = ["updateItemModifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateItemModifier>>,
    {
      itemId: number;
      modifierId: number;
      data: BodyType<UpdateItemModifierBody>;
    }
  > = (props) => {
    const { itemId, modifierId, data } = props ?? {};

    return updateItemModifier(itemId, modifierId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateItemModifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateItemModifier>>
>;
export type UpdateItemModifierMutationBody = BodyType<UpdateItemModifierBody>;
export type UpdateItemModifierMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update a modifier (admin only)
 */
export const useUpdateItemModifier = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateItemModifier>>,
    TError,
    {
      itemId: number;
      modifierId: number;
      data: BodyType<UpdateItemModifierBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateItemModifier>>,
  TError,
  {
    itemId: number;
    modifierId: number;
    data: BodyType<UpdateItemModifierBody>;
  },
  TContext
> => {
  return useMutation(getUpdateItemModifierMutationOptions(options));
};

/**
 * @summary Delete a modifier (admin only)
 */
export const getDeleteItemModifierUrl = (
  itemId: number,
  modifierId: number,
) => {
  return `/api/inventory/items/${itemId}/modifiers/${modifierId}`;
};

export const deleteItemModifier = async (
  itemId: number,
  modifierId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteItemModifierUrl(itemId, modifierId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteItemModifierMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteItemModifier>>,
    TError,
    { itemId: number; modifierId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteItemModifier>>,
  TError,
  { itemId: number; modifierId: number },
  TContext
> => {
  const mutationKey = ["deleteItemModifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteItemModifier>>,
    { itemId: number; modifierId: number }
  > = (props) => {
    const { itemId, modifierId } = props ?? {};

    return deleteItemModifier(itemId, modifierId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteItemModifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteItemModifier>>
>;

export type DeleteItemModifierMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a modifier (admin only)
 */
export const useDeleteItemModifier = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteItemModifier>>,
    TError,
    { itemId: number; modifierId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteItemModifier>>,
  TError,
  { itemId: number; modifierId: number },
  TContext
> => {
  return useMutation(getDeleteItemModifierMutationOptions(options));
};

/**
 * @summary List vendor item pricing rows
 */
export const getListVendorItemPricingUrl = (
  params?: ListVendorItemPricingParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/pricing?${stringifiedParams}`
    : `/api/inventory/pricing`;
};

export const listVendorItemPricing = async (
  params?: ListVendorItemPricingParams,
  options?: RequestInit,
): Promise<VendorItemPricing[]> => {
  return customFetch<VendorItemPricing[]>(getListVendorItemPricingUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListVendorItemPricingQueryKey = (
  params?: ListVendorItemPricingParams,
) => {
  return [`/api/inventory/pricing`, ...(params ? [params] : [])] as const;
};

export const getListVendorItemPricingQueryOptions = <
  TData = Awaited<ReturnType<typeof listVendorItemPricing>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListVendorItemPricingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorItemPricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVendorItemPricingQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVendorItemPricing>>
  > = ({ signal }) =>
    listVendorItemPricing(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVendorItemPricing>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVendorItemPricingQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVendorItemPricing>>
>;
export type ListVendorItemPricingQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List vendor item pricing rows
 */

export function useListVendorItemPricing<
  TData = Awaited<ReturnType<typeof listVendorItemPricing>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListVendorItemPricingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorItemPricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVendorItemPricingQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a vendor item pricing row (admin only)
 */
export const getCreateVendorItemPricingUrl = () => {
  return `/api/inventory/pricing`;
};

export const createVendorItemPricing = async (
  createVendorItemPricingBody: CreateVendorItemPricingBody,
  options?: RequestInit,
): Promise<VendorItemPricing> => {
  return customFetch<VendorItemPricing>(getCreateVendorItemPricingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createVendorItemPricingBody),
  });
};

export const getCreateVendorItemPricingMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorItemPricing>>,
    TError,
    { data: BodyType<CreateVendorItemPricingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVendorItemPricing>>,
  TError,
  { data: BodyType<CreateVendorItemPricingBody> },
  TContext
> => {
  const mutationKey = ["createVendorItemPricing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVendorItemPricing>>,
    { data: BodyType<CreateVendorItemPricingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createVendorItemPricing(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVendorItemPricingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVendorItemPricing>>
>;
export type CreateVendorItemPricingMutationBody =
  BodyType<CreateVendorItemPricingBody>;
export type CreateVendorItemPricingMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse
>;

/**
 * @summary Create a vendor item pricing row (admin only)
 */
export const useCreateVendorItemPricing = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorItemPricing>>,
    TError,
    { data: BodyType<CreateVendorItemPricingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVendorItemPricing>>,
  TError,
  { data: BodyType<CreateVendorItemPricingBody> },
  TContext
> => {
  return useMutation(getCreateVendorItemPricingMutationOptions(options));
};

/**
 * @summary Get a vendor item pricing row by ID
 */
export const getGetVendorItemPricingUrl = (id: number) => {
  return `/api/inventory/pricing/${id}`;
};

export const getVendorItemPricing = async (
  id: number,
  options?: RequestInit,
): Promise<VendorItemPricing> => {
  return customFetch<VendorItemPricing>(getGetVendorItemPricingUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVendorItemPricingQueryKey = (id: number) => {
  return [`/api/inventory/pricing/${id}`] as const;
};

export const getGetVendorItemPricingQueryOptions = <
  TData = Awaited<ReturnType<typeof getVendorItemPricing>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVendorItemPricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVendorItemPricingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVendorItemPricing>>
  > = ({ signal }) => getVendorItemPricing(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVendorItemPricing>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVendorItemPricingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVendorItemPricing>>
>;
export type GetVendorItemPricingQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get a vendor item pricing row by ID
 */

export function useGetVendorItemPricing<
  TData = Awaited<ReturnType<typeof getVendorItemPricing>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVendorItemPricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVendorItemPricingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a vendor item pricing row (admin only)
 */
export const getUpdateVendorItemPricingUrl = (id: number) => {
  return `/api/inventory/pricing/${id}`;
};

export const updateVendorItemPricing = async (
  id: number,
  updateVendorItemPricingBody: UpdateVendorItemPricingBody,
  options?: RequestInit,
): Promise<VendorItemPricing> => {
  return customFetch<VendorItemPricing>(getUpdateVendorItemPricingUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVendorItemPricingBody),
  });
};

export const getUpdateVendorItemPricingMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVendorItemPricing>>,
    TError,
    { id: number; data: BodyType<UpdateVendorItemPricingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVendorItemPricing>>,
  TError,
  { id: number; data: BodyType<UpdateVendorItemPricingBody> },
  TContext
> => {
  const mutationKey = ["updateVendorItemPricing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVendorItemPricing>>,
    { id: number; data: BodyType<UpdateVendorItemPricingBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVendorItemPricing(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVendorItemPricingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVendorItemPricing>>
>;
export type UpdateVendorItemPricingMutationBody =
  BodyType<UpdateVendorItemPricingBody>;
export type UpdateVendorItemPricingMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update a vendor item pricing row (admin only)
 */
export const useUpdateVendorItemPricing = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVendorItemPricing>>,
    TError,
    { id: number; data: BodyType<UpdateVendorItemPricingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVendorItemPricing>>,
  TError,
  { id: number; data: BodyType<UpdateVendorItemPricingBody> },
  TContext
> => {
  return useMutation(getUpdateVendorItemPricingMutationOptions(options));
};

/**
 * @summary Delete a vendor item pricing row (admin only)
 */
export const getDeleteVendorItemPricingUrl = (id: number) => {
  return `/api/inventory/pricing/${id}`;
};

export const deleteVendorItemPricing = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteVendorItemPricingUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteVendorItemPricingMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorItemPricing>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVendorItemPricing>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteVendorItemPricing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVendorItemPricing>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteVendorItemPricing(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVendorItemPricingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVendorItemPricing>>
>;

export type DeleteVendorItemPricingMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a vendor item pricing row (admin only)
 */
export const useDeleteVendorItemPricing = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorItemPricing>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVendorItemPricing>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteVendorItemPricingMutationOptions(options));
};

/**
 * @summary Read-only price history for an item (Phase 2.1 D-23)
 */
export const getListVendorItemPricingHistoryUrl = (
  params: ListVendorItemPricingHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/pricing/history?${stringifiedParams}`
    : `/api/inventory/pricing/history`;
};

export const listVendorItemPricingHistory = async (
  params: ListVendorItemPricingHistoryParams,
  options?: RequestInit,
): Promise<VendorItemPricingHistory[]> => {
  return customFetch<VendorItemPricingHistory[]>(
    getListVendorItemPricingHistoryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListVendorItemPricingHistoryQueryKey = (
  params?: ListVendorItemPricingHistoryParams,
) => {
  return [
    `/api/inventory/pricing/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListVendorItemPricingHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listVendorItemPricingHistory>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params: ListVendorItemPricingHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorItemPricingHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVendorItemPricingHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVendorItemPricingHistory>>
  > = ({ signal }) =>
    listVendorItemPricingHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVendorItemPricingHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVendorItemPricingHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVendorItemPricingHistory>>
>;
export type ListVendorItemPricingHistoryQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Read-only price history for an item (Phase 2.1 D-23)
 */

export function useListVendorItemPricingHistory<
  TData = Awaited<ReturnType<typeof listVendorItemPricingHistory>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params: ListVendorItemPricingHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorItemPricingHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVendorItemPricingHistoryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List inventory plans
 */
export const getListInventoryPlansUrl = (params?: ListInventoryPlansParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/plans?${stringifiedParams}`
    : `/api/inventory/plans`;
};

export const listInventoryPlans = async (
  params?: ListInventoryPlansParams,
  options?: RequestInit,
): Promise<InventoryPlan[]> => {
  return customFetch<InventoryPlan[]>(getListInventoryPlansUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInventoryPlansQueryKey = (
  params?: ListInventoryPlansParams,
) => {
  return [`/api/inventory/plans`, ...(params ? [params] : [])] as const;
};

export const getListInventoryPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryPlans>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryPlansParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryPlans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryPlansQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryPlans>>
  > = ({ signal }) => listInventoryPlans(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryPlans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryPlans>>
>;
export type ListInventoryPlansQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List inventory plans
 */

export function useListInventoryPlans<
  TData = Awaited<ReturnType<typeof listInventoryPlans>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryPlansParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryPlans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryPlansQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an inventory plan (admin only)
 */
export const getCreateInventoryPlanUrl = () => {
  return `/api/inventory/plans`;
};

export const createInventoryPlan = async (
  createInventoryPlanBody: CreateInventoryPlanBody,
  options?: RequestInit,
): Promise<InventoryPlan> => {
  return customFetch<InventoryPlan>(getCreateInventoryPlanUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInventoryPlanBody),
  });
};

export const getCreateInventoryPlanMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInventoryPlan>>,
    TError,
    { data: BodyType<CreateInventoryPlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInventoryPlan>>,
  TError,
  { data: BodyType<CreateInventoryPlanBody> },
  TContext
> => {
  const mutationKey = ["createInventoryPlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInventoryPlan>>,
    { data: BodyType<CreateInventoryPlanBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInventoryPlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInventoryPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInventoryPlan>>
>;
export type CreateInventoryPlanMutationBody = BodyType<CreateInventoryPlanBody>;
export type CreateInventoryPlanMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an inventory plan (admin only)
 */
export const useCreateInventoryPlan = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInventoryPlan>>,
    TError,
    { data: BodyType<CreateInventoryPlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInventoryPlan>>,
  TError,
  { data: BodyType<CreateInventoryPlanBody> },
  TContext
> => {
  return useMutation(getCreateInventoryPlanMutationOptions(options));
};

/**
 * @summary List period discount overrides for a plan
 */
export const getListInventoryPlanPeriodsUrl = (
  id: number,
  params?: ListInventoryPlanPeriodsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/plans/${id}/periods?${stringifiedParams}`
    : `/api/inventory/plans/${id}/periods`;
};

export const listInventoryPlanPeriods = async (
  id: number,
  params?: ListInventoryPlanPeriodsParams,
  options?: RequestInit,
): Promise<InventoryPlanPeriod[]> => {
  return customFetch<InventoryPlanPeriod[]>(
    getListInventoryPlanPeriodsUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInventoryPlanPeriodsQueryKey = (
  id: number,
  params?: ListInventoryPlanPeriodsParams,
) => {
  return [
    `/api/inventory/plans/${id}/periods`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListInventoryPlanPeriodsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryPlanPeriods>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  id: number,
  params?: ListInventoryPlanPeriodsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryPlanPeriods>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryPlanPeriodsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryPlanPeriods>>
  > = ({ signal }) =>
    listInventoryPlanPeriods(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryPlanPeriods>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryPlanPeriodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryPlanPeriods>>
>;
export type ListInventoryPlanPeriodsQueryError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary List period discount overrides for a plan
 */

export function useListInventoryPlanPeriods<
  TData = Awaited<ReturnType<typeof listInventoryPlanPeriods>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  id: number,
  params?: ListInventoryPlanPeriodsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryPlanPeriods>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryPlanPeriodsQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Phase 27 — Single-row matrix lookup for Convert Lead Sheet auto-query.
Returns the active matrix row matching (planId, periodValue, periodUnit, seats)
or 404 if no match.

 */
export const getLookupInventoryPlanPeriodUrl = (
  id: number,
  params: LookupInventoryPlanPeriodParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/plans/${id}/periods/lookup?${stringifiedParams}`
    : `/api/inventory/plans/${id}/periods/lookup`;
};

export const lookupInventoryPlanPeriod = async (
  id: number,
  params: LookupInventoryPlanPeriodParams,
  options?: RequestInit,
): Promise<InventoryPlanPeriod> => {
  return customFetch<InventoryPlanPeriod>(
    getLookupInventoryPlanPeriodUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getLookupInventoryPlanPeriodQueryKey = (
  id: number,
  params?: LookupInventoryPlanPeriodParams,
) => {
  return [
    `/api/inventory/plans/${id}/periods/lookup`,
    ...(params ? [params] : []),
  ] as const;
};

export const getLookupInventoryPlanPeriodQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupInventoryPlanPeriod>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  params: LookupInventoryPlanPeriodParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupInventoryPlanPeriod>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupInventoryPlanPeriodQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupInventoryPlanPeriod>>
  > = ({ signal }) =>
    lookupInventoryPlanPeriod(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupInventoryPlanPeriod>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LookupInventoryPlanPeriodQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupInventoryPlanPeriod>>
>;
export type LookupInventoryPlanPeriodQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Phase 27 — Single-row matrix lookup for Convert Lead Sheet auto-query.
Returns the active matrix row matching (planId, periodValue, periodUnit, seats)
or 404 if no match.

 */

export function useLookupInventoryPlanPeriod<
  TData = Awaited<ReturnType<typeof lookupInventoryPlanPeriod>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  params: LookupInventoryPlanPeriodParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupInventoryPlanPeriod>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLookupInventoryPlanPeriodQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Phase 27 — Soft-archive a single matrix row by primary key.
Disambiguates which row to archive when multiple Active rows share
the same (period_value, period_unit) but differ in seats.
The legacy DELETE /periods/{cycle} endpoint (Phase 26) stays for
backwards compatibility.

 */
export const getDeleteInventoryPlanPeriodByIdUrl = (
  id: number,
  periodRowId: number,
) => {
  return `/api/inventory/plans/${id}/periods/by-id/${periodRowId}`;
};

export const deleteInventoryPlanPeriodById = async (
  id: number,
  periodRowId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(
    getDeleteInventoryPlanPeriodByIdUrl(id, periodRowId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteInventoryPlanPeriodByIdMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryPlanPeriodById>>,
    TError,
    { id: number; periodRowId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInventoryPlanPeriodById>>,
  TError,
  { id: number; periodRowId: number },
  TContext
> => {
  const mutationKey = ["deleteInventoryPlanPeriodById"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInventoryPlanPeriodById>>,
    { id: number; periodRowId: number }
  > = (props) => {
    const { id, periodRowId } = props ?? {};

    return deleteInventoryPlanPeriodById(id, periodRowId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInventoryPlanPeriodByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInventoryPlanPeriodById>>
>;

export type DeleteInventoryPlanPeriodByIdMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Phase 27 — Soft-archive a single matrix row by primary key.
Disambiguates which row to archive when multiple Active rows share
the same (period_value, period_unit) but differ in seats.
The legacy DELETE /periods/{cycle} endpoint (Phase 26) stays for
backwards compatibility.

 */
export const useDeleteInventoryPlanPeriodById = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryPlanPeriodById>>,
    TError,
    { id: number; periodRowId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInventoryPlanPeriodById>>,
  TError,
  { id: number; periodRowId: number },
  TContext
> => {
  return useMutation(getDeleteInventoryPlanPeriodByIdMutationOptions(options));
};

/**
 * @summary Upsert a period discount override for a plan
 */
export const getUpsertInventoryPlanPeriodUrl = (id: number, cycle: string) => {
  return `/api/inventory/plans/${id}/periods/${cycle}`;
};

export const upsertInventoryPlanPeriod = async (
  id: number,
  cycle: string,
  createInventoryPlanPeriodBody: CreateInventoryPlanPeriodBody,
  options?: RequestInit,
): Promise<InventoryPlanPeriod> => {
  return customFetch<InventoryPlanPeriod>(
    getUpsertInventoryPlanPeriodUrl(id, cycle),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createInventoryPlanPeriodBody),
    },
  );
};

export const getUpsertInventoryPlanPeriodMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertInventoryPlanPeriod>>,
    TError,
    {
      id: number;
      cycle: string;
      data: BodyType<CreateInventoryPlanPeriodBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertInventoryPlanPeriod>>,
  TError,
  { id: number; cycle: string; data: BodyType<CreateInventoryPlanPeriodBody> },
  TContext
> => {
  const mutationKey = ["upsertInventoryPlanPeriod"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertInventoryPlanPeriod>>,
    { id: number; cycle: string; data: BodyType<CreateInventoryPlanPeriodBody> }
  > = (props) => {
    const { id, cycle, data } = props ?? {};

    return upsertInventoryPlanPeriod(id, cycle, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertInventoryPlanPeriodMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertInventoryPlanPeriod>>
>;
export type UpsertInventoryPlanPeriodMutationBody =
  BodyType<CreateInventoryPlanPeriodBody>;
export type UpsertInventoryPlanPeriodMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Upsert a period discount override for a plan
 */
export const useUpsertInventoryPlanPeriod = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertInventoryPlanPeriod>>,
    TError,
    {
      id: number;
      cycle: string;
      data: BodyType<CreateInventoryPlanPeriodBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertInventoryPlanPeriod>>,
  TError,
  { id: number; cycle: string; data: BodyType<CreateInventoryPlanPeriodBody> },
  TContext
> => {
  return useMutation(getUpsertInventoryPlanPeriodMutationOptions(options));
};

/**
 * @summary Delete a period discount override
 */
export const getDeleteInventoryPlanPeriodUrl = (id: number, cycle: string) => {
  return `/api/inventory/plans/${id}/periods/${cycle}`;
};

export const deleteInventoryPlanPeriod = async (
  id: number,
  cycle: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInventoryPlanPeriodUrl(id, cycle), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInventoryPlanPeriodMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryPlanPeriod>>,
    TError,
    { id: number; cycle: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInventoryPlanPeriod>>,
  TError,
  { id: number; cycle: string },
  TContext
> => {
  const mutationKey = ["deleteInventoryPlanPeriod"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInventoryPlanPeriod>>,
    { id: number; cycle: string }
  > = (props) => {
    const { id, cycle } = props ?? {};

    return deleteInventoryPlanPeriod(id, cycle, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInventoryPlanPeriodMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInventoryPlanPeriod>>
>;

export type DeleteInventoryPlanPeriodMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Delete a period discount override
 */
export const useDeleteInventoryPlanPeriod = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryPlanPeriod>>,
    TError,
    { id: number; cycle: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInventoryPlanPeriod>>,
  TError,
  { id: number; cycle: string },
  TContext
> => {
  return useMutation(getDeleteInventoryPlanPeriodMutationOptions(options));
};

/**
 * @summary List secondary access rules for a plan
 */
export const getListPlanSecondaryAccessUrl = (id: number) => {
  return `/api/inventory/plans/${id}/secondary-access`;
};

export const listPlanSecondaryAccess = async (
  id: number,
  options?: RequestInit,
): Promise<PlanSecondaryAccess[]> => {
  return customFetch<PlanSecondaryAccess[]>(getListPlanSecondaryAccessUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListPlanSecondaryAccessQueryKey = (id: number) => {
  return [`/api/inventory/plans/${id}/secondary-access`] as const;
};

export const getListPlanSecondaryAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof listPlanSecondaryAccess>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPlanSecondaryAccess>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPlanSecondaryAccessQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPlanSecondaryAccess>>
  > = ({ signal }) =>
    listPlanSecondaryAccess(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPlanSecondaryAccess>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPlanSecondaryAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPlanSecondaryAccess>>
>;
export type ListPlanSecondaryAccessQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List secondary access rules for a plan
 */

export function useListPlanSecondaryAccess<
  TData = Awaited<ReturnType<typeof listPlanSecondaryAccess>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPlanSecondaryAccess>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPlanSecondaryAccessQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * The catalog rate for the Sunday access add-on, one row per space type. A sold membership freezes its own snapshot, so editing a rate here never re-prices a live plan. Billing only - nothing here gates entry.
 * @summary Sunday access rates per space type
 */
export const getListSundayAccessRatesUrl = () => {
  return `/api/inventory/sunday-access-rates`;
};

export const listSundayAccessRates = async (
  options?: RequestInit,
): Promise<SundayAccessRate[]> => {
  return customFetch<SundayAccessRate[]>(getListSundayAccessRatesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSundayAccessRatesQueryKey = () => {
  return [`/api/inventory/sunday-access-rates`] as const;
};

export const getListSundayAccessRatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSundayAccessRates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSundayAccessRates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSundayAccessRatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSundayAccessRates>>
  > = ({ signal }) => listSundayAccessRates({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSundayAccessRates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSundayAccessRatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSundayAccessRates>>
>;
export type ListSundayAccessRatesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Sunday access rates per space type
 */

export function useListSundayAccessRates<
  TData = Awaited<ReturnType<typeof listSundayAccessRates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSundayAccessRates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSundayAccessRatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Set the Sunday access rate for a space type
 */
export const getUpsertSundayAccessRateUrl = (
  resourceType: "Private_Cabin" | "Workstation",
) => {
  return `/api/inventory/sunday-access-rates/${resourceType}`;
};

export const upsertSundayAccessRate = async (
  resourceType: "Private_Cabin" | "Workstation",
  upsertSundayAccessRateBody: UpsertSundayAccessRateBody,
  options?: RequestInit,
): Promise<SundayAccessRate> => {
  return customFetch<SundayAccessRate>(
    getUpsertSundayAccessRateUrl(resourceType),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(upsertSundayAccessRateBody),
    },
  );
};

export const getUpsertSundayAccessRateMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertSundayAccessRate>>,
    TError,
    {
      resourceType: "Private_Cabin" | "Workstation";
      data: BodyType<UpsertSundayAccessRateBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertSundayAccessRate>>,
  TError,
  {
    resourceType: "Private_Cabin" | "Workstation";
    data: BodyType<UpsertSundayAccessRateBody>;
  },
  TContext
> => {
  const mutationKey = ["upsertSundayAccessRate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertSundayAccessRate>>,
    {
      resourceType: "Private_Cabin" | "Workstation";
      data: BodyType<UpsertSundayAccessRateBody>;
    }
  > = (props) => {
    const { resourceType, data } = props ?? {};

    return upsertSundayAccessRate(resourceType, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertSundayAccessRateMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertSundayAccessRate>>
>;
export type UpsertSundayAccessRateMutationBody =
  BodyType<UpsertSundayAccessRateBody>;
export type UpsertSundayAccessRateMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Set the Sunday access rate for a space type
 */
export const useUpsertSundayAccessRate = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertSundayAccessRate>>,
    TError,
    {
      resourceType: "Private_Cabin" | "Workstation";
      data: BodyType<UpsertSundayAccessRateBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertSundayAccessRate>>,
  TError,
  {
    resourceType: "Private_Cabin" | "Workstation";
    data: BodyType<UpsertSundayAccessRateBody>;
  },
  TContext
> => {
  return useMutation(getUpsertSundayAccessRateMutationOptions(options));
};

/**
 * Re-prices only UNPAID periods with no payment, tax invoice, credit note or operator-pinned amount, applying a DELTA so first-period proration survives. An unpaid period that already has an order receipt IS repriced and reported in receiptsToRefreshPeriodIds so the receipt can be regenerated. Settled periods are skipped and reported, not refused. 422 sunday_access_not_applicable when the plan's space type is not sold this way or the line is One_Time; 422 sunday_rate_not_configured when enabling with no active catalog rate.
 * @summary Turn Sunday access on or off on a running plan
 */
export const getToggleMembershipSundayAccessUrl = (
  id: number,
  membershipId: number,
) => {
  return `/api/accounts/${id}/memberships/${membershipId}/sunday-access`;
};

export const toggleMembershipSundayAccess = async (
  id: number,
  membershipId: number,
  toggleMembershipSundayAccessBody: ToggleMembershipSundayAccessBody,
  options?: RequestInit,
): Promise<SundayAccessToggleResult> => {
  return customFetch<SundayAccessToggleResult>(
    getToggleMembershipSundayAccessUrl(id, membershipId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(toggleMembershipSundayAccessBody),
    },
  );
};

export const getToggleMembershipSundayAccessMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleMembershipSundayAccess>>,
    TError,
    {
      id: number;
      membershipId: number;
      data: BodyType<ToggleMembershipSundayAccessBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleMembershipSundayAccess>>,
  TError,
  {
    id: number;
    membershipId: number;
    data: BodyType<ToggleMembershipSundayAccessBody>;
  },
  TContext
> => {
  const mutationKey = ["toggleMembershipSundayAccess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleMembershipSundayAccess>>,
    {
      id: number;
      membershipId: number;
      data: BodyType<ToggleMembershipSundayAccessBody>;
    }
  > = (props) => {
    const { id, membershipId, data } = props ?? {};

    return toggleMembershipSundayAccess(id, membershipId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleMembershipSundayAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleMembershipSundayAccess>>
>;
export type ToggleMembershipSundayAccessMutationBody =
  BodyType<ToggleMembershipSundayAccessBody>;
export type ToggleMembershipSundayAccessMutationError =
  ErrorType<UnauthorizedResponse | void>;

/**
 * @summary Turn Sunday access on or off on a running plan
 */
export const useToggleMembershipSundayAccess = <
  TError = ErrorType<UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleMembershipSundayAccess>>,
    TError,
    {
      id: number;
      membershipId: number;
      data: BodyType<ToggleMembershipSundayAccessBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof toggleMembershipSundayAccess>>,
  TError,
  {
    id: number;
    membershipId: number;
    data: BodyType<ToggleMembershipSundayAccessBody>;
  },
  TContext
> => {
  return useMutation(getToggleMembershipSundayAccessMutationOptions(options));
};

/**
 * @summary Upsert a secondary access rule for a plan
 */
export const getUpsertPlanSecondaryAccessUrl = (
  id: number,
  resourceType:
    | "Workstation"
    | "Private_Cabin"
    | "Meeting_Room"
    | "Conference_Room",
) => {
  return `/api/inventory/plans/${id}/secondary-access/${resourceType}`;
};

export const upsertPlanSecondaryAccess = async (
  id: number,
  resourceType:
    | "Workstation"
    | "Private_Cabin"
    | "Meeting_Room"
    | "Conference_Room",
  createPlanSecondaryAccessBody: CreatePlanSecondaryAccessBody,
  options?: RequestInit,
): Promise<PlanSecondaryAccess> => {
  return customFetch<PlanSecondaryAccess>(
    getUpsertPlanSecondaryAccessUrl(id, resourceType),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createPlanSecondaryAccessBody),
    },
  );
};

export const getUpsertPlanSecondaryAccessMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPlanSecondaryAccess>>,
    TError,
    {
      id: number;
      resourceType:
        | "Workstation"
        | "Private_Cabin"
        | "Meeting_Room"
        | "Conference_Room";
      data: BodyType<CreatePlanSecondaryAccessBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertPlanSecondaryAccess>>,
  TError,
  {
    id: number;
    resourceType:
      | "Workstation"
      | "Private_Cabin"
      | "Meeting_Room"
      | "Conference_Room";
    data: BodyType<CreatePlanSecondaryAccessBody>;
  },
  TContext
> => {
  const mutationKey = ["upsertPlanSecondaryAccess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertPlanSecondaryAccess>>,
    {
      id: number;
      resourceType:
        | "Workstation"
        | "Private_Cabin"
        | "Meeting_Room"
        | "Conference_Room";
      data: BodyType<CreatePlanSecondaryAccessBody>;
    }
  > = (props) => {
    const { id, resourceType, data } = props ?? {};

    return upsertPlanSecondaryAccess(id, resourceType, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertPlanSecondaryAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertPlanSecondaryAccess>>
>;
export type UpsertPlanSecondaryAccessMutationBody =
  BodyType<CreatePlanSecondaryAccessBody>;
export type UpsertPlanSecondaryAccessMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Upsert a secondary access rule for a plan
 */
export const useUpsertPlanSecondaryAccess = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPlanSecondaryAccess>>,
    TError,
    {
      id: number;
      resourceType:
        | "Workstation"
        | "Private_Cabin"
        | "Meeting_Room"
        | "Conference_Room";
      data: BodyType<CreatePlanSecondaryAccessBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertPlanSecondaryAccess>>,
  TError,
  {
    id: number;
    resourceType:
      | "Workstation"
      | "Private_Cabin"
      | "Meeting_Room"
      | "Conference_Room";
    data: BodyType<CreatePlanSecondaryAccessBody>;
  },
  TContext
> => {
  return useMutation(getUpsertPlanSecondaryAccessMutationOptions(options));
};

/**
 * @summary Delete a secondary access rule
 */
export const getDeletePlanSecondaryAccessUrl = (
  id: number,
  resourceType: string,
) => {
  return `/api/inventory/plans/${id}/secondary-access/${resourceType}`;
};

export const deletePlanSecondaryAccess = async (
  id: number,
  resourceType: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePlanSecondaryAccessUrl(id, resourceType), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePlanSecondaryAccessMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlanSecondaryAccess>>,
    TError,
    { id: number; resourceType: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlanSecondaryAccess>>,
  TError,
  { id: number; resourceType: string },
  TContext
> => {
  const mutationKey = ["deletePlanSecondaryAccess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePlanSecondaryAccess>>,
    { id: number; resourceType: string }
  > = (props) => {
    const { id, resourceType } = props ?? {};

    return deletePlanSecondaryAccess(id, resourceType, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlanSecondaryAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePlanSecondaryAccess>>
>;

export type DeletePlanSecondaryAccessMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Delete a secondary access rule
 */
export const useDeletePlanSecondaryAccess = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlanSecondaryAccess>>,
    TError,
    { id: number; resourceType: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePlanSecondaryAccess>>,
  TError,
  { id: number; resourceType: string },
  TContext
> => {
  return useMutation(getDeletePlanSecondaryAccessMutationOptions(options));
};

/**
 * @summary Get an inventory plan by ID
 */
export const getGetInventoryPlanUrl = (id: number) => {
  return `/api/inventory/plans/${id}`;
};

export const getInventoryPlan = async (
  id: number,
  options?: RequestInit,
): Promise<InventoryPlan> => {
  return customFetch<InventoryPlan>(getGetInventoryPlanUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInventoryPlanQueryKey = (id: number) => {
  return [`/api/inventory/plans/${id}`] as const;
};

export const getGetInventoryPlanQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryPlan>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryPlan>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInventoryPlanQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryPlan>>
  > = ({ signal }) => getInventoryPlan(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryPlan>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryPlanQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryPlan>>
>;
export type GetInventoryPlanQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get an inventory plan by ID
 */

export function useGetInventoryPlan<
  TData = Awaited<ReturnType<typeof getInventoryPlan>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryPlan>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInventoryPlanQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an inventory plan (admin only)
 */
export const getUpdateInventoryPlanUrl = (id: number) => {
  return `/api/inventory/plans/${id}`;
};

export const updateInventoryPlan = async (
  id: number,
  updateInventoryPlanBody: UpdateInventoryPlanBody,
  options?: RequestInit,
): Promise<InventoryPlan> => {
  return customFetch<InventoryPlan>(getUpdateInventoryPlanUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInventoryPlanBody),
  });
};

export const getUpdateInventoryPlanMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryPlan>>,
    TError,
    { id: number; data: BodyType<UpdateInventoryPlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInventoryPlan>>,
  TError,
  { id: number; data: BodyType<UpdateInventoryPlanBody> },
  TContext
> => {
  const mutationKey = ["updateInventoryPlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInventoryPlan>>,
    { id: number; data: BodyType<UpdateInventoryPlanBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInventoryPlan(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInventoryPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInventoryPlan>>
>;
export type UpdateInventoryPlanMutationBody = BodyType<UpdateInventoryPlanBody>;
export type UpdateInventoryPlanMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Update an inventory plan (admin only)
 */
export const useUpdateInventoryPlan = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventoryPlan>>,
    TError,
    { id: number; data: BodyType<UpdateInventoryPlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInventoryPlan>>,
  TError,
  { id: number; data: BodyType<UpdateInventoryPlanBody> },
  TContext
> => {
  return useMutation(getUpdateInventoryPlanMutationOptions(options));
};

/**
 * @summary Delete an inventory plan (admin only)
 */
export const getDeleteInventoryPlanUrl = (id: number) => {
  return `/api/inventory/plans/${id}`;
};

export const deleteInventoryPlan = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInventoryPlanUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInventoryPlanMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryPlan>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInventoryPlan>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInventoryPlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInventoryPlan>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInventoryPlan(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInventoryPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInventoryPlan>>
>;

export type DeleteInventoryPlanMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete an inventory plan (admin only)
 */
export const useDeleteInventoryPlan = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInventoryPlan>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInventoryPlan>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInventoryPlanMutationOptions(options));
};

/**
 * Sets a new monthly_price on the plan and appends a version-history row
(old → new). The new price must be greater than or equal to the current
price (a plan price can never be lowered). Running memberships are
untouched — they keep their frozen price for the current term and pick up
the new price only on renewal.

 * @summary Change a plan's headline monthly price (admin only)
 */
export const getChangeInventoryPlanPriceUrl = (id: number) => {
  return `/api/inventory/plans/${id}/change-price`;
};

export const changeInventoryPlanPrice = async (
  id: number,
  changeInventoryPlanPriceBody: ChangeInventoryPlanPriceBody,
  options?: RequestInit,
): Promise<InventoryPlan> => {
  return customFetch<InventoryPlan>(getChangeInventoryPlanPriceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changeInventoryPlanPriceBody),
  });
};

export const getChangeInventoryPlanPriceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeInventoryPlanPrice>>,
    TError,
    { id: number; data: BodyType<ChangeInventoryPlanPriceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeInventoryPlanPrice>>,
  TError,
  { id: number; data: BodyType<ChangeInventoryPlanPriceBody> },
  TContext
> => {
  const mutationKey = ["changeInventoryPlanPrice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeInventoryPlanPrice>>,
    { id: number; data: BodyType<ChangeInventoryPlanPriceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return changeInventoryPlanPrice(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeInventoryPlanPriceMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeInventoryPlanPrice>>
>;
export type ChangeInventoryPlanPriceMutationBody =
  BodyType<ChangeInventoryPlanPriceBody>;
export type ChangeInventoryPlanPriceMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Change a plan's headline monthly price (admin only)
 */
export const useChangeInventoryPlanPrice = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeInventoryPlanPrice>>,
    TError,
    { id: number; data: BodyType<ChangeInventoryPlanPriceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeInventoryPlanPrice>>,
  TError,
  { id: number; data: BodyType<ChangeInventoryPlanPriceBody> },
  TContext
> => {
  return useMutation(getChangeInventoryPlanPriceMutationOptions(options));
};

/**
 * @summary List a plan's price-change history (newest first)
 */
export const getListInventoryPlanPriceHistoryUrl = (id: number) => {
  return `/api/inventory/plans/${id}/price-history`;
};

export const listInventoryPlanPriceHistory = async (
  id: number,
  options?: RequestInit,
): Promise<InventoryPlanPriceHistoryEntry[]> => {
  return customFetch<InventoryPlanPriceHistoryEntry[]>(
    getListInventoryPlanPriceHistoryUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInventoryPlanPriceHistoryQueryKey = (id: number) => {
  return [`/api/inventory/plans/${id}/price-history`] as const;
};

export const getListInventoryPlanPriceHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryPlanPriceHistory>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryPlanPriceHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryPlanPriceHistoryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryPlanPriceHistory>>
  > = ({ signal }) =>
    listInventoryPlanPriceHistory(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryPlanPriceHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryPlanPriceHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryPlanPriceHistory>>
>;
export type ListInventoryPlanPriceHistoryQueryError =
  ErrorType<NotFoundResponse>;

/**
 * @summary List a plan's price-change history (newest first)
 */

export function useListInventoryPlanPriceHistory<
  TData = Awaited<ReturnType<typeof listInventoryPlanPriceHistory>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryPlanPriceHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryPlanPriceHistoryQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List plan entitlements
 */
export const getListPlanEntitlementsUrl = (
  params?: ListPlanEntitlementsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/plan-entitlements?${stringifiedParams}`
    : `/api/inventory/plan-entitlements`;
};

export const listPlanEntitlements = async (
  params?: ListPlanEntitlementsParams,
  options?: RequestInit,
): Promise<PlanEntitlement[]> => {
  return customFetch<PlanEntitlement[]>(getListPlanEntitlementsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPlanEntitlementsQueryKey = (
  params?: ListPlanEntitlementsParams,
) => {
  return [
    `/api/inventory/plan-entitlements`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListPlanEntitlementsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPlanEntitlements>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListPlanEntitlementsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPlanEntitlements>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPlanEntitlementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPlanEntitlements>>
  > = ({ signal }) =>
    listPlanEntitlements(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPlanEntitlements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPlanEntitlementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPlanEntitlements>>
>;
export type ListPlanEntitlementsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List plan entitlements
 */

export function useListPlanEntitlements<
  TData = Awaited<ReturnType<typeof listPlanEntitlements>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListPlanEntitlementsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPlanEntitlements>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPlanEntitlementsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a plan entitlement (admin only)
 */
export const getCreatePlanEntitlementUrl = () => {
  return `/api/inventory/plan-entitlements`;
};

export const createPlanEntitlement = async (
  createPlanEntitlementBody: CreatePlanEntitlementBody,
  options?: RequestInit,
): Promise<PlanEntitlement> => {
  return customFetch<PlanEntitlement>(getCreatePlanEntitlementUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPlanEntitlementBody),
  });
};

export const getCreatePlanEntitlementMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlanEntitlement>>,
    TError,
    { data: BodyType<CreatePlanEntitlementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlanEntitlement>>,
  TError,
  { data: BodyType<CreatePlanEntitlementBody> },
  TContext
> => {
  const mutationKey = ["createPlanEntitlement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlanEntitlement>>,
    { data: BodyType<CreatePlanEntitlementBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPlanEntitlement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlanEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPlanEntitlement>>
>;
export type CreatePlanEntitlementMutationBody =
  BodyType<CreatePlanEntitlementBody>;
export type CreatePlanEntitlementMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create a plan entitlement (admin only)
 */
export const useCreatePlanEntitlement = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlanEntitlement>>,
    TError,
    { data: BodyType<CreatePlanEntitlementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPlanEntitlement>>,
  TError,
  { data: BodyType<CreatePlanEntitlementBody> },
  TContext
> => {
  return useMutation(getCreatePlanEntitlementMutationOptions(options));
};

/**
 * @summary Get a plan entitlement by ID
 */
export const getGetPlanEntitlementUrl = (id: number) => {
  return `/api/inventory/plan-entitlements/${id}`;
};

export const getPlanEntitlement = async (
  id: number,
  options?: RequestInit,
): Promise<PlanEntitlement> => {
  return customFetch<PlanEntitlement>(getGetPlanEntitlementUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPlanEntitlementQueryKey = (id: number) => {
  return [`/api/inventory/plan-entitlements/${id}`] as const;
};

export const getGetPlanEntitlementQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanEntitlement>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlanEntitlement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlanEntitlementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlanEntitlement>>
  > = ({ signal }) => getPlanEntitlement(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlanEntitlement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlanEntitlementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlanEntitlement>>
>;
export type GetPlanEntitlementQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get a plan entitlement by ID
 */

export function useGetPlanEntitlement<
  TData = Awaited<ReturnType<typeof getPlanEntitlement>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlanEntitlement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlanEntitlementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a plan entitlement (admin only)
 */
export const getUpdatePlanEntitlementUrl = (id: number) => {
  return `/api/inventory/plan-entitlements/${id}`;
};

export const updatePlanEntitlement = async (
  id: number,
  updatePlanEntitlementBody: UpdatePlanEntitlementBody,
  options?: RequestInit,
): Promise<PlanEntitlement> => {
  return customFetch<PlanEntitlement>(getUpdatePlanEntitlementUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePlanEntitlementBody),
  });
};

export const getUpdatePlanEntitlementMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlanEntitlement>>,
    TError,
    { id: number; data: BodyType<UpdatePlanEntitlementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlanEntitlement>>,
  TError,
  { id: number; data: BodyType<UpdatePlanEntitlementBody> },
  TContext
> => {
  const mutationKey = ["updatePlanEntitlement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlanEntitlement>>,
    { id: number; data: BodyType<UpdatePlanEntitlementBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePlanEntitlement(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlanEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlanEntitlement>>
>;
export type UpdatePlanEntitlementMutationBody =
  BodyType<UpdatePlanEntitlementBody>;
export type UpdatePlanEntitlementMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Update a plan entitlement (admin only)
 */
export const useUpdatePlanEntitlement = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlanEntitlement>>,
    TError,
    { id: number; data: BodyType<UpdatePlanEntitlementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePlanEntitlement>>,
  TError,
  { id: number; data: BodyType<UpdatePlanEntitlementBody> },
  TContext
> => {
  return useMutation(getUpdatePlanEntitlementMutationOptions(options));
};

/**
 * @summary Delete a plan entitlement (admin only)
 */
export const getDeletePlanEntitlementUrl = (id: number) => {
  return `/api/inventory/plan-entitlements/${id}`;
};

export const deletePlanEntitlement = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePlanEntitlementUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePlanEntitlementMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlanEntitlement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlanEntitlement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deletePlanEntitlement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePlanEntitlement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePlanEntitlement(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlanEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePlanEntitlement>>
>;

export type DeletePlanEntitlementMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a plan entitlement (admin only)
 */
export const useDeletePlanEntitlement = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlanEntitlement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePlanEntitlement>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeletePlanEntitlementMutationOptions(options));
};

/**
 * @summary List accounts
 */
export const getListAccountsUrl = (params?: ListAccountsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounts?${stringifiedParams}`
    : `/api/accounts`;
};

export const listAccounts = async (
  params?: ListAccountsParams,
  options?: RequestInit,
): Promise<Account[]> => {
  return customFetch<Account[]>(getListAccountsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAccountsQueryKey = (params?: ListAccountsParams) => {
  return [`/api/accounts`, ...(params ? [params] : [])] as const;
};

export const getListAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccounts>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccounts>>> = ({
    signal,
  }) => listAccounts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccounts>>
>;
export type ListAccountsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List accounts
 */

export function useListAccounts<
  TData = Awaited<ReturnType<typeof listAccounts>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAccountsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new account (admin only)
 */
export const getCreateAccountUrl = () => {
  return `/api/accounts`;
};

export const createAccount = async (
  createAccountBody: CreateAccountBody,
  options?: RequestInit,
): Promise<Account> => {
  return customFetch<Account>(getCreateAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAccountBody),
  });
};

export const getCreateAccountMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccount>>,
    TError,
    { data: BodyType<CreateAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccount>>,
  TError,
  { data: BodyType<CreateAccountBody> },
  TContext
> => {
  const mutationKey = ["createAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccount>>,
    { data: BodyType<CreateAccountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccount>>
>;
export type CreateAccountMutationBody = BodyType<CreateAccountBody>;
export type CreateAccountMutationError = ErrorType<
  UnauthorizedResponse | ErrorResponse
>;

/**
 * @summary Create a new account (admin only)
 */
export const useCreateAccount = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccount>>,
    TError,
    { data: BodyType<CreateAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAccount>>,
  TError,
  { data: BodyType<CreateAccountBody> },
  TContext
> => {
  return useMutation(getCreateAccountMutationOptions(options));
};

/**
 * @summary Merge source accounts into this target account (admin only)
 */
export const getMergeAccountsUrl = (id: number) => {
  return `/api/accounts/${id}/merge`;
};

export const mergeAccounts = async (
  id: number,
  mergeAccountsBody: MergeAccountsBody,
  options?: RequestInit,
): Promise<Account> => {
  return customFetch<Account>(getMergeAccountsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mergeAccountsBody),
  });
};

export const getMergeAccountsMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeAccounts>>,
    TError,
    { id: number; data: BodyType<MergeAccountsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mergeAccounts>>,
  TError,
  { id: number; data: BodyType<MergeAccountsBody> },
  TContext
> => {
  const mutationKey = ["mergeAccounts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mergeAccounts>>,
    { id: number; data: BodyType<MergeAccountsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return mergeAccounts(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MergeAccountsMutationResult = NonNullable<
  Awaited<ReturnType<typeof mergeAccounts>>
>;
export type MergeAccountsMutationBody = BodyType<MergeAccountsBody>;
export type MergeAccountsMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Merge source accounts into this target account (admin only)
 */
export const useMergeAccounts = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeAccounts>>,
    TError,
    { id: number; data: BodyType<MergeAccountsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof mergeAccounts>>,
  TError,
  { id: number; data: BodyType<MergeAccountsBody> },
  TContext
> => {
  return useMutation(getMergeAccountsMutationOptions(options));
};

/**
 * @summary Check whether an account satisfies the invoice-ready gate
 */
export const getGetAccountInvoiceReadyUrl = (id: number) => {
  return `/api/accounts/${id}/invoice-ready`;
};

export const getAccountInvoiceReady = async (
  id: number,
  options?: RequestInit,
): Promise<InvoiceReadyStatus> => {
  return customFetch<InvoiceReadyStatus>(getGetAccountInvoiceReadyUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAccountInvoiceReadyQueryKey = (id: number) => {
  return [`/api/accounts/${id}/invoice-ready`] as const;
};

export const getGetAccountInvoiceReadyQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountInvoiceReady>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountInvoiceReady>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountInvoiceReadyQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountInvoiceReady>>
  > = ({ signal }) => getAccountInvoiceReady(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountInvoiceReady>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountInvoiceReadyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountInvoiceReady>>
>;
export type GetAccountInvoiceReadyQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Check whether an account satisfies the invoice-ready gate
 */

export function useGetAccountInvoiceReady<
  TData = Awaited<ReturnType<typeof getAccountInvoiceReady>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountInvoiceReady>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAccountInvoiceReadyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns every Contact row in the operator's space with the parent
account's `legalName` and `billingPhone` joined inline. Used by
operations forms (Pay-Per-Use stock-out picker, etc.) that need
to identify the actual person consuming an item, not just the
billable account. Also powers the cross-account Member directory
(Phase 37) via the optional filters below. Response stays a bare
array (mirrors listAccounts), server-capped by pageSize.

 * @summary List all contacts in the space (flattened, with account info joined)
 */
export const getListContactsUrl = (params?: ListContactsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/contacts?${stringifiedParams}`
    : `/api/contacts`;
};

export const listContacts = async (
  params?: ListContactsParams,
  options?: RequestInit,
): Promise<ContactDirectoryRow[]> => {
  return customFetch<ContactDirectoryRow[]>(getListContactsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListContactsQueryKey = (params?: ListContactsParams) => {
  return [`/api/contacts`, ...(params ? [params] : [])] as const;
};

export const getListContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListContactsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContacts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListContactsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listContacts>>> = ({
    signal,
  }) => listContacts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContacts>>
>;
export type ListContactsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List all contacts in the space (flattened, with account info joined)
 */

export function useListContacts<
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListContactsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContacts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContactsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Bookmarkable/deep-linkable lookup for the Member detail page
(Phase 37). Returns the same base fields as Contact plus
account-context fields (accountType, accountGstTreatment,
accountGstin, accountPlaceOfSupply) needed to render the Account
section without a second round-trip.

 * @summary Get a single contact by id (full profile + account context)
 */
export const getGetContactUrl = (id: number) => {
  return `/api/contacts/${id}`;
};

export const getContact = async (
  id: number,
  options?: RequestInit,
): Promise<ContactDetail> => {
  return customFetch<ContactDetail>(getGetContactUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContactQueryKey = (id: number) => {
  return [`/api/contacts/${id}`] as const;
};

export const getGetContactQueryOptions = <
  TData = Awaited<ReturnType<typeof getContact>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContact>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContact>>> = ({
    signal,
  }) => getContact(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContact>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContact>>
>;
export type GetContactQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get a single contact by id (full profile + account context)
 */

export function useGetContact<
  TData = Awaited<ReturnType<typeof getContact>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContact>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContactQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Server-side assembly endpoint (Phase 37 Member detail Transactions
section). Buckets are attributed via the actual child tables that
carry a contactId (stock_out, resource_assignments,
membership_payment_periods) — NOT a naive member_charges filter,
since member_charges has no contactId column. Charges with no
resolvable contact stay account-only and never appear here.

 * @summary Get this contact's transactions, bucketed by category
 */
export const getGetContactTransactionsUrl = (id: number) => {
  return `/api/contacts/${id}/transactions`;
};

export const getContactTransactions = async (
  id: number,
  options?: RequestInit,
): Promise<ContactTransactions> => {
  return customFetch<ContactTransactions>(getGetContactTransactionsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContactTransactionsQueryKey = (id: number) => {
  return [`/api/contacts/${id}/transactions`] as const;
};

export const getGetContactTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactTransactions>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContactTransactions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetContactTransactionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactTransactions>>
  > = ({ signal }) => getContactTransactions(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactTransactions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactTransactions>>
>;
export type GetContactTransactionsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get this contact's transactions, bucketed by category
 */

export function useGetContactTransactions<
  TData = Awaited<ReturnType<typeof getContactTransactions>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContactTransactions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContactTransactionsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Phase 38 — single aggregation pass (no N+1) covering Lifetime Paid,
Pending Dues, Total Visits, Member Since, and an 18-week attendance
heatmap + day streak, for the Member profile page.

 * @summary Get aggregated stat-tile + heatmap data for a contact's member profile
 */
export const getGetContactStatsUrl = (id: number) => {
  return `/api/contacts/${id}/stats`;
};

export const getContactStats = async (
  id: number,
  options?: RequestInit,
): Promise<ContactStats> => {
  return customFetch<ContactStats>(getGetContactStatsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetContactStatsQueryKey = (id: number) => {
  return [`/api/contacts/${id}/stats`] as const;
};

export const getGetContactStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactStats>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContactStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactStatsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactStats>>> = ({
    signal,
  }) => getContactStats(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactStats>>
>;
export type GetContactStatsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get aggregated stat-tile + heatmap data for a contact's member profile
 */

export function useGetContactStats<
  TData = Awaited<ReturnType<typeof getContactStats>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getContactStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetContactStatsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Phase 38 — money-sensitive, audited transaction. Blocks if the
contact has pending plan dues. If the contact currently holds the
primary or billing role on the old account, a replacement contact
for each vacated role must be supplied so the old account is never
left without a primary + billing contact. The moved contact always
lands as role "user" on the new account. Already-issued
invoices/receipts and past attendance stay on the old account —
only future billing follows the re-parented memberships.

 * @summary Re-parent a contact (and their active memberships) to a different account
 */
export const getReassignContactUrl = (id: number) => {
  return `/api/contacts/${id}/reassign`;
};

export const reassignContact = async (
  id: number,
  reassignContactBody: ReassignContactBody,
  options?: RequestInit,
): Promise<ReassignContactResult> => {
  return customFetch<ReassignContactResult>(getReassignContactUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reassignContactBody),
  });
};

export const getReassignContactMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reassignContact>>,
    TError,
    { id: number; data: BodyType<ReassignContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reassignContact>>,
  TError,
  { id: number; data: BodyType<ReassignContactBody> },
  TContext
> => {
  const mutationKey = ["reassignContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reassignContact>>,
    { id: number; data: BodyType<ReassignContactBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reassignContact(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReassignContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof reassignContact>>
>;
export type ReassignContactMutationBody = BodyType<ReassignContactBody>;
export type ReassignContactMutationError = ErrorType<
  UnauthorizedResponse | ErrorResponse
>;

/**
 * @summary Re-parent a contact (and their active memberships) to a different account
 */
export const useReassignContact = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reassignContact>>,
    TError,
    { id: number; data: BodyType<ReassignContactBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reassignContact>>,
  TError,
  { id: number; data: BodyType<ReassignContactBody> },
  TContext
> => {
  return useMutation(getReassignContactMutationOptions(options));
};

/**
 * @summary List contacts belonging to an account
 */
export const getListAccountContactsUrl = (id: number) => {
  return `/api/accounts/${id}/contacts`;
};

export const listAccountContacts = async (
  id: number,
  options?: RequestInit,
): Promise<Contact[]> => {
  return customFetch<Contact[]>(getListAccountContactsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListAccountContactsQueryKey = (id: number) => {
  return [`/api/accounts/${id}/contacts`] as const;
};

export const getListAccountContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountContacts>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountContacts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountContactsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountContacts>>
  > = ({ signal }) => listAccountContacts(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAccountContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountContacts>>
>;
export type ListAccountContactsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List contacts belonging to an account
 */

export function useListAccountContacts<
  TData = Awaited<ReturnType<typeof listAccountContacts>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountContacts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAccountContactsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a contact to an account (admin only)
 */
export const getCreateAccountContactUrl = (id: number) => {
  return `/api/accounts/${id}/contacts`;
};

export const createAccountContact = async (
  id: number,
  createContactBody: NonReadonly<CreateContactBody>,
  options?: RequestInit,
): Promise<Contact> => {
  return customFetch<Contact>(getCreateAccountContactUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createContactBody),
  });
};

export const getCreateAccountContactMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountContact>>,
    TError,
    { id: number; data: BodyType<NonReadonly<CreateContactBody>> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccountContact>>,
  TError,
  { id: number; data: BodyType<NonReadonly<CreateContactBody>> },
  TContext
> => {
  const mutationKey = ["createAccountContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccountContact>>,
    { id: number; data: BodyType<NonReadonly<CreateContactBody>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createAccountContact(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccountContact>>
>;
export type CreateAccountContactMutationBody = BodyType<
  NonReadonly<CreateContactBody>
>;
export type CreateAccountContactMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Add a contact to an account (admin only)
 */
export const useCreateAccountContact = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountContact>>,
    TError,
    { id: number; data: BodyType<NonReadonly<CreateContactBody>> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAccountContact>>,
  TError,
  { id: number; data: BodyType<NonReadonly<CreateContactBody>> },
  TContext
> => {
  return useMutation(getCreateAccountContactMutationOptions(options));
};

/**
 * @summary Update a contact (admin only)
 */
export const getUpdateAccountContactUrl = (id: number, contactId: number) => {
  return `/api/accounts/${id}/contacts/${contactId}`;
};

export const updateAccountContact = async (
  id: number,
  contactId: number,
  updateContactBody: NonReadonly<UpdateContactBody>,
  options?: RequestInit,
): Promise<Contact> => {
  return customFetch<Contact>(getUpdateAccountContactUrl(id, contactId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateContactBody),
  });
};

export const getUpdateAccountContactMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccountContact>>,
    TError,
    {
      id: number;
      contactId: number;
      data: BodyType<NonReadonly<UpdateContactBody>>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccountContact>>,
  TError,
  {
    id: number;
    contactId: number;
    data: BodyType<NonReadonly<UpdateContactBody>>;
  },
  TContext
> => {
  const mutationKey = ["updateAccountContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccountContact>>,
    {
      id: number;
      contactId: number;
      data: BodyType<NonReadonly<UpdateContactBody>>;
    }
  > = (props) => {
    const { id, contactId, data } = props ?? {};

    return updateAccountContact(id, contactId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAccountContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccountContact>>
>;
export type UpdateAccountContactMutationBody = BodyType<
  NonReadonly<UpdateContactBody>
>;
export type UpdateAccountContactMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Update a contact (admin only)
 */
export const useUpdateAccountContact = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccountContact>>,
    TError,
    {
      id: number;
      contactId: number;
      data: BodyType<NonReadonly<UpdateContactBody>>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAccountContact>>,
  TError,
  {
    id: number;
    contactId: number;
    data: BodyType<NonReadonly<UpdateContactBody>>;
  },
  TContext
> => {
  return useMutation(getUpdateAccountContactMutationOptions(options));
};

/**
 * @summary Remove a contact from an account (admin only)
 */
export const getDeleteAccountContactUrl = (id: number, contactId: number) => {
  return `/api/accounts/${id}/contacts/${contactId}`;
};

export const deleteAccountContact = async (
  id: number,
  contactId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteAccountContactUrl(id, contactId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAccountContactMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountContact>>,
    TError,
    { id: number; contactId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccountContact>>,
  TError,
  { id: number; contactId: number },
  TContext
> => {
  const mutationKey = ["deleteAccountContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccountContact>>,
    { id: number; contactId: number }
  > = (props) => {
    const { id, contactId } = props ?? {};

    return deleteAccountContact(id, contactId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccountContact>>
>;

export type DeleteAccountContactMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Remove a contact from an account (admin only)
 */
export const useDeleteAccountContact = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountContact>>,
    TError,
    { id: number; contactId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccountContact>>,
  TError,
  { id: number; contactId: number },
  TContext
> => {
  return useMutation(getDeleteAccountContactMutationOptions(options));
};

/**
 * @summary List memberships for an account
 */
export const getListAccountMembershipsUrl = (id: number) => {
  return `/api/accounts/${id}/memberships`;
};

export const listAccountMemberships = async (
  id: number,
  options?: RequestInit,
): Promise<Membership[]> => {
  return customFetch<Membership[]>(getListAccountMembershipsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListAccountMembershipsQueryKey = (id: number) => {
  return [`/api/accounts/${id}/memberships`] as const;
};

export const getListAccountMembershipsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountMemberships>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountMemberships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAccountMembershipsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountMemberships>>
  > = ({ signal }) => listAccountMemberships(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountMemberships>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAccountMembershipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountMemberships>>
>;
export type ListAccountMembershipsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List memberships for an account
 */

export function useListAccountMemberships<
  TData = Awaited<ReturnType<typeof listAccountMemberships>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountMemberships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAccountMembershipsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a membership for an account (admin only)
 */
export const getCreateAccountMembershipUrl = (id: number) => {
  return `/api/accounts/${id}/memberships`;
};

export const createAccountMembership = async (
  id: number,
  createMembershipBody: CreateMembershipBody,
  options?: RequestInit,
): Promise<Membership> => {
  return customFetch<Membership>(getCreateAccountMembershipUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMembershipBody),
  });
};

export const getCreateAccountMembershipMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountMembership>>,
    TError,
    { id: number; data: BodyType<CreateMembershipBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccountMembership>>,
  TError,
  { id: number; data: BodyType<CreateMembershipBody> },
  TContext
> => {
  const mutationKey = ["createAccountMembership"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccountMembership>>,
    { id: number; data: BodyType<CreateMembershipBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createAccountMembership(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccountMembership>>
>;
export type CreateAccountMembershipMutationBody =
  BodyType<CreateMembershipBody>;
export type CreateAccountMembershipMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Create a membership for an account (admin only)
 */
export const useCreateAccountMembership = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountMembership>>,
    TError,
    { id: number; data: BodyType<CreateMembershipBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAccountMembership>>,
  TError,
  { id: number; data: BodyType<CreateMembershipBody> },
  TContext
> => {
  return useMutation(getCreateAccountMembershipMutationOptions(options));
};

/**
 * @summary Update a membership (admin only)
 */
export const getUpdateAccountMembershipUrl = (
  id: number,
  membershipId: number,
) => {
  return `/api/accounts/${id}/memberships/${membershipId}`;
};

export const updateAccountMembership = async (
  id: number,
  membershipId: number,
  updateMembershipBody: UpdateMembershipBody,
  options?: RequestInit,
): Promise<Membership> => {
  return customFetch<Membership>(
    getUpdateAccountMembershipUrl(id, membershipId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateMembershipBody),
    },
  );
};

export const getUpdateAccountMembershipMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccountMembership>>,
    TError,
    { id: number; membershipId: number; data: BodyType<UpdateMembershipBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccountMembership>>,
  TError,
  { id: number; membershipId: number; data: BodyType<UpdateMembershipBody> },
  TContext
> => {
  const mutationKey = ["updateAccountMembership"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccountMembership>>,
    { id: number; membershipId: number; data: BodyType<UpdateMembershipBody> }
  > = (props) => {
    const { id, membershipId, data } = props ?? {};

    return updateAccountMembership(id, membershipId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAccountMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccountMembership>>
>;
export type UpdateAccountMembershipMutationBody =
  BodyType<UpdateMembershipBody>;
export type UpdateAccountMembershipMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Update a membership (admin only)
 */
export const useUpdateAccountMembership = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccountMembership>>,
    TError,
    { id: number; membershipId: number; data: BodyType<UpdateMembershipBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAccountMembership>>,
  TError,
  { id: number; membershipId: number; data: BodyType<UpdateMembershipBody> },
  TContext
> => {
  return useMutation(getUpdateAccountMembershipMutationOptions(options));
};

/**
 * @summary Delete a membership / plan (admin only)
 */
export const getDeleteAccountMembershipUrl = (
  id: number,
  membershipId: number,
) => {
  return `/api/accounts/${id}/memberships/${membershipId}`;
};

export const deleteAccountMembership = async (
  id: number,
  membershipId: number,
  options?: RequestInit,
): Promise<DeleteAccountMembership200> => {
  return customFetch<DeleteAccountMembership200>(
    getDeleteAccountMembershipUrl(id, membershipId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteAccountMembershipMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountMembership>>,
    TError,
    { id: number; membershipId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccountMembership>>,
  TError,
  { id: number; membershipId: number },
  TContext
> => {
  const mutationKey = ["deleteAccountMembership"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccountMembership>>,
    { id: number; membershipId: number }
  > = (props) => {
    const { id, membershipId } = props ?? {};

    return deleteAccountMembership(id, membershipId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccountMembership>>
>;

export type DeleteAccountMembershipMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Delete a membership / plan (admin only)
 */
export const useDeleteAccountMembership = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountMembership>>,
    TError,
    { id: number; membershipId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccountMembership>>,
  TError,
  { id: number; membershipId: number },
  TContext
> => {
  return useMutation(getDeleteAccountMembershipMutationOptions(options));
};

/**
 * @summary Change history of a plan's period (committed months) and end date
 */
export const getGetMembershipPeriodLogUrl = (
  id: number,
  membershipId: number,
) => {
  return `/api/accounts/${id}/memberships/${membershipId}/period-log`;
};

export const getMembershipPeriodLog = async (
  id: number,
  membershipId: number,
  options?: RequestInit,
): Promise<MembershipPeriodLogEntry[]> => {
  return customFetch<MembershipPeriodLogEntry[]>(
    getGetMembershipPeriodLogUrl(id, membershipId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetMembershipPeriodLogQueryKey = (
  id: number,
  membershipId: number,
) => {
  return [
    `/api/accounts/${id}/memberships/${membershipId}/period-log`,
  ] as const;
};

export const getGetMembershipPeriodLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getMembershipPeriodLog>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  membershipId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMembershipPeriodLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMembershipPeriodLogQueryKey(id, membershipId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMembershipPeriodLog>>
  > = ({ signal }) =>
    getMembershipPeriodLog(id, membershipId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && membershipId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMembershipPeriodLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMembershipPeriodLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMembershipPeriodLog>>
>;
export type GetMembershipPeriodLogQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Change history of a plan's period (committed months) and end date
 */

export function useGetMembershipPeriodLog<
  TData = Awaited<ReturnType<typeof getMembershipPeriodLog>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  membershipId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMembershipPeriodLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMembershipPeriodLogQueryOptions(
    id,
    membershipId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Atomically updates billing_cycle_day and deletes the membership's materialised payment periods so the next schedule read regenerates them against the new anchor. Refused with 422 when ANY period on the membership is Paid/Partial, has an operator amount override, carries a receipt number, or is still referenced by a payment allocation or credit note.

 * @summary Move a membership's billing anchor and regenerate its schedule (admin only)
 */
export const getReanchorAccountMembershipUrl = (
  id: number,
  membershipId: number,
) => {
  return `/api/accounts/${id}/memberships/${membershipId}/reanchor`;
};

export const reanchorAccountMembership = async (
  id: number,
  membershipId: number,
  reanchorAccountMembershipBody: ReanchorAccountMembershipBody,
  options?: RequestInit,
): Promise<ReanchorAccountMembership200> => {
  return customFetch<ReanchorAccountMembership200>(
    getReanchorAccountMembershipUrl(id, membershipId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(reanchorAccountMembershipBody),
    },
  );
};

export const getReanchorAccountMembershipMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reanchorAccountMembership>>,
    TError,
    {
      id: number;
      membershipId: number;
      data: BodyType<ReanchorAccountMembershipBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reanchorAccountMembership>>,
  TError,
  {
    id: number;
    membershipId: number;
    data: BodyType<ReanchorAccountMembershipBody>;
  },
  TContext
> => {
  const mutationKey = ["reanchorAccountMembership"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reanchorAccountMembership>>,
    {
      id: number;
      membershipId: number;
      data: BodyType<ReanchorAccountMembershipBody>;
    }
  > = (props) => {
    const { id, membershipId, data } = props ?? {};

    return reanchorAccountMembership(id, membershipId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReanchorAccountMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof reanchorAccountMembership>>
>;
export type ReanchorAccountMembershipMutationBody =
  BodyType<ReanchorAccountMembershipBody>;
export type ReanchorAccountMembershipMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Move a membership's billing anchor and regenerate its schedule (admin only)
 */
export const useReanchorAccountMembership = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reanchorAccountMembership>>,
    TError,
    {
      id: number;
      membershipId: number;
      data: BodyType<ReanchorAccountMembershipBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reanchorAccountMembership>>,
  TError,
  {
    id: number;
    membershipId: number;
    data: BodyType<ReanchorAccountMembershipBody>;
  },
  TContext
> => {
  return useMutation(getReanchorAccountMembershipMutationOptions(options));
};

/**
 * @summary Create multiple memberships at once + optional proforma estimate (admin only)
 */
export const getCreateAccountMembershipBatchUrl = (id: number) => {
  return `/api/accounts/${id}/memberships/batch`;
};

export const createAccountMembershipBatch = async (
  id: number,
  createMembershipBatchBody: CreateMembershipBatchBody,
  options?: RequestInit,
): Promise<MembershipBatchResponse> => {
  return customFetch<MembershipBatchResponse>(
    getCreateAccountMembershipBatchUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createMembershipBatchBody),
    },
  );
};

export const getCreateAccountMembershipBatchMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountMembershipBatch>>,
    TError,
    { id: number; data: BodyType<CreateMembershipBatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccountMembershipBatch>>,
  TError,
  { id: number; data: BodyType<CreateMembershipBatchBody> },
  TContext
> => {
  const mutationKey = ["createAccountMembershipBatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccountMembershipBatch>>,
    { id: number; data: BodyType<CreateMembershipBatchBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createAccountMembershipBatch(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountMembershipBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccountMembershipBatch>>
>;
export type CreateAccountMembershipBatchMutationBody =
  BodyType<CreateMembershipBatchBody>;
export type CreateAccountMembershipBatchMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Create multiple memberships at once + optional proforma estimate (admin only)
 */
export const useCreateAccountMembershipBatch = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountMembershipBatch>>,
    TError,
    { id: number; data: BodyType<CreateMembershipBatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAccountMembershipBatch>>,
  TError,
  { id: number; data: BodyType<CreateMembershipBatchBody> },
  TContext
> => {
  return useMutation(getCreateAccountMembershipBatchMutationOptions(options));
};

/**
 * @summary List proforma estimates for an account
 */
export const getListAccountProformasUrl = (id: number) => {
  return `/api/accounts/${id}/proformas`;
};

export const listAccountProformas = async (
  id: number,
  options?: RequestInit,
): Promise<MembershipQuote[]> => {
  return customFetch<MembershipQuote[]>(getListAccountProformasUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListAccountProformasQueryKey = (id: number) => {
  return [`/api/accounts/${id}/proformas`] as const;
};

export const getListAccountProformasQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountProformas>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountProformas>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAccountProformasQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountProformas>>
  > = ({ signal }) => listAccountProformas(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountProformas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAccountProformasQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountProformas>>
>;
export type ListAccountProformasQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List proforma estimates for an account
 */

export function useListAccountProformas<
  TData = Awaited<ReturnType<typeof listAccountProformas>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountProformas>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAccountProformasQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a proforma estimate (with line items) for an account
 */
export const getGetAccountProformaUrl = (id: number, proformaId: number) => {
  return `/api/accounts/${id}/proformas/${proformaId}`;
};

export const getAccountProforma = async (
  id: number,
  proformaId: number,
  options?: RequestInit,
): Promise<MembershipQuote> => {
  return customFetch<MembershipQuote>(
    getGetAccountProformaUrl(id, proformaId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAccountProformaQueryKey = (
  id: number,
  proformaId: number,
) => {
  return [`/api/accounts/${id}/proformas/${proformaId}`] as const;
};

export const getGetAccountProformaQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountProforma>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  proformaId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountProforma>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountProformaQueryKey(id, proformaId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountProforma>>
  > = ({ signal }) =>
    getAccountProforma(id, proformaId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && proformaId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountProforma>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountProformaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountProforma>>
>;
export type GetAccountProformaQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get a proforma estimate (with line items) for an account
 */

export function useGetAccountProforma<
  TData = Awaited<ReturnType<typeof getAccountProforma>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  proformaId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountProforma>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAccountProformaQueryOptions(
    id,
    proformaId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Generate the order-receipt PDF, record the received amount, and WhatsApp it (admin only)
 */
export const getSendAccountProformaReceiptUrl = (
  id: number,
  proformaId: number,
) => {
  return `/api/accounts/${id}/proformas/${proformaId}/send-receipt`;
};

export const sendAccountProformaReceipt = async (
  id: number,
  proformaId: number,
  sendProformaReceiptBody?: SendProformaReceiptBody,
  options?: RequestInit,
): Promise<SendProformaReceiptResponse> => {
  return customFetch<SendProformaReceiptResponse>(
    getSendAccountProformaReceiptUrl(id, proformaId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(sendProformaReceiptBody),
    },
  );
};

export const getSendAccountProformaReceiptMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAccountProformaReceipt>>,
    TError,
    { id: number; proformaId: number; data: BodyType<SendProformaReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendAccountProformaReceipt>>,
  TError,
  { id: number; proformaId: number; data: BodyType<SendProformaReceiptBody> },
  TContext
> => {
  const mutationKey = ["sendAccountProformaReceipt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendAccountProformaReceipt>>,
    { id: number; proformaId: number; data: BodyType<SendProformaReceiptBody> }
  > = (props) => {
    const { id, proformaId, data } = props ?? {};

    return sendAccountProformaReceipt(id, proformaId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendAccountProformaReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendAccountProformaReceipt>>
>;
export type SendAccountProformaReceiptMutationBody =
  BodyType<SendProformaReceiptBody>;
export type SendAccountProformaReceiptMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Generate the order-receipt PDF, record the received amount, and WhatsApp it (admin only)
 */
export const useSendAccountProformaReceipt = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAccountProformaReceipt>>,
    TError,
    { id: number; proformaId: number; data: BodyType<SendProformaReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendAccountProformaReceipt>>,
  TError,
  { id: number; proformaId: number; data: BodyType<SendProformaReceiptBody> },
  TContext
> => {
  return useMutation(getSendAccountProformaReceiptMutationOptions(options));
};

/**
 * Expands each ACTIVE recurring membership into its billing periods (from start date to the current + next upcoming period), lazily upserting any missing period rows, and returns them with the summary tiles.

 * @summary Payment schedule (one row per billing period) for the account's recurring plans
 */
export const getGetAccountPlanScheduleUrl = (id: number) => {
  return `/api/accounts/${id}/plan-schedule`;
};

export const getAccountPlanSchedule = async (
  id: number,
  options?: RequestInit,
): Promise<PlanScheduleResponse> => {
  return customFetch<PlanScheduleResponse>(getGetAccountPlanScheduleUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAccountPlanScheduleQueryKey = (id: number) => {
  return [`/api/accounts/${id}/plan-schedule`] as const;
};

export const getGetAccountPlanScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountPlanSchedule>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountPlanSchedule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountPlanScheduleQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountPlanSchedule>>
  > = ({ signal }) => getAccountPlanSchedule(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountPlanSchedule>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountPlanScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountPlanSchedule>>
>;
export type GetAccountPlanScheduleQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Payment schedule (one row per billing period) for the account's recurring plans
 */

export function useGetAccountPlanSchedule<
  TData = Awaited<ReturnType<typeof getAccountPlanSchedule>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountPlanSchedule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAccountPlanScheduleQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark a plan payment period paid / unpaid (admin only)
 */
export const getMarkPlanPeriodPaidUrl = (periodId: number) => {
  return `/api/plan-schedule/${periodId}/mark-paid`;
};

export const markPlanPeriodPaid = async (
  periodId: number,
  markPlanPeriodPaidBody?: MarkPlanPeriodPaidBody,
  options?: RequestInit,
): Promise<PlanSchedulePeriod> => {
  return customFetch<PlanSchedulePeriod>(getMarkPlanPeriodPaidUrl(periodId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(markPlanPeriodPaidBody),
  });
};

export const getMarkPlanPeriodPaidMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markPlanPeriodPaid>>,
    TError,
    { periodId: number; data: BodyType<MarkPlanPeriodPaidBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markPlanPeriodPaid>>,
  TError,
  { periodId: number; data: BodyType<MarkPlanPeriodPaidBody> },
  TContext
> => {
  const mutationKey = ["markPlanPeriodPaid"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markPlanPeriodPaid>>,
    { periodId: number; data: BodyType<MarkPlanPeriodPaidBody> }
  > = (props) => {
    const { periodId, data } = props ?? {};

    return markPlanPeriodPaid(periodId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkPlanPeriodPaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof markPlanPeriodPaid>>
>;
export type MarkPlanPeriodPaidMutationBody = BodyType<MarkPlanPeriodPaidBody>;
export type MarkPlanPeriodPaidMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Mark a plan payment period paid / unpaid (admin only)
 */
export const useMarkPlanPeriodPaid = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markPlanPeriodPaid>>,
    TError,
    { periodId: number; data: BodyType<MarkPlanPeriodPaidBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markPlanPeriodPaid>>,
  TError,
  { periodId: number; data: BodyType<MarkPlanPeriodPaidBody> },
  TContext
> => {
  return useMutation(getMarkPlanPeriodPaidMutationOptions(options));
};

/**
 * @summary Set the reminder date on a plan payment period (admin only)
 */
export const getUpdatePlanPeriodReminderUrl = (periodId: number) => {
  return `/api/plan-schedule/${periodId}/reminder`;
};

export const updatePlanPeriodReminder = async (
  periodId: number,
  updatePlanPeriodReminderBody: UpdatePlanPeriodReminderBody,
  options?: RequestInit,
): Promise<PlanSchedulePeriod> => {
  return customFetch<PlanSchedulePeriod>(
    getUpdatePlanPeriodReminderUrl(periodId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updatePlanPeriodReminderBody),
    },
  );
};

export const getUpdatePlanPeriodReminderMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlanPeriodReminder>>,
    TError,
    { periodId: number; data: BodyType<UpdatePlanPeriodReminderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlanPeriodReminder>>,
  TError,
  { periodId: number; data: BodyType<UpdatePlanPeriodReminderBody> },
  TContext
> => {
  const mutationKey = ["updatePlanPeriodReminder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlanPeriodReminder>>,
    { periodId: number; data: BodyType<UpdatePlanPeriodReminderBody> }
  > = (props) => {
    const { periodId, data } = props ?? {};

    return updatePlanPeriodReminder(periodId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlanPeriodReminderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlanPeriodReminder>>
>;
export type UpdatePlanPeriodReminderMutationBody =
  BodyType<UpdatePlanPeriodReminderBody>;
export type UpdatePlanPeriodReminderMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Set the reminder date on a plan payment period (admin only)
 */
export const useUpdatePlanPeriodReminder = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlanPeriodReminder>>,
    TError,
    { periodId: number; data: BodyType<UpdatePlanPeriodReminderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePlanPeriodReminder>>,
  TError,
  { periodId: number; data: BodyType<UpdatePlanPeriodReminderBody> },
  TContext
> => {
  return useMutation(getUpdatePlanPeriodReminderMutationOptions(options));
};

/**
 * @summary Phase 28 — pin a period's amount (sets amount_overridden=true)
 */
export const getUpdatePeriodAmountUrl = (periodId: number) => {
  return `/api/plan-schedule/${periodId}/amount`;
};

export const updatePeriodAmount = async (
  periodId: number,
  updatePeriodAmountBody: UpdatePeriodAmountBody,
  options?: RequestInit,
): Promise<PlanSchedulePeriod> => {
  return customFetch<PlanSchedulePeriod>(getUpdatePeriodAmountUrl(periodId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePeriodAmountBody),
  });
};

export const getUpdatePeriodAmountMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | NotFoundResponse | UpdatePeriodAmount422
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePeriodAmount>>,
    TError,
    { periodId: number; data: BodyType<UpdatePeriodAmountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePeriodAmount>>,
  TError,
  { periodId: number; data: BodyType<UpdatePeriodAmountBody> },
  TContext
> => {
  const mutationKey = ["updatePeriodAmount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePeriodAmount>>,
    { periodId: number; data: BodyType<UpdatePeriodAmountBody> }
  > = (props) => {
    const { periodId, data } = props ?? {};

    return updatePeriodAmount(periodId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePeriodAmountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePeriodAmount>>
>;
export type UpdatePeriodAmountMutationBody = BodyType<UpdatePeriodAmountBody>;
export type UpdatePeriodAmountMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse | UpdatePeriodAmount422
>;

/**
 * @summary Phase 28 — pin a period's amount (sets amount_overridden=true)
 */
export const useUpdatePeriodAmount = <
  TError = ErrorType<
    BadRequestResponse | NotFoundResponse | UpdatePeriodAmount422
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePeriodAmount>>,
    TError,
    { periodId: number; data: BodyType<UpdatePeriodAmountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePeriodAmount>>,
  TError,
  { periodId: number; data: BodyType<UpdatePeriodAmountBody> },
  TContext
> => {
  return useMutation(getUpdatePeriodAmountMutationOptions(options));
};

/**
 * @summary Generate (and optionally WhatsApp) the order receipt for a single period (admin only)
 */
export const getGeneratePlanPeriodReceiptUrl = (periodId: number) => {
  return `/api/plan-schedule/${periodId}/receipt`;
};

export const generatePlanPeriodReceipt = async (
  periodId: number,
  generatePlanPeriodReceiptBody?: GeneratePlanPeriodReceiptBody,
  options?: RequestInit,
): Promise<PlanPeriodReceiptResponse> => {
  return customFetch<PlanPeriodReceiptResponse>(
    getGeneratePlanPeriodReceiptUrl(periodId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(generatePlanPeriodReceiptBody),
    },
  );
};

export const getGeneratePlanPeriodReceiptMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePlanPeriodReceipt>>,
    TError,
    { periodId: number; data: BodyType<GeneratePlanPeriodReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generatePlanPeriodReceipt>>,
  TError,
  { periodId: number; data: BodyType<GeneratePlanPeriodReceiptBody> },
  TContext
> => {
  const mutationKey = ["generatePlanPeriodReceipt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generatePlanPeriodReceipt>>,
    { periodId: number; data: BodyType<GeneratePlanPeriodReceiptBody> }
  > = (props) => {
    const { periodId, data } = props ?? {};

    return generatePlanPeriodReceipt(periodId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GeneratePlanPeriodReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof generatePlanPeriodReceipt>>
>;
export type GeneratePlanPeriodReceiptMutationBody =
  BodyType<GeneratePlanPeriodReceiptBody>;
export type GeneratePlanPeriodReceiptMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Generate (and optionally WhatsApp) the order receipt for a single period (admin only)
 */
export const useGeneratePlanPeriodReceipt = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePlanPeriodReceipt>>,
    TError,
    { periodId: number; data: BodyType<GeneratePlanPeriodReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generatePlanPeriodReceipt>>,
  TError,
  { periodId: number; data: BodyType<GeneratePlanPeriodReceiptBody> },
  TContext
> => {
  return useMutation(getGeneratePlanPeriodReceiptMutationOptions(options));
};

/**
 * @summary Generate a combined order receipt PDF for all periods in a quoteGroupId bundle (admin only)
 */
export const getGenerateBundleReceiptUrl = (id: number) => {
  return `/api/accounts/${id}/plan-schedule/bundle-receipt`;
};

export const generateBundleReceipt = async (
  id: number,
  bundleReceiptBody: BundleReceiptBody,
  options?: RequestInit,
): Promise<BundleReceiptResult> => {
  return customFetch<BundleReceiptResult>(getGenerateBundleReceiptUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bundleReceiptBody),
  });
};

export const getGenerateBundleReceiptMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateBundleReceipt>>,
    TError,
    { id: number; data: BodyType<BundleReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateBundleReceipt>>,
  TError,
  { id: number; data: BodyType<BundleReceiptBody> },
  TContext
> => {
  const mutationKey = ["generateBundleReceipt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateBundleReceipt>>,
    { id: number; data: BodyType<BundleReceiptBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateBundleReceipt(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateBundleReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateBundleReceipt>>
>;
export type GenerateBundleReceiptMutationBody = BodyType<BundleReceiptBody>;
export type GenerateBundleReceiptMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Generate a combined order receipt PDF for all periods in a quoteGroupId bundle (admin only)
 */
export const useGenerateBundleReceipt = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateBundleReceipt>>,
    TError,
    { id: number; data: BodyType<BundleReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateBundleReceipt>>,
  TError,
  { id: number; data: BodyType<BundleReceiptBody> },
  TContext
> => {
  return useMutation(getGenerateBundleReceiptMutationOptions(options));
};

/**
 * @summary Generate a combined TAX INVOICE PDF for a fully-paid quoteGroupId bundle (admin only)
 */
export const getGenerateBundleInvoiceUrl = (id: number) => {
  return `/api/accounts/${id}/plan-schedule/bundle-invoice`;
};

export const generateBundleInvoice = async (
  id: number,
  bundleInvoiceBody: BundleInvoiceBody,
  options?: RequestInit,
): Promise<BundleInvoiceResult> => {
  return customFetch<BundleInvoiceResult>(getGenerateBundleInvoiceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bundleInvoiceBody),
  });
};

export const getGenerateBundleInvoiceMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | GenerateBundleInvoice422
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateBundleInvoice>>,
    TError,
    { id: number; data: BodyType<BundleInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateBundleInvoice>>,
  TError,
  { id: number; data: BodyType<BundleInvoiceBody> },
  TContext
> => {
  const mutationKey = ["generateBundleInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateBundleInvoice>>,
    { id: number; data: BodyType<BundleInvoiceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateBundleInvoice(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateBundleInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateBundleInvoice>>
>;
export type GenerateBundleInvoiceMutationBody = BodyType<BundleInvoiceBody>;
export type GenerateBundleInvoiceMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | GenerateBundleInvoice422
>;

/**
 * @summary Generate a combined TAX INVOICE PDF for a fully-paid quoteGroupId bundle (admin only)
 */
export const useGenerateBundleInvoice = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | GenerateBundleInvoice422
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateBundleInvoice>>,
    TError,
    { id: number; data: BodyType<BundleInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateBundleInvoice>>,
  TError,
  { id: number; data: BodyType<BundleInvoiceBody> },
  TContext
> => {
  return useMutation(getGenerateBundleInvoiceMutationOptions(options));
};

/**
 * @summary Atomically restructure a bundle — end old memberships, issue credit note, create new One_Time memberships (admin only)
 */
export const getRestructureBundleUrl = (id: number) => {
  return `/api/accounts/${id}/plan-schedule/restructure`;
};

export const restructureBundle = async (
  id: number,
  restructureBody: RestructureBody,
  options?: RequestInit,
): Promise<RestructureResult> => {
  return customFetch<RestructureResult>(getRestructureBundleUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(restructureBody),
  });
};

export const getRestructureBundleMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restructureBundle>>,
    TError,
    { id: number; data: BodyType<RestructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restructureBundle>>,
  TError,
  { id: number; data: BodyType<RestructureBody> },
  TContext
> => {
  const mutationKey = ["restructureBundle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restructureBundle>>,
    { id: number; data: BodyType<RestructureBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return restructureBundle(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestructureBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof restructureBundle>>
>;
export type RestructureBundleMutationBody = BodyType<RestructureBody>;
export type RestructureBundleMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Atomically restructure a bundle — end old memberships, issue credit note, create new One_Time memberships (admin only)
 */
export const useRestructureBundle = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restructureBundle>>,
    TError,
    { id: number; data: BodyType<RestructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restructureBundle>>,
  TError,
  { id: number; data: BodyType<RestructureBody> },
  TContext
> => {
  return useMutation(getRestructureBundleMutationOptions(options));
};

/**
 * @summary List refund records (deposit + credit-note) for an account
 */
export const getGetAccountRefundsUrl = (id: number) => {
  return `/api/accounts/${id}/plan-schedule/refunds`;
};

export const getAccountRefunds = async (
  id: number,
  options?: RequestInit,
): Promise<RefundList> => {
  return customFetch<RefundList>(getGetAccountRefundsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAccountRefundsQueryKey = (id: number) => {
  return [`/api/accounts/${id}/plan-schedule/refunds`] as const;
};

export const getGetAccountRefundsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountRefunds>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountRefunds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountRefundsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountRefunds>>
  > = ({ signal }) => getAccountRefunds(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountRefunds>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountRefundsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountRefunds>>
>;
export type GetAccountRefundsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List refund records (deposit + credit-note) for an account
 */

export function useGetAccountRefunds<
  TData = Awaited<ReturnType<typeof getAccountRefunds>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountRefunds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAccountRefundsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * By default returns only Held deposits (Restructure picker
compatibility). Pass `includeAll=true` to receive the full
history — Held / Refunded / Adjusted / Applied — needed by
the Security Deposits section on the account-detail page.

 * @summary List security deposits for an account
 */
export const getGetAccountDepositsUrl = (
  id: number,
  params?: GetAccountDepositsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounts/${id}/plan-schedule/deposits?${stringifiedParams}`
    : `/api/accounts/${id}/plan-schedule/deposits`;
};

export const getAccountDeposits = async (
  id: number,
  params?: GetAccountDepositsParams,
  options?: RequestInit,
): Promise<DepositList> => {
  return customFetch<DepositList>(getGetAccountDepositsUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getGetAccountDepositsQueryKey = (
  id: number,
  params?: GetAccountDepositsParams,
) => {
  return [
    `/api/accounts/${id}/plan-schedule/deposits`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAccountDepositsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountDeposits>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  params?: GetAccountDepositsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountDeposits>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountDepositsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountDeposits>>
  > = ({ signal }) =>
    getAccountDeposits(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountDeposits>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountDepositsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountDeposits>>
>;
export type GetAccountDepositsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List security deposits for an account
 */

export function useGetAccountDeposits<
  TData = Awaited<ReturnType<typeof getAccountDeposits>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  params?: GetAccountDepositsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountDeposits>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAccountDepositsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Transitions a Held deposit to:
  * Refunded — terminal. Requires lockInUntilDate <= today;
    returns 400 lock_in_not_completed otherwise. Records
    refund date, payment mode, proof, notes for the audit
    trail.
  * Adjusted — pending; the deposit will auto-apply to the
    customer's next plan.
Cannot transition from terminal states (Refunded/Applied).

 * @summary Mark a security deposit as Refunded or Adjusted (admin only)
 */
export const getSettleAccountDepositUrl = (id: number, depositId: number) => {
  return `/api/accounts/${id}/plan-schedule/deposits/${depositId}/settle`;
};

export const settleAccountDeposit = async (
  id: number,
  depositId: number,
  settleDepositBody: SettleDepositBody,
  options?: RequestInit,
): Promise<HeldDeposit> => {
  return customFetch<HeldDeposit>(getSettleAccountDepositUrl(id, depositId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(settleDepositBody),
  });
};

export const getSettleAccountDepositMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof settleAccountDeposit>>,
    TError,
    { id: number; depositId: number; data: BodyType<SettleDepositBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof settleAccountDeposit>>,
  TError,
  { id: number; depositId: number; data: BodyType<SettleDepositBody> },
  TContext
> => {
  const mutationKey = ["settleAccountDeposit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof settleAccountDeposit>>,
    { id: number; depositId: number; data: BodyType<SettleDepositBody> }
  > = (props) => {
    const { id, depositId, data } = props ?? {};

    return settleAccountDeposit(id, depositId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SettleAccountDepositMutationResult = NonNullable<
  Awaited<ReturnType<typeof settleAccountDeposit>>
>;
export type SettleAccountDepositMutationBody = BodyType<SettleDepositBody>;
export type SettleAccountDepositMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Mark a security deposit as Refunded or Adjusted (admin only)
 */
export const useSettleAccountDeposit = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof settleAccountDeposit>>,
    TError,
    { id: number; depositId: number; data: BodyType<SettleDepositBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof settleAccountDeposit>>,
  TError,
  { id: number; depositId: number; data: BodyType<SettleDepositBody> },
  TContext
> => {
  return useMutation(getSettleAccountDepositMutationOptions(options));
};

/**
 * Atomically: (1) clamps the applied amount to
min(deposit.amount, period.amount − period.amountPaid) and rejects
400 nothing_due if that is <= 0; (2) records the covered rent as
received on the period (amountPaid/status, ledger row linked via
depositId, paymentMode Deposit_Adjustment); (3) settles the deposit
to settlementStatus=Applied. Reduces cash-to-collect on the Record
Payment form. A refundable deposit is not a taxable supply, so this
does NOT alter the period's tax invoice — the deposit is only the
funding source. Requires the deposit be currently Held; returns 400
deposit_already_settled otherwise.

 * @summary Apply a Held security deposit toward a period's rent due (admin only)
 */
export const getApplyDepositToPeriodUrl = (id: number, depositId: number) => {
  return `/api/accounts/${id}/plan-schedule/deposits/${depositId}/apply-to-period`;
};

export const applyDepositToPeriod = async (
  id: number,
  depositId: number,
  applyDepositToPeriodBody: ApplyDepositToPeriodBody,
  options?: RequestInit,
): Promise<PlanSchedulePeriod> => {
  return customFetch<PlanSchedulePeriod>(
    getApplyDepositToPeriodUrl(id, depositId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(applyDepositToPeriodBody),
    },
  );
};

export const getApplyDepositToPeriodMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyDepositToPeriod>>,
    TError,
    { id: number; depositId: number; data: BodyType<ApplyDepositToPeriodBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyDepositToPeriod>>,
  TError,
  { id: number; depositId: number; data: BodyType<ApplyDepositToPeriodBody> },
  TContext
> => {
  const mutationKey = ["applyDepositToPeriod"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyDepositToPeriod>>,
    { id: number; depositId: number; data: BodyType<ApplyDepositToPeriodBody> }
  > = (props) => {
    const { id, depositId, data } = props ?? {};

    return applyDepositToPeriod(id, depositId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyDepositToPeriodMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyDepositToPeriod>>
>;
export type ApplyDepositToPeriodMutationBody =
  BodyType<ApplyDepositToPeriodBody>;
export type ApplyDepositToPeriodMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Apply a Held security deposit toward a period's rent due (admin only)
 */
export const useApplyDepositToPeriod = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyDepositToPeriod>>,
    TError,
    { id: number; depositId: number; data: BodyType<ApplyDepositToPeriodBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyDepositToPeriod>>,
  TError,
  { id: number; depositId: number; data: BodyType<ApplyDepositToPeriodBody> },
  TContext
> => {
  return useMutation(getApplyDepositToPeriodMutationOptions(options));
};

/**
 * @summary Exit a bundle and renew with a subset of items — drops one-off charges, starts fresh recurring memberships (admin only)
 */
export const getExitRenewBundleUrl = (id: number) => {
  return `/api/accounts/${id}/plan-schedule/exit-renew`;
};

export const exitRenewBundle = async (
  id: number,
  exitRenewBody: ExitRenewBody,
  options?: RequestInit,
): Promise<ExitRenewResult> => {
  return customFetch<ExitRenewResult>(getExitRenewBundleUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(exitRenewBody),
  });
};

export const getExitRenewBundleMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exitRenewBundle>>,
    TError,
    { id: number; data: BodyType<ExitRenewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exitRenewBundle>>,
  TError,
  { id: number; data: BodyType<ExitRenewBody> },
  TContext
> => {
  const mutationKey = ["exitRenewBundle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exitRenewBundle>>,
    { id: number; data: BodyType<ExitRenewBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return exitRenewBundle(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExitRenewBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof exitRenewBundle>>
>;
export type ExitRenewBundleMutationBody = BodyType<ExitRenewBody>;
export type ExitRenewBundleMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Exit a bundle and renew with a subset of items — drops one-off charges, starts fresh recurring memberships (admin only)
 */
export const useExitRenewBundle = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exitRenewBundle>>,
    TError,
    { id: number; data: BodyType<ExitRenewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof exitRenewBundle>>,
  TError,
  { id: number; data: BodyType<ExitRenewBody> },
  TContext
> => {
  return useMutation(getExitRenewBundleMutationOptions(options));
};

/**
 * @summary List all credit notes for an account, newest first
 */
export const getListAccountCreditNotesUrl = (id: number) => {
  return `/api/accounts/${id}/credit-notes`;
};

export const listAccountCreditNotes = async (
  id: number,
  options?: RequestInit,
): Promise<CreditNote[]> => {
  return customFetch<CreditNote[]>(getListAccountCreditNotesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListAccountCreditNotesQueryKey = (id: number) => {
  return [`/api/accounts/${id}/credit-notes`] as const;
};

export const getListAccountCreditNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountCreditNotes>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountCreditNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAccountCreditNotesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountCreditNotes>>
  > = ({ signal }) => listAccountCreditNotes(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountCreditNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAccountCreditNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountCreditNotes>>
>;
export type ListAccountCreditNotesQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List all credit notes for an account, newest first
 */

export function useListAccountCreditNotes<
  TData = Awaited<ReturnType<typeof listAccountCreditNotes>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountCreditNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAccountCreditNotesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a proper §34 GST credit note from an operator-entered
amount + reason. Backend splits the amount into taxable + GST
at the membership plan's tax rate, references the latest paid
invoice as the source, generates a PDF, and persists the row.
Different from the Restructure flow — this one is a single
manual entry, not a full membership restructure.

 * @summary Manually issue a credit note for an early-exit / settlement scenario
 */
export const getCreateManualCreditNoteUrl = (id: number) => {
  return `/api/accounts/${id}/credit-notes`;
};

export const createManualCreditNote = async (
  id: number,
  createManualCreditNoteBody: CreateManualCreditNoteBody,
  options?: RequestInit,
): Promise<CreditNote> => {
  return customFetch<CreditNote>(getCreateManualCreditNoteUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createManualCreditNoteBody),
  });
};

export const getCreateManualCreditNoteMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createManualCreditNote>>,
    TError,
    { id: number; data: BodyType<CreateManualCreditNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createManualCreditNote>>,
  TError,
  { id: number; data: BodyType<CreateManualCreditNoteBody> },
  TContext
> => {
  const mutationKey = ["createManualCreditNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createManualCreditNote>>,
    { id: number; data: BodyType<CreateManualCreditNoteBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createManualCreditNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateManualCreditNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createManualCreditNote>>
>;
export type CreateManualCreditNoteMutationBody =
  BodyType<CreateManualCreditNoteBody>;
export type CreateManualCreditNoteMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Manually issue a credit note for an early-exit / settlement scenario
 */
export const useCreateManualCreditNote = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createManualCreditNote>>,
    TError,
    { id: number; data: BodyType<CreateManualCreditNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createManualCreditNote>>,
  TError,
  { id: number; data: BodyType<CreateManualCreditNoteBody> },
  TContext
> => {
  return useMutation(getCreateManualCreditNoteMutationOptions(options));
};

/**
 * @summary Get a single credit note with its line items
 */
export const getGetCreditNoteUrl = (id: number) => {
  return `/api/credit-notes/${id}`;
};

export const getCreditNote = async (
  id: number,
  options?: RequestInit,
): Promise<CreditNote> => {
  return customFetch<CreditNote>(getGetCreditNoteUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCreditNoteQueryKey = (id: number) => {
  return [`/api/credit-notes/${id}`] as const;
};

export const getGetCreditNoteQueryOptions = <
  TData = Awaited<ReturnType<typeof getCreditNote>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCreditNote>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCreditNoteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditNote>>> = ({
    signal,
  }) => getCreditNote(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCreditNote>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCreditNoteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCreditNote>>
>;
export type GetCreditNoteQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get a single credit note with its line items
 */

export function useGetCreditNote<
  TData = Awaited<ReturnType<typeof getCreditNote>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCreditNote>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCreditNoteQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Atomically: (1) clamps the applied amount to
min(creditNote.totalReversed, period.amount − period.amountPaid) and
rejects 400 nothing_due if that is <= 0; (2) records the covered
rent as received on the period (amountPaid/status, ledger row
linked via creditNoteId, paymentMode Credit_Note_Adjustment);
(3) settles the credit note to settlementStatus=Applied. WHOLE
credit note only — there is no partial-amount body param; if
totalReversed exceeds the rent due, the excess is not usable here
and the credit note still flips to Applied. This is a
gross-to-gross funding offset — the credit note already reversed
GST on its original (superseded) period when issued, so applying
it does NOT create a second GST reversal and does NOT alter the
new period's tax invoice. Requires the credit note be currently
Issued or Adjusted; returns 400 credit_note_already_settled
otherwise.

 * @summary Apply a WHOLE Issued/Adjusted credit note toward a period's rent due (admin only)
 */
export const getApplyCreditNoteToPeriodUrl = (id: number) => {
  return `/api/credit-notes/${id}/apply-to-period`;
};

export const applyCreditNoteToPeriod = async (
  id: number,
  applyCreditNoteToPeriodBody: ApplyCreditNoteToPeriodBody,
  options?: RequestInit,
): Promise<PlanSchedulePeriod> => {
  return customFetch<PlanSchedulePeriod>(getApplyCreditNoteToPeriodUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(applyCreditNoteToPeriodBody),
  });
};

export const getApplyCreditNoteToPeriodMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyCreditNoteToPeriod>>,
    TError,
    { id: number; data: BodyType<ApplyCreditNoteToPeriodBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyCreditNoteToPeriod>>,
  TError,
  { id: number; data: BodyType<ApplyCreditNoteToPeriodBody> },
  TContext
> => {
  const mutationKey = ["applyCreditNoteToPeriod"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyCreditNoteToPeriod>>,
    { id: number; data: BodyType<ApplyCreditNoteToPeriodBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return applyCreditNoteToPeriod(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyCreditNoteToPeriodMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyCreditNoteToPeriod>>
>;
export type ApplyCreditNoteToPeriodMutationBody =
  BodyType<ApplyCreditNoteToPeriodBody>;
export type ApplyCreditNoteToPeriodMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Apply a WHOLE Issued/Adjusted credit note toward a period's rent due (admin only)
 */
export const useApplyCreditNoteToPeriod = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyCreditNoteToPeriod>>,
    TError,
    { id: number; data: BodyType<ApplyCreditNoteToPeriodBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyCreditNoteToPeriod>>,
  TError,
  { id: number; data: BodyType<ApplyCreditNoteToPeriodBody> },
  TContext
> => {
  return useMutation(getApplyCreditNoteToPeriodMutationOptions(options));
};

/**
 * @summary Re-render and re-upload the credit note PDF (admin only)
 */
export const getRegenerateCreditNotePdfUrl = (id: number) => {
  return `/api/credit-notes/${id}/pdf`;
};

export const regenerateCreditNotePdf = async (
  id: number,
  options?: RequestInit,
): Promise<RegenerateCreditNotePdfResult> => {
  return customFetch<RegenerateCreditNotePdfResult>(
    getRegenerateCreditNotePdfUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRegenerateCreditNotePdfMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCreditNotePdf>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateCreditNotePdf>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["regenerateCreditNotePdf"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateCreditNotePdf>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return regenerateCreditNotePdf(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateCreditNotePdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateCreditNotePdf>>
>;

export type RegenerateCreditNotePdfMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Re-render and re-upload the credit note PDF (admin only)
 */
export const useRegenerateCreditNotePdf = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCreditNotePdf>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateCreditNotePdf>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRegenerateCreditNotePdfMutationOptions(options));
};

/**
 * Transitions a credit note from Issued to:
  * Refunded — terminal; money paid back to the customer. The
    body's settlementPaymentMode/Date/ProofUrl/Notes are
    recorded as the refund audit trail.
  * Adjusted — pending; the credit will auto-apply to the
    customer's next plan via the Add Plan flow.
Cannot transition from Refunded/Applied (terminal states) or
manually set status to Issued/Applied (internal-only).

 * @summary Mark a credit note as Refunded or Adjusted (admin only)
 */
export const getSettleCreditNoteUrl = (id: number) => {
  return `/api/credit-notes/${id}/settle`;
};

export const settleCreditNote = async (
  id: number,
  settleCreditNoteBody: SettleCreditNoteBody,
  options?: RequestInit,
): Promise<CreditNote> => {
  return customFetch<CreditNote>(getSettleCreditNoteUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(settleCreditNoteBody),
  });
};

export const getSettleCreditNoteMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof settleCreditNote>>,
    TError,
    { id: number; data: BodyType<SettleCreditNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof settleCreditNote>>,
  TError,
  { id: number; data: BodyType<SettleCreditNoteBody> },
  TContext
> => {
  const mutationKey = ["settleCreditNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof settleCreditNote>>,
    { id: number; data: BodyType<SettleCreditNoteBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return settleCreditNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SettleCreditNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof settleCreditNote>>
>;
export type SettleCreditNoteMutationBody = BodyType<SettleCreditNoteBody>;
export type SettleCreditNoteMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Mark a credit note as Refunded or Adjusted (admin only)
 */
export const useSettleCreditNote = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof settleCreditNote>>,
    TError,
    { id: number; data: BodyType<SettleCreditNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof settleCreditNote>>,
  TError,
  { id: number; data: BodyType<SettleCreditNoteBody> },
  TContext
> => {
  return useMutation(getSettleCreditNoteMutationOptions(options));
};

/**
 * LEFT-JOIN-shaped read: each payment carries its allocations, and each
allocation carries enough target metadata (targetKind + targetId + a
display label) that the ledger card renders without a second
round-trip. Includes Void payments (status distinguishes them) so the
ledger reads as history, not just current state.

 * @summary List the payment ledger for an account — every payment with its allocation lines, newest first
 */
export const getListAccountPaymentsUrl = (id: number) => {
  return `/api/accounts/${id}/payments`;
};

export const listAccountPayments = async (
  id: number,
  options?: RequestInit,
): Promise<Payment[]> => {
  return customFetch<Payment[]>(getListAccountPaymentsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListAccountPaymentsQueryKey = (id: number) => {
  return [`/api/accounts/${id}/payments`] as const;
};

export const getListAccountPaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountPayments>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountPaymentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountPayments>>
  > = ({ signal }) => listAccountPayments(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountPayments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAccountPaymentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountPayments>>
>;
export type ListAccountPaymentsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List the payment ledger for an account — every payment with its allocation lines, newest first
 */

export function useListAccountPayments<
  TData = Awaited<ReturnType<typeof listAccountPayments>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAccountPaymentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates one payment header row for the tendered amount, plus zero or
more allocation lines. Sum of allocations[].amount must be <=
amount; any remainder stays unallocated on-account credit (spent
later via applyOnAccountCredit). An empty allocations array is a
valid booking advance — money received before any invoice or charge
exists. Concurrent allocation against the same target is guarded
server-side so two operators collecting on one account cannot
double-spend the due. Recomputes the paid state of every targeted
period/charge from the sum of its active allocations, inside the
same transaction as the allocation write.

 * @summary Record a payment against an account and allocate it across periods/charges/deposits/stock-outs in one transaction
 */
export const getAllocatePaymentUrl = (id: number) => {
  return `/api/accounts/${id}/payments`;
};

export const allocatePayment = async (
  id: number,
  allocatePaymentBody: AllocatePaymentBody,
  options?: RequestInit,
): Promise<Payment> => {
  return customFetch<Payment>(getAllocatePaymentUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(allocatePaymentBody),
  });
};

export const getAllocatePaymentMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allocatePayment>>,
    TError,
    { id: number; data: BodyType<AllocatePaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allocatePayment>>,
  TError,
  { id: number; data: BodyType<AllocatePaymentBody> },
  TContext
> => {
  const mutationKey = ["allocatePayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allocatePayment>>,
    { id: number; data: BodyType<AllocatePaymentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return allocatePayment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllocatePaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof allocatePayment>>
>;
export type AllocatePaymentMutationBody = BodyType<AllocatePaymentBody>;
export type AllocatePaymentMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Record a payment against an account and allocate it across periods/charges/deposits/stock-outs in one transaction
 */
export const useAllocatePayment = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allocatePayment>>,
    TError,
    { id: number; data: BodyType<AllocatePaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof allocatePayment>>,
  TError,
  { id: number; data: BodyType<AllocatePaymentBody> },
  TContext
> => {
  return useMutation(getAllocatePaymentMutationOptions(options));
};

/**
 * Explicit, audited move of on-account credit — money never moves
silently. Clamps each allocation to both the target's remaining due
and the payment's unallocatedAmount; rejects 400 if the payment has
insufficient remainder or does not belong to this account.

 * @summary Spend an existing payment's unallocated remainder against new dues (admin only)
 */
export const getApplyOnAccountCreditUrl = (id: number) => {
  return `/api/accounts/${id}/payments/apply-on-account`;
};

export const applyOnAccountCredit = async (
  id: number,
  applyOnAccountBody: ApplyOnAccountBody,
  options?: RequestInit,
): Promise<Payment> => {
  return customFetch<Payment>(getApplyOnAccountCreditUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(applyOnAccountBody),
  });
};

export const getApplyOnAccountCreditMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyOnAccountCredit>>,
    TError,
    { id: number; data: BodyType<ApplyOnAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyOnAccountCredit>>,
  TError,
  { id: number; data: BodyType<ApplyOnAccountBody> },
  TContext
> => {
  const mutationKey = ["applyOnAccountCredit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyOnAccountCredit>>,
    { id: number; data: BodyType<ApplyOnAccountBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return applyOnAccountCredit(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyOnAccountCreditMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyOnAccountCredit>>
>;
export type ApplyOnAccountCreditMutationBody = BodyType<ApplyOnAccountBody>;
export type ApplyOnAccountCreditMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Spend an existing payment's unallocated remainder against new dues (admin only)
 */
export const useApplyOnAccountCredit = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyOnAccountCredit>>,
    TError,
    { id: number; data: BodyType<ApplyOnAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyOnAccountCredit>>,
  TError,
  { id: number; data: BodyType<ApplyOnAccountBody> },
  TContext
> => {
  return useMutation(getApplyOnAccountCreditMutationOptions(options));
};

/**
 * Marks the payment Void — never deleted — and writes a compensating
reversal row for each active allocation line, recomputing the paid
state of every affected period/charge inside the same transaction.
Used for a bounced cheque or an erroneous entry.

 * @summary Void a payment and reverse every one of its active allocations (admin only)
 */
export const getVoidPaymentUrl = (paymentId: number) => {
  return `/api/payments/${paymentId}/void`;
};

export const voidPayment = async (
  paymentId: number,
  voidPaymentBody: VoidPaymentBody,
  options?: RequestInit,
): Promise<Payment> => {
  return customFetch<Payment>(getVoidPaymentUrl(paymentId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(voidPaymentBody),
  });
};

export const getVoidPaymentMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voidPayment>>,
    TError,
    { paymentId: number; data: BodyType<VoidPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof voidPayment>>,
  TError,
  { paymentId: number; data: BodyType<VoidPaymentBody> },
  TContext
> => {
  const mutationKey = ["voidPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof voidPayment>>,
    { paymentId: number; data: BodyType<VoidPaymentBody> }
  > = (props) => {
    const { paymentId, data } = props ?? {};

    return voidPayment(paymentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VoidPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof voidPayment>>
>;
export type VoidPaymentMutationBody = BodyType<VoidPaymentBody>;
export type VoidPaymentMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Void a payment and reverse every one of its active allocations (admin only)
 */
export const useVoidPayment = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voidPayment>>,
    TError,
    { paymentId: number; data: BodyType<VoidPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof voidPayment>>,
  TError,
  { paymentId: number; data: BodyType<VoidPaymentBody> },
  TContext
> => {
  return useMutation(getVoidPaymentMutationOptions(options));
};

/**
 * @summary Current-month order receipt for the account (consolidated, computed)
 */
export const getGetAccountOrderReceiptUrl = (id: number) => {
  return `/api/accounts/${id}/order-receipt`;
};

export const getAccountOrderReceipt = async (
  id: number,
  options?: RequestInit,
): Promise<AccountOrderReceiptView> => {
  return customFetch<AccountOrderReceiptView>(
    getGetAccountOrderReceiptUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAccountOrderReceiptQueryKey = (id: number) => {
  return [`/api/accounts/${id}/order-receipt`] as const;
};

export const getGetAccountOrderReceiptQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountOrderReceipt>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountOrderReceipt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountOrderReceiptQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountOrderReceipt>>
  > = ({ signal }) => getAccountOrderReceipt(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountOrderReceipt>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountOrderReceiptQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountOrderReceipt>>
>;
export type GetAccountOrderReceiptQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Current-month order receipt for the account (consolidated, computed)
 */

export function useGetAccountOrderReceipt<
  TData = Awaited<ReturnType<typeof getAccountOrderReceipt>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountOrderReceipt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAccountOrderReceiptQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Record received amount, render the order-receipt PDF, and WhatsApp it (admin only)
 */
export const getSendAccountOrderReceiptUrl = (id: number) => {
  return `/api/accounts/${id}/order-receipt/send`;
};

export const sendAccountOrderReceipt = async (
  id: number,
  sendOrderReceiptBody?: SendOrderReceiptBody,
  options?: RequestInit,
): Promise<SendOrderReceiptResponse> => {
  return customFetch<SendOrderReceiptResponse>(
    getSendAccountOrderReceiptUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(sendOrderReceiptBody),
    },
  );
};

export const getSendAccountOrderReceiptMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAccountOrderReceipt>>,
    TError,
    { id: number; data: BodyType<SendOrderReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendAccountOrderReceipt>>,
  TError,
  { id: number; data: BodyType<SendOrderReceiptBody> },
  TContext
> => {
  const mutationKey = ["sendAccountOrderReceipt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendAccountOrderReceipt>>,
    { id: number; data: BodyType<SendOrderReceiptBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendAccountOrderReceipt(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendAccountOrderReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendAccountOrderReceipt>>
>;
export type SendAccountOrderReceiptMutationBody =
  BodyType<SendOrderReceiptBody>;
export type SendAccountOrderReceiptMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Record received amount, render the order-receipt PDF, and WhatsApp it (admin only)
 */
export const useSendAccountOrderReceipt = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAccountOrderReceipt>>,
    TError,
    { id: number; data: BodyType<SendOrderReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendAccountOrderReceipt>>,
  TError,
  { id: number; data: BodyType<SendOrderReceiptBody> },
  TContext
> => {
  return useMutation(getSendAccountOrderReceiptMutationOptions(options));
};

/**
 * @summary List documents for an account
 */
export const getListAccountDocumentsUrl = (id: number) => {
  return `/api/accounts/${id}/documents`;
};

export const listAccountDocuments = async (
  id: number,
  options?: RequestInit,
): Promise<Document[]> => {
  return customFetch<Document[]>(getListAccountDocumentsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListAccountDocumentsQueryKey = (id: number) => {
  return [`/api/accounts/${id}/documents`] as const;
};

export const getListAccountDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountDocuments>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAccountDocumentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountDocuments>>
  > = ({ signal }) => listAccountDocuments(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountDocuments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAccountDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountDocuments>>
>;
export type ListAccountDocumentsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List documents for an account
 */

export function useListAccountDocuments<
  TData = Awaited<ReturnType<typeof listAccountDocuments>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAccountDocumentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload a document for an account (multipart/form-data)
 */
export const getUploadAccountDocumentUrl = (id: number) => {
  return `/api/accounts/${id}/documents`;
};

export const uploadAccountDocument = async (
  id: number,
  uploadDocumentBody: UploadDocumentBody,
  options?: RequestInit,
): Promise<Document> => {
  const formData = new FormData();
  formData.append(`type`, uploadDocumentBody.type);
  if (
    uploadDocumentBody.contactId !== undefined &&
    uploadDocumentBody.contactId !== null
  ) {
    formData.append(`contactId`, uploadDocumentBody.contactId.toString());
  }
  if (
    uploadDocumentBody.signedAt !== undefined &&
    uploadDocumentBody.signedAt !== null
  ) {
    formData.append(`signedAt`, uploadDocumentBody.signedAt);
  }
  if (uploadDocumentBody.file !== undefined) {
    formData.append(`file`, uploadDocumentBody.file);
  }

  return customFetch<Document>(getUploadAccountDocumentUrl(id), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadAccountDocumentMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadAccountDocument>>,
    TError,
    { id: number; data: BodyType<UploadDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadAccountDocument>>,
  TError,
  { id: number; data: BodyType<UploadDocumentBody> },
  TContext
> => {
  const mutationKey = ["uploadAccountDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadAccountDocument>>,
    { id: number; data: BodyType<UploadDocumentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return uploadAccountDocument(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadAccountDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadAccountDocument>>
>;
export type UploadAccountDocumentMutationBody = BodyType<UploadDocumentBody>;
export type UploadAccountDocumentMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Upload a document for an account (multipart/form-data)
 */
export const useUploadAccountDocument = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadAccountDocument>>,
    TError,
    { id: number; data: BodyType<UploadDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadAccountDocument>>,
  TError,
  { id: number; data: BodyType<UploadDocumentBody> },
  TContext
> => {
  return useMutation(getUploadAccountDocumentMutationOptions(options));
};

/**
 * @summary List communication log entries for an account
 */
export const getListAccountCommunicationsUrl = (
  id: number,
  params?: ListAccountCommunicationsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounts/${id}/communications?${stringifiedParams}`
    : `/api/accounts/${id}/communications`;
};

export const listAccountCommunications = async (
  id: number,
  params?: ListAccountCommunicationsParams,
  options?: RequestInit,
): Promise<CommunicationLogListResponse> => {
  return customFetch<CommunicationLogListResponse>(
    getListAccountCommunicationsUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAccountCommunicationsQueryKey = (
  id: number,
  params?: ListAccountCommunicationsParams,
) => {
  return [
    `/api/accounts/${id}/communications`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAccountCommunicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountCommunications>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  params?: ListAccountCommunicationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountCommunications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAccountCommunicationsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountCommunications>>
  > = ({ signal }) =>
    listAccountCommunications(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountCommunications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAccountCommunicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountCommunications>>
>;
export type ListAccountCommunicationsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List communication log entries for an account
 */

export function useListAccountCommunications<
  TData = Awaited<ReturnType<typeof listAccountCommunications>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  params?: ListAccountCommunicationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountCommunications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAccountCommunicationsQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get an account by ID
 */
export const getGetAccountUrl = (id: number) => {
  return `/api/accounts/${id}`;
};

export const getAccount = async (
  id: number,
  options?: RequestInit,
): Promise<Account> => {
  return customFetch<Account>(getGetAccountUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAccountQueryKey = (id: number) => {
  return [`/api/accounts/${id}`] as const;
};

export const getGetAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccount>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccount>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({
    signal,
  }) => getAccount(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccount>>
>;
export type GetAccountQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get an account by ID
 */

export function useGetAccount<
  TData = Awaited<ReturnType<typeof getAccount>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccount>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAccountQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an account (admin only)
 */
export const getUpdateAccountUrl = (id: number) => {
  return `/api/accounts/${id}`;
};

export const updateAccount = async (
  id: number,
  updateAccountBody: UpdateAccountBody,
  options?: RequestInit,
): Promise<Account> => {
  return customFetch<Account>(getUpdateAccountUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAccountBody),
  });
};

export const getUpdateAccountMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccount>>,
    TError,
    { id: number; data: BodyType<UpdateAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccount>>,
  TError,
  { id: number; data: BodyType<UpdateAccountBody> },
  TContext
> => {
  const mutationKey = ["updateAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccount>>,
    { id: number; data: BodyType<UpdateAccountBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAccount(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccount>>
>;
export type UpdateAccountMutationBody = BodyType<UpdateAccountBody>;
export type UpdateAccountMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Update an account (admin only)
 */
export const useUpdateAccount = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccount>>,
    TError,
    { id: number; data: BodyType<UpdateAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAccount>>,
  TError,
  { id: number; data: BodyType<UpdateAccountBody> },
  TContext
> => {
  return useMutation(getUpdateAccountMutationOptions(options));
};

/**
 * Safe-delete. Removes the account and its contacts only when the account has no real records attached. Refuses with 409 account_has_dependents (listing the blocking categories) if any memberships, invoices, charges, security deposits, proforma quotes, resource assignments, or documents reference it.

 * @summary Delete an account (admin only — guarded)
 */
export const getDeleteAccountUrl = (id: number) => {
  return `/api/accounts/${id}`;
};

export const deleteAccount = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteAccountUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAccountMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | NotFoundResponse | DeleteAccount409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccount>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAccount(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccount>>
>;

export type DeleteAccountMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | DeleteAccount409
>;

/**
 * @summary Delete an account (admin only — guarded)
 */
export const useDeleteAccount = <
  TError = ErrorType<
    UnauthorizedResponse | NotFoundResponse | DeleteAccount409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAccountMutationOptions(options));
};

/**
 * Phase 23: Creates account + primary contact + membership in a single transaction. Body reshaped from ConvertLeadToMemberBody (deprecated). Server defaults gstTreatment='unregistered_b2c' + placeOfSupply='07' when omitted (walk-in fast path).
 * @summary Convert a closed_won lead into an account + primary contact + membership (admin only)
 */
export const getConvertLeadUrl = () => {
  return `/api/members/convert-lead`;
};

export const convertLead = async (
  convertLeadToAccountBody: ConvertLeadToAccountBody,
  options?: RequestInit,
): Promise<ConvertLeadToAccountResponse> => {
  return customFetch<ConvertLeadToAccountResponse>(getConvertLeadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(convertLeadToAccountBody),
  });
};

export const getConvertLeadMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof convertLead>>,
    TError,
    { data: BodyType<ConvertLeadToAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof convertLead>>,
  TError,
  { data: BodyType<ConvertLeadToAccountBody> },
  TContext
> => {
  const mutationKey = ["convertLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof convertLead>>,
    { data: BodyType<ConvertLeadToAccountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return convertLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConvertLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof convertLead>>
>;
export type ConvertLeadMutationBody = BodyType<ConvertLeadToAccountBody>;
export type ConvertLeadMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Convert a closed_won lead into an account + primary contact + membership (admin only)
 */
export const useConvertLead = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof convertLead>>,
    TError,
    { data: BodyType<ConvertLeadToAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof convertLead>>,
  TError,
  { data: BodyType<ConvertLeadToAccountBody> },
  TContext
> => {
  return useMutation(getConvertLeadMutationOptions(options));
};

/**
 * @summary List inventory audit log entries (admin only)
 */
export const getListInventoryAuditLogUrl = (
  params?: ListInventoryAuditLogParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inventory/audit-log?${stringifiedParams}`
    : `/api/inventory/audit-log`;
};

export const listInventoryAuditLog = async (
  params?: ListInventoryAuditLogParams,
  options?: RequestInit,
): Promise<InventoryAuditLogListResponse> => {
  return customFetch<InventoryAuditLogListResponse>(
    getListInventoryAuditLogUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInventoryAuditLogQueryKey = (
  params?: ListInventoryAuditLogParams,
) => {
  return [`/api/inventory/audit-log`, ...(params ? [params] : [])] as const;
};

export const getListInventoryAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryAuditLog>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryAuditLogQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryAuditLog>>
  > = ({ signal }) =>
    listInventoryAuditLog(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryAuditLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInventoryAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryAuditLog>>
>;
export type ListInventoryAuditLogQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List inventory audit log entries (admin only)
 */

export function useListInventoryAuditLog<
  TData = Awaited<ReturnType<typeof listInventoryAuditLog>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInventoryAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInventoryAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInventoryAuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single audit log entry by ID
 */
export const getGetInventoryAuditLogEntryUrl = (id: number) => {
  return `/api/inventory/audit-log/${id}`;
};

export const getInventoryAuditLogEntry = async (
  id: number,
  options?: RequestInit,
): Promise<InventoryAuditLog> => {
  return customFetch<InventoryAuditLog>(getGetInventoryAuditLogEntryUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInventoryAuditLogEntryQueryKey = (id: number) => {
  return [`/api/inventory/audit-log/${id}`] as const;
};

export const getGetInventoryAuditLogEntryQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryAuditLogEntry>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryAuditLogEntry>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventoryAuditLogEntryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryAuditLogEntry>>
  > = ({ signal }) =>
    getInventoryAuditLogEntry(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryAuditLogEntry>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInventoryAuditLogEntryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryAuditLogEntry>>
>;
export type GetInventoryAuditLogEntryQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get a single audit log entry by ID
 */

export function useGetInventoryAuditLogEntry<
  TData = Awaited<ReturnType<typeof getInventoryAuditLogEntry>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInventoryAuditLogEntry>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInventoryAuditLogEntryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List Stock_In rows
 */
export const getListStockInUrl = (params?: ListStockInParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/stock-in?${stringifiedParams}`
    : `/api/operations/stock-in`;
};

export const listStockIn = async (
  params?: ListStockInParams,
  options?: RequestInit,
): Promise<StockInListResponse> => {
  return customFetch<StockInListResponse>(getListStockInUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListStockInQueryKey = (params?: ListStockInParams) => {
  return [`/api/operations/stock-in`, ...(params ? [params] : [])] as const;
};

export const getListStockInQueryOptions = <
  TData = Awaited<ReturnType<typeof listStockIn>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockInParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockIn>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStockInQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStockIn>>> = ({
    signal,
  }) => listStockIn(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStockIn>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStockInQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStockIn>>
>;
export type ListStockInQueryError = ErrorType<unknown>;

/**
 * @summary List Stock_In rows
 */

export function useListStockIn<
  TData = Awaited<ReturnType<typeof listStockIn>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockInParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockIn>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStockInQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create Stock_In (header + line items, atomic)
 */
export const getCreateStockInUrl = () => {
  return `/api/operations/stock-in`;
};

export const createStockIn = async (
  createStockInBody: CreateStockInBody,
  options?: RequestInit,
): Promise<StockIn> => {
  return customFetch<StockIn>(getCreateStockInUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createStockInBody),
  });
};

export const getCreateStockInMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockIn>>,
    TError,
    { data: BodyType<CreateStockInBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStockIn>>,
  TError,
  { data: BodyType<CreateStockInBody> },
  TContext
> => {
  const mutationKey = ["createStockIn"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStockIn>>,
    { data: BodyType<CreateStockInBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createStockIn(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStockInMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStockIn>>
>;
export type CreateStockInMutationBody = BodyType<CreateStockInBody>;
export type CreateStockInMutationError = ErrorType<void>;

/**
 * @summary Create Stock_In (header + line items, atomic)
 */
export const useCreateStockIn = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockIn>>,
    TError,
    { data: BodyType<CreateStockInBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStockIn>>,
  TError,
  { data: BodyType<CreateStockInBody> },
  TContext
> => {
  return useMutation(getCreateStockInMutationOptions(options));
};

/**
 * @summary Stock-In KPI summary tiles (current + previous-period comparison)
 */
export const getGetStockInSummaryUrl = (params: GetStockInSummaryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/stock-in/summary?${stringifiedParams}`
    : `/api/operations/stock-in/summary`;
};

export const getStockInSummary = async (
  params: GetStockInSummaryParams,
  options?: RequestInit,
): Promise<StockInSummary> => {
  return customFetch<StockInSummary>(getGetStockInSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetStockInSummaryQueryKey = (
  params?: GetStockInSummaryParams,
) => {
  return [
    `/api/operations/stock-in/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStockInSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockInSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetStockInSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockInSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockInSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockInSummary>>
  > = ({ signal }) => getStockInSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockInSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockInSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockInSummary>>
>;
export type GetStockInSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Stock-In KPI summary tiles (current + previous-period comparison)
 */

export function useGetStockInSummary<
  TData = Awaited<ReturnType<typeof getStockInSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetStockInSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockInSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStockInSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetStockInUrl = (id: number) => {
  return `/api/operations/stock-in/${id}`;
};

export const getStockIn = async (
  id: number,
  options?: RequestInit,
): Promise<StockIn> => {
  return customFetch<StockIn>(getGetStockInUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetStockInQueryKey = (id: number) => {
  return [`/api/operations/stock-in/${id}`] as const;
};

export const getGetStockInQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockIn>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockIn>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockInQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockIn>>> = ({
    signal,
  }) => getStockIn(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockIn>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockInQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockIn>>
>;
export type GetStockInQueryError = ErrorType<void>;

export function useGetStockIn<
  TData = Awaited<ReturnType<typeof getStockIn>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockIn>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStockInQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update Stock_In — used for Stage 2 QC reconciliation (D-23 same row)
 */
export const getUpdateStockInUrl = (id: number) => {
  return `/api/operations/stock-in/${id}`;
};

export const updateStockIn = async (
  id: number,
  updateStockInBody: UpdateStockInBody,
  options?: RequestInit,
): Promise<StockIn> => {
  return customFetch<StockIn>(getUpdateStockInUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateStockInBody),
  });
};

export const getUpdateStockInMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockIn>>,
    TError,
    { id: number; data: BodyType<UpdateStockInBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockIn>>,
  TError,
  { id: number; data: BodyType<UpdateStockInBody> },
  TContext
> => {
  const mutationKey = ["updateStockIn"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockIn>>,
    { id: number; data: BodyType<UpdateStockInBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStockIn(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockInMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockIn>>
>;
export type UpdateStockInMutationBody = BodyType<UpdateStockInBody>;
export type UpdateStockInMutationError = ErrorType<void>;

/**
 * @summary Update Stock_In — used for Stage 2 QC reconciliation (D-23 same row)
 */
export const useUpdateStockIn = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockIn>>,
    TError,
    { id: number; data: BodyType<UpdateStockInBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStockIn>>,
  TError,
  { id: number; data: BodyType<UpdateStockInBody> },
  TContext
> => {
  return useMutation(getUpdateStockInMutationOptions(options));
};

export const getDeleteStockInUrl = (id: number) => {
  return `/api/operations/stock-in/${id}`;
};

export const deleteStockIn = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteStockInUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteStockInMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStockIn>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStockIn>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteStockIn"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStockIn>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteStockIn(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStockInMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStockIn>>
>;

export type DeleteStockInMutationError = ErrorType<void>;

export const useDeleteStockIn = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStockIn>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteStockIn>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteStockInMutationOptions(options));
};

/**
 * @summary List Stock_In Orders (paginated, with filters)
 */
export const getListStockInOrdersUrl = (params?: ListStockInOrdersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/stock-in-orders?${stringifiedParams}`
    : `/api/operations/stock-in-orders`;
};

export const listStockInOrders = async (
  params?: ListStockInOrdersParams,
  options?: RequestInit,
): Promise<StockInOrderListResponse> => {
  return customFetch<StockInOrderListResponse>(
    getListStockInOrdersUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListStockInOrdersQueryKey = (
  params?: ListStockInOrdersParams,
) => {
  return [
    `/api/operations/stock-in-orders`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListStockInOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof listStockInOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockInOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockInOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListStockInOrdersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStockInOrders>>
  > = ({ signal }) => listStockInOrders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStockInOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStockInOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStockInOrders>>
>;
export type ListStockInOrdersQueryError = ErrorType<unknown>;

/**
 * @summary List Stock_In Orders (paginated, with filters)
 */

export function useListStockInOrders<
  TData = Awaited<ReturnType<typeof listStockInOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockInOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockInOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStockInOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a draft Stock_In Order (header + cart lines)
 */
export const getCreateStockInOrderUrl = () => {
  return `/api/operations/stock-in-orders`;
};

export const createStockInOrder = async (
  createStockInOrderBody: CreateStockInOrderBody,
  options?: RequestInit,
): Promise<StockInOrder> => {
  return customFetch<StockInOrder>(getCreateStockInOrderUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createStockInOrderBody),
  });
};

export const getCreateStockInOrderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockInOrder>>,
    TError,
    { data: BodyType<CreateStockInOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStockInOrder>>,
  TError,
  { data: BodyType<CreateStockInOrderBody> },
  TContext
> => {
  const mutationKey = ["createStockInOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStockInOrder>>,
    { data: BodyType<CreateStockInOrderBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createStockInOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStockInOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStockInOrder>>
>;
export type CreateStockInOrderMutationBody = BodyType<CreateStockInOrderBody>;
export type CreateStockInOrderMutationError = ErrorType<void>;

/**
 * @summary Create a draft Stock_In Order (header + cart lines)
 */
export const useCreateStockInOrder = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockInOrder>>,
    TError,
    { data: BodyType<CreateStockInOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStockInOrder>>,
  TError,
  { data: BodyType<CreateStockInOrderBody> },
  TContext
> => {
  return useMutation(getCreateStockInOrderMutationOptions(options));
};

/**
 * @summary Get a Stock_In Order with cart lines, deliveries, refund lines, and reconciliation
 */
export const getGetStockInOrderUrl = (id: number) => {
  return `/api/operations/stock-in-orders/${id}`;
};

export const getStockInOrder = async (
  id: number,
  options?: RequestInit,
): Promise<StockInOrder> => {
  return customFetch<StockInOrder>(getGetStockInOrderUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetStockInOrderQueryKey = (id: number) => {
  return [`/api/operations/stock-in-orders/${id}`] as const;
};

export const getGetStockInOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockInOrder>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockInOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockInOrderQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockInOrder>>> = ({
    signal,
  }) => getStockInOrder(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockInOrder>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockInOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockInOrder>>
>;
export type GetStockInOrderQueryError = ErrorType<void>;

/**
 * @summary Get a Stock_In Order with cart lines, deliveries, refund lines, and reconciliation
 */

export function useGetStockInOrder<
  TData = Awaited<ReturnType<typeof getStockInOrder>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockInOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStockInOrderQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Record upfront payment — transitions Draft → Placed
 */
export const getRecordStockInOrderPaymentUrl = (id: number) => {
  return `/api/operations/stock-in-orders/${id}/payment`;
};

export const recordStockInOrderPayment = async (
  id: number,
  recordOrderPaymentBody: RecordOrderPaymentBody,
  options?: RequestInit,
): Promise<StockInOrder> => {
  return customFetch<StockInOrder>(getRecordStockInOrderPaymentUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recordOrderPaymentBody),
  });
};

export const getRecordStockInOrderPaymentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordStockInOrderPayment>>,
    TError,
    { id: number; data: BodyType<RecordOrderPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordStockInOrderPayment>>,
  TError,
  { id: number; data: BodyType<RecordOrderPaymentBody> },
  TContext
> => {
  const mutationKey = ["recordStockInOrderPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordStockInOrderPayment>>,
    { id: number; data: BodyType<RecordOrderPaymentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return recordStockInOrderPayment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordStockInOrderPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordStockInOrderPayment>>
>;
export type RecordStockInOrderPaymentMutationBody =
  BodyType<RecordOrderPaymentBody>;
export type RecordStockInOrderPaymentMutationError = ErrorType<void>;

/**
 * @summary Record upfront payment — transitions Draft → Placed
 */
export const useRecordStockInOrderPayment = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordStockInOrderPayment>>,
    TError,
    { id: number; data: BodyType<RecordOrderPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordStockInOrderPayment>>,
  TError,
  { id: number; data: BodyType<RecordOrderPaymentBody> },
  TContext
> => {
  return useMutation(getRecordStockInOrderPaymentMutationOptions(options));
};

/**
 * @summary Edit non-payment header fields (notes / reference id / order proof URL)
 */
export const getUpdateStockInOrderHeaderUrl = (id: number) => {
  return `/api/operations/stock-in-orders/${id}/header`;
};

export const updateStockInOrderHeader = async (
  id: number,
  updateStockInOrderHeaderBody: UpdateStockInOrderHeaderBody,
  options?: RequestInit,
): Promise<StockInOrder> => {
  return customFetch<StockInOrder>(getUpdateStockInOrderHeaderUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateStockInOrderHeaderBody),
  });
};

export const getUpdateStockInOrderHeaderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderHeader>>,
    TError,
    { id: number; data: BodyType<UpdateStockInOrderHeaderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockInOrderHeader>>,
  TError,
  { id: number; data: BodyType<UpdateStockInOrderHeaderBody> },
  TContext
> => {
  const mutationKey = ["updateStockInOrderHeader"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockInOrderHeader>>,
    { id: number; data: BodyType<UpdateStockInOrderHeaderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStockInOrderHeader(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockInOrderHeaderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockInOrderHeader>>
>;
export type UpdateStockInOrderHeaderMutationBody =
  BodyType<UpdateStockInOrderHeaderBody>;
export type UpdateStockInOrderHeaderMutationError = ErrorType<void>;

/**
 * @summary Edit non-payment header fields (notes / reference id / order proof URL)
 */
export const useUpdateStockInOrderHeader = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderHeader>>,
    TError,
    { id: number; data: BodyType<UpdateStockInOrderHeaderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStockInOrderHeader>>,
  TError,
  { id: number; data: BodyType<UpdateStockInOrderHeaderBody> },
  TContext
> => {
  return useMutation(getUpdateStockInOrderHeaderMutationOptions(options));
};

/**
 * @summary Edit payment transaction details on an already-placed order
 */
export const getUpdateStockInOrderPaymentDetailsUrl = (id: number) => {
  return `/api/operations/stock-in-orders/${id}/payment-details`;
};

export const updateStockInOrderPaymentDetails = async (
  id: number,
  updateStockInOrderPaymentDetailsBody: UpdateStockInOrderPaymentDetailsBody,
  options?: RequestInit,
): Promise<StockInOrder> => {
  return customFetch<StockInOrder>(getUpdateStockInOrderPaymentDetailsUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateStockInOrderPaymentDetailsBody),
  });
};

export const getUpdateStockInOrderPaymentDetailsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderPaymentDetails>>,
    TError,
    { id: number; data: BodyType<UpdateStockInOrderPaymentDetailsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockInOrderPaymentDetails>>,
  TError,
  { id: number; data: BodyType<UpdateStockInOrderPaymentDetailsBody> },
  TContext
> => {
  const mutationKey = ["updateStockInOrderPaymentDetails"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockInOrderPaymentDetails>>,
    { id: number; data: BodyType<UpdateStockInOrderPaymentDetailsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStockInOrderPaymentDetails(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockInOrderPaymentDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockInOrderPaymentDetails>>
>;
export type UpdateStockInOrderPaymentDetailsMutationBody =
  BodyType<UpdateStockInOrderPaymentDetailsBody>;
export type UpdateStockInOrderPaymentDetailsMutationError = ErrorType<void>;

/**
 * @summary Edit payment transaction details on an already-placed order
 */
export const useUpdateStockInOrderPaymentDetails = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderPaymentDetails>>,
    TError,
    { id: number; data: BodyType<UpdateStockInOrderPaymentDetailsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStockInOrderPaymentDetails>>,
  TError,
  { id: number; data: BodyType<UpdateStockInOrderPaymentDetailsBody> },
  TContext
> => {
  return useMutation(
    getUpdateStockInOrderPaymentDetailsMutationOptions(options),
  );
};

/**
 * @summary Record a delivery — creates a linked Stock_In receipt with transactionType=Order_Delivery
 */
export const getRecordStockInOrderDeliveryUrl = (id: number) => {
  return `/api/operations/stock-in-orders/${id}/deliveries`;
};

export const recordStockInOrderDelivery = async (
  id: number,
  recordOrderDeliveryBody: RecordOrderDeliveryBody,
  options?: RequestInit,
): Promise<StockIn> => {
  return customFetch<StockIn>(getRecordStockInOrderDeliveryUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recordOrderDeliveryBody),
  });
};

export const getRecordStockInOrderDeliveryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordStockInOrderDelivery>>,
    TError,
    { id: number; data: BodyType<RecordOrderDeliveryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordStockInOrderDelivery>>,
  TError,
  { id: number; data: BodyType<RecordOrderDeliveryBody> },
  TContext
> => {
  const mutationKey = ["recordStockInOrderDelivery"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordStockInOrderDelivery>>,
    { id: number; data: BodyType<RecordOrderDeliveryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return recordStockInOrderDelivery(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordStockInOrderDeliveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordStockInOrderDelivery>>
>;
export type RecordStockInOrderDeliveryMutationBody =
  BodyType<RecordOrderDeliveryBody>;
export type RecordStockInOrderDeliveryMutationError = ErrorType<void>;

/**
 * @summary Record a delivery — creates a linked Stock_In receipt with transactionType=Order_Delivery
 */
export const useRecordStockInOrderDelivery = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordStockInOrderDelivery>>,
    TError,
    { id: number; data: BodyType<RecordOrderDeliveryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordStockInOrderDelivery>>,
  TError,
  { id: number; data: BodyType<RecordOrderDeliveryBody> },
  TContext
> => {
  return useMutation(getRecordStockInOrderDeliveryMutationOptions(options));
};

/**
 * @summary Add a refund line to a Stock_In Order
 */
export const getCreateStockInOrderRefundLineUrl = (id: number) => {
  return `/api/operations/stock-in-orders/${id}/refund-lines`;
};

export const createStockInOrderRefundLine = async (
  id: number,
  createOrderRefundLineBody: CreateOrderRefundLineBody,
  options?: RequestInit,
): Promise<StockInOrderRefundLine> => {
  return customFetch<StockInOrderRefundLine>(
    getCreateStockInOrderRefundLineUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createOrderRefundLineBody),
    },
  );
};

export const getCreateStockInOrderRefundLineMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockInOrderRefundLine>>,
    TError,
    { id: number; data: BodyType<CreateOrderRefundLineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStockInOrderRefundLine>>,
  TError,
  { id: number; data: BodyType<CreateOrderRefundLineBody> },
  TContext
> => {
  const mutationKey = ["createStockInOrderRefundLine"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStockInOrderRefundLine>>,
    { id: number; data: BodyType<CreateOrderRefundLineBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createStockInOrderRefundLine(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStockInOrderRefundLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStockInOrderRefundLine>>
>;
export type CreateStockInOrderRefundLineMutationBody =
  BodyType<CreateOrderRefundLineBody>;
export type CreateStockInOrderRefundLineMutationError = ErrorType<void>;

/**
 * @summary Add a refund line to a Stock_In Order
 */
export const useCreateStockInOrderRefundLine = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockInOrderRefundLine>>,
    TError,
    { id: number; data: BodyType<CreateOrderRefundLineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStockInOrderRefundLine>>,
  TError,
  { id: number; data: BodyType<CreateOrderRefundLineBody> },
  TContext
> => {
  return useMutation(getCreateStockInOrderRefundLineMutationOptions(options));
};

/**
 * @summary Add a new cart line to an existing order
 */
export const getAddStockInOrderCartLineUrl = (id: number) => {
  return `/api/operations/stock-in-orders/${id}/cart-lines`;
};

export const addStockInOrderCartLine = async (
  id: number,
  createStockInOrderCartLineInput: CreateStockInOrderCartLineInput,
  options?: RequestInit,
): Promise<StockInOrderCartLine> => {
  return customFetch<StockInOrderCartLine>(getAddStockInOrderCartLineUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createStockInOrderCartLineInput),
  });
};

export const getAddStockInOrderCartLineMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addStockInOrderCartLine>>,
    TError,
    { id: number; data: BodyType<CreateStockInOrderCartLineInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addStockInOrderCartLine>>,
  TError,
  { id: number; data: BodyType<CreateStockInOrderCartLineInput> },
  TContext
> => {
  const mutationKey = ["addStockInOrderCartLine"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addStockInOrderCartLine>>,
    { id: number; data: BodyType<CreateStockInOrderCartLineInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addStockInOrderCartLine(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddStockInOrderCartLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof addStockInOrderCartLine>>
>;
export type AddStockInOrderCartLineMutationBody =
  BodyType<CreateStockInOrderCartLineInput>;
export type AddStockInOrderCartLineMutationError = ErrorType<void>;

/**
 * @summary Add a new cart line to an existing order
 */
export const useAddStockInOrderCartLine = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addStockInOrderCartLine>>,
    TError,
    { id: number; data: BodyType<CreateStockInOrderCartLineInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addStockInOrderCartLine>>,
  TError,
  { id: number; data: BodyType<CreateStockInOrderCartLineInput> },
  TContext
> => {
  return useMutation(getAddStockInOrderCartLineMutationOptions(options));
};

/**
 * @summary Edit qty / expected price / notes on a cart line (status uses its own endpoint)
 */
export const getUpdateStockInOrderCartLineUrl = (
  id: number,
  lineId: number,
) => {
  return `/api/operations/stock-in-orders/${id}/cart-lines/${lineId}`;
};

export const updateStockInOrderCartLine = async (
  id: number,
  lineId: number,
  updateStockInOrderCartLineBody: UpdateStockInOrderCartLineBody,
  options?: RequestInit,
): Promise<StockInOrderCartLine> => {
  return customFetch<StockInOrderCartLine>(
    getUpdateStockInOrderCartLineUrl(id, lineId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateStockInOrderCartLineBody),
    },
  );
};

export const getUpdateStockInOrderCartLineMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderCartLine>>,
    TError,
    {
      id: number;
      lineId: number;
      data: BodyType<UpdateStockInOrderCartLineBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockInOrderCartLine>>,
  TError,
  {
    id: number;
    lineId: number;
    data: BodyType<UpdateStockInOrderCartLineBody>;
  },
  TContext
> => {
  const mutationKey = ["updateStockInOrderCartLine"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockInOrderCartLine>>,
    {
      id: number;
      lineId: number;
      data: BodyType<UpdateStockInOrderCartLineBody>;
    }
  > = (props) => {
    const { id, lineId, data } = props ?? {};

    return updateStockInOrderCartLine(id, lineId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockInOrderCartLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockInOrderCartLine>>
>;
export type UpdateStockInOrderCartLineMutationBody =
  BodyType<UpdateStockInOrderCartLineBody>;
export type UpdateStockInOrderCartLineMutationError = ErrorType<void>;

/**
 * @summary Edit qty / expected price / notes on a cart line (status uses its own endpoint)
 */
export const useUpdateStockInOrderCartLine = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderCartLine>>,
    TError,
    {
      id: number;
      lineId: number;
      data: BodyType<UpdateStockInOrderCartLineBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStockInOrderCartLine>>,
  TError,
  {
    id: number;
    lineId: number;
    data: BodyType<UpdateStockInOrderCartLineBody>;
  },
  TContext
> => {
  return useMutation(getUpdateStockInOrderCartLineMutationOptions(options));
};

/**
 * @summary Remove a cart line — only when no delivery has been recorded against it
 */
export const getDeleteStockInOrderCartLineUrl = (
  id: number,
  lineId: number,
) => {
  return `/api/operations/stock-in-orders/${id}/cart-lines/${lineId}`;
};

export const deleteStockInOrderCartLine = async (
  id: number,
  lineId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteStockInOrderCartLineUrl(id, lineId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteStockInOrderCartLineMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStockInOrderCartLine>>,
    TError,
    { id: number; lineId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStockInOrderCartLine>>,
  TError,
  { id: number; lineId: number },
  TContext
> => {
  const mutationKey = ["deleteStockInOrderCartLine"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStockInOrderCartLine>>,
    { id: number; lineId: number }
  > = (props) => {
    const { id, lineId } = props ?? {};

    return deleteStockInOrderCartLine(id, lineId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStockInOrderCartLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStockInOrderCartLine>>
>;

export type DeleteStockInOrderCartLineMutationError = ErrorType<void>;

/**
 * @summary Remove a cart line — only when no delivery has been recorded against it
 */
export const useDeleteStockInOrderCartLine = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStockInOrderCartLine>>,
    TError,
    { id: number; lineId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteStockInOrderCartLine>>,
  TError,
  { id: number; lineId: number },
  TContext
> => {
  return useMutation(getDeleteStockInOrderCartLineMutationOptions(options));
};

/**
 * @summary Change a cart-line's status (Returned / Refunded / Personal / etc)
 */
export const getUpdateStockInOrderCartLineStatusUrl = (
  id: number,
  lineId: number,
) => {
  return `/api/operations/stock-in-orders/${id}/cart-lines/${lineId}/status`;
};

export const updateStockInOrderCartLineStatus = async (
  id: number,
  lineId: number,
  updateStockInOrderCartLineStatusBody: UpdateStockInOrderCartLineStatusBody,
  options?: RequestInit,
): Promise<StockInOrderCartLine> => {
  return customFetch<StockInOrderCartLine>(
    getUpdateStockInOrderCartLineStatusUrl(id, lineId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateStockInOrderCartLineStatusBody),
    },
  );
};

export const getUpdateStockInOrderCartLineStatusMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderCartLineStatus>>,
    TError,
    {
      id: number;
      lineId: number;
      data: BodyType<UpdateStockInOrderCartLineStatusBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockInOrderCartLineStatus>>,
  TError,
  {
    id: number;
    lineId: number;
    data: BodyType<UpdateStockInOrderCartLineStatusBody>;
  },
  TContext
> => {
  const mutationKey = ["updateStockInOrderCartLineStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockInOrderCartLineStatus>>,
    {
      id: number;
      lineId: number;
      data: BodyType<UpdateStockInOrderCartLineStatusBody>;
    }
  > = (props) => {
    const { id, lineId, data } = props ?? {};

    return updateStockInOrderCartLineStatus(id, lineId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockInOrderCartLineStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockInOrderCartLineStatus>>
>;
export type UpdateStockInOrderCartLineStatusMutationBody =
  BodyType<UpdateStockInOrderCartLineStatusBody>;
export type UpdateStockInOrderCartLineStatusMutationError = ErrorType<void>;

/**
 * @summary Change a cart-line's status (Returned / Refunded / Personal / etc)
 */
export const useUpdateStockInOrderCartLineStatus = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderCartLineStatus>>,
    TError,
    {
      id: number;
      lineId: number;
      data: BodyType<UpdateStockInOrderCartLineStatusBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStockInOrderCartLineStatus>>,
  TError,
  {
    id: number;
    lineId: number;
    data: BodyType<UpdateStockInOrderCartLineStatusBody>;
  },
  TContext
> => {
  return useMutation(
    getUpdateStockInOrderCartLineStatusMutationOptions(options),
  );
};

/**
 * @summary Mark a refund line as Received (+ capture payment detail)
 */
export const getUpdateStockInOrderRefundLineUrl = (
  id: number,
  lineId: number,
) => {
  return `/api/operations/stock-in-orders/${id}/refund-lines/${lineId}`;
};

export const updateStockInOrderRefundLine = async (
  id: number,
  lineId: number,
  updateOrderRefundLineBody: UpdateOrderRefundLineBody,
  options?: RequestInit,
): Promise<StockInOrderRefundLine> => {
  return customFetch<StockInOrderRefundLine>(
    getUpdateStockInOrderRefundLineUrl(id, lineId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateOrderRefundLineBody),
    },
  );
};

export const getUpdateStockInOrderRefundLineMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderRefundLine>>,
    TError,
    { id: number; lineId: number; data: BodyType<UpdateOrderRefundLineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockInOrderRefundLine>>,
  TError,
  { id: number; lineId: number; data: BodyType<UpdateOrderRefundLineBody> },
  TContext
> => {
  const mutationKey = ["updateStockInOrderRefundLine"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockInOrderRefundLine>>,
    { id: number; lineId: number; data: BodyType<UpdateOrderRefundLineBody> }
  > = (props) => {
    const { id, lineId, data } = props ?? {};

    return updateStockInOrderRefundLine(id, lineId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockInOrderRefundLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockInOrderRefundLine>>
>;
export type UpdateStockInOrderRefundLineMutationBody =
  BodyType<UpdateOrderRefundLineBody>;
export type UpdateStockInOrderRefundLineMutationError = ErrorType<void>;

/**
 * @summary Mark a refund line as Received (+ capture payment detail)
 */
export const useUpdateStockInOrderRefundLine = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockInOrderRefundLine>>,
    TError,
    { id: number; lineId: number; data: BodyType<UpdateOrderRefundLineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStockInOrderRefundLine>>,
  TError,
  { id: number; lineId: number; data: BodyType<UpdateOrderRefundLineBody> },
  TContext
> => {
  return useMutation(getUpdateStockInOrderRefundLineMutationOptions(options));
};

/**
 * @summary Cancel a Stock_In Order (Draft or Placed); auto-creates refund line for delivered value
 */
export const getCancelStockInOrderUrl = (id: number) => {
  return `/api/operations/stock-in-orders/${id}/cancel`;
};

export const cancelStockInOrder = async (
  id: number,
  cancelOrderBody: CancelOrderBody,
  options?: RequestInit,
): Promise<StockInOrder> => {
  return customFetch<StockInOrder>(getCancelStockInOrderUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cancelOrderBody),
  });
};

export const getCancelStockInOrderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelStockInOrder>>,
    TError,
    { id: number; data: BodyType<CancelOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelStockInOrder>>,
  TError,
  { id: number; data: BodyType<CancelOrderBody> },
  TContext
> => {
  const mutationKey = ["cancelStockInOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelStockInOrder>>,
    { id: number; data: BodyType<CancelOrderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return cancelStockInOrder(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelStockInOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelStockInOrder>>
>;
export type CancelStockInOrderMutationBody = BodyType<CancelOrderBody>;
export type CancelStockInOrderMutationError = ErrorType<void>;

/**
 * @summary Cancel a Stock_In Order (Draft or Placed); auto-creates refund line for delivered value
 */
export const useCancelStockInOrder = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelStockInOrder>>,
    TError,
    { id: number; data: BodyType<CancelOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelStockInOrder>>,
  TError,
  { id: number; data: BodyType<CancelOrderBody> },
  TContext
> => {
  return useMutation(getCancelStockInOrderMutationOptions(options));
};

/**
 * @summary Close a Fully_Delivered order; warns on shortfall and auto-creates refund lines on confirm
 */
export const getCloseStockInOrderUrl = (id: number) => {
  return `/api/operations/stock-in-orders/${id}/close`;
};

export const closeStockInOrder = async (
  id: number,
  closeOrderBody: CloseOrderBody,
  options?: RequestInit,
): Promise<StockInOrder> => {
  return customFetch<StockInOrder>(getCloseStockInOrderUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(closeOrderBody),
  });
};

export const getCloseStockInOrderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeStockInOrder>>,
    TError,
    { id: number; data: BodyType<CloseOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeStockInOrder>>,
  TError,
  { id: number; data: BodyType<CloseOrderBody> },
  TContext
> => {
  const mutationKey = ["closeStockInOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeStockInOrder>>,
    { id: number; data: BodyType<CloseOrderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return closeStockInOrder(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseStockInOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof closeStockInOrder>>
>;
export type CloseStockInOrderMutationBody = BodyType<CloseOrderBody>;
export type CloseStockInOrderMutationError = ErrorType<void>;

/**
 * @summary Close a Fully_Delivered order; warns on shortfall and auto-creates refund lines on confirm
 */
export const useCloseStockInOrder = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeStockInOrder>>,
    TError,
    { id: number; data: BodyType<CloseOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof closeStockInOrder>>,
  TError,
  { id: number; data: BodyType<CloseOrderBody> },
  TContext
> => {
  return useMutation(getCloseStockInOrderMutationOptions(options));
};

/**
 * @summary List Stock_Out rows
 */
export const getListStockOutUrl = (params?: ListStockOutParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/stock-out?${stringifiedParams}`
    : `/api/operations/stock-out`;
};

export const listStockOut = async (
  params?: ListStockOutParams,
  options?: RequestInit,
): Promise<StockOutListResponse> => {
  return customFetch<StockOutListResponse>(getListStockOutUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListStockOutQueryKey = (params?: ListStockOutParams) => {
  return [`/api/operations/stock-out`, ...(params ? [params] : [])] as const;
};

export const getListStockOutQueryOptions = <
  TData = Awaited<ReturnType<typeof listStockOut>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockOutParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockOut>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStockOutQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStockOut>>> = ({
    signal,
  }) => listStockOut(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStockOut>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStockOutQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStockOut>>
>;
export type ListStockOutQueryError = ErrorType<unknown>;

/**
 * @summary List Stock_Out rows
 */

export function useListStockOut<
  TData = Awaited<ReturnType<typeof listStockOut>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockOutParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockOut>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStockOutQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create Stock_Out (atomic decrement + entitlement + charge)
 */
export const getCreateStockOutUrl = () => {
  return `/api/operations/stock-out`;
};

export const createStockOut = async (
  createStockOutBody: CreateStockOutBody,
  options?: RequestInit,
): Promise<StockOut> => {
  return customFetch<StockOut>(getCreateStockOutUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createStockOutBody),
  });
};

export const getCreateStockOutMutationOptions = <
  TError = ErrorType<void | StockOutInsufficientComponentError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockOut>>,
    TError,
    { data: BodyType<CreateStockOutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStockOut>>,
  TError,
  { data: BodyType<CreateStockOutBody> },
  TContext
> => {
  const mutationKey = ["createStockOut"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStockOut>>,
    { data: BodyType<CreateStockOutBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createStockOut(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStockOutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStockOut>>
>;
export type CreateStockOutMutationBody = BodyType<CreateStockOutBody>;
export type CreateStockOutMutationError =
  ErrorType<void | StockOutInsufficientComponentError>;

/**
 * @summary Create Stock_Out (atomic decrement + entitlement + charge)
 */
export const useCreateStockOut = <
  TError = ErrorType<void | StockOutInsufficientComponentError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockOut>>,
    TError,
    { data: BodyType<CreateStockOutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStockOut>>,
  TError,
  { data: BodyType<CreateStockOutBody> },
  TContext
> => {
  return useMutation(getCreateStockOutMutationOptions(options));
};

export const getGetStockOutUrl = (id: number) => {
  return `/api/operations/stock-out/${id}`;
};

export const getStockOut = async (
  id: number,
  options?: RequestInit,
): Promise<StockOut> => {
  return customFetch<StockOut>(getGetStockOutUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetStockOutQueryKey = (id: number) => {
  return [`/api/operations/stock-out/${id}`] as const;
};

export const getGetStockOutQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockOut>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockOut>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockOutQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockOut>>> = ({
    signal,
  }) => getStockOut(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockOut>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockOutQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockOut>>
>;
export type GetStockOutQueryError = ErrorType<void>;

export function useGetStockOut<
  TData = Awaited<ReturnType<typeof getStockOut>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockOut>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStockOutQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a Stock_Out row's payment status / method (used by the Transactions tab's Mark-as-Paid action)
 */
export const getUpdateStockOutUrl = (id: number) => {
  return `/api/operations/stock-out/${id}`;
};

export const updateStockOut = async (
  id: number,
  updateStockOutBody: UpdateStockOutBody,
  options?: RequestInit,
): Promise<StockOut> => {
  return customFetch<StockOut>(getUpdateStockOutUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateStockOutBody),
  });
};

export const getUpdateStockOutMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockOut>>,
    TError,
    { id: number; data: BodyType<UpdateStockOutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockOut>>,
  TError,
  { id: number; data: BodyType<UpdateStockOutBody> },
  TContext
> => {
  const mutationKey = ["updateStockOut"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockOut>>,
    { id: number; data: BodyType<UpdateStockOutBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStockOut(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockOutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockOut>>
>;
export type UpdateStockOutMutationBody = BodyType<UpdateStockOutBody>;
export type UpdateStockOutMutationError = ErrorType<void>;

/**
 * @summary Update a Stock_Out row's payment status / method (used by the Transactions tab's Mark-as-Paid action)
 */
export const useUpdateStockOut = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockOut>>,
    TError,
    { id: number; data: BodyType<UpdateStockOutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStockOut>>,
  TError,
  { id: number; data: BodyType<UpdateStockOutBody> },
  TContext
> => {
  return useMutation(getUpdateStockOutMutationOptions(options));
};

/**
 * Removes a stock-out row that is still pending payment. Reverses each
recipe-component / variant / simple-item stock decrement, restores
the member entitlement quota, and cascade-deletes the linked
member_charge if any (must be status='Pending'). All actions run in
one transaction with audit-log entries so the deletion is
recoverable. Rejects with 409 if the row (or its charge) is already
Paid or invoice-referenced.

 * @summary Delete a Pending Stock_Out (reverses stock, entitlement, and cascades the linked Pending member_charge)
 */
export const getDeleteStockOutUrl = (id: number) => {
  return `/api/operations/stock-out/${id}`;
};

export const deleteStockOut = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteStockOut200> => {
  return customFetch<DeleteStockOut200>(getDeleteStockOutUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteStockOutMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStockOut>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStockOut>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteStockOut"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStockOut>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteStockOut(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStockOutMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStockOut>>
>;

export type DeleteStockOutMutationError = ErrorType<void>;

/**
 * @summary Delete a Pending Stock_Out (reverses stock, entitlement, and cascades the linked Pending member_charge)
 */
export const useDeleteStockOut = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStockOut>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteStockOut>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteStockOutMutationOptions(options));
};

/**
 * Retroactively settles a set of Pending stock_out rows that were sold
at different times (different or NULL cart_ids). Used by the account
Transactions tab's F&B multi-select "Collect payment" action when the
operator collects one payment covering more than one prior sale.
Cascades to each linked Pending member_charge in the same
transaction; idempotent for charges already Paid/Waived.

 * @summary Mark multiple Stock_Out rows Paid in one transaction (retro-bundle collect)
 */
export const getMarkStockOutBulkPaidUrl = () => {
  return `/api/operations/stock-out/bulk-payment`;
};

export const markStockOutBulkPaid = async (
  markStockOutBulkPaidBody: MarkStockOutBulkPaidBody,
  options?: RequestInit,
): Promise<MarkStockOutBulkPaid200> => {
  return customFetch<MarkStockOutBulkPaid200>(getMarkStockOutBulkPaidUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(markStockOutBulkPaidBody),
  });
};

export const getMarkStockOutBulkPaidMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markStockOutBulkPaid>>,
    TError,
    { data: BodyType<MarkStockOutBulkPaidBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markStockOutBulkPaid>>,
  TError,
  { data: BodyType<MarkStockOutBulkPaidBody> },
  TContext
> => {
  const mutationKey = ["markStockOutBulkPaid"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markStockOutBulkPaid>>,
    { data: BodyType<MarkStockOutBulkPaidBody> }
  > = (props) => {
    const { data } = props ?? {};

    return markStockOutBulkPaid(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkStockOutBulkPaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof markStockOutBulkPaid>>
>;
export type MarkStockOutBulkPaidMutationBody =
  BodyType<MarkStockOutBulkPaidBody>;
export type MarkStockOutBulkPaidMutationError = ErrorType<void>;

/**
 * @summary Mark multiple Stock_Out rows Paid in one transaction (retro-bundle collect)
 */
export const useMarkStockOutBulkPaid = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markStockOutBulkPaid>>,
    TError,
    { data: BodyType<MarkStockOutBulkPaidBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markStockOutBulkPaid>>,
  TError,
  { data: BodyType<MarkStockOutBulkPaidBody> },
  TContext
> => {
  return useMutation(getMarkStockOutBulkPaidMutationOptions(options));
};

/**
 * Atomically updates `payment_status`, `payment_method`,
`invoice_reference`, and `payment_proof_url` on every row that
shares the given `cart_id`. Used by the Transactions tab when
the operator settles a multi-item Pay-Per-Use cart with one
UPI transfer — the same Merchant Copy is recorded against
each sibling row, so the audit trail still has the proof.

 * @summary Mark every Stock_Out row in a cart as Paid with one proof / txn id
 */
export const getMarkStockOutCartPaidUrl = (cartId: string) => {
  return `/api/operations/stock-out/cart/${cartId}/payment`;
};

export const markStockOutCartPaid = async (
  cartId: string,
  updateStockOutBody: UpdateStockOutBody,
  options?: RequestInit,
): Promise<MarkStockOutCartPaid200> => {
  return customFetch<MarkStockOutCartPaid200>(
    getMarkStockOutCartPaidUrl(cartId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateStockOutBody),
    },
  );
};

export const getMarkStockOutCartPaidMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markStockOutCartPaid>>,
    TError,
    { cartId: string; data: BodyType<UpdateStockOutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markStockOutCartPaid>>,
  TError,
  { cartId: string; data: BodyType<UpdateStockOutBody> },
  TContext
> => {
  const mutationKey = ["markStockOutCartPaid"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markStockOutCartPaid>>,
    { cartId: string; data: BodyType<UpdateStockOutBody> }
  > = (props) => {
    const { cartId, data } = props ?? {};

    return markStockOutCartPaid(cartId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkStockOutCartPaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof markStockOutCartPaid>>
>;
export type MarkStockOutCartPaidMutationBody = BodyType<UpdateStockOutBody>;
export type MarkStockOutCartPaidMutationError = ErrorType<void>;

/**
 * @summary Mark every Stock_Out row in a cart as Paid with one proof / txn id
 */
export const useMarkStockOutCartPaid = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markStockOutCartPaid>>,
    TError,
    { cartId: string; data: BodyType<UpdateStockOutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markStockOutCartPaid>>,
  TError,
  { cartId: string; data: BodyType<UpdateStockOutBody> },
  TContext
> => {
  return useMutation(getMarkStockOutCartPaidMutationOptions(options));
};

/**
 * @summary List Daily_Order_Schedule rows
 */
export const getListDailyOrderScheduleUrl = (
  params?: ListDailyOrderScheduleParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/daily-orders?${stringifiedParams}`
    : `/api/operations/daily-orders`;
};

export const listDailyOrderSchedule = async (
  params?: ListDailyOrderScheduleParams,
  options?: RequestInit,
): Promise<DailyOrderSchedule[]> => {
  return customFetch<DailyOrderSchedule[]>(
    getListDailyOrderScheduleUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListDailyOrderScheduleQueryKey = (
  params?: ListDailyOrderScheduleParams,
) => {
  return [`/api/operations/daily-orders`, ...(params ? [params] : [])] as const;
};

export const getListDailyOrderScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof listDailyOrderSchedule>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDailyOrderScheduleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDailyOrderSchedule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDailyOrderScheduleQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDailyOrderSchedule>>
  > = ({ signal }) =>
    listDailyOrderSchedule(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDailyOrderSchedule>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDailyOrderScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDailyOrderSchedule>>
>;
export type ListDailyOrderScheduleQueryError = ErrorType<unknown>;

/**
 * @summary List Daily_Order_Schedule rows
 */

export function useListDailyOrderSchedule<
  TData = Awaited<ReturnType<typeof listDailyOrderSchedule>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDailyOrderScheduleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDailyOrderSchedule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDailyOrderScheduleQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateDailyOrderScheduleUrl = () => {
  return `/api/operations/daily-orders`;
};

export const createDailyOrderSchedule = async (
  createDailyOrderScheduleBody: CreateDailyOrderScheduleBody,
  options?: RequestInit,
): Promise<DailyOrderSchedule> => {
  return customFetch<DailyOrderSchedule>(getCreateDailyOrderScheduleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createDailyOrderScheduleBody),
  });
};

export const getCreateDailyOrderScheduleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDailyOrderSchedule>>,
    TError,
    { data: BodyType<CreateDailyOrderScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDailyOrderSchedule>>,
  TError,
  { data: BodyType<CreateDailyOrderScheduleBody> },
  TContext
> => {
  const mutationKey = ["createDailyOrderSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDailyOrderSchedule>>,
    { data: BodyType<CreateDailyOrderScheduleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createDailyOrderSchedule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDailyOrderScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDailyOrderSchedule>>
>;
export type CreateDailyOrderScheduleMutationBody =
  BodyType<CreateDailyOrderScheduleBody>;
export type CreateDailyOrderScheduleMutationError = ErrorType<unknown>;

export const useCreateDailyOrderSchedule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDailyOrderSchedule>>,
    TError,
    { data: BodyType<CreateDailyOrderScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDailyOrderSchedule>>,
  TError,
  { data: BodyType<CreateDailyOrderScheduleBody> },
  TContext
> => {
  return useMutation(getCreateDailyOrderScheduleMutationOptions(options));
};

/**
 * @summary Today's scheduled deliveries (filtered by next_action_due + weekend_pattern)
 */
export const getGetDailyOrdersTodayUrl = (
  params?: GetDailyOrdersTodayParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/daily-orders/today?${stringifiedParams}`
    : `/api/operations/daily-orders/today`;
};

export const getDailyOrdersToday = async (
  params?: GetDailyOrdersTodayParams,
  options?: RequestInit,
): Promise<DailyOrderSchedule[]> => {
  return customFetch<DailyOrderSchedule[]>(getGetDailyOrdersTodayUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetDailyOrdersTodayQueryKey = (
  params?: GetDailyOrdersTodayParams,
) => {
  return [
    `/api/operations/daily-orders/today`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDailyOrdersTodayQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyOrdersToday>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDailyOrdersTodayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyOrdersToday>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyOrdersTodayQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyOrdersToday>>
  > = ({ signal }) =>
    getDailyOrdersToday(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyOrdersToday>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDailyOrdersTodayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyOrdersToday>>
>;
export type GetDailyOrdersTodayQueryError = ErrorType<unknown>;

/**
 * @summary Today's scheduled deliveries (filtered by next_action_due + weekend_pattern)
 */

export function useGetDailyOrdersToday<
  TData = Awaited<ReturnType<typeof getDailyOrdersToday>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDailyOrdersTodayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyOrdersToday>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDailyOrdersTodayQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetDailyOrderScheduleUrl = (id: number) => {
  return `/api/operations/daily-orders/${id}`;
};

export const getDailyOrderSchedule = async (
  id: number,
  options?: RequestInit,
): Promise<DailyOrderSchedule> => {
  return customFetch<DailyOrderSchedule>(getGetDailyOrderScheduleUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetDailyOrderScheduleQueryKey = (id: number) => {
  return [`/api/operations/daily-orders/${id}`] as const;
};

export const getGetDailyOrderScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyOrderSchedule>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyOrderSchedule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyOrderScheduleQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyOrderSchedule>>
  > = ({ signal }) => getDailyOrderSchedule(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyOrderSchedule>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDailyOrderScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyOrderSchedule>>
>;
export type GetDailyOrderScheduleQueryError = ErrorType<unknown>;

export function useGetDailyOrderSchedule<
  TData = Awaited<ReturnType<typeof getDailyOrderSchedule>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyOrderSchedule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDailyOrderScheduleQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateDailyOrderScheduleUrl = (id: number) => {
  return `/api/operations/daily-orders/${id}`;
};

export const updateDailyOrderSchedule = async (
  id: number,
  updateDailyOrderScheduleBody: UpdateDailyOrderScheduleBody,
  options?: RequestInit,
): Promise<DailyOrderSchedule> => {
  return customFetch<DailyOrderSchedule>(getUpdateDailyOrderScheduleUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateDailyOrderScheduleBody),
  });
};

export const getUpdateDailyOrderScheduleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDailyOrderSchedule>>,
    TError,
    { id: number; data: BodyType<UpdateDailyOrderScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDailyOrderSchedule>>,
  TError,
  { id: number; data: BodyType<UpdateDailyOrderScheduleBody> },
  TContext
> => {
  const mutationKey = ["updateDailyOrderSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDailyOrderSchedule>>,
    { id: number; data: BodyType<UpdateDailyOrderScheduleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDailyOrderSchedule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDailyOrderScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDailyOrderSchedule>>
>;
export type UpdateDailyOrderScheduleMutationBody =
  BodyType<UpdateDailyOrderScheduleBody>;
export type UpdateDailyOrderScheduleMutationError = ErrorType<unknown>;

export const useUpdateDailyOrderSchedule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDailyOrderSchedule>>,
    TError,
    { id: number; data: BodyType<UpdateDailyOrderScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateDailyOrderSchedule>>,
  TError,
  { id: number; data: BodyType<UpdateDailyOrderScheduleBody> },
  TContext
> => {
  return useMutation(getUpdateDailyOrderScheduleMutationOptions(options));
};

export const getDeleteDailyOrderScheduleUrl = (id: number) => {
  return `/api/operations/daily-orders/${id}`;
};

export const deleteDailyOrderSchedule = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteDailyOrderScheduleUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteDailyOrderScheduleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDailyOrderSchedule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDailyOrderSchedule>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteDailyOrderSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDailyOrderSchedule>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDailyOrderSchedule(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDailyOrderScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDailyOrderSchedule>>
>;

export type DeleteDailyOrderScheduleMutationError = ErrorType<unknown>;

export const useDeleteDailyOrderSchedule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDailyOrderSchedule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDailyOrderSchedule>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteDailyOrderScheduleMutationOptions(options));
};

/**
 * @summary 5-tier inventory alerts (REP-04, computed on-demand per spec §8.5)
 */
export const getGetOperationsAlertsUrl = (
  params?: GetOperationsAlertsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/alerts?${stringifiedParams}`
    : `/api/operations/alerts`;
};

export const getOperationsAlerts = async (
  params?: GetOperationsAlertsParams,
  options?: RequestInit,
): Promise<OperationsAlert[]> => {
  return customFetch<OperationsAlert[]>(getGetOperationsAlertsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetOperationsAlertsQueryKey = (
  params?: GetOperationsAlertsParams,
) => {
  return [`/api/operations/alerts`, ...(params ? [params] : [])] as const;
};

export const getGetOperationsAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOperationsAlerts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOperationsAlertsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOperationsAlerts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOperationsAlertsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOperationsAlerts>>
  > = ({ signal }) =>
    getOperationsAlerts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOperationsAlerts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOperationsAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOperationsAlerts>>
>;
export type GetOperationsAlertsQueryError = ErrorType<unknown>;

/**
 * @summary 5-tier inventory alerts (REP-04, computed on-demand per spec §8.5)
 */

export function useGetOperationsAlerts<
  TData = Awaited<ReturnType<typeof getOperationsAlerts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOperationsAlertsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOperationsAlerts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOperationsAlertsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Current month QC spend + cap state (D-26, QC-04)
 */
export const getGetOperationsQcBudgetUrl = (
  params?: GetOperationsQcBudgetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/quick-commerce/budget?${stringifiedParams}`
    : `/api/operations/quick-commerce/budget`;
};

export const getOperationsQcBudget = async (
  params?: GetOperationsQcBudgetParams,
  options?: RequestInit,
): Promise<OperationsQcBudget> => {
  return customFetch<OperationsQcBudget>(getGetOperationsQcBudgetUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetOperationsQcBudgetQueryKey = (
  params?: GetOperationsQcBudgetParams,
) => {
  return [
    `/api/operations/quick-commerce/budget`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOperationsQcBudgetQueryOptions = <
  TData = Awaited<ReturnType<typeof getOperationsQcBudget>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOperationsQcBudgetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOperationsQcBudget>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOperationsQcBudgetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOperationsQcBudget>>
  > = ({ signal }) =>
    getOperationsQcBudget(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOperationsQcBudget>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOperationsQcBudgetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOperationsQcBudget>>
>;
export type GetOperationsQcBudgetQueryError = ErrorType<unknown>;

/**
 * @summary Current month QC spend + cap state (D-26, QC-04)
 */

export function useGetOperationsQcBudget<
  TData = Awaited<ReturnType<typeof getOperationsQcBudget>>,
  TError = ErrorType<unknown>,
>(
  params?: GetOperationsQcBudgetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOperationsQcBudget>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOperationsQcBudgetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update QC budget thresholds (admin only)
 */
export const getUpdateSpaceQcBudgetUrl = (id: number) => {
  return `/api/operations/spaces/${id}/qc-budget`;
};

export const updateSpaceQcBudget = async (
  id: number,
  updateSpaceQcBudgetBody: UpdateSpaceQcBudgetBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getUpdateSpaceQcBudgetUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSpaceQcBudgetBody),
  });
};

export const getUpdateSpaceQcBudgetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceQcBudget>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceQcBudgetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSpaceQcBudget>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceQcBudgetBody> },
  TContext
> => {
  const mutationKey = ["updateSpaceQcBudget"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSpaceQcBudget>>,
    { id: number; data: BodyType<UpdateSpaceQcBudgetBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSpaceQcBudget(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSpaceQcBudgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSpaceQcBudget>>
>;
export type UpdateSpaceQcBudgetMutationBody = BodyType<UpdateSpaceQcBudgetBody>;
export type UpdateSpaceQcBudgetMutationError = ErrorType<void>;

/**
 * @summary Update QC budget thresholds (admin only)
 */
export const useUpdateSpaceQcBudget = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceQcBudget>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceQcBudgetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSpaceQcBudget>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceQcBudgetBody> },
  TContext
> => {
  return useMutation(getUpdateSpaceQcBudgetMutationOptions(options));
};

export const getListMemberEntitlementsUrl = (
  params?: ListMemberEntitlementsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/member-entitlements?${stringifiedParams}`
    : `/api/operations/member-entitlements`;
};

export const listMemberEntitlements = async (
  params?: ListMemberEntitlementsParams,
  options?: RequestInit,
): Promise<MemberEntitlement[]> => {
  return customFetch<MemberEntitlement[]>(
    getListMemberEntitlementsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListMemberEntitlementsQueryKey = (
  params?: ListMemberEntitlementsParams,
) => {
  return [
    `/api/operations/member-entitlements`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMemberEntitlementsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMemberEntitlements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMemberEntitlementsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMemberEntitlements>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMemberEntitlementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMemberEntitlements>>
  > = ({ signal }) =>
    listMemberEntitlements(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMemberEntitlements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMemberEntitlementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMemberEntitlements>>
>;
export type ListMemberEntitlementsQueryError = ErrorType<unknown>;

export function useListMemberEntitlements<
  TData = Awaited<ReturnType<typeof listMemberEntitlements>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMemberEntitlementsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMemberEntitlements>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMemberEntitlementsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateMemberEntitlementUrl = () => {
  return `/api/operations/member-entitlements`;
};

export const createMemberEntitlement = async (
  createMemberEntitlementBody: CreateMemberEntitlementBody,
  options?: RequestInit,
): Promise<MemberEntitlement> => {
  return customFetch<MemberEntitlement>(getCreateMemberEntitlementUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMemberEntitlementBody),
  });
};

export const getCreateMemberEntitlementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMemberEntitlement>>,
    TError,
    { data: BodyType<CreateMemberEntitlementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMemberEntitlement>>,
  TError,
  { data: BodyType<CreateMemberEntitlementBody> },
  TContext
> => {
  const mutationKey = ["createMemberEntitlement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMemberEntitlement>>,
    { data: BodyType<CreateMemberEntitlementBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMemberEntitlement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMemberEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMemberEntitlement>>
>;
export type CreateMemberEntitlementMutationBody =
  BodyType<CreateMemberEntitlementBody>;
export type CreateMemberEntitlementMutationError = ErrorType<unknown>;

export const useCreateMemberEntitlement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMemberEntitlement>>,
    TError,
    { data: BodyType<CreateMemberEntitlementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMemberEntitlement>>,
  TError,
  { data: BodyType<CreateMemberEntitlementBody> },
  TContext
> => {
  return useMutation(getCreateMemberEntitlementMutationOptions(options));
};

export const getGetMemberEntitlementUrl = (id: number) => {
  return `/api/operations/member-entitlements/${id}`;
};

export const getMemberEntitlement = async (
  id: number,
  options?: RequestInit,
): Promise<MemberEntitlement> => {
  return customFetch<MemberEntitlement>(getGetMemberEntitlementUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetMemberEntitlementQueryKey = (id: number) => {
  return [`/api/operations/member-entitlements/${id}`] as const;
};

export const getGetMemberEntitlementQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemberEntitlement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMemberEntitlement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMemberEntitlementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemberEntitlement>>
  > = ({ signal }) => getMemberEntitlement(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemberEntitlement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMemberEntitlementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemberEntitlement>>
>;
export type GetMemberEntitlementQueryError = ErrorType<unknown>;

export function useGetMemberEntitlement<
  TData = Awaited<ReturnType<typeof getMemberEntitlement>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMemberEntitlement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMemberEntitlementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateMemberEntitlementUrl = (id: number) => {
  return `/api/operations/member-entitlements/${id}`;
};

export const updateMemberEntitlement = async (
  id: number,
  updateMemberEntitlementBody: UpdateMemberEntitlementBody,
  options?: RequestInit,
): Promise<MemberEntitlement> => {
  return customFetch<MemberEntitlement>(getUpdateMemberEntitlementUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMemberEntitlementBody),
  });
};

export const getUpdateMemberEntitlementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemberEntitlement>>,
    TError,
    { id: number; data: BodyType<UpdateMemberEntitlementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMemberEntitlement>>,
  TError,
  { id: number; data: BodyType<UpdateMemberEntitlementBody> },
  TContext
> => {
  const mutationKey = ["updateMemberEntitlement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMemberEntitlement>>,
    { id: number; data: BodyType<UpdateMemberEntitlementBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMemberEntitlement(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMemberEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMemberEntitlement>>
>;
export type UpdateMemberEntitlementMutationBody =
  BodyType<UpdateMemberEntitlementBody>;
export type UpdateMemberEntitlementMutationError = ErrorType<unknown>;

export const useUpdateMemberEntitlement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemberEntitlement>>,
    TError,
    { id: number; data: BodyType<UpdateMemberEntitlementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMemberEntitlement>>,
  TError,
  { id: number; data: BodyType<UpdateMemberEntitlementBody> },
  TContext
> => {
  return useMutation(getUpdateMemberEntitlementMutationOptions(options));
};

export const getDeleteMemberEntitlementUrl = (id: number) => {
  return `/api/operations/member-entitlements/${id}`;
};

export const deleteMemberEntitlement = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMemberEntitlementUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMemberEntitlementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMemberEntitlement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMemberEntitlement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMemberEntitlement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMemberEntitlement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMemberEntitlement(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMemberEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMemberEntitlement>>
>;

export type DeleteMemberEntitlementMutationError = ErrorType<unknown>;

export const useDeleteMemberEntitlement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMemberEntitlement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMemberEntitlement>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteMemberEntitlementMutationOptions(options));
};

export const getListMemberChargesUrl = (params?: ListMemberChargesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/operations/member-charges?${stringifiedParams}`
    : `/api/operations/member-charges`;
};

export const listMemberCharges = async (
  params?: ListMemberChargesParams,
  options?: RequestInit,
): Promise<MemberChargeListResponse> => {
  return customFetch<MemberChargeListResponse>(
    getListMemberChargesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListMemberChargesQueryKey = (
  params?: ListMemberChargesParams,
) => {
  return [
    `/api/operations/member-charges`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMemberChargesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMemberCharges>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMemberChargesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMemberCharges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMemberChargesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMemberCharges>>
  > = ({ signal }) => listMemberCharges(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMemberCharges>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMemberChargesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMemberCharges>>
>;
export type ListMemberChargesQueryError = ErrorType<unknown>;

export function useListMemberCharges<
  TData = Awaited<ReturnType<typeof listMemberCharges>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMemberChargesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMemberCharges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMemberChargesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Manually create a Member_Charges row (admin only; D-29)
 */
export const getCreateMemberChargeUrl = () => {
  return `/api/operations/member-charges`;
};

export const createMemberCharge = async (
  createMemberChargeBody: CreateMemberChargeBody,
  options?: RequestInit,
): Promise<MemberCharge> => {
  return customFetch<MemberCharge>(getCreateMemberChargeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMemberChargeBody),
  });
};

export const getCreateMemberChargeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMemberCharge>>,
    TError,
    { data: BodyType<CreateMemberChargeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMemberCharge>>,
  TError,
  { data: BodyType<CreateMemberChargeBody> },
  TContext
> => {
  const mutationKey = ["createMemberCharge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMemberCharge>>,
    { data: BodyType<CreateMemberChargeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMemberCharge(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMemberChargeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMemberCharge>>
>;
export type CreateMemberChargeMutationBody = BodyType<CreateMemberChargeBody>;
export type CreateMemberChargeMutationError = ErrorType<void>;

/**
 * @summary Manually create a Member_Charges row (admin only; D-29)
 */
export const useCreateMemberCharge = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMemberCharge>>,
    TError,
    { data: BodyType<CreateMemberChargeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMemberCharge>>,
  TError,
  { data: BodyType<CreateMemberChargeBody> },
  TContext
> => {
  return useMutation(getCreateMemberChargeMutationOptions(options));
};

export const getGetMemberChargeUrl = (id: number) => {
  return `/api/operations/member-charges/${id}`;
};

export const getMemberCharge = async (
  id: number,
  options?: RequestInit,
): Promise<MemberCharge> => {
  return customFetch<MemberCharge>(getGetMemberChargeUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetMemberChargeQueryKey = (id: number) => {
  return [`/api/operations/member-charges/${id}`] as const;
};

export const getGetMemberChargeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemberCharge>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMemberCharge>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMemberChargeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberCharge>>> = ({
    signal,
  }) => getMemberCharge(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemberCharge>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMemberChargeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemberCharge>>
>;
export type GetMemberChargeQueryError = ErrorType<unknown>;

export function useGetMemberCharge<
  TData = Awaited<ReturnType<typeof getMemberCharge>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMemberCharge>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMemberChargeQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update Member_Charges (Phase 2 — Pending↔Disputed only)
 */
export const getUpdateMemberChargeUrl = (id: number) => {
  return `/api/operations/member-charges/${id}`;
};

export const updateMemberCharge = async (
  id: number,
  updateMemberChargeBody: UpdateMemberChargeBody,
  options?: RequestInit,
): Promise<MemberCharge> => {
  return customFetch<MemberCharge>(getUpdateMemberChargeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMemberChargeBody),
  });
};

export const getUpdateMemberChargeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemberCharge>>,
    TError,
    { id: number; data: BodyType<UpdateMemberChargeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMemberCharge>>,
  TError,
  { id: number; data: BodyType<UpdateMemberChargeBody> },
  TContext
> => {
  const mutationKey = ["updateMemberCharge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMemberCharge>>,
    { id: number; data: BodyType<UpdateMemberChargeBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMemberCharge(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMemberChargeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMemberCharge>>
>;
export type UpdateMemberChargeMutationBody = BodyType<UpdateMemberChargeBody>;
export type UpdateMemberChargeMutationError = ErrorType<unknown>;

/**
 * @summary Update Member_Charges (Phase 2 — Pending↔Disputed only)
 */
export const useUpdateMemberCharge = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemberCharge>>,
    TError,
    { id: number; data: BodyType<UpdateMemberChargeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMemberCharge>>,
  TError,
  { id: number; data: BodyType<UpdateMemberChargeBody> },
  TContext
> => {
  return useMutation(getUpdateMemberChargeMutationOptions(options));
};

/**
 * @summary Delete a non-paid member charge (e.g. an erroneous booking); admin only
 */
export const getDeleteMemberChargeUrl = (id: number) => {
  return `/api/operations/member-charges/${id}`;
};

export const deleteMemberCharge = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMemberChargeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMemberChargeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMemberCharge>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMemberCharge>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMemberCharge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMemberCharge>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMemberCharge(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMemberChargeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMemberCharge>>
>;

export type DeleteMemberChargeMutationError = ErrorType<void>;

/**
 * @summary Delete a non-paid member charge (e.g. an erroneous booking); admin only
 */
export const useDeleteMemberCharge = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMemberCharge>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMemberCharge>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteMemberChargeMutationOptions(options));
};

/**
 * @summary Generate (and optionally deliver) the order receipt for a member charge (admin only)
 */
export const getGenerateMemberChargeReceiptUrl = (id: number) => {
  return `/api/operations/member-charges/${id}/receipt`;
};

export const generateMemberChargeReceipt = async (
  id: number,
  generateMemberChargeReceiptBody?: GenerateMemberChargeReceiptBody,
  options?: RequestInit,
): Promise<MemberChargeReceiptResponse> => {
  return customFetch<MemberChargeReceiptResponse>(
    getGenerateMemberChargeReceiptUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(generateMemberChargeReceiptBody),
    },
  );
};

export const getGenerateMemberChargeReceiptMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMemberChargeReceipt>>,
    TError,
    { id: number; data: BodyType<GenerateMemberChargeReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateMemberChargeReceipt>>,
  TError,
  { id: number; data: BodyType<GenerateMemberChargeReceiptBody> },
  TContext
> => {
  const mutationKey = ["generateMemberChargeReceipt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateMemberChargeReceipt>>,
    { id: number; data: BodyType<GenerateMemberChargeReceiptBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateMemberChargeReceipt(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateMemberChargeReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateMemberChargeReceipt>>
>;
export type GenerateMemberChargeReceiptMutationBody =
  BodyType<GenerateMemberChargeReceiptBody>;
export type GenerateMemberChargeReceiptMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Generate (and optionally deliver) the order receipt for a member charge (admin only)
 */
export const useGenerateMemberChargeReceipt = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMemberChargeReceipt>>,
    TError,
    { id: number; data: BodyType<GenerateMemberChargeReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateMemberChargeReceipt>>,
  TError,
  { id: number; data: BodyType<GenerateMemberChargeReceiptBody> },
  TContext
> => {
  return useMutation(getGenerateMemberChargeReceiptMutationOptions(options));
};

/**
 * @summary List derived entry/exit sessions (defaults to a 30-day window)
 */
export const getListAttendanceSessionsUrl = (
  params?: ListAttendanceSessionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/attendance/sessions?${stringifiedParams}`
    : `/api/attendance/sessions`;
};

export const listAttendanceSessions = async (
  params?: ListAttendanceSessionsParams,
  options?: RequestInit,
): Promise<AttendanceSessionListResponse> => {
  return customFetch<AttendanceSessionListResponse>(
    getListAttendanceSessionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAttendanceSessionsQueryKey = (
  params?: ListAttendanceSessionsParams,
) => {
  return [`/api/attendance/sessions`, ...(params ? [params] : [])] as const;
};

export const getListAttendanceSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAttendanceSessions>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAttendanceSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttendanceSessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAttendanceSessionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAttendanceSessions>>
  > = ({ signal }) =>
    listAttendanceSessions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAttendanceSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAttendanceSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAttendanceSessions>>
>;
export type ListAttendanceSessionsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List derived entry/exit sessions (defaults to a 30-day window)
 */

export function useListAttendanceSessions<
  TData = Awaited<ReturnType<typeof listAttendanceSessions>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAttendanceSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttendanceSessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAttendanceSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Manually create a session (admin — e.g. a missed punch)
 */
export const getCreateAttendanceSessionUrl = () => {
  return `/api/attendance/sessions`;
};

export const createAttendanceSession = async (
  createAttendanceSessionBody: CreateAttendanceSessionBody,
  options?: RequestInit,
): Promise<AttendanceSession> => {
  return customFetch<AttendanceSession>(getCreateAttendanceSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAttendanceSessionBody),
  });
};

export const getCreateAttendanceSessionMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttendanceSession>>,
    TError,
    { data: BodyType<CreateAttendanceSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAttendanceSession>>,
  TError,
  { data: BodyType<CreateAttendanceSessionBody> },
  TContext
> => {
  const mutationKey = ["createAttendanceSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAttendanceSession>>,
    { data: BodyType<CreateAttendanceSessionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAttendanceSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAttendanceSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAttendanceSession>>
>;
export type CreateAttendanceSessionMutationBody =
  BodyType<CreateAttendanceSessionBody>;
export type CreateAttendanceSessionMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Manually create a session (admin — e.g. a missed punch)
 */
export const useCreateAttendanceSession = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttendanceSession>>,
    TError,
    { data: BodyType<CreateAttendanceSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAttendanceSession>>,
  TError,
  { data: BodyType<CreateAttendanceSessionBody> },
  TContext
> => {
  return useMutation(getCreateAttendanceSessionMutationOptions(options));
};

export const getGetAttendanceSessionUrl = (id: number) => {
  return `/api/attendance/sessions/${id}`;
};

export const getAttendanceSession = async (
  id: number,
  options?: RequestInit,
): Promise<AttendanceSession> => {
  return customFetch<AttendanceSession>(getGetAttendanceSessionUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAttendanceSessionQueryKey = (id: number) => {
  return [`/api/attendance/sessions/${id}`] as const;
};

export const getGetAttendanceSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttendanceSession>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAttendanceSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAttendanceSessionQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAttendanceSession>>
  > = ({ signal }) => getAttendanceSession(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttendanceSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAttendanceSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttendanceSession>>
>;
export type GetAttendanceSessionQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

export function useGetAttendanceSession<
  TData = Awaited<ReturnType<typeof getAttendanceSession>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAttendanceSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAttendanceSessionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Correct a session's entry/exit times, status or note (admin)
 */
export const getUpdateAttendanceSessionUrl = (id: number) => {
  return `/api/attendance/sessions/${id}`;
};

export const updateAttendanceSession = async (
  id: number,
  updateAttendanceSessionBody: UpdateAttendanceSessionBody,
  options?: RequestInit,
): Promise<AttendanceSession> => {
  return customFetch<AttendanceSession>(getUpdateAttendanceSessionUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAttendanceSessionBody),
  });
};

export const getUpdateAttendanceSessionMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttendanceSession>>,
    TError,
    { id: number; data: BodyType<UpdateAttendanceSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAttendanceSession>>,
  TError,
  { id: number; data: BodyType<UpdateAttendanceSessionBody> },
  TContext
> => {
  const mutationKey = ["updateAttendanceSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAttendanceSession>>,
    { id: number; data: BodyType<UpdateAttendanceSessionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAttendanceSession(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAttendanceSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAttendanceSession>>
>;
export type UpdateAttendanceSessionMutationBody =
  BodyType<UpdateAttendanceSessionBody>;
export type UpdateAttendanceSessionMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Correct a session's entry/exit times, status or note (admin)
 */
export const useUpdateAttendanceSession = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttendanceSession>>,
    TError,
    { id: number; data: BodyType<UpdateAttendanceSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAttendanceSession>>,
  TError,
  { id: number; data: BodyType<UpdateAttendanceSessionBody> },
  TContext
> => {
  return useMutation(getUpdateAttendanceSessionMutationOptions(options));
};

export const getListAttendanceDevicesUrl = (
  params?: ListAttendanceDevicesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/attendance/devices?${stringifiedParams}`
    : `/api/attendance/devices`;
};

export const listAttendanceDevices = async (
  params?: ListAttendanceDevicesParams,
  options?: RequestInit,
): Promise<AttendanceDevice[]> => {
  return customFetch<AttendanceDevice[]>(getListAttendanceDevicesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAttendanceDevicesQueryKey = (
  params?: ListAttendanceDevicesParams,
) => {
  return [`/api/attendance/devices`, ...(params ? [params] : [])] as const;
};

export const getListAttendanceDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAttendanceDevices>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAttendanceDevicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttendanceDevices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAttendanceDevicesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAttendanceDevices>>
  > = ({ signal }) =>
    listAttendanceDevices(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAttendanceDevices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAttendanceDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAttendanceDevices>>
>;
export type ListAttendanceDevicesQueryError = ErrorType<UnauthorizedResponse>;

export function useListAttendanceDevices<
  TData = Awaited<ReturnType<typeof listAttendanceDevices>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListAttendanceDevicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttendanceDevices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAttendanceDevicesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a biometric device (admin)
 */
export const getCreateAttendanceDeviceUrl = () => {
  return `/api/attendance/devices`;
};

export const createAttendanceDevice = async (
  createAttendanceDeviceBody: CreateAttendanceDeviceBody,
  options?: RequestInit,
): Promise<AttendanceDevice> => {
  return customFetch<AttendanceDevice>(getCreateAttendanceDeviceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAttendanceDeviceBody),
  });
};

export const getCreateAttendanceDeviceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttendanceDevice>>,
    TError,
    { data: BodyType<CreateAttendanceDeviceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAttendanceDevice>>,
  TError,
  { data: BodyType<CreateAttendanceDeviceBody> },
  TContext
> => {
  const mutationKey = ["createAttendanceDevice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAttendanceDevice>>,
    { data: BodyType<CreateAttendanceDeviceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAttendanceDevice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAttendanceDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAttendanceDevice>>
>;
export type CreateAttendanceDeviceMutationBody =
  BodyType<CreateAttendanceDeviceBody>;
export type CreateAttendanceDeviceMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Register a biometric device (admin)
 */
export const useCreateAttendanceDevice = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttendanceDevice>>,
    TError,
    { data: BodyType<CreateAttendanceDeviceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAttendanceDevice>>,
  TError,
  { data: BodyType<CreateAttendanceDeviceBody> },
  TContext
> => {
  return useMutation(getCreateAttendanceDeviceMutationOptions(options));
};

/**
 * @summary Update a registered device (admin)
 */
export const getUpdateAttendanceDeviceUrl = (id: number) => {
  return `/api/attendance/devices/${id}`;
};

export const updateAttendanceDevice = async (
  id: number,
  updateAttendanceDeviceBody: UpdateAttendanceDeviceBody,
  options?: RequestInit,
): Promise<AttendanceDevice> => {
  return customFetch<AttendanceDevice>(getUpdateAttendanceDeviceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAttendanceDeviceBody),
  });
};

export const getUpdateAttendanceDeviceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttendanceDevice>>,
    TError,
    { id: number; data: BodyType<UpdateAttendanceDeviceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAttendanceDevice>>,
  TError,
  { id: number; data: BodyType<UpdateAttendanceDeviceBody> },
  TContext
> => {
  const mutationKey = ["updateAttendanceDevice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAttendanceDevice>>,
    { id: number; data: BodyType<UpdateAttendanceDeviceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAttendanceDevice(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAttendanceDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAttendanceDevice>>
>;
export type UpdateAttendanceDeviceMutationBody =
  BodyType<UpdateAttendanceDeviceBody>;
export type UpdateAttendanceDeviceMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Update a registered device (admin)
 */
export const useUpdateAttendanceDevice = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttendanceDevice>>,
    TError,
    { id: number; data: BodyType<UpdateAttendanceDeviceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAttendanceDevice>>,
  TError,
  { id: number; data: BodyType<UpdateAttendanceDeviceBody> },
  TContext
> => {
  return useMutation(getUpdateAttendanceDeviceMutationOptions(options));
};

/**
 * @summary Import attendance punches from parsed rows (CSV/eTimeTrackLite backfill, admin)
 */
export const getImportAttendanceUrl = () => {
  return `/api/attendance/import`;
};

export const importAttendance = async (
  importAttendanceBody: ImportAttendanceBody,
  options?: RequestInit,
): Promise<ImportAttendanceResponse> => {
  return customFetch<ImportAttendanceResponse>(getImportAttendanceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(importAttendanceBody),
  });
};

export const getImportAttendanceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importAttendance>>,
    TError,
    { data: BodyType<ImportAttendanceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importAttendance>>,
  TError,
  { data: BodyType<ImportAttendanceBody> },
  TContext
> => {
  const mutationKey = ["importAttendance"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importAttendance>>,
    { data: BodyType<ImportAttendanceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return importAttendance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportAttendanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof importAttendance>>
>;
export type ImportAttendanceMutationBody = BodyType<ImportAttendanceBody>;
export type ImportAttendanceMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Import attendance punches from parsed rows (CSV/eTimeTrackLite backfill, admin)
 */
export const useImportAttendance = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importAttendance>>,
    TError,
    { data: BodyType<ImportAttendanceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importAttendance>>,
  TError,
  { data: BodyType<ImportAttendanceBody> },
  TContext
> => {
  return useMutation(getImportAttendanceMutationOptions(options));
};

/**
 * @summary Check out (close) an open session — geofence-verified (reception)
 */
export const getCheckoutAttendanceSessionUrl = (id: number) => {
  return `/api/attendance/sessions/${id}/checkout`;
};

export const checkoutAttendanceSession = async (
  id: number,
  checkoutAttendanceSessionBody: CheckoutAttendanceSessionBody,
  options?: RequestInit,
): Promise<AttendanceSession> => {
  return customFetch<AttendanceSession>(getCheckoutAttendanceSessionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(checkoutAttendanceSessionBody),
  });
};

export const getCheckoutAttendanceSessionMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutAttendanceSession>>,
    TError,
    { id: number; data: BodyType<CheckoutAttendanceSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkoutAttendanceSession>>,
  TError,
  { id: number; data: BodyType<CheckoutAttendanceSessionBody> },
  TContext
> => {
  const mutationKey = ["checkoutAttendanceSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkoutAttendanceSession>>,
    { id: number; data: BodyType<CheckoutAttendanceSessionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return checkoutAttendanceSession(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckoutAttendanceSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkoutAttendanceSession>>
>;
export type CheckoutAttendanceSessionMutationBody =
  BodyType<CheckoutAttendanceSessionBody>;
export type CheckoutAttendanceSessionMutationError = ErrorType<
  UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Check out (close) an open session — geofence-verified (reception)
 */
export const useCheckoutAttendanceSession = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutAttendanceSession>>,
    TError,
    { id: number; data: BodyType<CheckoutAttendanceSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof checkoutAttendanceSession>>,
  TError,
  { id: number; data: BodyType<CheckoutAttendanceSessionBody> },
  TContext
> => {
  return useMutation(getCheckoutAttendanceSessionMutationOptions(options));
};

/**
 * @summary List spaces with their attendance geofence config
 */
export const getListAttendanceGeofencesUrl = () => {
  return `/api/attendance/geofence`;
};

export const listAttendanceGeofences = async (
  options?: RequestInit,
): Promise<GeofenceSpace[]> => {
  return customFetch<GeofenceSpace[]>(getListAttendanceGeofencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAttendanceGeofencesQueryKey = () => {
  return [`/api/attendance/geofence`] as const;
};

export const getListAttendanceGeofencesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAttendanceGeofences>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAttendanceGeofences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAttendanceGeofencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAttendanceGeofences>>
  > = ({ signal }) => listAttendanceGeofences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAttendanceGeofences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAttendanceGeofencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAttendanceGeofences>>
>;
export type ListAttendanceGeofencesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List spaces with their attendance geofence config
 */

export function useListAttendanceGeofences<
  TData = Awaited<ReturnType<typeof listAttendanceGeofences>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAttendanceGeofences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAttendanceGeofencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Set a space's attendance geofence (admin)
 */
export const getUpdateAttendanceGeofenceUrl = (spaceId: number) => {
  return `/api/attendance/geofence/${spaceId}`;
};

export const updateAttendanceGeofence = async (
  spaceId: number,
  updateGeofenceBody: UpdateGeofenceBody,
  options?: RequestInit,
): Promise<GeofenceSpace> => {
  return customFetch<GeofenceSpace>(getUpdateAttendanceGeofenceUrl(spaceId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateGeofenceBody),
  });
};

export const getUpdateAttendanceGeofenceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttendanceGeofence>>,
    TError,
    { spaceId: number; data: BodyType<UpdateGeofenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAttendanceGeofence>>,
  TError,
  { spaceId: number; data: BodyType<UpdateGeofenceBody> },
  TContext
> => {
  const mutationKey = ["updateAttendanceGeofence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAttendanceGeofence>>,
    { spaceId: number; data: BodyType<UpdateGeofenceBody> }
  > = (props) => {
    const { spaceId, data } = props ?? {};

    return updateAttendanceGeofence(spaceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAttendanceGeofenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAttendanceGeofence>>
>;
export type UpdateAttendanceGeofenceMutationBody = BodyType<UpdateGeofenceBody>;
export type UpdateAttendanceGeofenceMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Set a space's attendance geofence (admin)
 */
export const useUpdateAttendanceGeofence = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttendanceGeofence>>,
    TError,
    { spaceId: number; data: BodyType<UpdateGeofenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAttendanceGeofence>>,
  TError,
  { spaceId: number; data: BodyType<UpdateGeofenceBody> },
  TContext
> => {
  return useMutation(getUpdateAttendanceGeofenceMutationOptions(options));
};

/**
 * @summary Re-resolve unmatched punches against current enrollments and build missing check-ins (admin)
 */
export const getResyncAttendanceUrl = () => {
  return `/api/attendance/resync`;
};

export const resyncAttendance = async (
  options?: RequestInit,
): Promise<ResyncAttendanceResponse> => {
  return customFetch<ResyncAttendanceResponse>(getResyncAttendanceUrl(), {
    ...options,
    method: "POST",
  });
};

export const getResyncAttendanceMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resyncAttendance>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resyncAttendance>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["resyncAttendance"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resyncAttendance>>,
    void
  > = () => {
    return resyncAttendance(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResyncAttendanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof resyncAttendance>>
>;

export type ResyncAttendanceMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Re-resolve unmatched punches against current enrollments and build missing check-ins (admin)
 */
export const useResyncAttendance = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resyncAttendance>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resyncAttendance>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getResyncAttendanceMutationOptions(options));
};

/**
 * @summary Biometric punch log — taps per person per day (count + times), biometric only
 */
export const getGetAttendancePunchLogUrl = (
  params?: GetAttendancePunchLogParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/attendance/punch-log?${stringifiedParams}`
    : `/api/attendance/punch-log`;
};

export const getAttendancePunchLog = async (
  params?: GetAttendancePunchLogParams,
  options?: RequestInit,
): Promise<PunchLogEntry[]> => {
  return customFetch<PunchLogEntry[]>(getGetAttendancePunchLogUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAttendancePunchLogQueryKey = (
  params?: GetAttendancePunchLogParams,
) => {
  return [`/api/attendance/punch-log`, ...(params ? [params] : [])] as const;
};

export const getGetAttendancePunchLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttendancePunchLog>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetAttendancePunchLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAttendancePunchLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAttendancePunchLogQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAttendancePunchLog>>
  > = ({ signal }) =>
    getAttendancePunchLog(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttendancePunchLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAttendancePunchLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttendancePunchLog>>
>;
export type GetAttendancePunchLogQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Biometric punch log — taps per person per day (count + times), biometric only
 */

export function useGetAttendancePunchLog<
  TData = Awaited<ReturnType<typeof getAttendancePunchLog>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetAttendancePunchLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAttendancePunchLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAttendancePunchLogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Daily roster — every active member with their check-in status for the date
 */
export const getGetAttendanceRosterUrl = (
  params?: GetAttendanceRosterParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/attendance/roster?${stringifiedParams}`
    : `/api/attendance/roster`;
};

export const getAttendanceRoster = async (
  params?: GetAttendanceRosterParams,
  options?: RequestInit,
): Promise<AttendanceRosterEntry[]> => {
  return customFetch<AttendanceRosterEntry[]>(
    getGetAttendanceRosterUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAttendanceRosterQueryKey = (
  params?: GetAttendanceRosterParams,
) => {
  return [`/api/attendance/roster`, ...(params ? [params] : [])] as const;
};

export const getGetAttendanceRosterQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttendanceRoster>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetAttendanceRosterParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAttendanceRoster>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAttendanceRosterQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAttendanceRoster>>
  > = ({ signal }) =>
    getAttendanceRoster(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttendanceRoster>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAttendanceRosterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttendanceRoster>>
>;
export type GetAttendanceRosterQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Daily roster — every active member with their check-in status for the date
 */

export function useGetAttendanceRoster<
  TData = Awaited<ReturnType<typeof getAttendanceRoster>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetAttendanceRosterParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAttendanceRoster>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAttendanceRosterQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * One entry per team user who has attendance ON THE DATE (users with none are simply absent from the array; earlier days are never carried forward). A staff login is opened automatically by the biometric punch; the logout is manual (POST /attendance/sessions/{id}/logout), so an entry with openSessionId set is still on the clock.

 * @summary Staff attendance for one day — each team member's biometric login, logout and hours
 */
export const getGetStaffAttendanceDayUrl = (
  params?: GetStaffAttendanceDayParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/attendance/staff-day?${stringifiedParams}`
    : `/api/attendance/staff-day`;
};

export const getStaffAttendanceDay = async (
  params?: GetStaffAttendanceDayParams,
  options?: RequestInit,
): Promise<StaffAttendanceDayEntry[]> => {
  return customFetch<StaffAttendanceDayEntry[]>(
    getGetStaffAttendanceDayUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetStaffAttendanceDayQueryKey = (
  params?: GetStaffAttendanceDayParams,
) => {
  return [`/api/attendance/staff-day`, ...(params ? [params] : [])] as const;
};

export const getGetStaffAttendanceDayQueryOptions = <
  TData = Awaited<ReturnType<typeof getStaffAttendanceDay>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetStaffAttendanceDayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStaffAttendanceDay>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStaffAttendanceDayQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStaffAttendanceDay>>
  > = ({ signal }) =>
    getStaffAttendanceDay(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStaffAttendanceDay>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStaffAttendanceDayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStaffAttendanceDay>>
>;
export type GetStaffAttendanceDayQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Staff attendance for one day — each team member's biometric login, logout and hours
 */

export function useGetStaffAttendanceDay<
  TData = Awaited<ReturnType<typeof getStaffAttendanceDay>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetStaffAttendanceDayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStaffAttendanceDay>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStaffAttendanceDayQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Closes an open STAFF session (userId set) and computes durationMinutes from login → logout. Not geofenced, unlike the member check-out endpoint: this is an admin action from the Team page, or a team member closing their own day.

 * @summary Manually log out a staff member's open session and bank the hours
 */
export const getLogoutAttendanceSessionUrl = (id: number) => {
  return `/api/attendance/sessions/${id}/logout`;
};

export const logoutAttendanceSession = async (
  id: number,
  logoutAttendanceSessionBody: LogoutAttendanceSessionBody,
  options?: RequestInit,
): Promise<AttendanceSession> => {
  return customFetch<AttendanceSession>(getLogoutAttendanceSessionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(logoutAttendanceSessionBody),
  });
};

export const getLogoutAttendanceSessionMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutAttendanceSession>>,
    TError,
    { id: number; data: BodyType<LogoutAttendanceSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logoutAttendanceSession>>,
  TError,
  { id: number; data: BodyType<LogoutAttendanceSessionBody> },
  TContext
> => {
  const mutationKey = ["logoutAttendanceSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logoutAttendanceSession>>,
    { id: number; data: BodyType<LogoutAttendanceSessionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return logoutAttendanceSession(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutAttendanceSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof logoutAttendanceSession>>
>;
export type LogoutAttendanceSessionMutationBody =
  BodyType<LogoutAttendanceSessionBody>;
export type LogoutAttendanceSessionMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Manually log out a staff member's open session and bank the hours
 */
export const useLogoutAttendanceSession = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutAttendanceSession>>,
    TError,
    { id: number; data: BodyType<LogoutAttendanceSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logoutAttendanceSession>>,
  TError,
  { id: number; data: BodyType<LogoutAttendanceSessionBody> },
  TContext
> => {
  return useMutation(getLogoutAttendanceSessionMutationOptions(options));
};

/**
 * @summary D-28 sub-view 1 — members whose billing_cycle_day == today IST
 */
export const getListBillingTodayUrl = (params?: ListBillingTodayParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/billing/today?${stringifiedParams}`
    : `/api/billing/today`;
};

export const listBillingToday = async (
  params?: ListBillingTodayParams,
  options?: RequestInit,
): Promise<BillingTodayMember[]> => {
  return customFetch<BillingTodayMember[]>(getListBillingTodayUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListBillingTodayQueryKey = (
  params?: ListBillingTodayParams,
) => {
  return [`/api/billing/today`, ...(params ? [params] : [])] as const;
};

export const getListBillingTodayQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingToday>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBillingTodayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBillingToday>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBillingTodayQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBillingToday>>
  > = ({ signal }) => listBillingToday(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBillingToday>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBillingTodayQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingToday>>
>;
export type ListBillingTodayQueryError = ErrorType<unknown>;

/**
 * @summary D-28 sub-view 1 — members whose billing_cycle_day == today IST
 */

export function useListBillingToday<
  TData = Awaited<ReturnType<typeof listBillingToday>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBillingTodayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBillingToday>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBillingTodayQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary D-28 sub-view 2 — invoice queue
 */
export const getListInvoicesUrl = (params?: ListInvoicesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/billing/invoices?${stringifiedParams}`
    : `/api/billing/invoices`;
};

export const listInvoices = async (
  params?: ListInvoicesParams,
  options?: RequestInit,
): Promise<InvoiceListResponse> => {
  return customFetch<InvoiceListResponse>(getListInvoicesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInvoicesQueryKey = (params?: ListInvoicesParams) => {
  return [`/api/billing/invoices`, ...(params ? [params] : [])] as const;
};

export const getListInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInvoicesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoices>>> = ({
    signal,
  }) => listInvoices(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvoices>>
>;
export type ListInvoicesQueryError = ErrorType<unknown>;

/**
 * @summary D-28 sub-view 2 — invoice queue
 */

export function useListInvoices<
  TData = Awaited<ReturnType<typeof listInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetInvoiceUrl = (id: number) => {
  return `/api/billing/invoices/${id}`;
};

export const getInvoice = async (
  id: number,
  options?: RequestInit,
): Promise<InvoiceWithLineItems> => {
  return customFetch<InvoiceWithLineItems>(getGetInvoiceUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInvoiceQueryKey = (id: number) => {
  return [`/api/billing/invoices/${id}`] as const;
};

export const getGetInvoiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoice>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvoice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvoiceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoice>>> = ({
    signal,
  }) => getInvoice(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoice>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoice>>
>;
export type GetInvoiceQueryError = ErrorType<unknown>;

export function useGetInvoice<
  TData = Awaited<ReturnType<typeof getInvoice>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvoice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvoiceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Generate PDF if missing, upload to Supabase Storage, send via WhatsApp document message
 */
export const getSendInvoiceUrl = (id: number) => {
  return `/api/billing/invoices/${id}/send`;
};

export const sendInvoice = async (
  id: number,
  options?: RequestInit,
): Promise<Invoice> => {
  return customFetch<Invoice>(getSendInvoiceUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSendInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInvoice>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendInvoice>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["sendInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendInvoice>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendInvoice(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendInvoice>>
>;

export type SendInvoiceMutationError = ErrorType<unknown>;

/**
 * @summary Generate PDF if missing, upload to Supabase Storage, send via WhatsApp document message
 */
export const useSendInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInvoice>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendInvoice>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSendInvoiceMutationOptions(options));
};

export const getMarkInvoicePaidUrl = (id: number) => {
  return `/api/billing/invoices/${id}/mark-paid`;
};

export const markInvoicePaid = async (
  id: number,
  markInvoicePaidBody: MarkInvoicePaidBody,
  options?: RequestInit,
): Promise<Invoice> => {
  return customFetch<Invoice>(getMarkInvoicePaidUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(markInvoicePaidBody),
  });
};

export const getMarkInvoicePaidMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markInvoicePaid>>,
    TError,
    { id: number; data: BodyType<MarkInvoicePaidBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markInvoicePaid>>,
  TError,
  { id: number; data: BodyType<MarkInvoicePaidBody> },
  TContext
> => {
  const mutationKey = ["markInvoicePaid"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markInvoicePaid>>,
    { id: number; data: BodyType<MarkInvoicePaidBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return markInvoicePaid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkInvoicePaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof markInvoicePaid>>
>;
export type MarkInvoicePaidMutationBody = BodyType<MarkInvoicePaidBody>;
export type MarkInvoicePaidMutationError = ErrorType<unknown>;

export const useMarkInvoicePaid = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markInvoicePaid>>,
    TError,
    { id: number; data: BodyType<MarkInvoicePaidBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markInvoicePaid>>,
  TError,
  { id: number; data: BodyType<MarkInvoicePaidBody> },
  TContext
> => {
  return useMutation(getMarkInvoicePaidMutationOptions(options));
};

/**
 * @summary Account-level invoice register — issued order receipts across the space
 */
export const getListOrderReceiptsUrl = (params?: ListOrderReceiptsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/billing/order-receipts?${stringifiedParams}`
    : `/api/billing/order-receipts`;
};

export const listOrderReceipts = async (
  params?: ListOrderReceiptsParams,
  options?: RequestInit,
): Promise<OrderReceiptRegisterResponse> => {
  return customFetch<OrderReceiptRegisterResponse>(
    getListOrderReceiptsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListOrderReceiptsQueryKey = (
  params?: ListOrderReceiptsParams,
) => {
  return [`/api/billing/order-receipts`, ...(params ? [params] : [])] as const;
};

export const getListOrderReceiptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrderReceipts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOrderReceiptsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOrderReceipts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOrderReceiptsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrderReceipts>>
  > = ({ signal }) => listOrderReceipts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrderReceipts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOrderReceiptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrderReceipts>>
>;
export type ListOrderReceiptsQueryError = ErrorType<unknown>;

/**
 * @summary Account-level invoice register — issued order receipts across the space
 */

export function useListOrderReceipts<
  TData = Awaited<ReturnType<typeof listOrderReceipts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOrderReceiptsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOrderReceipts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOrderReceiptsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary VAL-05 audit panel — plans with missing required-item entitlements
 */
export const getGetPlanCoverageGapsUrl = (
  params?: GetPlanCoverageGapsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/billing/plan-coverage?${stringifiedParams}`
    : `/api/billing/plan-coverage`;
};

export const getPlanCoverageGaps = async (
  params?: GetPlanCoverageGapsParams,
  options?: RequestInit,
): Promise<PlanCoverageGap[]> => {
  return customFetch<PlanCoverageGap[]>(getGetPlanCoverageGapsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetPlanCoverageGapsQueryKey = (
  params?: GetPlanCoverageGapsParams,
) => {
  return [`/api/billing/plan-coverage`, ...(params ? [params] : [])] as const;
};

export const getGetPlanCoverageGapsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanCoverageGaps>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanCoverageGapsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlanCoverageGaps>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlanCoverageGapsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlanCoverageGaps>>
  > = ({ signal }) =>
    getPlanCoverageGaps(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlanCoverageGaps>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlanCoverageGapsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlanCoverageGaps>>
>;
export type GetPlanCoverageGapsQueryError = ErrorType<unknown>;

/**
 * @summary VAL-05 audit panel — plans with missing required-item entitlements
 */

export function useGetPlanCoverageGaps<
  TData = Awaited<ReturnType<typeof getPlanCoverageGaps>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanCoverageGapsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlanCoverageGaps>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlanCoverageGapsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGenerateSelfServiceTokenUrl = () => {
  return `/api/billing/tokens/generate`;
};

export const generateSelfServiceToken = async (
  generateTokenBody: GenerateTokenBody,
  options?: RequestInit,
): Promise<GenerateTokenResponse> => {
  return customFetch<GenerateTokenResponse>(getGenerateSelfServiceTokenUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateTokenBody),
  });
};

export const getGenerateSelfServiceTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSelfServiceToken>>,
    TError,
    { data: BodyType<GenerateTokenBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSelfServiceToken>>,
  TError,
  { data: BodyType<GenerateTokenBody> },
  TContext
> => {
  const mutationKey = ["generateSelfServiceToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSelfServiceToken>>,
    { data: BodyType<GenerateTokenBody> }
  > = (props) => {
    const { data } = props ?? {};

    return generateSelfServiceToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateSelfServiceTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateSelfServiceToken>>
>;
export type GenerateSelfServiceTokenMutationBody = BodyType<GenerateTokenBody>;
export type GenerateSelfServiceTokenMutationError = ErrorType<unknown>;

export const useGenerateSelfServiceToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSelfServiceToken>>,
    TError,
    { data: BodyType<GenerateTokenBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateSelfServiceToken>>,
  TError,
  { data: BodyType<GenerateTokenBody> },
  TContext
> => {
  return useMutation(getGenerateSelfServiceTokenMutationOptions(options));
};

export const getGetSelfServiceChargesUrl = (token: string) => {
  return `/api/m/confirm/${token}`;
};

export const getSelfServiceCharges = async (
  token: string,
  options?: RequestInit,
): Promise<SelfServiceCharges> => {
  return customFetch<SelfServiceCharges>(getGetSelfServiceChargesUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetSelfServiceChargesQueryKey = (token: string) => {
  return [`/api/m/confirm/${token}`] as const;
};

export const getGetSelfServiceChargesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSelfServiceCharges>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSelfServiceCharges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSelfServiceChargesQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSelfServiceCharges>>
  > = ({ signal }) =>
    getSelfServiceCharges(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSelfServiceCharges>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSelfServiceChargesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSelfServiceCharges>>
>;
export type GetSelfServiceChargesQueryError = ErrorType<void>;

export function useGetSelfServiceCharges<
  TData = Awaited<ReturnType<typeof getSelfServiceCharges>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSelfServiceCharges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSelfServiceChargesQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getConfirmSelfServiceChargesUrl = (token: string) => {
  return `/api/m/confirm/${token}`;
};

export const confirmSelfServiceCharges = async (
  token: string,
  confirmChargesBody: ConfirmChargesBody,
  options?: RequestInit,
): Promise<SelfServiceCharges> => {
  return customFetch<SelfServiceCharges>(
    getConfirmSelfServiceChargesUrl(token),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(confirmChargesBody),
    },
  );
};

export const getConfirmSelfServiceChargesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSelfServiceCharges>>,
    TError,
    { token: string; data: BodyType<ConfirmChargesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmSelfServiceCharges>>,
  TError,
  { token: string; data: BodyType<ConfirmChargesBody> },
  TContext
> => {
  const mutationKey = ["confirmSelfServiceCharges"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmSelfServiceCharges>>,
    { token: string; data: BodyType<ConfirmChargesBody> }
  > = (props) => {
    const { token, data } = props ?? {};

    return confirmSelfServiceCharges(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmSelfServiceChargesMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmSelfServiceCharges>>
>;
export type ConfirmSelfServiceChargesMutationBody =
  BodyType<ConfirmChargesBody>;
export type ConfirmSelfServiceChargesMutationError = ErrorType<void>;

export const useConfirmSelfServiceCharges = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSelfServiceCharges>>,
    TError,
    { token: string; data: BodyType<ConfirmChargesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmSelfServiceCharges>>,
  TError,
  { token: string; data: BodyType<ConfirmChargesBody> },
  TContext
> => {
  return useMutation(getConfirmSelfServiceChargesMutationOptions(options));
};

/**
 * @summary List resource pricing rows
 */
export const getListResourcePricingUrl = (
  params?: ListResourcePricingParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/resource-pricing?${stringifiedParams}`
    : `/api/resource-pricing`;
};

export const listResourcePricing = async (
  params?: ListResourcePricingParams,
  options?: RequestInit,
): Promise<ResourcePricing[]> => {
  return customFetch<ResourcePricing[]>(getListResourcePricingUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListResourcePricingQueryKey = (
  params?: ListResourcePricingParams,
) => {
  return [`/api/resource-pricing`, ...(params ? [params] : [])] as const;
};

export const getListResourcePricingQueryOptions = <
  TData = Awaited<ReturnType<typeof listResourcePricing>>,
  TError = ErrorType<unknown>,
>(
  params?: ListResourcePricingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listResourcePricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListResourcePricingQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listResourcePricing>>
  > = ({ signal }) =>
    listResourcePricing(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listResourcePricing>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListResourcePricingQueryResult = NonNullable<
  Awaited<ReturnType<typeof listResourcePricing>>
>;
export type ListResourcePricingQueryError = ErrorType<unknown>;

/**
 * @summary List resource pricing rows
 */

export function useListResourcePricing<
  TData = Awaited<ReturnType<typeof listResourcePricing>>,
  TError = ErrorType<unknown>,
>(
  params?: ListResourcePricingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listResourcePricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListResourcePricingQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create resource pricing row
 */
export const getCreateResourcePricingUrl = () => {
  return `/api/resource-pricing`;
};

export const createResourcePricing = async (
  createResourcePricingBody: CreateResourcePricingBody,
  options?: RequestInit,
): Promise<ResourcePricing> => {
  return customFetch<ResourcePricing>(getCreateResourcePricingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createResourcePricingBody),
  });
};

export const getCreateResourcePricingMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createResourcePricing>>,
    TError,
    { data: BodyType<CreateResourcePricingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createResourcePricing>>,
  TError,
  { data: BodyType<CreateResourcePricingBody> },
  TContext
> => {
  const mutationKey = ["createResourcePricing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createResourcePricing>>,
    { data: BodyType<CreateResourcePricingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createResourcePricing(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateResourcePricingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createResourcePricing>>
>;
export type CreateResourcePricingMutationBody =
  BodyType<CreateResourcePricingBody>;
export type CreateResourcePricingMutationError = ErrorType<void>;

/**
 * @summary Create resource pricing row
 */
export const useCreateResourcePricing = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createResourcePricing>>,
    TError,
    { data: BodyType<CreateResourcePricingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createResourcePricing>>,
  TError,
  { data: BodyType<CreateResourcePricingBody> },
  TContext
> => {
  return useMutation(getCreateResourcePricingMutationOptions(options));
};

/**
 * @summary Get resource pricing row by id
 */
export const getGetResourcePricingUrl = (id: number) => {
  return `/api/resource-pricing/${id}`;
};

export const getResourcePricing = async (
  id: number,
  options?: RequestInit,
): Promise<ResourcePricing> => {
  return customFetch<ResourcePricing>(getGetResourcePricingUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetResourcePricingQueryKey = (id: number) => {
  return [`/api/resource-pricing/${id}`] as const;
};

export const getGetResourcePricingQueryOptions = <
  TData = Awaited<ReturnType<typeof getResourcePricing>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getResourcePricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetResourcePricingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getResourcePricing>>
  > = ({ signal }) => getResourcePricing(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getResourcePricing>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetResourcePricingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getResourcePricing>>
>;
export type GetResourcePricingQueryError = ErrorType<void>;

/**
 * @summary Get resource pricing row by id
 */

export function useGetResourcePricing<
  TData = Awaited<ReturnType<typeof getResourcePricing>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getResourcePricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetResourcePricingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update resource pricing row
 */
export const getUpdateResourcePricingUrl = (id: number) => {
  return `/api/resource-pricing/${id}`;
};

export const updateResourcePricing = async (
  id: number,
  updateResourcePricingBody: UpdateResourcePricingBody,
  options?: RequestInit,
): Promise<ResourcePricing> => {
  return customFetch<ResourcePricing>(getUpdateResourcePricingUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateResourcePricingBody),
  });
};

export const getUpdateResourcePricingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateResourcePricing>>,
    TError,
    { id: number; data: BodyType<UpdateResourcePricingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateResourcePricing>>,
  TError,
  { id: number; data: BodyType<UpdateResourcePricingBody> },
  TContext
> => {
  const mutationKey = ["updateResourcePricing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateResourcePricing>>,
    { id: number; data: BodyType<UpdateResourcePricingBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateResourcePricing(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateResourcePricingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateResourcePricing>>
>;
export type UpdateResourcePricingMutationBody =
  BodyType<UpdateResourcePricingBody>;
export type UpdateResourcePricingMutationError = ErrorType<unknown>;

/**
 * @summary Update resource pricing row
 */
export const useUpdateResourcePricing = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateResourcePricing>>,
    TError,
    { id: number; data: BodyType<UpdateResourcePricingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateResourcePricing>>,
  TError,
  { id: number; data: BodyType<UpdateResourcePricingBody> },
  TContext
> => {
  return useMutation(getUpdateResourcePricingMutationOptions(options));
};

/**
 * @summary Archive resource pricing row (soft delete; sets status='Archived')
 */
export const getArchiveResourcePricingUrl = (id: number) => {
  return `/api/resource-pricing/${id}`;
};

export const archiveResourcePricing = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getArchiveResourcePricingUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getArchiveResourcePricingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveResourcePricing>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveResourcePricing>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["archiveResourcePricing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveResourcePricing>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return archiveResourcePricing(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveResourcePricingMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveResourcePricing>>
>;

export type ArchiveResourcePricingMutationError = ErrorType<unknown>;

/**
 * @summary Archive resource pricing row (soft delete; sets status='Archived')
 */
export const useArchiveResourcePricing = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveResourcePricing>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveResourcePricing>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getArchiveResourcePricingMutationOptions(options));
};

/**
 * @summary Create non-recurring booking charge (D-04)
 */
export const getCreateBookingUrl = () => {
  return `/api/booking`;
};

export const createBooking = async (
  createBookingBody: CreateBookingBody,
  options?: RequestInit,
): Promise<CreateBooking201> => {
  return customFetch<CreateBooking201>(getCreateBookingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBookingBody),
  });
};

export const getCreateBookingMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBooking>>,
    TError,
    { data: BodyType<CreateBookingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBooking>>,
  TError,
  { data: BodyType<CreateBookingBody> },
  TContext
> => {
  const mutationKey = ["createBooking"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBooking>>,
    { data: BodyType<CreateBookingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBooking(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBooking>>
>;
export type CreateBookingMutationBody = BodyType<CreateBookingBody>;
export type CreateBookingMutationError = ErrorType<void>;

/**
 * @summary Create non-recurring booking charge (D-04)
 */
export const useCreateBooking = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBooking>>,
    TError,
    { data: BodyType<CreateBookingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBooking>>,
  TError,
  { data: BodyType<CreateBookingBody> },
  TContext
> => {
  return useMutation(getCreateBookingMutationOptions(options));
};

/**
 * @summary Cancel booking (D-20 — Waived + [Cancelled] prefix; refund_required if was Paid)
 */
export const getCancelBookingUrl = (id: number) => {
  return `/api/booking/${id}/cancel`;
};

export const cancelBooking = async (
  id: number,
  bookingActionReason: BookingActionReason,
  options?: RequestInit,
): Promise<MemberCharge> => {
  return customFetch<MemberCharge>(getCancelBookingUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bookingActionReason),
  });
};

export const getCancelBookingMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelBooking>>,
    TError,
    { id: number; data: BodyType<BookingActionReason> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelBooking>>,
  TError,
  { id: number; data: BodyType<BookingActionReason> },
  TContext
> => {
  const mutationKey = ["cancelBooking"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelBooking>>,
    { id: number; data: BodyType<BookingActionReason> }
  > = (props) => {
    const { id, data } = props ?? {};

    return cancelBooking(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelBooking>>
>;
export type CancelBookingMutationBody = BodyType<BookingActionReason>;
export type CancelBookingMutationError = ErrorType<void>;

/**
 * @summary Cancel booking (D-20 — Waived + [Cancelled] prefix; refund_required if was Paid)
 */
export const useCancelBooking = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelBooking>>,
    TError,
    { id: number; data: BodyType<BookingActionReason> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelBooking>>,
  TError,
  { id: number; data: BodyType<BookingActionReason> },
  TContext
> => {
  return useMutation(getCancelBookingMutationOptions(options));
};

/**
 * @summary Record no-show (D-20 — status unchanged + [No-Show] prefix)
 */
export const getNoShowBookingUrl = (id: number) => {
  return `/api/booking/${id}/no-show`;
};

export const noShowBooking = async (
  id: number,
  bookingActionReason: BookingActionReason,
  options?: RequestInit,
): Promise<MemberCharge> => {
  return customFetch<MemberCharge>(getNoShowBookingUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bookingActionReason),
  });
};

export const getNoShowBookingMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof noShowBooking>>,
    TError,
    { id: number; data: BodyType<BookingActionReason> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof noShowBooking>>,
  TError,
  { id: number; data: BodyType<BookingActionReason> },
  TContext
> => {
  const mutationKey = ["noShowBooking"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof noShowBooking>>,
    { id: number; data: BodyType<BookingActionReason> }
  > = (props) => {
    const { id, data } = props ?? {};

    return noShowBooking(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NoShowBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof noShowBooking>>
>;
export type NoShowBookingMutationBody = BodyType<BookingActionReason>;
export type NoShowBookingMutationError = ErrorType<void>;

/**
 * @summary Record no-show (D-20 — status unchanged + [No-Show] prefix)
 */
export const useNoShowBooking = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof noShowBooking>>,
    TError,
    { id: number; data: BodyType<BookingActionReason> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof noShowBooking>>,
  TError,
  { id: number; data: BodyType<BookingActionReason> },
  TContext
> => {
  return useMutation(getNoShowBookingMutationOptions(options));
};

/**
 * @summary Reschedule booking (D-20 — update transactionDate + booking times)
 */
export const getRescheduleBookingUrl = (id: number) => {
  return `/api/booking/${id}/reschedule`;
};

export const rescheduleBooking = async (
  id: number,
  rescheduleBookingBody: RescheduleBookingBody,
  options?: RequestInit,
): Promise<MemberCharge> => {
  return customFetch<MemberCharge>(getRescheduleBookingUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rescheduleBookingBody),
  });
};

export const getRescheduleBookingMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rescheduleBooking>>,
    TError,
    { id: number; data: BodyType<RescheduleBookingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rescheduleBooking>>,
  TError,
  { id: number; data: BodyType<RescheduleBookingBody> },
  TContext
> => {
  const mutationKey = ["rescheduleBooking"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rescheduleBooking>>,
    { id: number; data: BodyType<RescheduleBookingBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return rescheduleBooking(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RescheduleBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof rescheduleBooking>>
>;
export type RescheduleBookingMutationBody = BodyType<RescheduleBookingBody>;
export type RescheduleBookingMutationError = ErrorType<void>;

/**
 * @summary Reschedule booking (D-20 — update transactionDate + booking times)
 */
export const useRescheduleBooking = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rescheduleBooking>>,
    TError,
    { id: number; data: BodyType<RescheduleBookingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rescheduleBooking>>,
  TError,
  { id: number; data: BodyType<RescheduleBookingBody> },
  TContext
> => {
  return useMutation(getRescheduleBookingMutationOptions(options));
};

/**
 * @summary Sell a Non_Recurring pass (plan-priced, membership-not-required)
 */
export const getSellPassUrl = () => {
  return `/api/pass-sale`;
};

export const sellPass = async (
  createPassSaleBody: CreatePassSaleBody,
  options?: RequestInit,
): Promise<MemberCharge> => {
  return customFetch<MemberCharge>(getSellPassUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPassSaleBody),
  });
};

export const getSellPassMutationOptions = <
  TError = ErrorType<BadRequestResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sellPass>>,
    TError,
    { data: BodyType<CreatePassSaleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sellPass>>,
  TError,
  { data: BodyType<CreatePassSaleBody> },
  TContext
> => {
  const mutationKey = ["sellPass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sellPass>>,
    { data: BodyType<CreatePassSaleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return sellPass(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SellPassMutationResult = NonNullable<
  Awaited<ReturnType<typeof sellPass>>
>;
export type SellPassMutationBody = BodyType<CreatePassSaleBody>;
export type SellPassMutationError = ErrorType<BadRequestResponse | void>;

/**
 * @summary Sell a Non_Recurring pass (plan-priced, membership-not-required)
 */
export const useSellPass = <
  TError = ErrorType<BadRequestResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sellPass>>,
    TError,
    { data: BodyType<CreatePassSaleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sellPass>>,
  TError,
  { data: BodyType<CreatePassSaleBody> },
  TContext
> => {
  return useMutation(getSellPassMutationOptions(options));
};

/**
 * @summary Get invoice template config for a space (D-09)
 */
export const getGetSpaceInvoiceTemplateUrl = (id: number) => {
  return `/api/spaces/${id}/invoice-template`;
};

export const getSpaceInvoiceTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<InvoiceTemplateConfig> => {
  return customFetch<InvoiceTemplateConfig>(getGetSpaceInvoiceTemplateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSpaceInvoiceTemplateQueryKey = (id: number) => {
  return [`/api/spaces/${id}/invoice-template`] as const;
};

export const getGetSpaceInvoiceTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getSpaceInvoiceTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpaceInvoiceTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSpaceInvoiceTemplateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSpaceInvoiceTemplate>>
  > = ({ signal }) =>
    getSpaceInvoiceTemplate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSpaceInvoiceTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSpaceInvoiceTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSpaceInvoiceTemplate>>
>;
export type GetSpaceInvoiceTemplateQueryError = ErrorType<unknown>;

/**
 * @summary Get invoice template config for a space (D-09)
 */

export function useGetSpaceInvoiceTemplate<
  TData = Awaited<ReturnType<typeof getSpaceInvoiceTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpaceInvoiceTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSpaceInvoiceTemplateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update invoice template config (admin only)
 */
export const getUpdateSpaceInvoiceTemplateUrl = (id: number) => {
  return `/api/spaces/${id}/invoice-template`;
};

export const updateSpaceInvoiceTemplate = async (
  id: number,
  invoiceTemplateConfig: InvoiceTemplateConfig,
  options?: RequestInit,
): Promise<InvoiceTemplateConfig> => {
  return customFetch<InvoiceTemplateConfig>(
    getUpdateSpaceInvoiceTemplateUrl(id),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(invoiceTemplateConfig),
    },
  );
};

export const getUpdateSpaceInvoiceTemplateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceInvoiceTemplate>>,
    TError,
    { id: number; data: BodyType<InvoiceTemplateConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSpaceInvoiceTemplate>>,
  TError,
  { id: number; data: BodyType<InvoiceTemplateConfig> },
  TContext
> => {
  const mutationKey = ["updateSpaceInvoiceTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSpaceInvoiceTemplate>>,
    { id: number; data: BodyType<InvoiceTemplateConfig> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSpaceInvoiceTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSpaceInvoiceTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSpaceInvoiceTemplate>>
>;
export type UpdateSpaceInvoiceTemplateMutationBody =
  BodyType<InvoiceTemplateConfig>;
export type UpdateSpaceInvoiceTemplateMutationError = ErrorType<void>;

/**
 * @summary Update invoice template config (admin only)
 */
export const useUpdateSpaceInvoiceTemplate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceInvoiceTemplate>>,
    TError,
    { id: number; data: BodyType<InvoiceTemplateConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSpaceInvoiceTemplate>>,
  TError,
  { id: number; data: BodyType<InvoiceTemplateConfig> },
  TContext
> => {
  return useMutation(getUpdateSpaceInvoiceTemplateMutationOptions(options));
};

/**
 * @summary Get Order Receipt config for a space (0072)
 */
export const getGetSpaceReceiptConfigUrl = (id: number) => {
  return `/api/spaces/${id}/receipt-config`;
};

export const getSpaceReceiptConfig = async (
  id: number,
  options?: RequestInit,
): Promise<ReceiptConfig> => {
  return customFetch<ReceiptConfig>(getGetSpaceReceiptConfigUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSpaceReceiptConfigQueryKey = (id: number) => {
  return [`/api/spaces/${id}/receipt-config`] as const;
};

export const getGetSpaceReceiptConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getSpaceReceiptConfig>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpaceReceiptConfig>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSpaceReceiptConfigQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSpaceReceiptConfig>>
  > = ({ signal }) => getSpaceReceiptConfig(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSpaceReceiptConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSpaceReceiptConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSpaceReceiptConfig>>
>;
export type GetSpaceReceiptConfigQueryError = ErrorType<unknown>;

/**
 * @summary Get Order Receipt config for a space (0072)
 */

export function useGetSpaceReceiptConfig<
  TData = Awaited<ReturnType<typeof getSpaceReceiptConfig>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpaceReceiptConfig>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSpaceReceiptConfigQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update Order Receipt config (admin only)
 */
export const getUpdateSpaceReceiptConfigUrl = (id: number) => {
  return `/api/spaces/${id}/receipt-config`;
};

export const updateSpaceReceiptConfig = async (
  id: number,
  receiptConfig: ReceiptConfig,
  options?: RequestInit,
): Promise<ReceiptConfig> => {
  return customFetch<ReceiptConfig>(getUpdateSpaceReceiptConfigUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(receiptConfig),
  });
};

export const getUpdateSpaceReceiptConfigMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceReceiptConfig>>,
    TError,
    { id: number; data: BodyType<ReceiptConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSpaceReceiptConfig>>,
  TError,
  { id: number; data: BodyType<ReceiptConfig> },
  TContext
> => {
  const mutationKey = ["updateSpaceReceiptConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSpaceReceiptConfig>>,
    { id: number; data: BodyType<ReceiptConfig> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSpaceReceiptConfig(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSpaceReceiptConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSpaceReceiptConfig>>
>;
export type UpdateSpaceReceiptConfigMutationBody = BodyType<ReceiptConfig>;
export type UpdateSpaceReceiptConfigMutationError = ErrorType<void>;

/**
 * @summary Update Order Receipt config (admin only)
 */
export const useUpdateSpaceReceiptConfig = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceReceiptConfig>>,
    TError,
    { id: number; data: BodyType<ReceiptConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSpaceReceiptConfig>>,
  TError,
  { id: number; data: BodyType<ReceiptConfig> },
  TContext
> => {
  return useMutation(getUpdateSpaceReceiptConfigMutationOptions(options));
};

/**
 * @summary List infra categories
 */
export const getListInfraCategoriesUrl = (
  params?: ListInfraCategoriesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/infra/categories?${stringifiedParams}`
    : `/api/infra/categories`;
};

export const listInfraCategories = async (
  params?: ListInfraCategoriesParams,
  options?: RequestInit,
): Promise<InfraCategory[]> => {
  return customFetch<InfraCategory[]>(getListInfraCategoriesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInfraCategoriesQueryKey = (
  params?: ListInfraCategoriesParams,
) => {
  return [`/api/infra/categories`, ...(params ? [params] : [])] as const;
};

export const getListInfraCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfraCategories>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInfraCategoriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInfraCategories>>
  > = ({ signal }) =>
    listInfraCategories(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfraCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfraCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfraCategories>>
>;
export type ListInfraCategoriesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List infra categories
 */

export function useListInfraCategories<
  TData = Awaited<ReturnType<typeof listInfraCategories>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfraCategoriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an infra category (admin only)
 */
export const getCreateInfraCategoryUrl = () => {
  return `/api/infra/categories`;
};

export const createInfraCategory = async (
  createInfraCategoryBody: CreateInfraCategoryBody,
  options?: RequestInit,
): Promise<InfraCategory> => {
  return customFetch<InfraCategory>(getCreateInfraCategoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInfraCategoryBody),
  });
};

export const getCreateInfraCategoryMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraCategory>>,
    TError,
    { data: BodyType<CreateInfraCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfraCategory>>,
  TError,
  { data: BodyType<CreateInfraCategoryBody> },
  TContext
> => {
  const mutationKey = ["createInfraCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfraCategory>>,
    { data: BodyType<CreateInfraCategoryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInfraCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfraCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfraCategory>>
>;
export type CreateInfraCategoryMutationBody = BodyType<CreateInfraCategoryBody>;
export type CreateInfraCategoryMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an infra category (admin only)
 */
export const useCreateInfraCategory = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraCategory>>,
    TError,
    { data: BodyType<CreateInfraCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfraCategory>>,
  TError,
  { data: BodyType<CreateInfraCategoryBody> },
  TContext
> => {
  return useMutation(getCreateInfraCategoryMutationOptions(options));
};

/**
 * @summary Update an infra category (admin only)
 */
export const getUpdateInfraCategoryUrl = (id: number) => {
  return `/api/infra/categories/${id}`;
};

export const updateInfraCategory = async (
  id: number,
  updateInfraCategoryBody: UpdateInfraCategoryBody,
  options?: RequestInit,
): Promise<InfraCategory> => {
  return customFetch<InfraCategory>(getUpdateInfraCategoryUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInfraCategoryBody),
  });
};

export const getUpdateInfraCategoryMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraCategory>>,
    TError,
    { id: number; data: BodyType<UpdateInfraCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfraCategory>>,
  TError,
  { id: number; data: BodyType<UpdateInfraCategoryBody> },
  TContext
> => {
  const mutationKey = ["updateInfraCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfraCategory>>,
    { id: number; data: BodyType<UpdateInfraCategoryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInfraCategory(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfraCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfraCategory>>
>;
export type UpdateInfraCategoryMutationBody = BodyType<UpdateInfraCategoryBody>;
export type UpdateInfraCategoryMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update an infra category (admin only)
 */
export const useUpdateInfraCategory = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraCategory>>,
    TError,
    { id: number; data: BodyType<UpdateInfraCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfraCategory>>,
  TError,
  { id: number; data: BodyType<UpdateInfraCategoryBody> },
  TContext
> => {
  return useMutation(getUpdateInfraCategoryMutationOptions(options));
};

/**
 * @summary Delete an infra category (admin only)
 */
export const getDeleteInfraCategoryUrl = (id: number) => {
  return `/api/infra/categories/${id}`;
};

export const deleteInfraCategory = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInfraCategoryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInfraCategoryMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraCategory>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfraCategory>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInfraCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfraCategory>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInfraCategory(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfraCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfraCategory>>
>;

export type DeleteInfraCategoryMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete an infra category (admin only)
 */
export const useDeleteInfraCategory = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraCategory>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfraCategory>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInfraCategoryMutationOptions(options));
};

/**
 * @summary List infra catalog items
 */
export const getListInfraItemsUrl = (params?: ListInfraItemsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/infra/items?${stringifiedParams}`
    : `/api/infra/items`;
};

export const listInfraItems = async (
  params?: ListInfraItemsParams,
  options?: RequestInit,
): Promise<InfraItem[]> => {
  return customFetch<InfraItem[]>(getListInfraItemsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInfraItemsQueryKey = (params?: ListInfraItemsParams) => {
  return [`/api/infra/items`, ...(params ? [params] : [])] as const;
};

export const getListInfraItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfraItems>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInfraItemsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInfraItems>>> = ({
    signal,
  }) => listInfraItems(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfraItems>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfraItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfraItems>>
>;
export type ListInfraItemsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List infra catalog items
 */

export function useListInfraItems<
  TData = Awaited<ReturnType<typeof listInfraItems>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfraItemsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an infra catalog item (admin only)
 */
export const getCreateInfraItemUrl = () => {
  return `/api/infra/items`;
};

export const createInfraItem = async (
  createInfraItemBody: CreateInfraItemBody,
  options?: RequestInit,
): Promise<InfraItem> => {
  return customFetch<InfraItem>(getCreateInfraItemUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInfraItemBody),
  });
};

export const getCreateInfraItemMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraItem>>,
    TError,
    { data: BodyType<CreateInfraItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfraItem>>,
  TError,
  { data: BodyType<CreateInfraItemBody> },
  TContext
> => {
  const mutationKey = ["createInfraItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfraItem>>,
    { data: BodyType<CreateInfraItemBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInfraItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfraItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfraItem>>
>;
export type CreateInfraItemMutationBody = BodyType<CreateInfraItemBody>;
export type CreateInfraItemMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | void
>;

/**
 * @summary Create an infra catalog item (admin only)
 */
export const useCreateInfraItem = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraItem>>,
    TError,
    { data: BodyType<CreateInfraItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfraItem>>,
  TError,
  { data: BodyType<CreateInfraItemBody> },
  TContext
> => {
  return useMutation(getCreateInfraItemMutationOptions(options));
};

/**
 * @summary Update an infra catalog item (admin only)
 */
export const getUpdateInfraItemUrl = (id: number) => {
  return `/api/infra/items/${id}`;
};

export const updateInfraItem = async (
  id: number,
  updateInfraItemBody: UpdateInfraItemBody,
  options?: RequestInit,
): Promise<InfraItem> => {
  return customFetch<InfraItem>(getUpdateInfraItemUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInfraItemBody),
  });
};

export const getUpdateInfraItemMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraItem>>,
    TError,
    { id: number; data: BodyType<UpdateInfraItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfraItem>>,
  TError,
  { id: number; data: BodyType<UpdateInfraItemBody> },
  TContext
> => {
  const mutationKey = ["updateInfraItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfraItem>>,
    { id: number; data: BodyType<UpdateInfraItemBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInfraItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfraItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfraItem>>
>;
export type UpdateInfraItemMutationBody = BodyType<UpdateInfraItemBody>;
export type UpdateInfraItemMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update an infra catalog item (admin only)
 */
export const useUpdateInfraItem = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraItem>>,
    TError,
    { id: number; data: BodyType<UpdateInfraItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfraItem>>,
  TError,
  { id: number; data: BodyType<UpdateInfraItemBody> },
  TContext
> => {
  return useMutation(getUpdateInfraItemMutationOptions(options));
};

/**
 * @summary Delete an infra catalog item (admin only); 409 if acquisitions exist
 */
export const getDeleteInfraItemUrl = (id: number) => {
  return `/api/infra/items/${id}`;
};

export const deleteInfraItem = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInfraItemUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInfraItemMutationOptions = <
  TError = ErrorType<NotFoundResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraItem>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfraItem>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInfraItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfraItem>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInfraItem(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfraItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfraItem>>
>;

export type DeleteInfraItemMutationError = ErrorType<NotFoundResponse | void>;

/**
 * @summary Delete an infra catalog item (admin only); 409 if acquisitions exist
 */
export const useDeleteInfraItem = <
  TError = ErrorType<NotFoundResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraItem>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfraItem>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInfraItemMutationOptions(options));
};

/**
 * @summary List acquisitions with warranty info (expiring/expired view)
 */
export const getListInfraWarrantyUrl = (params?: ListInfraWarrantyParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/infra/acquisitions/warranty?${stringifiedParams}`
    : `/api/infra/acquisitions/warranty`;
};

export const listInfraWarranty = async (
  params?: ListInfraWarrantyParams,
  options?: RequestInit,
): Promise<InfraAcquisition[]> => {
  return customFetch<InfraAcquisition[]>(getListInfraWarrantyUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInfraWarrantyQueryKey = (
  params?: ListInfraWarrantyParams,
) => {
  return [
    `/api/infra/acquisitions/warranty`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListInfraWarrantyQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfraWarranty>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraWarrantyParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraWarranty>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInfraWarrantyQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInfraWarranty>>
  > = ({ signal }) => listInfraWarranty(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfraWarranty>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfraWarrantyQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfraWarranty>>
>;
export type ListInfraWarrantyQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List acquisitions with warranty info (expiring/expired view)
 */

export function useListInfraWarranty<
  TData = Awaited<ReturnType<typeof listInfraWarranty>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraWarrantyParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraWarranty>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfraWarrantyQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List infra acquisitions
 */
export const getListInfraAcquisitionsUrl = (
  params?: ListInfraAcquisitionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/infra/acquisitions?${stringifiedParams}`
    : `/api/infra/acquisitions`;
};

export const listInfraAcquisitions = async (
  params?: ListInfraAcquisitionsParams,
  options?: RequestInit,
): Promise<InfraAcquisition[]> => {
  return customFetch<InfraAcquisition[]>(getListInfraAcquisitionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInfraAcquisitionsQueryKey = (
  params?: ListInfraAcquisitionsParams,
) => {
  return [`/api/infra/acquisitions`, ...(params ? [params] : [])] as const;
};

export const getListInfraAcquisitionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfraAcquisitions>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraAcquisitionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraAcquisitions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInfraAcquisitionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInfraAcquisitions>>
  > = ({ signal }) =>
    listInfraAcquisitions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfraAcquisitions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfraAcquisitionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfraAcquisitions>>
>;
export type ListInfraAcquisitionsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List infra acquisitions
 */

export function useListInfraAcquisitions<
  TData = Awaited<ReturnType<typeof listInfraAcquisitions>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraAcquisitionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraAcquisitions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfraAcquisitionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Log a new infra acquisition / setup
 */
export const getCreateInfraAcquisitionUrl = () => {
  return `/api/infra/acquisitions`;
};

export const createInfraAcquisition = async (
  createInfraAcquisitionBody: CreateInfraAcquisitionBody,
  options?: RequestInit,
): Promise<InfraAcquisition> => {
  return customFetch<InfraAcquisition>(getCreateInfraAcquisitionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInfraAcquisitionBody),
  });
};

export const getCreateInfraAcquisitionMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraAcquisition>>,
    TError,
    { data: BodyType<CreateInfraAcquisitionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfraAcquisition>>,
  TError,
  { data: BodyType<CreateInfraAcquisitionBody> },
  TContext
> => {
  const mutationKey = ["createInfraAcquisition"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfraAcquisition>>,
    { data: BodyType<CreateInfraAcquisitionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInfraAcquisition(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfraAcquisitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfraAcquisition>>
>;
export type CreateInfraAcquisitionMutationBody =
  BodyType<CreateInfraAcquisitionBody>;
export type CreateInfraAcquisitionMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Log a new infra acquisition / setup
 */
export const useCreateInfraAcquisition = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraAcquisition>>,
    TError,
    { data: BodyType<CreateInfraAcquisitionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfraAcquisition>>,
  TError,
  { data: BodyType<CreateInfraAcquisitionBody> },
  TContext
> => {
  return useMutation(getCreateInfraAcquisitionMutationOptions(options));
};

/**
 * @summary Update an infra acquisition record
 */
export const getUpdateInfraAcquisitionUrl = (id: number) => {
  return `/api/infra/acquisitions/${id}`;
};

export const updateInfraAcquisition = async (
  id: number,
  updateInfraAcquisitionBody: UpdateInfraAcquisitionBody,
  options?: RequestInit,
): Promise<InfraAcquisition> => {
  return customFetch<InfraAcquisition>(getUpdateInfraAcquisitionUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInfraAcquisitionBody),
  });
};

export const getUpdateInfraAcquisitionMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraAcquisition>>,
    TError,
    { id: number; data: BodyType<UpdateInfraAcquisitionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfraAcquisition>>,
  TError,
  { id: number; data: BodyType<UpdateInfraAcquisitionBody> },
  TContext
> => {
  const mutationKey = ["updateInfraAcquisition"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfraAcquisition>>,
    { id: number; data: BodyType<UpdateInfraAcquisitionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInfraAcquisition(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfraAcquisitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfraAcquisition>>
>;
export type UpdateInfraAcquisitionMutationBody =
  BodyType<UpdateInfraAcquisitionBody>;
export type UpdateInfraAcquisitionMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update an infra acquisition record
 */
export const useUpdateInfraAcquisition = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraAcquisition>>,
    TError,
    { id: number; data: BodyType<UpdateInfraAcquisitionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfraAcquisition>>,
  TError,
  { id: number; data: BodyType<UpdateInfraAcquisitionBody> },
  TContext
> => {
  return useMutation(getUpdateInfraAcquisitionMutationOptions(options));
};

/**
 * @summary Delete an infra acquisition record
 */
export const getDeleteInfraAcquisitionUrl = (id: number) => {
  return `/api/infra/acquisitions/${id}`;
};

export const deleteInfraAcquisition = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInfraAcquisitionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInfraAcquisitionMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraAcquisition>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfraAcquisition>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInfraAcquisition"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfraAcquisition>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInfraAcquisition(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfraAcquisitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfraAcquisition>>
>;

export type DeleteInfraAcquisitionMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete an infra acquisition record
 */
export const useDeleteInfraAcquisition = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraAcquisition>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfraAcquisition>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInfraAcquisitionMutationOptions(options));
};

/**
 * @summary List infra attribute keys
 */
export const getListInfraAttributeKeysUrl = (
  params?: ListInfraAttributeKeysParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/infra/attribute-keys?${stringifiedParams}`
    : `/api/infra/attribute-keys`;
};

export const listInfraAttributeKeys = async (
  params?: ListInfraAttributeKeysParams,
  options?: RequestInit,
): Promise<InfraAttributeKey[]> => {
  return customFetch<InfraAttributeKey[]>(
    getListInfraAttributeKeysUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInfraAttributeKeysQueryKey = (
  params?: ListInfraAttributeKeysParams,
) => {
  return [`/api/infra/attribute-keys`, ...(params ? [params] : [])] as const;
};

export const getListInfraAttributeKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfraAttributeKeys>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraAttributeKeysParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraAttributeKeys>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInfraAttributeKeysQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInfraAttributeKeys>>
  > = ({ signal }) =>
    listInfraAttributeKeys(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfraAttributeKeys>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfraAttributeKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfraAttributeKeys>>
>;
export type ListInfraAttributeKeysQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List infra attribute keys
 */

export function useListInfraAttributeKeys<
  TData = Awaited<ReturnType<typeof listInfraAttributeKeys>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraAttributeKeysParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraAttributeKeys>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfraAttributeKeysQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an infra attribute key (admin only)
 */
export const getCreateInfraAttributeKeyUrl = () => {
  return `/api/infra/attribute-keys`;
};

export const createInfraAttributeKey = async (
  createInfraAttributeKeyBody: CreateInfraAttributeKeyBody,
  options?: RequestInit,
): Promise<InfraAttributeKey> => {
  return customFetch<InfraAttributeKey>(getCreateInfraAttributeKeyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInfraAttributeKeyBody),
  });
};

export const getCreateInfraAttributeKeyMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraAttributeKey>>,
    TError,
    { data: BodyType<CreateInfraAttributeKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfraAttributeKey>>,
  TError,
  { data: BodyType<CreateInfraAttributeKeyBody> },
  TContext
> => {
  const mutationKey = ["createInfraAttributeKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfraAttributeKey>>,
    { data: BodyType<CreateInfraAttributeKeyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInfraAttributeKey(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfraAttributeKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfraAttributeKey>>
>;
export type CreateInfraAttributeKeyMutationBody =
  BodyType<CreateInfraAttributeKeyBody>;
export type CreateInfraAttributeKeyMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an infra attribute key (admin only)
 */
export const useCreateInfraAttributeKey = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraAttributeKey>>,
    TError,
    { data: BodyType<CreateInfraAttributeKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfraAttributeKey>>,
  TError,
  { data: BodyType<CreateInfraAttributeKeyBody> },
  TContext
> => {
  return useMutation(getCreateInfraAttributeKeyMutationOptions(options));
};

/**
 * @summary Get an infra attribute key by ID
 */
export const getGetInfraAttributeKeyUrl = (id: number) => {
  return `/api/infra/attribute-keys/${id}`;
};

export const getInfraAttributeKey = async (
  id: number,
  options?: RequestInit,
): Promise<InfraAttributeKey> => {
  return customFetch<InfraAttributeKey>(getGetInfraAttributeKeyUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInfraAttributeKeyQueryKey = (id: number) => {
  return [`/api/infra/attribute-keys/${id}`] as const;
};

export const getGetInfraAttributeKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getInfraAttributeKey>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInfraAttributeKey>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInfraAttributeKeyQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInfraAttributeKey>>
  > = ({ signal }) => getInfraAttributeKey(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInfraAttributeKey>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInfraAttributeKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInfraAttributeKey>>
>;
export type GetInfraAttributeKeyQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get an infra attribute key by ID
 */

export function useGetInfraAttributeKey<
  TData = Awaited<ReturnType<typeof getInfraAttributeKey>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInfraAttributeKey>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInfraAttributeKeyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an infra attribute key (admin only)
 */
export const getUpdateInfraAttributeKeyUrl = (id: number) => {
  return `/api/infra/attribute-keys/${id}`;
};

export const updateInfraAttributeKey = async (
  id: number,
  updateInfraAttributeKeyBody: UpdateInfraAttributeKeyBody,
  options?: RequestInit,
): Promise<InfraAttributeKey> => {
  return customFetch<InfraAttributeKey>(getUpdateInfraAttributeKeyUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInfraAttributeKeyBody),
  });
};

export const getUpdateInfraAttributeKeyMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraAttributeKey>>,
    TError,
    { id: number; data: BodyType<UpdateInfraAttributeKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfraAttributeKey>>,
  TError,
  { id: number; data: BodyType<UpdateInfraAttributeKeyBody> },
  TContext
> => {
  const mutationKey = ["updateInfraAttributeKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfraAttributeKey>>,
    { id: number; data: BodyType<UpdateInfraAttributeKeyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInfraAttributeKey(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfraAttributeKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfraAttributeKey>>
>;
export type UpdateInfraAttributeKeyMutationBody =
  BodyType<UpdateInfraAttributeKeyBody>;
export type UpdateInfraAttributeKeyMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update an infra attribute key (admin only)
 */
export const useUpdateInfraAttributeKey = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraAttributeKey>>,
    TError,
    { id: number; data: BodyType<UpdateInfraAttributeKeyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfraAttributeKey>>,
  TError,
  { id: number; data: BodyType<UpdateInfraAttributeKeyBody> },
  TContext
> => {
  return useMutation(getUpdateInfraAttributeKeyMutationOptions(options));
};

/**
 * @summary Archive an infra attribute key — DELETE not supported; returns 405
 */
export const getDeleteInfraAttributeKeyUrl = (id: number) => {
  return `/api/infra/attribute-keys/${id}`;
};

export const deleteInfraAttributeKey = async (
  id: number,
  options?: RequestInit,
): Promise<unknown> => {
  return customFetch<unknown>(getDeleteInfraAttributeKeyUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInfraAttributeKeyMutationOptions = <
  TError = ErrorType<NotFoundResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraAttributeKey>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfraAttributeKey>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInfraAttributeKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfraAttributeKey>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInfraAttributeKey(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfraAttributeKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfraAttributeKey>>
>;

export type DeleteInfraAttributeKeyMutationError =
  ErrorType<NotFoundResponse | void>;

/**
 * @summary Archive an infra attribute key — DELETE not supported; returns 405
 */
export const useDeleteInfraAttributeKey = <
  TError = ErrorType<NotFoundResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraAttributeKey>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfraAttributeKey>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInfraAttributeKeyMutationOptions(options));
};

/**
 * @summary List infra attribute values
 */
export const getListInfraAttributeValuesUrl = (
  params?: ListInfraAttributeValuesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/infra/attribute-values?${stringifiedParams}`
    : `/api/infra/attribute-values`;
};

export const listInfraAttributeValues = async (
  params?: ListInfraAttributeValuesParams,
  options?: RequestInit,
): Promise<InfraAttributeValue[]> => {
  return customFetch<InfraAttributeValue[]>(
    getListInfraAttributeValuesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInfraAttributeValuesQueryKey = (
  params?: ListInfraAttributeValuesParams,
) => {
  return [`/api/infra/attribute-values`, ...(params ? [params] : [])] as const;
};

export const getListInfraAttributeValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfraAttributeValues>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraAttributeValuesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraAttributeValues>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInfraAttributeValuesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInfraAttributeValues>>
  > = ({ signal }) =>
    listInfraAttributeValues(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfraAttributeValues>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfraAttributeValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfraAttributeValues>>
>;
export type ListInfraAttributeValuesQueryError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary List infra attribute values
 */

export function useListInfraAttributeValues<
  TData = Awaited<ReturnType<typeof listInfraAttributeValues>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInfraAttributeValuesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraAttributeValues>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfraAttributeValuesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an infra attribute value (admin only)
 */
export const getCreateInfraAttributeValueUrl = () => {
  return `/api/infra/attribute-values`;
};

export const createInfraAttributeValue = async (
  createInfraAttributeValueBody: CreateInfraAttributeValueBody,
  options?: RequestInit,
): Promise<InfraAttributeValue> => {
  return customFetch<InfraAttributeValue>(getCreateInfraAttributeValueUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInfraAttributeValueBody),
  });
};

export const getCreateInfraAttributeValueMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraAttributeValue>>,
    TError,
    { data: BodyType<CreateInfraAttributeValueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfraAttributeValue>>,
  TError,
  { data: BodyType<CreateInfraAttributeValueBody> },
  TContext
> => {
  const mutationKey = ["createInfraAttributeValue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfraAttributeValue>>,
    { data: BodyType<CreateInfraAttributeValueBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInfraAttributeValue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfraAttributeValueMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfraAttributeValue>>
>;
export type CreateInfraAttributeValueMutationBody =
  BodyType<CreateInfraAttributeValueBody>;
export type CreateInfraAttributeValueMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create an infra attribute value (admin only)
 */
export const useCreateInfraAttributeValue = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraAttributeValue>>,
    TError,
    { data: BodyType<CreateInfraAttributeValueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfraAttributeValue>>,
  TError,
  { data: BodyType<CreateInfraAttributeValueBody> },
  TContext
> => {
  return useMutation(getCreateInfraAttributeValueMutationOptions(options));
};

/**
 * @summary Update an infra attribute value (admin only)
 */
export const getUpdateInfraAttributeValueUrl = (id: number) => {
  return `/api/infra/attribute-values/${id}`;
};

export const updateInfraAttributeValue = async (
  id: number,
  updateInfraAttributeValueBody: UpdateInfraAttributeValueBody,
  options?: RequestInit,
): Promise<InfraAttributeValue> => {
  return customFetch<InfraAttributeValue>(getUpdateInfraAttributeValueUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInfraAttributeValueBody),
  });
};

export const getUpdateInfraAttributeValueMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraAttributeValue>>,
    TError,
    { id: number; data: BodyType<UpdateInfraAttributeValueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfraAttributeValue>>,
  TError,
  { id: number; data: BodyType<UpdateInfraAttributeValueBody> },
  TContext
> => {
  const mutationKey = ["updateInfraAttributeValue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfraAttributeValue>>,
    { id: number; data: BodyType<UpdateInfraAttributeValueBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInfraAttributeValue(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfraAttributeValueMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfraAttributeValue>>
>;
export type UpdateInfraAttributeValueMutationBody =
  BodyType<UpdateInfraAttributeValueBody>;
export type UpdateInfraAttributeValueMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update an infra attribute value (admin only)
 */
export const useUpdateInfraAttributeValue = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraAttributeValue>>,
    TError,
    { id: number; data: BodyType<UpdateInfraAttributeValueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfraAttributeValue>>,
  TError,
  { id: number; data: BodyType<UpdateInfraAttributeValueBody> },
  TContext
> => {
  return useMutation(getUpdateInfraAttributeValueMutationOptions(options));
};

/**
 * @summary Archive an infra attribute value — DELETE not supported; returns 405
 */
export const getDeleteInfraAttributeValueUrl = (id: number) => {
  return `/api/infra/attribute-values/${id}`;
};

export const deleteInfraAttributeValue = async (
  id: number,
  options?: RequestInit,
): Promise<unknown> => {
  return customFetch<unknown>(getDeleteInfraAttributeValueUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInfraAttributeValueMutationOptions = <
  TError = ErrorType<NotFoundResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraAttributeValue>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfraAttributeValue>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInfraAttributeValue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfraAttributeValue>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInfraAttributeValue(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfraAttributeValueMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfraAttributeValue>>
>;

export type DeleteInfraAttributeValueMutationError =
  ErrorType<NotFoundResponse | void>;

/**
 * @summary Archive an infra attribute value — DELETE not supported; returns 405
 */
export const useDeleteInfraAttributeValue = <
  TError = ErrorType<NotFoundResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraAttributeValue>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfraAttributeValue>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInfraAttributeValueMutationOptions(options));
};

/**
 * @summary List variants for an infra catalog item
 */
export const getListInfraItemVariantsUrl = (
  itemId: number,
  params?: ListInfraItemVariantsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/infra/items/${itemId}/variants?${stringifiedParams}`
    : `/api/infra/items/${itemId}/variants`;
};

export const listInfraItemVariants = async (
  itemId: number,
  params?: ListInfraItemVariantsParams,
  options?: RequestInit,
): Promise<InfraItemVariant[]> => {
  return customFetch<InfraItemVariant[]>(
    getListInfraItemVariantsUrl(itemId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInfraItemVariantsQueryKey = (
  itemId: number,
  params?: ListInfraItemVariantsParams,
) => {
  return [
    `/api/infra/items/${itemId}/variants`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListInfraItemVariantsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfraItemVariants>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  itemId: number,
  params?: ListInfraItemVariantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraItemVariants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInfraItemVariantsQueryKey(itemId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInfraItemVariants>>
  > = ({ signal }) =>
    listInfraItemVariants(itemId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!itemId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfraItemVariants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfraItemVariantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfraItemVariants>>
>;
export type ListInfraItemVariantsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List variants for an infra catalog item
 */

export function useListInfraItemVariants<
  TData = Awaited<ReturnType<typeof listInfraItemVariants>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  itemId: number,
  params?: ListInfraItemVariantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraItemVariants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfraItemVariantsQueryOptions(
    itemId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a variant for an infra catalog item (admin only)
 */
export const getCreateInfraItemVariantUrl = (itemId: number) => {
  return `/api/infra/items/${itemId}/variants`;
};

export const createInfraItemVariant = async (
  itemId: number,
  createInfraItemVariantBody: CreateInfraItemVariantBody,
  options?: RequestInit,
): Promise<InfraItemVariant> => {
  return customFetch<InfraItemVariant>(getCreateInfraItemVariantUrl(itemId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInfraItemVariantBody),
  });
};

export const getCreateInfraItemVariantMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraItemVariant>>,
    TError,
    { itemId: number; data: BodyType<CreateInfraItemVariantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfraItemVariant>>,
  TError,
  { itemId: number; data: BodyType<CreateInfraItemVariantBody> },
  TContext
> => {
  const mutationKey = ["createInfraItemVariant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfraItemVariant>>,
    { itemId: number; data: BodyType<CreateInfraItemVariantBody> }
  > = (props) => {
    const { itemId, data } = props ?? {};

    return createInfraItemVariant(itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfraItemVariantMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfraItemVariant>>
>;
export type CreateInfraItemVariantMutationBody =
  BodyType<CreateInfraItemVariantBody>;
export type CreateInfraItemVariantMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Create a variant for an infra catalog item (admin only)
 */
export const useCreateInfraItemVariant = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraItemVariant>>,
    TError,
    { itemId: number; data: BodyType<CreateInfraItemVariantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfraItemVariant>>,
  TError,
  { itemId: number; data: BodyType<CreateInfraItemVariantBody> },
  TContext
> => {
  return useMutation(getCreateInfraItemVariantMutationOptions(options));
};

/**
 * @summary Update an infra item variant (admin only)
 */
export const getUpdateInfraItemVariantUrl = (
  itemId: number,
  variantId: number,
) => {
  return `/api/infra/items/${itemId}/variants/${variantId}`;
};

export const updateInfraItemVariant = async (
  itemId: number,
  variantId: number,
  updateInfraItemVariantBody: UpdateInfraItemVariantBody,
  options?: RequestInit,
): Promise<InfraItemVariant> => {
  return customFetch<InfraItemVariant>(
    getUpdateInfraItemVariantUrl(itemId, variantId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateInfraItemVariantBody),
    },
  );
};

export const getUpdateInfraItemVariantMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraItemVariant>>,
    TError,
    {
      itemId: number;
      variantId: number;
      data: BodyType<UpdateInfraItemVariantBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfraItemVariant>>,
  TError,
  {
    itemId: number;
    variantId: number;
    data: BodyType<UpdateInfraItemVariantBody>;
  },
  TContext
> => {
  const mutationKey = ["updateInfraItemVariant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfraItemVariant>>,
    {
      itemId: number;
      variantId: number;
      data: BodyType<UpdateInfraItemVariantBody>;
    }
  > = (props) => {
    const { itemId, variantId, data } = props ?? {};

    return updateInfraItemVariant(itemId, variantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfraItemVariantMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfraItemVariant>>
>;
export type UpdateInfraItemVariantMutationBody =
  BodyType<UpdateInfraItemVariantBody>;
export type UpdateInfraItemVariantMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update an infra item variant (admin only)
 */
export const useUpdateInfraItemVariant = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfraItemVariant>>,
    TError,
    {
      itemId: number;
      variantId: number;
      data: BodyType<UpdateInfraItemVariantBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfraItemVariant>>,
  TError,
  {
    itemId: number;
    variantId: number;
    data: BodyType<UpdateInfraItemVariantBody>;
  },
  TContext
> => {
  return useMutation(getUpdateInfraItemVariantMutationOptions(options));
};

/**
 * @summary Delete an infra item variant (admin only)
 */
export const getDeleteInfraItemVariantUrl = (
  itemId: number,
  variantId: number,
) => {
  return `/api/infra/items/${itemId}/variants/${variantId}`;
};

export const deleteInfraItemVariant = async (
  itemId: number,
  variantId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInfraItemVariantUrl(itemId, variantId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInfraItemVariantMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraItemVariant>>,
    TError,
    { itemId: number; variantId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfraItemVariant>>,
  TError,
  { itemId: number; variantId: number },
  TContext
> => {
  const mutationKey = ["deleteInfraItemVariant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfraItemVariant>>,
    { itemId: number; variantId: number }
  > = (props) => {
    const { itemId, variantId } = props ?? {};

    return deleteInfraItemVariant(itemId, variantId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfraItemVariantMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfraItemVariant>>
>;

export type DeleteInfraItemVariantMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete an infra item variant (admin only)
 */
export const useDeleteInfraItemVariant = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraItemVariant>>,
    TError,
    { itemId: number; variantId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfraItemVariant>>,
  TError,
  { itemId: number; variantId: number },
  TContext
> => {
  return useMutation(getDeleteInfraItemVariantMutationOptions(options));
};

/**
 * @summary List installment payments for an infra acquisition
 */
export const getListInfraAcquisitionPaymentsUrl = (acquisitionId: number) => {
  return `/api/infra/acquisitions/${acquisitionId}/payments`;
};

export const listInfraAcquisitionPayments = async (
  acquisitionId: number,
  options?: RequestInit,
): Promise<InfraAcquisitionPayment[]> => {
  return customFetch<InfraAcquisitionPayment[]>(
    getListInfraAcquisitionPaymentsUrl(acquisitionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInfraAcquisitionPaymentsQueryKey = (
  acquisitionId: number,
) => {
  return [`/api/infra/acquisitions/${acquisitionId}/payments`] as const;
};

export const getListInfraAcquisitionPaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfraAcquisitionPayments>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  acquisitionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraAcquisitionPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListInfraAcquisitionPaymentsQueryKey(acquisitionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInfraAcquisitionPayments>>
  > = ({ signal }) =>
    listInfraAcquisitionPayments(acquisitionId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!acquisitionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfraAcquisitionPayments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfraAcquisitionPaymentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfraAcquisitionPayments>>
>;
export type ListInfraAcquisitionPaymentsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List installment payments for an infra acquisition
 */

export function useListInfraAcquisitionPayments<
  TData = Awaited<ReturnType<typeof listInfraAcquisitionPayments>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  acquisitionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInfraAcquisitionPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfraAcquisitionPaymentsQueryOptions(
    acquisitionId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Log an installment payment for an infra acquisition
 */
export const getCreateInfraAcquisitionPaymentUrl = (acquisitionId: number) => {
  return `/api/infra/acquisitions/${acquisitionId}/payments`;
};

export const createInfraAcquisitionPayment = async (
  acquisitionId: number,
  createInfraAcquisitionPaymentBody: CreateInfraAcquisitionPaymentBody,
  options?: RequestInit,
): Promise<InfraAcquisitionPayment> => {
  return customFetch<InfraAcquisitionPayment>(
    getCreateInfraAcquisitionPaymentUrl(acquisitionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createInfraAcquisitionPaymentBody),
    },
  );
};

export const getCreateInfraAcquisitionPaymentMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraAcquisitionPayment>>,
    TError,
    {
      acquisitionId: number;
      data: BodyType<CreateInfraAcquisitionPaymentBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfraAcquisitionPayment>>,
  TError,
  { acquisitionId: number; data: BodyType<CreateInfraAcquisitionPaymentBody> },
  TContext
> => {
  const mutationKey = ["createInfraAcquisitionPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfraAcquisitionPayment>>,
    { acquisitionId: number; data: BodyType<CreateInfraAcquisitionPaymentBody> }
  > = (props) => {
    const { acquisitionId, data } = props ?? {};

    return createInfraAcquisitionPayment(acquisitionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfraAcquisitionPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfraAcquisitionPayment>>
>;
export type CreateInfraAcquisitionPaymentMutationBody =
  BodyType<CreateInfraAcquisitionPaymentBody>;
export type CreateInfraAcquisitionPaymentMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Log an installment payment for an infra acquisition
 */
export const useCreateInfraAcquisitionPayment = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfraAcquisitionPayment>>,
    TError,
    {
      acquisitionId: number;
      data: BodyType<CreateInfraAcquisitionPaymentBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfraAcquisitionPayment>>,
  TError,
  { acquisitionId: number; data: BodyType<CreateInfraAcquisitionPaymentBody> },
  TContext
> => {
  return useMutation(getCreateInfraAcquisitionPaymentMutationOptions(options));
};

/**
 * @summary Delete an infra acquisition payment record
 */
export const getDeleteInfraAcquisitionPaymentUrl = (
  acquisitionId: number,
  paymentId: number,
) => {
  return `/api/infra/acquisitions/${acquisitionId}/payments/${paymentId}`;
};

export const deleteInfraAcquisitionPayment = async (
  acquisitionId: number,
  paymentId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(
    getDeleteInfraAcquisitionPaymentUrl(acquisitionId, paymentId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteInfraAcquisitionPaymentMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraAcquisitionPayment>>,
    TError,
    { acquisitionId: number; paymentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfraAcquisitionPayment>>,
  TError,
  { acquisitionId: number; paymentId: number },
  TContext
> => {
  const mutationKey = ["deleteInfraAcquisitionPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfraAcquisitionPayment>>,
    { acquisitionId: number; paymentId: number }
  > = (props) => {
    const { acquisitionId, paymentId } = props ?? {};

    return deleteInfraAcquisitionPayment(
      acquisitionId,
      paymentId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfraAcquisitionPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfraAcquisitionPayment>>
>;

export type DeleteInfraAcquisitionPaymentMutationError =
  ErrorType<NotFoundResponse>;

/**
 * @summary Delete an infra acquisition payment record
 */
export const useDeleteInfraAcquisitionPayment = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfraAcquisitionPayment>>,
    TError,
    { acquisitionId: number; paymentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfraAcquisitionPayment>>,
  TError,
  { acquisitionId: number; paymentId: number },
  TContext
> => {
  return useMutation(getDeleteInfraAcquisitionPaymentMutationOptions(options));
};

/**
 * @summary List floors for the operator's space
 */
export const getListSpaceFloorsUrl = () => {
  return `/api/space/floors`;
};

export const listSpaceFloors = async (
  options?: RequestInit,
): Promise<SpaceFloor[]> => {
  return customFetch<SpaceFloor[]>(getListSpaceFloorsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSpaceFloorsQueryKey = () => {
  return [`/api/space/floors`] as const;
};

export const getListSpaceFloorsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSpaceFloors>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSpaceFloors>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSpaceFloorsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSpaceFloors>>> = ({
    signal,
  }) => listSpaceFloors({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSpaceFloors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSpaceFloorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSpaceFloors>>
>;
export type ListSpaceFloorsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List floors for the operator's space
 */

export function useListSpaceFloors<
  TData = Awaited<ReturnType<typeof listSpaceFloors>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSpaceFloors>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSpaceFloorsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a floor (admin only)
 */
export const getCreateSpaceFloorUrl = () => {
  return `/api/space/floors`;
};

export const createSpaceFloor = async (
  createSpaceFloorBody: CreateSpaceFloorBody,
  options?: RequestInit,
): Promise<SpaceFloor> => {
  return customFetch<SpaceFloor>(getCreateSpaceFloorUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSpaceFloorBody),
  });
};

export const getCreateSpaceFloorMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceFloor>>,
    TError,
    { data: BodyType<CreateSpaceFloorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSpaceFloor>>,
  TError,
  { data: BodyType<CreateSpaceFloorBody> },
  TContext
> => {
  const mutationKey = ["createSpaceFloor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSpaceFloor>>,
    { data: BodyType<CreateSpaceFloorBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSpaceFloor(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSpaceFloorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSpaceFloor>>
>;
export type CreateSpaceFloorMutationBody = BodyType<CreateSpaceFloorBody>;
export type CreateSpaceFloorMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create a floor (admin only)
 */
export const useCreateSpaceFloor = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceFloor>>,
    TError,
    { data: BodyType<CreateSpaceFloorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSpaceFloor>>,
  TError,
  { data: BodyType<CreateSpaceFloorBody> },
  TContext
> => {
  return useMutation(getCreateSpaceFloorMutationOptions(options));
};

/**
 * @summary Update a floor (admin only)
 */
export const getUpdateSpaceFloorUrl = (id: number) => {
  return `/api/space/floors/${id}`;
};

export const updateSpaceFloor = async (
  id: number,
  updateSpaceFloorBody: UpdateSpaceFloorBody,
  options?: RequestInit,
): Promise<SpaceFloor> => {
  return customFetch<SpaceFloor>(getUpdateSpaceFloorUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSpaceFloorBody),
  });
};

export const getUpdateSpaceFloorMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceFloor>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceFloorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSpaceFloor>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceFloorBody> },
  TContext
> => {
  const mutationKey = ["updateSpaceFloor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSpaceFloor>>,
    { id: number; data: BodyType<UpdateSpaceFloorBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSpaceFloor(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSpaceFloorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSpaceFloor>>
>;
export type UpdateSpaceFloorMutationBody = BodyType<UpdateSpaceFloorBody>;
export type UpdateSpaceFloorMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update a floor (admin only)
 */
export const useUpdateSpaceFloor = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceFloor>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceFloorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSpaceFloor>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceFloorBody> },
  TContext
> => {
  return useMutation(getUpdateSpaceFloorMutationOptions(options));
};

/**
 * @summary Delete a floor (admin only)
 */
export const getDeleteSpaceFloorUrl = (id: number) => {
  return `/api/space/floors/${id}`;
};

export const deleteSpaceFloor = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSpaceFloorUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSpaceFloorMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceFloor>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSpaceFloor>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSpaceFloor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSpaceFloor>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSpaceFloor(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSpaceFloorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSpaceFloor>>
>;

export type DeleteSpaceFloorMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a floor (admin only)
 */
export const useDeleteSpaceFloor = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceFloor>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSpaceFloor>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSpaceFloorMutationOptions(options));
};

/**
 * @summary Get the stored visual design (Scene blob) for a floor
 */
export const getGetSpaceFloorDesignUrl = (id: number) => {
  return `/api/space/floors/${id}/design`;
};

export const getSpaceFloorDesign = async (
  id: number,
  options?: RequestInit,
): Promise<FloorDesignResponse> => {
  return customFetch<FloorDesignResponse>(getGetSpaceFloorDesignUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSpaceFloorDesignQueryKey = (id: number) => {
  return [`/api/space/floors/${id}/design`] as const;
};

export const getGetSpaceFloorDesignQueryOptions = <
  TData = Awaited<ReturnType<typeof getSpaceFloorDesign>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpaceFloorDesign>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSpaceFloorDesignQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSpaceFloorDesign>>
  > = ({ signal }) => getSpaceFloorDesign(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSpaceFloorDesign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSpaceFloorDesignQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSpaceFloorDesign>>
>;
export type GetSpaceFloorDesignQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Get the stored visual design (Scene blob) for a floor
 */

export function useGetSpaceFloorDesign<
  TData = Awaited<ReturnType<typeof getSpaceFloorDesign>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpaceFloorDesign>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSpaceFloorDesignQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save the draft design (0104: writes to pending_design_data; no projection). Approve to publish.
 */
export const getPutSpaceFloorDesignUrl = (id: number) => {
  return `/api/space/floors/${id}/design`;
};

export const putSpaceFloorDesign = async (
  id: number,
  putFloorDesignBody: PutFloorDesignBody,
  options?: RequestInit,
): Promise<PutFloorDesignResponse> => {
  return customFetch<PutFloorDesignResponse>(getPutSpaceFloorDesignUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(putFloorDesignBody),
  });
};

export const getPutSpaceFloorDesignMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSpaceFloorDesign>>,
    TError,
    { id: number; data: BodyType<PutFloorDesignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSpaceFloorDesign>>,
  TError,
  { id: number; data: BodyType<PutFloorDesignBody> },
  TContext
> => {
  const mutationKey = ["putSpaceFloorDesign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSpaceFloorDesign>>,
    { id: number; data: BodyType<PutFloorDesignBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putSpaceFloorDesign(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSpaceFloorDesignMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSpaceFloorDesign>>
>;
export type PutSpaceFloorDesignMutationBody = BodyType<PutFloorDesignBody>;
export type PutSpaceFloorDesignMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Save the draft design (0104: writes to pending_design_data; no projection). Approve to publish.
 */
export const usePutSpaceFloorDesign = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSpaceFloorDesign>>,
    TError,
    { id: number; data: BodyType<PutFloorDesignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putSpaceFloorDesign>>,
  TError,
  { id: number; data: BodyType<PutFloorDesignBody> },
  TContext
> => {
  return useMutation(getPutSpaceFloorDesignMutationOptions(options));
};

/**
 * @summary Publish the pending draft: copy pending → design_data + run projection (admin only)
 */
export const getApproveSpaceFloorDesignUrl = (id: number) => {
  return `/api/space/floors/${id}/design/approve`;
};

export const approveSpaceFloorDesign = async (
  id: number,
  approveSpaceFloorDesignBody?: ApproveSpaceFloorDesignBody,
  options?: RequestInit,
): Promise<PutFloorDesignResponse> => {
  return customFetch<PutFloorDesignResponse>(
    getApproveSpaceFloorDesignUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(approveSpaceFloorDesignBody),
    },
  );
};

export const getApproveSpaceFloorDesignMutationOptions = <
  TError = ErrorType<NotFoundResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveSpaceFloorDesign>>,
    TError,
    { id: number; data: BodyType<ApproveSpaceFloorDesignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveSpaceFloorDesign>>,
  TError,
  { id: number; data: BodyType<ApproveSpaceFloorDesignBody> },
  TContext
> => {
  const mutationKey = ["approveSpaceFloorDesign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveSpaceFloorDesign>>,
    { id: number; data: BodyType<ApproveSpaceFloorDesignBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return approveSpaceFloorDesign(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveSpaceFloorDesignMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveSpaceFloorDesign>>
>;
export type ApproveSpaceFloorDesignMutationBody =
  BodyType<ApproveSpaceFloorDesignBody>;
export type ApproveSpaceFloorDesignMutationError =
  ErrorType<NotFoundResponse | void>;

/**
 * @summary Publish the pending draft: copy pending → design_data + run projection (admin only)
 */
export const useApproveSpaceFloorDesign = <
  TError = ErrorType<NotFoundResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveSpaceFloorDesign>>,
    TError,
    { id: number; data: BodyType<ApproveSpaceFloorDesignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveSpaceFloorDesign>>,
  TError,
  { id: number; data: BodyType<ApproveSpaceFloorDesignBody> },
  TContext
> => {
  return useMutation(getApproveSpaceFloorDesignMutationOptions(options));
};

/**
 * @summary Discard the pending draft — restores the live design as the sole state (admin only)
 */
export const getDiscardSpaceFloorDesignUrl = (id: number) => {
  return `/api/space/floors/${id}/design/discard`;
};

export const discardSpaceFloorDesign = async (
  id: number,
  options?: RequestInit,
): Promise<DiscardSpaceFloorDesign200> => {
  return customFetch<DiscardSpaceFloorDesign200>(
    getDiscardSpaceFloorDesignUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getDiscardSpaceFloorDesignMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discardSpaceFloorDesign>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof discardSpaceFloorDesign>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["discardSpaceFloorDesign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof discardSpaceFloorDesign>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return discardSpaceFloorDesign(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DiscardSpaceFloorDesignMutationResult = NonNullable<
  Awaited<ReturnType<typeof discardSpaceFloorDesign>>
>;

export type DiscardSpaceFloorDesignMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Discard the pending draft — restores the live design as the sole state (admin only)
 */
export const useDiscardSpaceFloorDesign = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discardSpaceFloorDesign>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof discardSpaceFloorDesign>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDiscardSpaceFloorDesignMutationOptions(options));
};

/**
 * @summary List shared custom-SVG assets for the operator's space
 */
export const getListSpaceSvgAssetsUrl = () => {
  return `/api/space/svg-assets`;
};

export const listSpaceSvgAssets = async (
  options?: RequestInit,
): Promise<SpaceSvgAsset[]> => {
  return customFetch<SpaceSvgAsset[]>(getListSpaceSvgAssetsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSpaceSvgAssetsQueryKey = () => {
  return [`/api/space/svg-assets`] as const;
};

export const getListSpaceSvgAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSpaceSvgAssets>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSpaceSvgAssets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSpaceSvgAssetsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSpaceSvgAssets>>
  > = ({ signal }) => listSpaceSvgAssets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSpaceSvgAssets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSpaceSvgAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSpaceSvgAssets>>
>;
export type ListSpaceSvgAssetsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List shared custom-SVG assets for the operator's space
 */

export function useListSpaceSvgAssets<
  TData = Awaited<ReturnType<typeof listSpaceSvgAssets>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSpaceSvgAssets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSpaceSvgAssetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload a shared custom-SVG asset (admin only)
 */
export const getCreateSpaceSvgAssetUrl = () => {
  return `/api/space/svg-assets`;
};

export const createSpaceSvgAsset = async (
  createSpaceSvgAssetBody: CreateSpaceSvgAssetBody,
  options?: RequestInit,
): Promise<SpaceSvgAsset> => {
  return customFetch<SpaceSvgAsset>(getCreateSpaceSvgAssetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSpaceSvgAssetBody),
  });
};

export const getCreateSpaceSvgAssetMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceSvgAsset>>,
    TError,
    { data: BodyType<CreateSpaceSvgAssetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSpaceSvgAsset>>,
  TError,
  { data: BodyType<CreateSpaceSvgAssetBody> },
  TContext
> => {
  const mutationKey = ["createSpaceSvgAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSpaceSvgAsset>>,
    { data: BodyType<CreateSpaceSvgAssetBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSpaceSvgAsset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSpaceSvgAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSpaceSvgAsset>>
>;
export type CreateSpaceSvgAssetMutationBody = BodyType<CreateSpaceSvgAssetBody>;
export type CreateSpaceSvgAssetMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Upload a shared custom-SVG asset (admin only)
 */
export const useCreateSpaceSvgAsset = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceSvgAsset>>,
    TError,
    { data: BodyType<CreateSpaceSvgAssetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSpaceSvgAsset>>,
  TError,
  { data: BodyType<CreateSpaceSvgAssetBody> },
  TContext
> => {
  return useMutation(getCreateSpaceSvgAssetMutationOptions(options));
};

/**
 * @summary Rename a shared custom-SVG asset (admin only)
 */
export const getUpdateSpaceSvgAssetUrl = (id: number) => {
  return `/api/space/svg-assets/${id}`;
};

export const updateSpaceSvgAsset = async (
  id: number,
  updateSpaceSvgAssetBody: UpdateSpaceSvgAssetBody,
  options?: RequestInit,
): Promise<SpaceSvgAsset> => {
  return customFetch<SpaceSvgAsset>(getUpdateSpaceSvgAssetUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSpaceSvgAssetBody),
  });
};

export const getUpdateSpaceSvgAssetMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceSvgAsset>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceSvgAssetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSpaceSvgAsset>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceSvgAssetBody> },
  TContext
> => {
  const mutationKey = ["updateSpaceSvgAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSpaceSvgAsset>>,
    { id: number; data: BodyType<UpdateSpaceSvgAssetBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSpaceSvgAsset(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSpaceSvgAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSpaceSvgAsset>>
>;
export type UpdateSpaceSvgAssetMutationBody = BodyType<UpdateSpaceSvgAssetBody>;
export type UpdateSpaceSvgAssetMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Rename a shared custom-SVG asset (admin only)
 */
export const useUpdateSpaceSvgAsset = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceSvgAsset>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceSvgAssetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSpaceSvgAsset>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceSvgAssetBody> },
  TContext
> => {
  return useMutation(getUpdateSpaceSvgAssetMutationOptions(options));
};

/**
 * @summary Delete a shared custom-SVG asset (admin only)
 */
export const getDeleteSpaceSvgAssetUrl = (id: number) => {
  return `/api/space/svg-assets/${id}`;
};

export const deleteSpaceSvgAsset = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSpaceSvgAssetUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSpaceSvgAssetMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceSvgAsset>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSpaceSvgAsset>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSpaceSvgAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSpaceSvgAsset>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSpaceSvgAsset(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSpaceSvgAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSpaceSvgAsset>>
>;

export type DeleteSpaceSvgAssetMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a shared custom-SVG asset (admin only)
 */
export const useDeleteSpaceSvgAsset = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceSvgAsset>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSpaceSvgAsset>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSpaceSvgAssetMutationOptions(options));
};

/**
 * @summary List resources (seats, cabins, rooms) for the operator's space
 */
export const getListSpaceResourcesUrl = (params?: ListSpaceResourcesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/space/resources?${stringifiedParams}`
    : `/api/space/resources`;
};

export const listSpaceResources = async (
  params?: ListSpaceResourcesParams,
  options?: RequestInit,
): Promise<SpaceResource[]> => {
  return customFetch<SpaceResource[]>(getListSpaceResourcesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSpaceResourcesQueryKey = (
  params?: ListSpaceResourcesParams,
) => {
  return [`/api/space/resources`, ...(params ? [params] : [])] as const;
};

export const getListSpaceResourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSpaceResources>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListSpaceResourcesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSpaceResources>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSpaceResourcesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSpaceResources>>
  > = ({ signal }) => listSpaceResources(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSpaceResources>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSpaceResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSpaceResources>>
>;
export type ListSpaceResourcesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List resources (seats, cabins, rooms) for the operator's space
 */

export function useListSpaceResources<
  TData = Awaited<ReturnType<typeof listSpaceResources>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListSpaceResourcesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSpaceResources>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSpaceResourcesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a resource (admin only)
 */
export const getCreateSpaceResourceUrl = () => {
  return `/api/space/resources`;
};

export const createSpaceResource = async (
  createSpaceResourceBody: CreateSpaceResourceBody,
  options?: RequestInit,
): Promise<SpaceResource> => {
  return customFetch<SpaceResource>(getCreateSpaceResourceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSpaceResourceBody),
  });
};

export const getCreateSpaceResourceMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceResource>>,
    TError,
    { data: BodyType<CreateSpaceResourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSpaceResource>>,
  TError,
  { data: BodyType<CreateSpaceResourceBody> },
  TContext
> => {
  const mutationKey = ["createSpaceResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSpaceResource>>,
    { data: BodyType<CreateSpaceResourceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSpaceResource(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSpaceResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSpaceResource>>
>;
export type CreateSpaceResourceMutationBody = BodyType<CreateSpaceResourceBody>;
export type CreateSpaceResourceMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | void
>;

/**
 * @summary Create a resource (admin only)
 */
export const useCreateSpaceResource = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceResource>>,
    TError,
    { data: BodyType<CreateSpaceResourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSpaceResource>>,
  TError,
  { data: BodyType<CreateSpaceResourceBody> },
  TContext
> => {
  return useMutation(getCreateSpaceResourceMutationOptions(options));
};

/**
 * @summary Assign a recurring seat/cabin hold to a member (admin only)
 */
export const getAssignRecurringResourceUrl = (id: number) => {
  return `/api/space/resources/${id}/assign-recurring`;
};

export const assignRecurringResource = async (
  id: number,
  assignRecurringBody: AssignRecurringBody,
  options?: RequestInit,
): Promise<ResourceAssignment> => {
  return customFetch<ResourceAssignment>(getAssignRecurringResourceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assignRecurringBody),
  });
};

export const getAssignRecurringResourceMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignRecurringResource>>,
    TError,
    { id: number; data: BodyType<AssignRecurringBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignRecurringResource>>,
  TError,
  { id: number; data: BodyType<AssignRecurringBody> },
  TContext
> => {
  const mutationKey = ["assignRecurringResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignRecurringResource>>,
    { id: number; data: BodyType<AssignRecurringBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignRecurringResource(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignRecurringResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignRecurringResource>>
>;
export type AssignRecurringResourceMutationBody = BodyType<AssignRecurringBody>;
export type AssignRecurringResourceMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | void
>;

/**
 * @summary Assign a recurring seat/cabin hold to a member (admin only)
 */
export const useAssignRecurringResource = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignRecurringResource>>,
    TError,
    { id: number; data: BodyType<AssignRecurringBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignRecurringResource>>,
  TError,
  { id: number; data: BodyType<AssignRecurringBody> },
  TContext
> => {
  return useMutation(getAssignRecurringResourceMutationOptions(options));
};

/**
 * @summary Move (or rename) a workstation cluster — cascade-shifts child seats
 */
export const getUpdateSpaceWorkstationClusterUrl = (id: number) => {
  return `/api/space/clusters/${id}`;
};

export const updateSpaceWorkstationCluster = async (
  id: number,
  updateSpaceWorkstationClusterBody: UpdateSpaceWorkstationClusterBody,
  options?: RequestInit,
): Promise<UpdateSpaceWorkstationCluster200> => {
  return customFetch<UpdateSpaceWorkstationCluster200>(
    getUpdateSpaceWorkstationClusterUrl(id),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateSpaceWorkstationClusterBody),
    },
  );
};

export const getUpdateSpaceWorkstationClusterMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceWorkstationCluster>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceWorkstationClusterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSpaceWorkstationCluster>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceWorkstationClusterBody> },
  TContext
> => {
  const mutationKey = ["updateSpaceWorkstationCluster"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSpaceWorkstationCluster>>,
    { id: number; data: BodyType<UpdateSpaceWorkstationClusterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSpaceWorkstationCluster(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSpaceWorkstationClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSpaceWorkstationCluster>>
>;
export type UpdateSpaceWorkstationClusterMutationBody =
  BodyType<UpdateSpaceWorkstationClusterBody>;
export type UpdateSpaceWorkstationClusterMutationError = ErrorType<void>;

/**
 * @summary Move (or rename) a workstation cluster — cascade-shifts child seats
 */
export const useUpdateSpaceWorkstationCluster = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceWorkstationCluster>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceWorkstationClusterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSpaceWorkstationCluster>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceWorkstationClusterBody> },
  TContext
> => {
  return useMutation(getUpdateSpaceWorkstationClusterMutationOptions(options));
};

/**
 * @summary Delete a workstation cluster — also deletes its child seat resources
 */
export const getDeleteSpaceWorkstationClusterUrl = (id: number) => {
  return `/api/space/clusters/${id}`;
};

export const deleteSpaceWorkstationCluster = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSpaceWorkstationClusterUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSpaceWorkstationClusterMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceWorkstationCluster>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSpaceWorkstationCluster>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSpaceWorkstationCluster"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSpaceWorkstationCluster>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSpaceWorkstationCluster(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSpaceWorkstationClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSpaceWorkstationCluster>>
>;

export type DeleteSpaceWorkstationClusterMutationError = ErrorType<void>;

/**
 * @summary Delete a workstation cluster — also deletes its child seat resources
 */
export const useDeleteSpaceWorkstationCluster = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceWorkstationCluster>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSpaceWorkstationCluster>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSpaceWorkstationClusterMutationOptions(options));
};

/**
 * @summary List workstation clusters on a floor
 */
export const getListSpaceWorkstationClustersUrl = (
  params: ListSpaceWorkstationClustersParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/space/clusters?${stringifiedParams}`
    : `/api/space/clusters`;
};

export const listSpaceWorkstationClusters = async (
  params: ListSpaceWorkstationClustersParams,
  options?: RequestInit,
): Promise<SpaceWorkstationClusterListResponse> => {
  return customFetch<SpaceWorkstationClusterListResponse>(
    getListSpaceWorkstationClustersUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListSpaceWorkstationClustersQueryKey = (
  params?: ListSpaceWorkstationClustersParams,
) => {
  return [`/api/space/clusters`, ...(params ? [params] : [])] as const;
};

export const getListSpaceWorkstationClustersQueryOptions = <
  TData = Awaited<ReturnType<typeof listSpaceWorkstationClusters>>,
  TError = ErrorType<unknown>,
>(
  params: ListSpaceWorkstationClustersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSpaceWorkstationClusters>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSpaceWorkstationClustersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSpaceWorkstationClusters>>
  > = ({ signal }) =>
    listSpaceWorkstationClusters(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSpaceWorkstationClusters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSpaceWorkstationClustersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSpaceWorkstationClusters>>
>;
export type ListSpaceWorkstationClustersQueryError = ErrorType<unknown>;

/**
 * @summary List workstation clusters on a floor
 */

export function useListSpaceWorkstationClusters<
  TData = Awaited<ReturnType<typeof listSpaceWorkstationClusters>>,
  TError = ErrorType<unknown>,
>(
  params: ListSpaceWorkstationClustersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSpaceWorkstationClusters>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSpaceWorkstationClustersQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a workstation cluster (auto-emits N seat resources)
 */
export const getCreateSpaceWorkstationClusterUrl = () => {
  return `/api/space/clusters`;
};

export const createSpaceWorkstationCluster = async (
  createSpaceWorkstationClusterBody: CreateSpaceWorkstationClusterBody,
  options?: RequestInit,
): Promise<CreateSpaceWorkstationClusterResponse> => {
  return customFetch<CreateSpaceWorkstationClusterResponse>(
    getCreateSpaceWorkstationClusterUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createSpaceWorkstationClusterBody),
    },
  );
};

export const getCreateSpaceWorkstationClusterMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceWorkstationCluster>>,
    TError,
    { data: BodyType<CreateSpaceWorkstationClusterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSpaceWorkstationCluster>>,
  TError,
  { data: BodyType<CreateSpaceWorkstationClusterBody> },
  TContext
> => {
  const mutationKey = ["createSpaceWorkstationCluster"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSpaceWorkstationCluster>>,
    { data: BodyType<CreateSpaceWorkstationClusterBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSpaceWorkstationCluster(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSpaceWorkstationClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSpaceWorkstationCluster>>
>;
export type CreateSpaceWorkstationClusterMutationBody =
  BodyType<CreateSpaceWorkstationClusterBody>;
export type CreateSpaceWorkstationClusterMutationError = ErrorType<void>;

/**
 * @summary Create a workstation cluster (auto-emits N seat resources)
 */
export const useCreateSpaceWorkstationCluster = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceWorkstationCluster>>,
    TError,
    { data: BodyType<CreateSpaceWorkstationClusterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSpaceWorkstationCluster>>,
  TError,
  { data: BodyType<CreateSpaceWorkstationClusterBody> },
  TContext
> => {
  return useMutation(getCreateSpaceWorkstationClusterMutationOptions(options));
};

/**
 * @summary Update a resource (label, status, x/y/w/h, zone, notes, capacity)
 */
export const getUpdateSpaceResourceUrl = (id: number) => {
  return `/api/space/resources/${id}`;
};

export const updateSpaceResource = async (
  id: number,
  updateSpaceResourceBody: UpdateSpaceResourceBody,
  options?: RequestInit,
): Promise<SpaceResource> => {
  return customFetch<SpaceResource>(getUpdateSpaceResourceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSpaceResourceBody),
  });
};

export const getUpdateSpaceResourceMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceResource>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceResourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSpaceResource>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceResourceBody> },
  TContext
> => {
  const mutationKey = ["updateSpaceResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSpaceResource>>,
    { id: number; data: BodyType<UpdateSpaceResourceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSpaceResource(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSpaceResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSpaceResource>>
>;
export type UpdateSpaceResourceMutationBody = BodyType<UpdateSpaceResourceBody>;
export type UpdateSpaceResourceMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Update a resource (label, status, x/y/w/h, zone, notes, capacity)
 */
export const useUpdateSpaceResource = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSpaceResource>>,
    TError,
    { id: number; data: BodyType<UpdateSpaceResourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSpaceResource>>,
  TError,
  { id: number; data: BodyType<UpdateSpaceResourceBody> },
  TContext
> => {
  return useMutation(getUpdateSpaceResourceMutationOptions(options));
};

/**
 * @summary Delete a resource (admin only)
 */
export const getDeleteSpaceResourceUrl = (id: number) => {
  return `/api/space/resources/${id}`;
};

export const deleteSpaceResource = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSpaceResourceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSpaceResourceMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceResource>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSpaceResource>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSpaceResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSpaceResource>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSpaceResource(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSpaceResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSpaceResource>>
>;

export type DeleteSpaceResourceMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a resource (admin only)
 */
export const useDeleteSpaceResource = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceResource>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSpaceResource>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSpaceResourceMutationOptions(options));
};

/**
 * @summary List resource assignments
 */
export const getListResourceAssignmentsUrl = (
  params?: ListResourceAssignmentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/space/assignments?${stringifiedParams}`
    : `/api/space/assignments`;
};

export const listResourceAssignments = async (
  params?: ListResourceAssignmentsParams,
  options?: RequestInit,
): Promise<ResourceAssignment[]> => {
  return customFetch<ResourceAssignment[]>(
    getListResourceAssignmentsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListResourceAssignmentsQueryKey = (
  params?: ListResourceAssignmentsParams,
) => {
  return [`/api/space/assignments`, ...(params ? [params] : [])] as const;
};

export const getListResourceAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listResourceAssignments>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListResourceAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listResourceAssignments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListResourceAssignmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listResourceAssignments>>
  > = ({ signal }) =>
    listResourceAssignments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listResourceAssignments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListResourceAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listResourceAssignments>>
>;
export type ListResourceAssignmentsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List resource assignments
 */

export function useListResourceAssignments<
  TData = Awaited<ReturnType<typeof listResourceAssignments>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListResourceAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listResourceAssignments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListResourceAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Release an assignment (sets release_date=today)
 */
export const getReleaseResourceAssignmentUrl = (id: number) => {
  return `/api/space/assignments/${id}/release`;
};

export const releaseResourceAssignment = async (
  id: number,
  options?: RequestInit,
): Promise<ResourceAssignment> => {
  return customFetch<ResourceAssignment>(getReleaseResourceAssignmentUrl(id), {
    ...options,
    method: "PATCH",
  });
};

export const getReleaseResourceAssignmentMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseResourceAssignment>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof releaseResourceAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["releaseResourceAssignment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof releaseResourceAssignment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return releaseResourceAssignment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReleaseResourceAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof releaseResourceAssignment>>
>;

export type ReleaseResourceAssignmentMutationError =
  ErrorType<NotFoundResponse>;

/**
 * @summary Release an assignment (sets release_date=today)
 */
export const useReleaseResourceAssignment = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseResourceAssignment>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof releaseResourceAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getReleaseResourceAssignmentMutationOptions(options));
};

/**
 * @summary Get real-time occupancy view for a floor on a given date/time
 */
export const getGetSpaceOccupancyUrl = (params: GetSpaceOccupancyParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/space/occupancy?${stringifiedParams}`
    : `/api/space/occupancy`;
};

export const getSpaceOccupancy = async (
  params: GetSpaceOccupancyParams,
  options?: RequestInit,
): Promise<OccupancyView[]> => {
  return customFetch<OccupancyView[]>(getGetSpaceOccupancyUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetSpaceOccupancyQueryKey = (
  params?: GetSpaceOccupancyParams,
) => {
  return [`/api/space/occupancy`, ...(params ? [params] : [])] as const;
};

export const getGetSpaceOccupancyQueryOptions = <
  TData = Awaited<ReturnType<typeof getSpaceOccupancy>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params: GetSpaceOccupancyParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpaceOccupancy>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSpaceOccupancyQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSpaceOccupancy>>
  > = ({ signal }) => getSpaceOccupancy(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSpaceOccupancy>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSpaceOccupancyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSpaceOccupancy>>
>;
export type GetSpaceOccupancyQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Get real-time occupancy view for a floor on a given date/time
 */

export function useGetSpaceOccupancy<
  TData = Awaited<ReturnType<typeof getSpaceOccupancy>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params: GetSpaceOccupancyParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSpaceOccupancy>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSpaceOccupancyQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Public plan catalog (no auth required; cached 5 min)
 */
export const getListPublicPlansUrl = (params: ListPublicPlansParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/public/plans?${stringifiedParams}`
    : `/api/public/plans`;
};

export const listPublicPlans = async (
  params: ListPublicPlansParams,
  options?: RequestInit,
): Promise<ListPublicPlans200> => {
  return customFetch<ListPublicPlans200>(getListPublicPlansUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPublicPlansQueryKey = (params?: ListPublicPlansParams) => {
  return [`/api/public/plans`, ...(params ? [params] : [])] as const;
};

export const getListPublicPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof listPublicPlans>>,
  TError = ErrorType<unknown>,
>(
  params: ListPublicPlansParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPublicPlans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPublicPlansQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPublicPlans>>> = ({
    signal,
  }) => listPublicPlans(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPublicPlans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPublicPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPublicPlans>>
>;
export type ListPublicPlansQueryError = ErrorType<unknown>;

/**
 * @summary Public plan catalog (no auth required; cached 5 min)
 */

export function useListPublicPlans<
  TData = Awaited<ReturnType<typeof listPublicPlans>>,
  TError = ErrorType<unknown>,
>(
  params: ListPublicPlansParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPublicPlans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPublicPlansQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * One search entry point for Phase 41: resolves an exact task_number
(e.g. NJF-T-00147) OR a bare per-space sequence number (e.g. 147).
Returns zero or one matching task (space-scoped for non-admins).

 * @summary Search tasks by member-quoted number (TASK-02)
 */
export const getListTasksUrl = (params: ListTasksParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tasks?${stringifiedParams}`
    : `/api/tasks`;
};

export const listTasks = async (
  params: ListTasksParams,
  options?: RequestInit,
): Promise<Task[]> => {
  return customFetch<Task[]>(getListTasksUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTasksQueryKey = (params?: ListTasksParams) => {
  return [`/api/tasks`, ...(params ? [params] : [])] as const;
};

export const getListTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params: ListTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({
    signal,
  }) => listTasks(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTasks>>
>;
export type ListTasksQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Search tasks by member-quoted number (TASK-02)
 */

export function useListTasks<
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params: ListTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Per-type required fields are enforced by a Zod superRefine at the
route layer (D-08/D-09 pattern), not in this schema. Issues a
task_number inside the same transaction as the task INSERT and
writes BOTH a `created` and an initial `status_change
{from:null,to:"open"}` task_activity row in that same transaction
(TASK-06 t=0 completeness contract). `operational` tasks are
rejected in Phase 41 — unreachable until Phase 43's task_template.

 * @summary Create a task (all six types, one wide body — TASK-01)
 */
export const getCreateTaskUrl = () => {
  return `/api/tasks`;
};

export const createTask = async (
  createTaskBody: CreateTaskBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getCreateTaskUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaskBody),
  });
};

export const getCreateTaskMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<CreateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<CreateTaskBody> },
  TContext
> => {
  const mutationKey = ["createTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTask>>,
    { data: BodyType<CreateTaskBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTask>>
>;
export type CreateTaskMutationBody = BodyType<CreateTaskBody>;
export type CreateTaskMutationError = ErrorType<
  UnauthorizedResponse | ErrorResponse
>;

/**
 * @summary Create a task (all six types, one wide body — TASK-01)
 */
export const useCreateTask = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<CreateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<CreateTaskBody> },
  TContext
> => {
  return useMutation(getCreateTaskMutationOptions(options));
};

/**
 * @summary Get a task + its full append-only activity log, attachments, watchers (TASK-05/06/10)
 */
export const getGetTaskUrl = (id: number) => {
  return `/api/tasks/${id}`;
};

export const getTask = async (
  id: number,
  options?: RequestInit,
): Promise<TaskDetail> => {
  return customFetch<TaskDetail>(getGetTaskUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTaskQueryKey = (id: number) => {
  return [`/api/tasks/${id}`] as const;
};

export const getGetTaskQueryOptions = <
  TData = Awaited<ReturnType<typeof getTask>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({
    signal,
  }) => getTask(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetTaskQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTask>>
>;
export type GetTaskQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get a task + its full append-only activity log, attachments, watchers (TASK-05/06/10)
 */

export function useGetTask<
  TData = Awaited<ReturnType<typeof getTask>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTaskQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary First assignment (open -> assigned). Gated by canReassign (TPRM-04).
 */
export const getAssignTaskUrl = (id: number) => {
  return `/api/tasks/${id}/assign`;
};

export const assignTask = async (
  id: number,
  assignTaskBody: AssignTaskBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getAssignTaskUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assignTaskBody),
  });
};

export const getAssignTaskMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignTask>>,
    TError,
    { id: number; data: BodyType<AssignTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignTask>>,
  TError,
  { id: number; data: BodyType<AssignTaskBody> },
  TContext
> => {
  const mutationKey = ["assignTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignTask>>,
    { id: number; data: BodyType<AssignTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignTask>>
>;
export type AssignTaskMutationBody = BodyType<AssignTaskBody>;
export type AssignTaskMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | TaskStaleTransitionResponse
  | TaskIllegalTransitionResponse
>;

/**
 * @summary First assignment (open -> assigned). Gated by canReassign (TPRM-04).
 */
export const useAssignTask = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignTask>>,
    TError,
    { id: number; data: BodyType<AssignTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignTask>>,
  TError,
  { id: number; data: BodyType<AssignTaskBody> },
  TContext
> => {
  return useMutation(getAssignTaskMutationOptions(options));
};

/**
 * Does NOT call transitionTaskStatusTx — there is no assigned->assigned
or in_progress->in_progress edge. Updates assignee_id/assigned_role
only, writes an `assignment` task_activity row. Works from `assigned`
AND `in_progress`.

 * @summary Re-route an already-assigned/in_progress task WITHOUT a status change (TPRM-04, SC5)
 */
export const getReassignTaskUrl = (id: number) => {
  return `/api/tasks/${id}/reassign`;
};

export const reassignTask = async (
  id: number,
  reassignTaskBody: ReassignTaskBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getReassignTaskUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reassignTaskBody),
  });
};

export const getReassignTaskMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reassignTask>>,
    TError,
    { id: number; data: BodyType<ReassignTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reassignTask>>,
  TError,
  { id: number; data: BodyType<ReassignTaskBody> },
  TContext
> => {
  const mutationKey = ["reassignTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reassignTask>>,
    { id: number; data: BodyType<ReassignTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reassignTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReassignTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof reassignTask>>
>;
export type ReassignTaskMutationBody = BodyType<ReassignTaskBody>;
export type ReassignTaskMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Re-route an already-assigned/in_progress task WITHOUT a status change (TPRM-04, SC5)
 */
export const useReassignTask = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reassignTask>>,
    TError,
    { id: number; data: BodyType<ReassignTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reassignTask>>,
  TError,
  { id: number; data: BodyType<ReassignTaskBody> },
  TContext
> => {
  return useMutation(getReassignTaskMutationOptions(options));
};

/**
 * @summary assigned -> in_progress (stamps first_response_at once)
 */
export const getStartTaskUrl = (id: number) => {
  return `/api/tasks/${id}/start`;
};

export const startTask = async (
  id: number,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getStartTaskUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getStartTaskMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startTask>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startTask>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["startTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startTask>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return startTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof startTask>>
>;

export type StartTaskMutationError = ErrorType<
  | UnauthorizedResponse
  | NotFoundResponse
  | TaskStaleTransitionResponse
  | TaskIllegalTransitionResponse
>;

/**
 * @summary assigned -> in_progress (stamps first_response_at once)
 */
export const useStartTask = <
  TError = ErrorType<
    | UnauthorizedResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startTask>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startTask>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getStartTaskMutationOptions(options));
};

/**
 * @summary in_progress -> on_hold (TASK-09, holdReason mandatory)
 */
export const getHoldTaskUrl = (id: number) => {
  return `/api/tasks/${id}/hold`;
};

export const holdTask = async (
  id: number,
  holdTaskBody: HoldTaskBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getHoldTaskUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(holdTaskBody),
  });
};

export const getHoldTaskMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof holdTask>>,
    TError,
    { id: number; data: BodyType<HoldTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof holdTask>>,
  TError,
  { id: number; data: BodyType<HoldTaskBody> },
  TContext
> => {
  const mutationKey = ["holdTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof holdTask>>,
    { id: number; data: BodyType<HoldTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return holdTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HoldTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof holdTask>>
>;
export type HoldTaskMutationBody = BodyType<HoldTaskBody>;
export type HoldTaskMutationError = ErrorType<
  | UnauthorizedResponse
  | NotFoundResponse
  | TaskStaleTransitionResponse
  | TaskIllegalTransitionResponse
>;

/**
 * @summary in_progress -> on_hold (TASK-09, holdReason mandatory)
 */
export const useHoldTask = <
  TError = ErrorType<
    | UnauthorizedResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof holdTask>>,
    TError,
    { id: number; data: BodyType<HoldTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof holdTask>>,
  TError,
  { id: number; data: BodyType<HoldTaskBody> },
  TContext
> => {
  return useMutation(getHoldTaskMutationOptions(options));
};

/**
 * @summary on_hold -> in_progress
 */
export const getResumeTaskUrl = (id: number) => {
  return `/api/tasks/${id}/resume`;
};

export const resumeTask = async (
  id: number,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getResumeTaskUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getResumeTaskMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeTask>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeTask>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["resumeTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeTask>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return resumeTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeTask>>
>;

export type ResumeTaskMutationError = ErrorType<
  | UnauthorizedResponse
  | NotFoundResponse
  | TaskStaleTransitionResponse
  | TaskIllegalTransitionResponse
>;

/**
 * @summary on_hold -> in_progress
 */
export const useResumeTask = <
  TError = ErrorType<
    | UnauthorizedResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeTask>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resumeTask>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getResumeTaskMutationOptions(options));
};

/**
 * @summary in_progress -> resolved. Gated by canResolve. Concurrent loser gets an attributed 409 (TASK-11).
 */
export const getResolveTaskUrl = (id: number) => {
  return `/api/tasks/${id}/resolve`;
};

export const resolveTask = async (
  id: number,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getResolveTaskUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getResolveTaskMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveTask>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveTask>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["resolveTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveTask>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return resolveTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveTask>>
>;

export type ResolveTaskMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | TaskStaleTransitionResponse
  | TaskIllegalTransitionResponse
>;

/**
 * @summary in_progress -> resolved. Gated by canResolve. Concurrent loser gets an attributed 409 (TASK-11).
 */
export const useResolveTask = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveTask>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolveTask>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getResolveTaskMutationOptions(options));
};

/**
 * @summary Cancel with mandatory enum reason + note (TASK-07). Gated by canCancel (creator-own for front_desk/bde, TPRM-07).
 */
export const getCancelTaskUrl = (id: number) => {
  return `/api/tasks/${id}/cancel`;
};

export const cancelTask = async (
  id: number,
  cancelTaskBody: CancelTaskBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getCancelTaskUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cancelTaskBody),
  });
};

export const getCancelTaskMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelTask>>,
    TError,
    { id: number; data: BodyType<CancelTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelTask>>,
  TError,
  { id: number; data: BodyType<CancelTaskBody> },
  TContext
> => {
  const mutationKey = ["cancelTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelTask>>,
    { id: number; data: BodyType<CancelTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return cancelTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelTask>>
>;
export type CancelTaskMutationBody = BodyType<CancelTaskBody>;
export type CancelTaskMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | TaskStaleTransitionResponse
  | TaskIllegalTransitionResponse
>;

/**
 * @summary Cancel with mandatory enum reason + note (TASK-07). Gated by canCancel (creator-own for front_desk/bde, TPRM-07).
 */
export const useCancelTask = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | TaskStaleTransitionResponse
    | TaskIllegalTransitionResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelTask>>,
    TError,
    { id: number; data: BodyType<CancelTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelTask>>,
  TError,
  { id: number; data: BodyType<CancelTaskBody> },
  TContext
> => {
  return useMutation(getCancelTaskMutationOptions(options));
};

/**
 * Does NOT call transitionTaskStatusTx (no status change). Updates
`priority` only and writes a `priority_override` task_activity row
`{from, to, note}`.

 * @summary Override priority (mandatory >=10-char note, server-enforced). Gated by canOverridePriority.
 */
export const getOverrideTaskPriorityUrl = (id: number) => {
  return `/api/tasks/${id}/priority`;
};

export const overrideTaskPriority = async (
  id: number,
  overrideTaskPriorityBody: OverrideTaskPriorityBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getOverrideTaskPriorityUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(overrideTaskPriorityBody),
  });
};

export const getOverrideTaskPriorityMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof overrideTaskPriority>>,
    TError,
    { id: number; data: BodyType<OverrideTaskPriorityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof overrideTaskPriority>>,
  TError,
  { id: number; data: BodyType<OverrideTaskPriorityBody> },
  TContext
> => {
  const mutationKey = ["overrideTaskPriority"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof overrideTaskPriority>>,
    { id: number; data: BodyType<OverrideTaskPriorityBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return overrideTaskPriority(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OverrideTaskPriorityMutationResult = NonNullable<
  Awaited<ReturnType<typeof overrideTaskPriority>>
>;
export type OverrideTaskPriorityMutationBody =
  BodyType<OverrideTaskPriorityBody>;
export type OverrideTaskPriorityMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Override priority (mandatory >=10-char note, server-enforced). Gated by canOverridePriority.
 */
export const useOverrideTaskPriority = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof overrideTaskPriority>>,
    TError,
    { id: number; data: BodyType<OverrideTaskPriorityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof overrideTaskPriority>>,
  TError,
  { id: number; data: BodyType<OverrideTaskPriorityBody> },
  TContext
> => {
  return useMutation(getOverrideTaskPriorityMutationOptions(options));
};

/**
 * @summary Attach a photo/document to a task (TASK-10)
 */
export const getAddTaskAttachmentUrl = (id: number) => {
  return `/api/tasks/${id}/attachments`;
};

export const addTaskAttachment = async (
  id: number,
  addTaskAttachmentBody: AddTaskAttachmentBody,
  options?: RequestInit,
): Promise<TaskAttachment> => {
  return customFetch<TaskAttachment>(getAddTaskAttachmentUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addTaskAttachmentBody),
  });
};

export const getAddTaskAttachmentMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | NotFoundResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTaskAttachment>>,
    TError,
    { id: number; data: BodyType<AddTaskAttachmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addTaskAttachment>>,
  TError,
  { id: number; data: BodyType<AddTaskAttachmentBody> },
  TContext
> => {
  const mutationKey = ["addTaskAttachment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addTaskAttachment>>,
    { id: number; data: BodyType<AddTaskAttachmentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addTaskAttachment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTaskAttachmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof addTaskAttachment>>
>;
export type AddTaskAttachmentMutationBody = BodyType<AddTaskAttachmentBody>;
export type AddTaskAttachmentMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | BadRequestResponse
>;

/**
 * @summary Attach a photo/document to a task (TASK-10)
 */
export const useAddTaskAttachment = <
  TError = ErrorType<
    UnauthorizedResponse | NotFoundResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTaskAttachment>>,
    TError,
    { id: number; data: BodyType<AddTaskAttachmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addTaskAttachment>>,
  TError,
  { id: number; data: BodyType<AddTaskAttachmentBody> },
  TContext
> => {
  return useMutation(getAddTaskAttachmentMutationOptions(options));
};

/**
 * @summary Add a watcher (idempotent — no duplicate row, TASK-10)
 */
export const getAddTaskWatcherUrl = (id: number) => {
  return `/api/tasks/${id}/watchers`;
};

export const addTaskWatcher = async (
  id: number,
  addTaskWatcherBody: AddTaskWatcherBody,
  options?: RequestInit,
): Promise<TaskWatcher> => {
  return customFetch<TaskWatcher>(getAddTaskWatcherUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addTaskWatcherBody),
  });
};

export const getAddTaskWatcherMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | NotFoundResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTaskWatcher>>,
    TError,
    { id: number; data: BodyType<AddTaskWatcherBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addTaskWatcher>>,
  TError,
  { id: number; data: BodyType<AddTaskWatcherBody> },
  TContext
> => {
  const mutationKey = ["addTaskWatcher"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addTaskWatcher>>,
    { id: number; data: BodyType<AddTaskWatcherBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addTaskWatcher(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTaskWatcherMutationResult = NonNullable<
  Awaited<ReturnType<typeof addTaskWatcher>>
>;
export type AddTaskWatcherMutationBody = BodyType<AddTaskWatcherBody>;
export type AddTaskWatcherMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse | BadRequestResponse
>;

/**
 * @summary Add a watcher (idempotent — no duplicate row, TASK-10)
 */
export const useAddTaskWatcher = <
  TError = ErrorType<
    UnauthorizedResponse | NotFoundResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTaskWatcher>>,
    TError,
    { id: number; data: BodyType<AddTaskWatcherBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addTaskWatcher>>,
  TError,
  { id: number; data: BodyType<AddTaskWatcherBody> },
  TContext
> => {
  return useMutation(getAddTaskWatcherMutationOptions(options));
};

/**
 * @summary Remove a watcher (watchers are NOT append-only, unlike task_activity — TASK-10)
 */
export const getRemoveTaskWatcherUrl = (id: number, userId: number) => {
  return `/api/tasks/${id}/watchers/${userId}`;
};

export const removeTaskWatcher = async (
  id: number,
  userId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRemoveTaskWatcherUrl(id, userId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveTaskWatcherMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTaskWatcher>>,
    TError,
    { id: number; userId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeTaskWatcher>>,
  TError,
  { id: number; userId: number },
  TContext
> => {
  const mutationKey = ["removeTaskWatcher"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeTaskWatcher>>,
    { id: number; userId: number }
  > = (props) => {
    const { id, userId } = props ?? {};

    return removeTaskWatcher(id, userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveTaskWatcherMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeTaskWatcher>>
>;

export type RemoveTaskWatcherMutationError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Remove a watcher (watchers are NOT append-only, unlike task_activity — TASK-10)
 */
export const useRemoveTaskWatcher = <
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTaskWatcher>>,
    TError,
    { id: number; userId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeTaskWatcher>>,
  TError,
  { id: number; userId: number },
  TContext
> => {
  return useMutation(getRemoveTaskWatcherMutationOptions(options));
};

/**
 * @summary List task categories (TCFG-01), space-scoped
 */
export const getListTaskCategoriesUrl = (params?: ListTaskCategoriesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/task-config/categories?${stringifiedParams}`
    : `/api/task-config/categories`;
};

export const listTaskCategories = async (
  params?: ListTaskCategoriesParams,
  options?: RequestInit,
): Promise<TaskCategory[]> => {
  return customFetch<TaskCategory[]>(getListTaskCategoriesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTaskCategoriesQueryKey = (
  params?: ListTaskCategoriesParams,
) => {
  return [`/api/task-config/categories`, ...(params ? [params] : [])] as const;
};

export const getListTaskCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTaskCategories>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListTaskCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTaskCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTaskCategoriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTaskCategories>>
  > = ({ signal }) => listTaskCategories(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTaskCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTaskCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTaskCategories>>
>;
export type ListTaskCategoriesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List task categories (TCFG-01), space-scoped
 */

export function useListTaskCategories<
  TData = Awaited<ReturnType<typeof listTaskCategories>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListTaskCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTaskCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTaskCategoriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a task category (TCFG-01). Gated to admin+ops_lead (TPRM-05).
 */
export const getCreateTaskCategoryUrl = () => {
  return `/api/task-config/categories`;
};

export const createTaskCategory = async (
  createTaskCategoryBody: CreateTaskCategoryBody,
  options?: RequestInit,
): Promise<TaskCategory> => {
  return customFetch<TaskCategory>(getCreateTaskCategoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaskCategoryBody),
  });
};

export const getCreateTaskCategoryMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaskCategory>>,
    TError,
    { data: BodyType<CreateTaskCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTaskCategory>>,
  TError,
  { data: BodyType<CreateTaskCategoryBody> },
  TContext
> => {
  const mutationKey = ["createTaskCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaskCategory>>,
    { data: BodyType<CreateTaskCategoryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTaskCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTaskCategory>>
>;
export type CreateTaskCategoryMutationBody = BodyType<CreateTaskCategoryBody>;
export type CreateTaskCategoryMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
>;

/**
 * @summary Create a task category (TCFG-01). Gated to admin+ops_lead (TPRM-05).
 */
export const useCreateTaskCategory = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaskCategory>>,
    TError,
    { data: BodyType<CreateTaskCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTaskCategory>>,
  TError,
  { data: BodyType<CreateTaskCategoryBody> },
  TContext
> => {
  return useMutation(getCreateTaskCategoryMutationOptions(options));
};

/**
 * @summary Update a task category (TCFG-01). Gated to admin+ops_lead (TPRM-05).
 */
export const getUpdateTaskCategoryUrl = (id: number) => {
  return `/api/task-config/categories/${id}`;
};

export const updateTaskCategory = async (
  id: number,
  updateTaskCategoryBody: UpdateTaskCategoryBody,
  options?: RequestInit,
): Promise<TaskCategory> => {
  return customFetch<TaskCategory>(getUpdateTaskCategoryUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTaskCategoryBody),
  });
};

export const getUpdateTaskCategoryMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaskCategory>>,
    TError,
    { id: number; data: BodyType<UpdateTaskCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTaskCategory>>,
  TError,
  { id: number; data: BodyType<UpdateTaskCategoryBody> },
  TContext
> => {
  const mutationKey = ["updateTaskCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTaskCategory>>,
    { id: number; data: BodyType<UpdateTaskCategoryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTaskCategory(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTaskCategory>>
>;
export type UpdateTaskCategoryMutationBody = BodyType<UpdateTaskCategoryBody>;
export type UpdateTaskCategoryMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | BadRequestResponse
>;

/**
 * @summary Update a task category (TCFG-01). Gated to admin+ops_lead (TPRM-05).
 */
export const useUpdateTaskCategory = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaskCategory>>,
    TError,
    { id: number; data: BodyType<UpdateTaskCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTaskCategory>>,
  TError,
  { id: number; data: BodyType<UpdateTaskCategoryBody> },
  TContext
> => {
  return useMutation(getUpdateTaskCategoryMutationOptions(options));
};

/**
 * @summary Archive a task category (soft delete via active=false — never orphans task.category_id, TCFG-01). Gated to admin+ops_lead (TPRM-05).
 */
export const getDeleteTaskCategoryUrl = (id: number) => {
  return `/api/task-config/categories/${id}`;
};

export const deleteTaskCategory = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTaskCategoryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTaskCategoryMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaskCategory>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaskCategory>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteTaskCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaskCategory>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTaskCategory(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTaskCategory>>
>;

export type DeleteTaskCategoryMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Archive a task category (soft delete via active=false — never orphans task.category_id, TCFG-01). Gated to admin+ops_lead (TPRM-05).
 */
export const useDeleteTaskCategory = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaskCategory>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaskCategory>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteTaskCategoryMutationOptions(options));
};

/**
 * @summary List SLA policies (TCFG-02), space-scoped
 */
export const getListSlaPoliciesUrl = (params?: ListSlaPoliciesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/task-config/sla-policies?${stringifiedParams}`
    : `/api/task-config/sla-policies`;
};

export const listSlaPolicies = async (
  params?: ListSlaPoliciesParams,
  options?: RequestInit,
): Promise<SlaPolicy[]> => {
  return customFetch<SlaPolicy[]>(getListSlaPoliciesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSlaPoliciesQueryKey = (params?: ListSlaPoliciesParams) => {
  return [
    `/api/task-config/sla-policies`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListSlaPoliciesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSlaPolicies>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListSlaPoliciesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSlaPolicies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSlaPoliciesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSlaPolicies>>> = ({
    signal,
  }) => listSlaPolicies(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSlaPolicies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSlaPoliciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSlaPolicies>>
>;
export type ListSlaPoliciesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List SLA policies (TCFG-02), space-scoped
 */

export function useListSlaPolicies<
  TData = Awaited<ReturnType<typeof listSlaPolicies>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListSlaPoliciesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSlaPolicies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSlaPoliciesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an SLA policy (TCFG-02, relative minutes — never an absolute timestamp). Gated to admin+ops_lead (TPRM-05).
 */
export const getCreateSlaPolicyUrl = () => {
  return `/api/task-config/sla-policies`;
};

export const createSlaPolicy = async (
  createSlaPolicyBody: CreateSlaPolicyBody,
  options?: RequestInit,
): Promise<SlaPolicy> => {
  return customFetch<SlaPolicy>(getCreateSlaPolicyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSlaPolicyBody),
  });
};

export const getCreateSlaPolicyMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSlaPolicy>>,
    TError,
    { data: BodyType<CreateSlaPolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSlaPolicy>>,
  TError,
  { data: BodyType<CreateSlaPolicyBody> },
  TContext
> => {
  const mutationKey = ["createSlaPolicy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSlaPolicy>>,
    { data: BodyType<CreateSlaPolicyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSlaPolicy(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSlaPolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSlaPolicy>>
>;
export type CreateSlaPolicyMutationBody = BodyType<CreateSlaPolicyBody>;
export type CreateSlaPolicyMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
>;

/**
 * @summary Create an SLA policy (TCFG-02, relative minutes — never an absolute timestamp). Gated to admin+ops_lead (TPRM-05).
 */
export const useCreateSlaPolicy = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSlaPolicy>>,
    TError,
    { data: BodyType<CreateSlaPolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSlaPolicy>>,
  TError,
  { data: BodyType<CreateSlaPolicyBody> },
  TContext
> => {
  return useMutation(getCreateSlaPolicyMutationOptions(options));
};

/**
 * @summary Update an SLA policy's targets (TCFG-02). Gated to admin+ops_lead
(TPRM-05). TCFG-06: this NEVER touches any existing task's frozen
sla_respond_by/sla_resolve_by — those are absolute timestamps baked
onto the task row at creation time (Phase 42); this route only edits
the policy's relative-minutes template for FUTURE task creations.

 */
export const getUpdateSlaPolicyUrl = (id: number) => {
  return `/api/task-config/sla-policies/${id}`;
};

export const updateSlaPolicy = async (
  id: number,
  updateSlaPolicyBody: UpdateSlaPolicyBody,
  options?: RequestInit,
): Promise<SlaPolicy> => {
  return customFetch<SlaPolicy>(getUpdateSlaPolicyUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSlaPolicyBody),
  });
};

export const getUpdateSlaPolicyMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSlaPolicy>>,
    TError,
    { id: number; data: BodyType<UpdateSlaPolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSlaPolicy>>,
  TError,
  { id: number; data: BodyType<UpdateSlaPolicyBody> },
  TContext
> => {
  const mutationKey = ["updateSlaPolicy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSlaPolicy>>,
    { id: number; data: BodyType<UpdateSlaPolicyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSlaPolicy(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSlaPolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSlaPolicy>>
>;
export type UpdateSlaPolicyMutationBody = BodyType<UpdateSlaPolicyBody>;
export type UpdateSlaPolicyMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | BadRequestResponse
>;

/**
 * @summary Update an SLA policy's targets (TCFG-02). Gated to admin+ops_lead
(TPRM-05). TCFG-06: this NEVER touches any existing task's frozen
sla_respond_by/sla_resolve_by — those are absolute timestamps baked
onto the task row at creation time (Phase 42); this route only edits
the policy's relative-minutes template for FUTURE task creations.

 */
export const useUpdateSlaPolicy = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSlaPolicy>>,
    TError,
    { id: number; data: BodyType<UpdateSlaPolicyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSlaPolicy>>,
  TError,
  { id: number; data: BodyType<UpdateSlaPolicyBody> },
  TContext
> => {
  return useMutation(getUpdateSlaPolicyMutationOptions(options));
};

/**
 * @summary Archive an SLA policy (soft delete via active=false, TCFG-02). Gated to admin+ops_lead (TPRM-05).
 */
export const getDeleteSlaPolicyUrl = (id: number) => {
  return `/api/task-config/sla-policies/${id}`;
};

export const deleteSlaPolicy = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSlaPolicyUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSlaPolicyMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSlaPolicy>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSlaPolicy>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSlaPolicy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSlaPolicy>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSlaPolicy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSlaPolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSlaPolicy>>
>;

export type DeleteSlaPolicyMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Archive an SLA policy (soft delete via active=false, TCFG-02). Gated to admin+ops_lead (TPRM-05).
 */
export const useDeleteSlaPolicy = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSlaPolicy>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSlaPolicy>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSlaPolicyMutationOptions(options));
};

/**
 * @summary List routing rules (TCFG-03), space-scoped, ordered by sort_order (first-match-wins evaluation order)
 */
export const getListRoutingRulesUrl = (params?: ListRoutingRulesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/task-config/routing-rules?${stringifiedParams}`
    : `/api/task-config/routing-rules`;
};

export const listRoutingRules = async (
  params?: ListRoutingRulesParams,
  options?: RequestInit,
): Promise<RoutingRule[]> => {
  return customFetch<RoutingRule[]>(getListRoutingRulesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListRoutingRulesQueryKey = (
  params?: ListRoutingRulesParams,
) => {
  return [
    `/api/task-config/routing-rules`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListRoutingRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listRoutingRules>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListRoutingRulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRoutingRules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListRoutingRulesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRoutingRules>>
  > = ({ signal }) => listRoutingRules(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRoutingRules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRoutingRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRoutingRules>>
>;
export type ListRoutingRulesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List routing rules (TCFG-03), space-scoped, ordered by sort_order (first-match-wins evaluation order)
 */

export function useListRoutingRules<
  TData = Awaited<ReturnType<typeof listRoutingRules>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListRoutingRulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRoutingRules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRoutingRulesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a routing rule (TCFG-03). Appended at end-of-list (max sortOrder + 1) when sortOrder is omitted. Gated to admin+ops_lead (TPRM-05).
 */
export const getCreateRoutingRuleUrl = () => {
  return `/api/task-config/routing-rules`;
};

export const createRoutingRule = async (
  createRoutingRuleBody: CreateRoutingRuleBody,
  options?: RequestInit,
): Promise<RoutingRule> => {
  return customFetch<RoutingRule>(getCreateRoutingRuleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createRoutingRuleBody),
  });
};

export const getCreateRoutingRuleMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRoutingRule>>,
    TError,
    { data: BodyType<CreateRoutingRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRoutingRule>>,
  TError,
  { data: BodyType<CreateRoutingRuleBody> },
  TContext
> => {
  const mutationKey = ["createRoutingRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRoutingRule>>,
    { data: BodyType<CreateRoutingRuleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createRoutingRule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRoutingRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRoutingRule>>
>;
export type CreateRoutingRuleMutationBody = BodyType<CreateRoutingRuleBody>;
export type CreateRoutingRuleMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
>;

/**
 * @summary Create a routing rule (TCFG-03). Appended at end-of-list (max sortOrder + 1) when sortOrder is omitted. Gated to admin+ops_lead (TPRM-05).
 */
export const useCreateRoutingRule = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRoutingRule>>,
    TError,
    { data: BodyType<CreateRoutingRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRoutingRule>>,
  TError,
  { data: BodyType<CreateRoutingRuleBody> },
  TContext
> => {
  return useMutation(getCreateRoutingRuleMutationOptions(options));
};

/**
 * @summary Update a routing rule (TCFG-03, does not reorder — use the reorder endpoint). Gated to admin+ops_lead (TPRM-05).
 */
export const getUpdateRoutingRuleUrl = (id: number) => {
  return `/api/task-config/routing-rules/${id}`;
};

export const updateRoutingRule = async (
  id: number,
  updateRoutingRuleBody: UpdateRoutingRuleBody,
  options?: RequestInit,
): Promise<RoutingRule> => {
  return customFetch<RoutingRule>(getUpdateRoutingRuleUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateRoutingRuleBody),
  });
};

export const getUpdateRoutingRuleMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRoutingRule>>,
    TError,
    { id: number; data: BodyType<UpdateRoutingRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRoutingRule>>,
  TError,
  { id: number; data: BodyType<UpdateRoutingRuleBody> },
  TContext
> => {
  const mutationKey = ["updateRoutingRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRoutingRule>>,
    { id: number; data: BodyType<UpdateRoutingRuleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateRoutingRule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRoutingRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRoutingRule>>
>;
export type UpdateRoutingRuleMutationBody = BodyType<UpdateRoutingRuleBody>;
export type UpdateRoutingRuleMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | BadRequestResponse
>;

/**
 * @summary Update a routing rule (TCFG-03, does not reorder — use the reorder endpoint). Gated to admin+ops_lead (TPRM-05).
 */
export const useUpdateRoutingRule = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRoutingRule>>,
    TError,
    { id: number; data: BodyType<UpdateRoutingRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRoutingRule>>,
  TError,
  { id: number; data: BodyType<UpdateRoutingRuleBody> },
  TContext
> => {
  return useMutation(getUpdateRoutingRuleMutationOptions(options));
};

/**
 * @summary Archive a routing rule (soft delete via active=false, TCFG-03). Gated to admin+ops_lead (TPRM-05).
 */
export const getDeleteRoutingRuleUrl = (id: number) => {
  return `/api/task-config/routing-rules/${id}`;
};

export const deleteRoutingRule = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteRoutingRuleUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteRoutingRuleMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRoutingRule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRoutingRule>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteRoutingRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRoutingRule>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteRoutingRule(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRoutingRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRoutingRule>>
>;

export type DeleteRoutingRuleMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Archive a routing rule (soft delete via active=false, TCFG-03). Gated to admin+ops_lead (TPRM-05).
 */
export const useDeleteRoutingRule = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRoutingRule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteRoutingRule>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteRoutingRuleMutationOptions(options));
};

/**
 * @summary Swap sort_order with the immediately adjacent rule (up/down) within
the same space (TCFG-03, first-match-wins). Gated to admin+ops_lead
(TPRM-05). Returns both swapped rows.

 */
export const getReorderRoutingRuleUrl = (id: number) => {
  return `/api/task-config/routing-rules/${id}/reorder`;
};

export const reorderRoutingRule = async (
  id: number,
  reorderRoutingRuleBody: ReorderRoutingRuleBody,
  options?: RequestInit,
): Promise<RoutingRule[]> => {
  return customFetch<RoutingRule[]>(getReorderRoutingRuleUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderRoutingRuleBody),
  });
};

export const getReorderRoutingRuleMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderRoutingRule>>,
    TError,
    { id: number; data: BodyType<ReorderRoutingRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderRoutingRule>>,
  TError,
  { id: number; data: BodyType<ReorderRoutingRuleBody> },
  TContext
> => {
  const mutationKey = ["reorderRoutingRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderRoutingRule>>,
    { id: number; data: BodyType<ReorderRoutingRuleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reorderRoutingRule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderRoutingRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderRoutingRule>>
>;
export type ReorderRoutingRuleMutationBody = BodyType<ReorderRoutingRuleBody>;
export type ReorderRoutingRuleMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Swap sort_order with the immediately adjacent rule (up/down) within
the same space (TCFG-03, first-match-wins). Gated to admin+ops_lead
(TPRM-05). Returns both swapped rows.

 */
export const useReorderRoutingRule = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderRoutingRule>>,
    TError,
    { id: number; data: BodyType<ReorderRoutingRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderRoutingRule>>,
  TError,
  { id: number; data: BodyType<ReorderRoutingRuleBody> },
  TContext
> => {
  return useMutation(getReorderRoutingRuleMutationOptions(options));
};

/**
 * @summary List escalation rules (TCFG-04), space-scoped
 */
export const getListEscalationRulesUrl = (
  params?: ListEscalationRulesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/task-config/escalation-rules?${stringifiedParams}`
    : `/api/task-config/escalation-rules`;
};

export const listEscalationRules = async (
  params?: ListEscalationRulesParams,
  options?: RequestInit,
): Promise<EscalationRule[]> => {
  return customFetch<EscalationRule[]>(getListEscalationRulesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListEscalationRulesQueryKey = (
  params?: ListEscalationRulesParams,
) => {
  return [
    `/api/task-config/escalation-rules`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListEscalationRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listEscalationRules>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListEscalationRulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEscalationRules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEscalationRulesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEscalationRules>>
  > = ({ signal }) =>
    listEscalationRules(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEscalationRules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEscalationRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEscalationRules>>
>;
export type ListEscalationRulesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List escalation rules (TCFG-04), space-scoped
 */

export function useListEscalationRules<
  TData = Awaited<ReturnType<typeof listEscalationRules>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListEscalationRulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEscalationRules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEscalationRulesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an escalation rule (TCFG-04). Gated to admin+ops_lead (TPRM-05).
 */
export const getCreateEscalationRuleUrl = () => {
  return `/api/task-config/escalation-rules`;
};

export const createEscalationRule = async (
  createEscalationRuleBody: CreateEscalationRuleBody,
  options?: RequestInit,
): Promise<EscalationRule> => {
  return customFetch<EscalationRule>(getCreateEscalationRuleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createEscalationRuleBody),
  });
};

export const getCreateEscalationRuleMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEscalationRule>>,
    TError,
    { data: BodyType<CreateEscalationRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEscalationRule>>,
  TError,
  { data: BodyType<CreateEscalationRuleBody> },
  TContext
> => {
  const mutationKey = ["createEscalationRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEscalationRule>>,
    { data: BodyType<CreateEscalationRuleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createEscalationRule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEscalationRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEscalationRule>>
>;
export type CreateEscalationRuleMutationBody =
  BodyType<CreateEscalationRuleBody>;
export type CreateEscalationRuleMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
>;

/**
 * @summary Create an escalation rule (TCFG-04). Gated to admin+ops_lead (TPRM-05).
 */
export const useCreateEscalationRule = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEscalationRule>>,
    TError,
    { data: BodyType<CreateEscalationRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEscalationRule>>,
  TError,
  { data: BodyType<CreateEscalationRuleBody> },
  TContext
> => {
  return useMutation(getCreateEscalationRuleMutationOptions(options));
};

/**
 * @summary Update an escalation rule's trigger/action (TCFG-04). Gated to admin+ops_lead (TPRM-05).
 */
export const getUpdateEscalationRuleUrl = (id: number) => {
  return `/api/task-config/escalation-rules/${id}`;
};

export const updateEscalationRule = async (
  id: number,
  updateEscalationRuleBody: UpdateEscalationRuleBody,
  options?: RequestInit,
): Promise<EscalationRule> => {
  return customFetch<EscalationRule>(getUpdateEscalationRuleUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateEscalationRuleBody),
  });
};

export const getUpdateEscalationRuleMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEscalationRule>>,
    TError,
    { id: number; data: BodyType<UpdateEscalationRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEscalationRule>>,
  TError,
  { id: number; data: BodyType<UpdateEscalationRuleBody> },
  TContext
> => {
  const mutationKey = ["updateEscalationRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEscalationRule>>,
    { id: number; data: BodyType<UpdateEscalationRuleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEscalationRule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEscalationRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEscalationRule>>
>;
export type UpdateEscalationRuleMutationBody =
  BodyType<UpdateEscalationRuleBody>;
export type UpdateEscalationRuleMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | BadRequestResponse
>;

/**
 * @summary Update an escalation rule's trigger/action (TCFG-04). Gated to admin+ops_lead (TPRM-05).
 */
export const useUpdateEscalationRule = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEscalationRule>>,
    TError,
    { id: number; data: BodyType<UpdateEscalationRuleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEscalationRule>>,
  TError,
  { id: number; data: BodyType<UpdateEscalationRuleBody> },
  TContext
> => {
  return useMutation(getUpdateEscalationRuleMutationOptions(options));
};

/**
 * @summary Archive an escalation rule (soft delete via active=false — removes it from future evaluation; firing itself is Phase 42, TCFG-04). Gated to admin+ops_lead (TPRM-05).
 */
export const getDeleteEscalationRuleUrl = (id: number) => {
  return `/api/task-config/escalation-rules/${id}`;
};

export const deleteEscalationRule = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteEscalationRuleUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteEscalationRuleMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEscalationRule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEscalationRule>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteEscalationRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEscalationRule>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteEscalationRule(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEscalationRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEscalationRule>>
>;

export type DeleteEscalationRuleMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Archive an escalation rule (soft delete via active=false — removes it from future evaluation; firing itself is Phase 42, TCFG-04). Gated to admin+ops_lead (TPRM-05).
 */
export const useDeleteEscalationRule = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEscalationRule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteEscalationRule>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteEscalationRuleMutationOptions(options));
};

/**
 * @summary Get business hours for a space (TCFG-07, round-trip only — SLA arithmetic is Phase 42)
 */
export const getGetBusinessHoursUrl = (params?: GetBusinessHoursParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/task-config/business-hours?${stringifiedParams}`
    : `/api/task-config/business-hours`;
};

export const getBusinessHours = async (
  params?: GetBusinessHoursParams,
  options?: RequestInit,
): Promise<BusinessHours> => {
  return customFetch<BusinessHours>(getGetBusinessHoursUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetBusinessHoursQueryKey = (
  params?: GetBusinessHoursParams,
) => {
  return [
    `/api/task-config/business-hours`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBusinessHoursQueryOptions = <
  TData = Awaited<ReturnType<typeof getBusinessHours>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  params?: GetBusinessHoursParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBusinessHours>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBusinessHoursQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBusinessHours>>
  > = ({ signal }) => getBusinessHours(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBusinessHours>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBusinessHoursQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBusinessHours>>
>;
export type GetBusinessHoursQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get business hours for a space (TCFG-07, round-trip only — SLA arithmetic is Phase 42)
 */

export function useGetBusinessHours<
  TData = Awaited<ReturnType<typeof getBusinessHours>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  params?: GetBusinessHoursParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBusinessHours>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBusinessHoursQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update business hours for a space (TCFG-07, round-trip only). Gated to admin+ops_lead (TPRM-05).
 */
export const getUpdateBusinessHoursUrl = () => {
  return `/api/task-config/business-hours`;
};

export const updateBusinessHours = async (
  updateBusinessHoursBody: UpdateBusinessHoursBody,
  options?: RequestInit,
): Promise<BusinessHours> => {
  return customFetch<BusinessHours>(getUpdateBusinessHoursUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBusinessHoursBody),
  });
};

export const getUpdateBusinessHoursMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBusinessHours>>,
    TError,
    { data: BodyType<UpdateBusinessHoursBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBusinessHours>>,
  TError,
  { data: BodyType<UpdateBusinessHoursBody> },
  TContext
> => {
  const mutationKey = ["updateBusinessHours"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBusinessHours>>,
    { data: BodyType<UpdateBusinessHoursBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateBusinessHours(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBusinessHoursMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBusinessHours>>
>;
export type UpdateBusinessHoursMutationBody = BodyType<UpdateBusinessHoursBody>;
export type UpdateBusinessHoursMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Update business hours for a space (TCFG-07, round-trip only). Gated to admin+ops_lead (TPRM-05).
 */
export const useUpdateBusinessHours = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBusinessHours>>,
    TError,
    { data: BodyType<UpdateBusinessHoursBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBusinessHours>>,
  TError,
  { data: BodyType<UpdateBusinessHoursBody> },
  TContext
> => {
  return useMutation(getUpdateBusinessHoursMutationOptions(options));
};

/**
 * @summary "Copy config from space" — TCFG-08 zero-code-change franchise
onboarding. 2-pass FK remap (sla_policy + routing_rule copied first,
then task_category remapping its slaPolicyId/routingRuleId via the
id maps; escalation_rule has no config-to-config FK, plain copy).
Idempotent via a precondition check: 409 if the target space already
has ANY task-config rows (never silently merges). Gated to
admin+ops_lead (TPRM-05, at minimum) via canEditConfig — same
predicate as every other config mutation, no bespoke check.

 */
export const getCopyTaskConfigUrl = () => {
  return `/api/task-config/copy`;
};

export const copyTaskConfig = async (
  copyTaskConfigBody: CopyTaskConfigBody,
  options?: RequestInit,
): Promise<CopyTaskConfigResponse> => {
  return customFetch<CopyTaskConfigResponse>(getCopyTaskConfigUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(copyTaskConfigBody),
  });
};

export const getCopyTaskConfigMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | ErrorResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyTaskConfig>>,
    TError,
    { data: BodyType<CopyTaskConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyTaskConfig>>,
  TError,
  { data: BodyType<CopyTaskConfigBody> },
  TContext
> => {
  const mutationKey = ["copyTaskConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyTaskConfig>>,
    { data: BodyType<CopyTaskConfigBody> }
  > = (props) => {
    const { data } = props ?? {};

    return copyTaskConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyTaskConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyTaskConfig>>
>;
export type CopyTaskConfigMutationBody = BodyType<CopyTaskConfigBody>;
export type CopyTaskConfigMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | ErrorResponse | BadRequestResponse
>;

/**
 * @summary "Copy config from space" — TCFG-08 zero-code-change franchise
onboarding. 2-pass FK remap (sla_policy + routing_rule copied first,
then task_category remapping its slaPolicyId/routingRuleId via the
id maps; escalation_rule has no config-to-config FK, plain copy).
Idempotent via a precondition check: 409 if the target space already
has ANY task-config rows (never silently merges). Gated to
admin+ops_lead (TPRM-05, at minimum) via canEditConfig — same
predicate as every other config mutation, no bespoke check.

 */
export const useCopyTaskConfig = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | ErrorResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyTaskConfig>>,
    TError,
    { data: BodyType<CopyTaskConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof copyTaskConfig>>,
  TError,
  { data: BodyType<CopyTaskConfigBody> },
  TContext
> => {
  return useMutation(getCopyTaskConfigMutationOptions(options));
};

/**
 * @summary List checklist templates (+ their items), space-scoped
 */
export const getListTaskTemplatesUrl = (params?: ListTaskTemplatesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/task-templates?${stringifiedParams}`
    : `/api/task-templates`;
};

export const listTaskTemplates = async (
  params?: ListTaskTemplatesParams,
  options?: RequestInit,
): Promise<TaskTemplateDetail[]> => {
  return customFetch<TaskTemplateDetail[]>(getListTaskTemplatesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTaskTemplatesQueryKey = (
  params?: ListTaskTemplatesParams,
) => {
  return [`/api/task-templates`, ...(params ? [params] : [])] as const;
};

export const getListTaskTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTaskTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListTaskTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTaskTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTaskTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTaskTemplates>>
  > = ({ signal }) => listTaskTemplates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTaskTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTaskTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTaskTemplates>>
>;
export type ListTaskTemplatesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List checklist templates (+ their items), space-scoped
 */

export function useListTaskTemplates<
  TData = Awaited<ReturnType<typeof listTaskTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListTaskTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTaskTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTaskTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a checklist template (no items yet — add via POST
/task-templates/{id}/items). Starts version=1, active=true, and
anchorDate=today (IST, server-computed — the RRULE dtstart).
Gated to admin+ops_lead (canEditConfig).

 */
export const getCreateTaskTemplateUrl = () => {
  return `/api/task-templates`;
};

export const createTaskTemplate = async (
  createTaskTemplateBody: CreateTaskTemplateBody,
  options?: RequestInit,
): Promise<TaskTemplateDetail> => {
  return customFetch<TaskTemplateDetail>(getCreateTaskTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaskTemplateBody),
  });
};

export const getCreateTaskTemplateMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaskTemplate>>,
    TError,
    { data: BodyType<CreateTaskTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTaskTemplate>>,
  TError,
  { data: BodyType<CreateTaskTemplateBody> },
  TContext
> => {
  const mutationKey = ["createTaskTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaskTemplate>>,
    { data: BodyType<CreateTaskTemplateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTaskTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTaskTemplate>>
>;
export type CreateTaskTemplateMutationBody = BodyType<CreateTaskTemplateBody>;
export type CreateTaskTemplateMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
>;

/**
 * @summary Create a checklist template (no items yet — add via POST
/task-templates/{id}/items). Starts version=1, active=true, and
anchorDate=today (IST, server-computed — the RRULE dtstart).
Gated to admin+ops_lead (canEditConfig).

 */
export const useCreateTaskTemplate = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaskTemplate>>,
    TError,
    { data: BodyType<CreateTaskTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTaskTemplate>>,
  TError,
  { data: BodyType<CreateTaskTemplateBody> },
  TContext
> => {
  return useMutation(getCreateTaskTemplateMutationOptions(options));
};

/**
 * @summary Get a single checklist template + its items
 */
export const getGetTaskTemplateUrl = (id: number) => {
  return `/api/task-templates/${id}`;
};

export const getTaskTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<TaskTemplateDetail> => {
  return customFetch<TaskTemplateDetail>(getGetTaskTemplateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTaskTemplateQueryKey = (id: number) => {
  return [`/api/task-templates/${id}`] as const;
};

export const getGetTaskTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskTemplate>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTaskTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskTemplateQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskTemplate>>> = ({
    signal,
  }) => getTaskTemplate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTaskTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaskTemplate>>
>;
export type GetTaskTemplateQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get a single checklist template + its items
 */

export function useGetTaskTemplate<
  TData = Awaited<ReturnType<typeof getTaskTemplate>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTaskTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTaskTemplateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a template's own fields (name/kind/category/priority/recurrence/
atTime/pauseDates) and/or the active toggle (TREC-10 — false stops
future spawns only, already-spawned instances stay untouched). Bumps
version in the same UPDATE (TREC-07). Gated to admin+ops_lead.

 */
export const getUpdateTaskTemplateUrl = (id: number) => {
  return `/api/task-templates/${id}`;
};

export const updateTaskTemplate = async (
  id: number,
  updateTaskTemplateBody: UpdateTaskTemplateBody,
  options?: RequestInit,
): Promise<TaskTemplateDetail> => {
  return customFetch<TaskTemplateDetail>(getUpdateTaskTemplateUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTaskTemplateBody),
  });
};

export const getUpdateTaskTemplateMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaskTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateTaskTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTaskTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateTaskTemplateBody> },
  TContext
> => {
  const mutationKey = ["updateTaskTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTaskTemplate>>,
    { id: number; data: BodyType<UpdateTaskTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTaskTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTaskTemplate>>
>;
export type UpdateTaskTemplateMutationBody = BodyType<UpdateTaskTemplateBody>;
export type UpdateTaskTemplateMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | BadRequestResponse
>;

/**
 * @summary Update a template's own fields (name/kind/category/priority/recurrence/
atTime/pauseDates) and/or the active toggle (TREC-10 — false stops
future spawns only, already-spawned instances stay untouched). Bumps
version in the same UPDATE (TREC-07). Gated to admin+ops_lead.

 */
export const useUpdateTaskTemplate = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaskTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateTaskTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTaskTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateTaskTemplateBody> },
  TContext
> => {
  return useMutation(getUpdateTaskTemplateMutationOptions(options));
};

/**
 * @summary Archive a checklist template (soft delete via active=false, TREC-10 — never touches already-spawned instances). Gated to admin+ops_lead.
 */
export const getDeleteTaskTemplateUrl = (id: number) => {
  return `/api/task-templates/${id}`;
};

export const deleteTaskTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTaskTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTaskTemplateMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaskTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaskTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteTaskTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaskTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTaskTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTaskTemplate>>
>;

export type DeleteTaskTemplateMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Archive a checklist template (soft delete via active=false, TREC-10 — never touches already-spawned instances). Gated to admin+ops_lead.
 */
export const useDeleteTaskTemplate = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaskTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaskTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteTaskTemplateMutationOptions(options));
};

/**
 * @summary Hotfix — PERMANENTLY delete a checklist template + its task_template_item
rows (SQL migration 0118: template_id CASCADEs). Historical spawned
rounds are KEPT for the record — every task row that referenced this
template has its template_id set to NULL (ON DELETE SET NULL); the
task rows themselves, their task_checklist_item copies, and their
task_activity log are never touched or deleted. Distinct from
DELETE /task-templates/{id} (the soft Archive above, still the
non-destructive default — this endpoint does not replace it). Gated
to admin+ops_lead (canEditConfig).

 */
export const getPermanentlyDeleteTaskTemplateUrl = (id: number) => {
  return `/api/task-templates/${id}/permanent`;
};

export const permanentlyDeleteTaskTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteTaskTemplatePermanentResult> => {
  return customFetch<DeleteTaskTemplatePermanentResult>(
    getPermanentlyDeleteTaskTemplateUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getPermanentlyDeleteTaskTemplateMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof permanentlyDeleteTaskTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof permanentlyDeleteTaskTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["permanentlyDeleteTaskTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof permanentlyDeleteTaskTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return permanentlyDeleteTaskTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PermanentlyDeleteTaskTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof permanentlyDeleteTaskTemplate>>
>;

export type PermanentlyDeleteTaskTemplateMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Hotfix — PERMANENTLY delete a checklist template + its task_template_item
rows (SQL migration 0118: template_id CASCADEs). Historical spawned
rounds are KEPT for the record — every task row that referenced this
template has its template_id set to NULL (ON DELETE SET NULL); the
task rows themselves, their task_checklist_item copies, and their
task_activity log are never touched or deleted. Distinct from
DELETE /task-templates/{id} (the soft Archive above, still the
non-destructive default — this endpoint does not replace it). Gated
to admin+ops_lead (canEditConfig).

 */
export const usePermanentlyDeleteTaskTemplate = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof permanentlyDeleteTaskTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof permanentlyDeleteTaskTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPermanentlyDeleteTaskTemplateMutationOptions(options));
};

/**
 * @summary Add a checklist item, appended at end-of-list (max seq + 1) when seq
is omitted. Bumps the parent template's version (TREC-07). Gated to
admin+ops_lead.

 */
export const getCreateTaskTemplateItemUrl = (id: number) => {
  return `/api/task-templates/${id}/items`;
};

export const createTaskTemplateItem = async (
  id: number,
  createTaskTemplateItemBody: CreateTaskTemplateItemBody,
  options?: RequestInit,
): Promise<TaskTemplateItem> => {
  return customFetch<TaskTemplateItem>(getCreateTaskTemplateItemUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaskTemplateItemBody),
  });
};

export const getCreateTaskTemplateItemMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaskTemplateItem>>,
    TError,
    { id: number; data: BodyType<CreateTaskTemplateItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTaskTemplateItem>>,
  TError,
  { id: number; data: BodyType<CreateTaskTemplateItemBody> },
  TContext
> => {
  const mutationKey = ["createTaskTemplateItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaskTemplateItem>>,
    { id: number; data: BodyType<CreateTaskTemplateItemBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTaskTemplateItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskTemplateItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTaskTemplateItem>>
>;
export type CreateTaskTemplateItemMutationBody =
  BodyType<CreateTaskTemplateItemBody>;
export type CreateTaskTemplateItemMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | BadRequestResponse
>;

/**
 * @summary Add a checklist item, appended at end-of-list (max seq + 1) when seq
is omitted. Bumps the parent template's version (TREC-07). Gated to
admin+ops_lead.

 */
export const useCreateTaskTemplateItem = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaskTemplateItem>>,
    TError,
    { id: number; data: BodyType<CreateTaskTemplateItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTaskTemplateItem>>,
  TError,
  { id: number; data: BodyType<CreateTaskTemplateItemBody> },
  TContext
> => {
  return useMutation(getCreateTaskTemplateItemMutationOptions(options));
};

/**
 * @summary Update a checklist item's label/required/assignedRole/zone (does not
reorder — use the /reorder endpoint). Bumps the parent template's
version (TREC-07). Gated to admin+ops_lead.

 */
export const getUpdateTaskTemplateItemUrl = (id: number, itemId: number) => {
  return `/api/task-templates/${id}/items/${itemId}`;
};

export const updateTaskTemplateItem = async (
  id: number,
  itemId: number,
  updateTaskTemplateItemBody: UpdateTaskTemplateItemBody,
  options?: RequestInit,
): Promise<TaskTemplateItem> => {
  return customFetch<TaskTemplateItem>(
    getUpdateTaskTemplateItemUrl(id, itemId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateTaskTemplateItemBody),
    },
  );
};

export const getUpdateTaskTemplateItemMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaskTemplateItem>>,
    TError,
    { id: number; itemId: number; data: BodyType<UpdateTaskTemplateItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTaskTemplateItem>>,
  TError,
  { id: number; itemId: number; data: BodyType<UpdateTaskTemplateItemBody> },
  TContext
> => {
  const mutationKey = ["updateTaskTemplateItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTaskTemplateItem>>,
    { id: number; itemId: number; data: BodyType<UpdateTaskTemplateItemBody> }
  > = (props) => {
    const { id, itemId, data } = props ?? {};

    return updateTaskTemplateItem(id, itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskTemplateItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTaskTemplateItem>>
>;
export type UpdateTaskTemplateItemMutationBody =
  BodyType<UpdateTaskTemplateItemBody>;
export type UpdateTaskTemplateItemMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | BadRequestResponse
>;

/**
 * @summary Update a checklist item's label/required/assignedRole/zone (does not
reorder — use the /reorder endpoint). Bumps the parent template's
version (TREC-07). Gated to admin+ops_lead.

 */
export const useUpdateTaskTemplateItem = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaskTemplateItem>>,
    TError,
    { id: number; itemId: number; data: BodyType<UpdateTaskTemplateItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTaskTemplateItem>>,
  TError,
  { id: number; itemId: number; data: BodyType<UpdateTaskTemplateItemBody> },
  TContext
> => {
  return useMutation(getUpdateTaskTemplateItemMutationOptions(options));
};

/**
 * @summary Remove a checklist item (real delete — task_checklist_item copies
carry no FK back to task_template_item, nothing is orphaned). Bumps
the parent template's version (TREC-07). Gated to admin+ops_lead.

 */
export const getDeleteTaskTemplateItemUrl = (id: number, itemId: number) => {
  return `/api/task-templates/${id}/items/${itemId}`;
};

export const deleteTaskTemplateItem = async (
  id: number,
  itemId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTaskTemplateItemUrl(id, itemId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTaskTemplateItemMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaskTemplateItem>>,
    TError,
    { id: number; itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaskTemplateItem>>,
  TError,
  { id: number; itemId: number },
  TContext
> => {
  const mutationKey = ["deleteTaskTemplateItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaskTemplateItem>>,
    { id: number; itemId: number }
  > = (props) => {
    const { id, itemId } = props ?? {};

    return deleteTaskTemplateItem(id, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskTemplateItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTaskTemplateItem>>
>;

export type DeleteTaskTemplateItemMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Remove a checklist item (real delete — task_checklist_item copies
carry no FK back to task_template_item, nothing is orphaned). Bumps
the parent template's version (TREC-07). Gated to admin+ops_lead.

 */
export const useDeleteTaskTemplateItem = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaskTemplateItem>>,
    TError,
    { id: number; itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaskTemplateItem>>,
  TError,
  { id: number; itemId: number },
  TContext
> => {
  return useMutation(getDeleteTaskTemplateItemMutationOptions(options));
};

/**
 * @summary Swap seq with the immediately adjacent item (up/down) within the
same template (mirrors /task-config/routing-rules/{id}/reorder
exactly — row-locked adjacent swap). Bumps the parent template's
version (TREC-07). Returns both swapped rows. Gated to admin+ops_lead.

 */
export const getReorderTaskTemplateItemUrl = (id: number, itemId: number) => {
  return `/api/task-templates/${id}/items/${itemId}/reorder`;
};

export const reorderTaskTemplateItem = async (
  id: number,
  itemId: number,
  reorderTaskTemplateItemBody: ReorderTaskTemplateItemBody,
  options?: RequestInit,
): Promise<TaskTemplateItem[]> => {
  return customFetch<TaskTemplateItem[]>(
    getReorderTaskTemplateItemUrl(id, itemId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(reorderTaskTemplateItemBody),
    },
  );
};

export const getReorderTaskTemplateItemMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderTaskTemplateItem>>,
    TError,
    { id: number; itemId: number; data: BodyType<ReorderTaskTemplateItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderTaskTemplateItem>>,
  TError,
  { id: number; itemId: number; data: BodyType<ReorderTaskTemplateItemBody> },
  TContext
> => {
  const mutationKey = ["reorderTaskTemplateItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderTaskTemplateItem>>,
    { id: number; itemId: number; data: BodyType<ReorderTaskTemplateItemBody> }
  > = (props) => {
    const { id, itemId, data } = props ?? {};

    return reorderTaskTemplateItem(id, itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderTaskTemplateItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderTaskTemplateItem>>
>;
export type ReorderTaskTemplateItemMutationBody =
  BodyType<ReorderTaskTemplateItemBody>;
export type ReorderTaskTemplateItemMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Swap seq with the immediately adjacent item (up/down) within the
same template (mirrors /task-config/routing-rules/{id}/reorder
exactly — row-locked adjacent swap). Bumps the parent template's
version (TREC-07). Returns both swapped rows. Gated to admin+ops_lead.

 */
export const useReorderTaskTemplateItem = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderTaskTemplateItem>>,
    TError,
    { id: number; itemId: number; data: BodyType<ReorderTaskTemplateItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderTaskTemplateItem>>,
  TError,
  { id: number; itemId: number; data: BodyType<ReorderTaskTemplateItemBody> },
  TContext
> => {
  return useMutation(getReorderTaskTemplateItemMutationOptions(options));
};

/**
 * @summary Hotfix (2026-07-18, "Sync today's round"). Phase 43's frozen-copy-at-spawn
design means today's already-spawned round never reflects a later item
edit, and a template created seconds before the scheduler's next tick got
a permanent empty round. This lets admin/ops_lead force today's round
onto the CURRENT items on demand:
  - no round yet for today       -> spawns it now (current items' fan-out)
  - round exists, zero progress  -> regenerates its items from the
    current template items (task_activity gets one new append-only row
    recording the resync; never mutated/deleted)
  - round exists, has progress   -> 409, left completely untouched
    (unless `force:true` — see requestBody below)
Gated to admin+ops_lead (canEditConfig). Runs in one transaction.

 */
export const getSyncTaskTemplateTodayUrl = (id: number) => {
  return `/api/task-templates/${id}/sync-today`;
};

export const syncTaskTemplateToday = async (
  id: number,
  syncTodayBody?: SyncTodayBody,
  options?: RequestInit,
): Promise<SyncTodayResult> => {
  return customFetch<SyncTodayResult>(getSyncTaskTemplateTodayUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(syncTodayBody),
  });
};

export const getSyncTaskTemplateTodayMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncTaskTemplateToday>>,
    TError,
    { id: number; data: BodyType<SyncTodayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncTaskTemplateToday>>,
  TError,
  { id: number; data: BodyType<SyncTodayBody> },
  TContext
> => {
  const mutationKey = ["syncTaskTemplateToday"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncTaskTemplateToday>>,
    { id: number; data: BodyType<SyncTodayBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return syncTaskTemplateToday(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncTaskTemplateTodayMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncTaskTemplateToday>>
>;
export type SyncTaskTemplateTodayMutationBody = BodyType<SyncTodayBody>;
export type SyncTaskTemplateTodayMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Hotfix (2026-07-18, "Sync today's round"). Phase 43's frozen-copy-at-spawn
design means today's already-spawned round never reflects a later item
edit, and a template created seconds before the scheduler's next tick got
a permanent empty round. This lets admin/ops_lead force today's round
onto the CURRENT items on demand:
  - no round yet for today       -> spawns it now (current items' fan-out)
  - round exists, zero progress  -> regenerates its items from the
    current template items (task_activity gets one new append-only row
    recording the resync; never mutated/deleted)
  - round exists, has progress   -> 409, left completely untouched
    (unless `force:true` — see requestBody below)
Gated to admin+ops_lead (canEditConfig). Runs in one transaction.

 */
export const useSyncTaskTemplateToday = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncTaskTemplateToday>>,
    TError,
    { id: number; data: BodyType<SyncTodayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncTaskTemplateToday>>,
  TError,
  { id: number; data: BodyType<SyncTodayBody> },
  TContext
> => {
  return useMutation(getSyncTaskTemplateTodayMutationOptions(options));
};

/**
 * @summary Read-only feed for the "Daily checklist" tab (43-RESEARCH Pattern
11). For each active template due on `date` (default = today IST),
returns the SPAWNED task for that date (if any) + its
task_checklist_item COPIES (never a live join to
task_template_item), grouped by template. A template with no
spawned task yet for the date is omitted (the "spawns at 8AM"
empty-state is a page-level concern, not per-card). Read-only —
ticking is Phase 44.

 */
export const getGetDailyChecklistUrl = (params?: GetDailyChecklistParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tasks/daily-checklist?${stringifiedParams}`
    : `/api/tasks/daily-checklist`;
};

export const getDailyChecklist = async (
  params?: GetDailyChecklistParams,
  options?: RequestInit,
): Promise<DailyChecklistEntry[]> => {
  return customFetch<DailyChecklistEntry[]>(getGetDailyChecklistUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetDailyChecklistQueryKey = (
  params?: GetDailyChecklistParams,
) => {
  return [`/api/tasks/daily-checklist`, ...(params ? [params] : [])] as const;
};

export const getGetDailyChecklistQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyChecklist>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetDailyChecklistParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyChecklist>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyChecklistQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyChecklist>>
  > = ({ signal }) => getDailyChecklist(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyChecklist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDailyChecklistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyChecklist>>
>;
export type GetDailyChecklistQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Read-only feed for the "Daily checklist" tab (43-RESEARCH Pattern
11). For each active template due on `date` (default = today IST),
returns the SPAWNED task for that date (if any) + its
task_checklist_item COPIES (never a live join to
task_template_item), grouped by template. A template with no
spawned task yet for the date is omitted (the "spawns at 8AM"
empty-state is a page-level concern, not per-card). Read-only —
ticking is Phase 44.

 */

export function useGetDailyChecklist<
  TData = Awaited<ReturnType<typeof getDailyChecklist>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: GetDailyChecklistParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyChecklist>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDailyChecklistQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Read-only feed for the Onboarding/Exit checklist tabs (Phase 49,
TEVT-01/06). Unlike GET /tasks/daily-checklist (contractually 1:1
template<->task per serviceDate), an event-trigger template has NO
serviceDate anchor and can have N concurrently open spawned
instances — each entry groups its template with ALL its currently
open instances[]. Read-only — ticking reuses the existing
done/na/validate endpoints (Phase 44) unchanged.

 */
export const getGetEventChecklistUrl = (params: GetEventChecklistParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tasks/checklist/events?${stringifiedParams}`
    : `/api/tasks/checklist/events`;
};

export const getEventChecklist = async (
  params: GetEventChecklistParams,
  options?: RequestInit,
): Promise<EventChecklistEntry[]> => {
  return customFetch<EventChecklistEntry[]>(getGetEventChecklistUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetEventChecklistQueryKey = (
  params?: GetEventChecklistParams,
) => {
  return [`/api/tasks/checklist/events`, ...(params ? [params] : [])] as const;
};

export const getGetEventChecklistQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventChecklist>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params: GetEventChecklistParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEventChecklist>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEventChecklistQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEventChecklist>>
  > = ({ signal }) => getEventChecklist(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventChecklist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEventChecklistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventChecklist>>
>;
export type GetEventChecklistQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Read-only feed for the Onboarding/Exit checklist tabs (Phase 49,
TEVT-01/06). Unlike GET /tasks/daily-checklist (contractually 1:1
template<->task per serviceDate), an event-trigger template has NO
serviceDate anchor and can have N concurrently open spawned
instances — each entry groups its template with ALL its currently
open instances[]. Read-only — ticking reuses the existing
done/na/validate endpoints (Phase 44) unchanged.

 */

export function useGetEventChecklist<
  TData = Awaited<ReturnType<typeof getEventChecklist>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params: GetEventChecklistParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEventChecklist>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEventChecklistQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Manually spawn a Team-Cabin/Visitor onboarding procedure on demand
(TEVT-06) — these two booking types have no backing booking schema
yet, so they never auto-trigger via the seat-assign/scheduler hooks
(49-RESEARCH). Reuses the same idempotent spawnInstanceTx as the
auto-trigger paths (onConflictDoNothing().returning() length check
against task_template_event_source_unique) — calling this twice for
the same (templateId, eventSourceType, eventSourceId) tuple is a
no-op, not a duplicate spawn.

 */
export const getStartProcedureUrl = () => {
  return `/api/tasks/checklist/start-procedure`;
};

export const startProcedure = async (
  startProcedureBody: StartProcedureBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getStartProcedureUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(startProcedureBody),
  });
};

export const getStartProcedureMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startProcedure>>,
    TError,
    { data: BodyType<StartProcedureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startProcedure>>,
  TError,
  { data: BodyType<StartProcedureBody> },
  TContext
> => {
  const mutationKey = ["startProcedure"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startProcedure>>,
    { data: BodyType<StartProcedureBody> }
  > = (props) => {
    const { data } = props ?? {};

    return startProcedure(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartProcedureMutationResult = NonNullable<
  Awaited<ReturnType<typeof startProcedure>>
>;
export type StartProcedureMutationBody = BodyType<StartProcedureBody>;
export type StartProcedureMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | BadRequestResponse
>;

/**
 * @summary Manually spawn a Team-Cabin/Visitor onboarding procedure on demand
(TEVT-06) — these two booking types have no backing booking schema
yet, so they never auto-trigger via the seat-assign/scheduler hooks
(49-RESEARCH). Reuses the same idempotent spawnInstanceTx as the
auto-trigger paths (onConflictDoNothing().returning() length check
against task_template_event_source_unique) — calling this twice for
the same (templateId, eventSourceType, eventSourceId) tuple is a
no-op, not a duplicate spawn.

 */
export const useStartProcedure = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | BadRequestResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startProcedure>>,
    TError,
    { data: BodyType<StartProcedureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startProcedure>>,
  TError,
  { data: BodyType<StartProcedureBody> },
  TContext
> => {
  return useMutation(getStartProcedureMutationOptions(options));
};

/**
 * @summary Mark a checklist item done (TCHK-01) — stamps doneByUserId/doneAt as
the caller. If the doer resolves to a terminal validator (manager_id
IS NULL), the item is auto-validated in the same write (44-RESEARCH
Pattern 6). Recomputes the round's rollup status inside the same
transaction — the parent task row is locked first (44-RESEARCH
Pattern 5). Phase 42 (TPRF-01/02/03) — optional body carries proof;
when the item's copied proofType is photo/note/signature the
matching field is REQUIRED (422 proof_required if absent — enforced
by the route's Zod superRefine, task.ts:24-25's convention; never a
silent pass, never a DB CHECK). signedAt is stamped SERVER-side at
tick time — never accepted from the client.

 */
export const getMarkTaskChecklistItemDoneUrl = (itemId: number) => {
  return `/api/tasks/checklist-items/${itemId}/done`;
};

export const markTaskChecklistItemDone = async (
  itemId: number,
  markChecklistItemDoneBody?: MarkChecklistItemDoneBody,
  options?: RequestInit,
): Promise<TaskChecklistItem> => {
  return customFetch<TaskChecklistItem>(
    getMarkTaskChecklistItemDoneUrl(itemId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(markChecklistItemDoneBody),
    },
  );
};

export const getMarkTaskChecklistItemDoneMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markTaskChecklistItemDone>>,
    TError,
    { itemId: number; data: BodyType<MarkChecklistItemDoneBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markTaskChecklistItemDone>>,
  TError,
  { itemId: number; data: BodyType<MarkChecklistItemDoneBody> },
  TContext
> => {
  const mutationKey = ["markTaskChecklistItemDone"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markTaskChecklistItemDone>>,
    { itemId: number; data: BodyType<MarkChecklistItemDoneBody> }
  > = (props) => {
    const { itemId, data } = props ?? {};

    return markTaskChecklistItemDone(itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkTaskChecklistItemDoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof markTaskChecklistItemDone>>
>;
export type MarkTaskChecklistItemDoneMutationBody =
  BodyType<MarkChecklistItemDoneBody>;
export type MarkTaskChecklistItemDoneMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Mark a checklist item done (TCHK-01) — stamps doneByUserId/doneAt as
the caller. If the doer resolves to a terminal validator (manager_id
IS NULL), the item is auto-validated in the same write (44-RESEARCH
Pattern 6). Recomputes the round's rollup status inside the same
transaction — the parent task row is locked first (44-RESEARCH
Pattern 5). Phase 42 (TPRF-01/02/03) — optional body carries proof;
when the item's copied proofType is photo/note/signature the
matching field is REQUIRED (422 proof_required if absent — enforced
by the route's Zod superRefine, task.ts:24-25's convention; never a
silent pass, never a DB CHECK). signedAt is stamped SERVER-side at
tick time — never accepted from the client.

 */
export const useMarkTaskChecklistItemDone = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markTaskChecklistItemDone>>,
    TError,
    { itemId: number; data: BodyType<MarkChecklistItemDoneBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markTaskChecklistItemDone>>,
  TError,
  { itemId: number; data: BodyType<MarkChecklistItemDoneBody> },
  TContext
> => {
  return useMutation(getMarkTaskChecklistItemDoneMutationOptions(options));
};

/**
 * @summary Mark a checklist item N/A with a required note (TCHK-03) — stamps
doneByUserId (who made the N/A call, so they can't later validate
their own judgment) + naReason; doneAt stays null. Recomputes the
round's rollup status inside the same transaction.

 */
export const getMarkTaskChecklistItemNaUrl = (itemId: number) => {
  return `/api/tasks/checklist-items/${itemId}/na`;
};

export const markTaskChecklistItemNa = async (
  itemId: number,
  markChecklistItemNaBody: MarkChecklistItemNaBody,
  options?: RequestInit,
): Promise<TaskChecklistItem> => {
  return customFetch<TaskChecklistItem>(getMarkTaskChecklistItemNaUrl(itemId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(markChecklistItemNaBody),
  });
};

export const getMarkTaskChecklistItemNaMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markTaskChecklistItemNa>>,
    TError,
    { itemId: number; data: BodyType<MarkChecklistItemNaBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markTaskChecklistItemNa>>,
  TError,
  { itemId: number; data: BodyType<MarkChecklistItemNaBody> },
  TContext
> => {
  const mutationKey = ["markTaskChecklistItemNa"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markTaskChecklistItemNa>>,
    { itemId: number; data: BodyType<MarkChecklistItemNaBody> }
  > = (props) => {
    const { itemId, data } = props ?? {};

    return markTaskChecklistItemNa(itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkTaskChecklistItemNaMutationResult = NonNullable<
  Awaited<ReturnType<typeof markTaskChecklistItemNa>>
>;
export type MarkTaskChecklistItemNaMutationBody =
  BodyType<MarkChecklistItemNaBody>;
export type MarkTaskChecklistItemNaMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Mark a checklist item N/A with a required note (TCHK-03) — stamps
doneByUserId (who made the N/A call, so they can't later validate
their own judgment) + naReason; doneAt stays null. Recomputes the
round's rollup status inside the same transaction.

 */
export const useMarkTaskChecklistItemNa = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markTaskChecklistItemNa>>,
    TError,
    { itemId: number; data: BodyType<MarkChecklistItemNaBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markTaskChecklistItemNa>>,
  TError,
  { itemId: number; data: BodyType<MarkChecklistItemNaBody> },
  TContext
> => {
  return useMutation(getMarkTaskChecklistItemNaMutationOptions(options));
};

/**
 * @summary Validate a done (or N/A'd) checklist item (TCHK-06/07) — stamps
validatedByUserId/validatedAt. Rejects the item's own doer (never
self-validate) and anyone who isn't the resolved validator (the
doer's users.manager_id, or an admin/ops_lead blanket override) via
canValidateItem. No request body. Auto-transitions the round's task
to resolved when this was the last required item validated (via
transitionTaskStatusTx, the sole writer).

 */
export const getValidateTaskChecklistItemUrl = (itemId: number) => {
  return `/api/tasks/checklist-items/${itemId}/validate`;
};

export const validateTaskChecklistItem = async (
  itemId: number,
  options?: RequestInit,
): Promise<TaskChecklistItem> => {
  return customFetch<TaskChecklistItem>(
    getValidateTaskChecklistItemUrl(itemId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getValidateTaskChecklistItemMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateTaskChecklistItem>>,
    TError,
    { itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateTaskChecklistItem>>,
  TError,
  { itemId: number },
  TContext
> => {
  const mutationKey = ["validateTaskChecklistItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateTaskChecklistItem>>,
    { itemId: number }
  > = (props) => {
    const { itemId } = props ?? {};

    return validateTaskChecklistItem(itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateTaskChecklistItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateTaskChecklistItem>>
>;

export type ValidateTaskChecklistItemMutationError = ErrorType<
  UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Validate a done (or N/A'd) checklist item (TCHK-06/07) — stamps
validatedByUserId/validatedAt. Rejects the item's own doer (never
self-validate) and anyone who isn't the resolved validator (the
doer's users.manager_id, or an admin/ops_lead blanket override) via
canValidateItem. No request body. Auto-transitions the round's task
to resolved when this was the last required item validated (via
transitionTaskStatusTx, the sole writer).

 */
export const useValidateTaskChecklistItem = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateTaskChecklistItem>>,
    TError,
    { itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof validateTaskChecklistItem>>,
  TError,
  { itemId: number },
  TContext
> => {
  return useMutation(getValidateTaskChecklistItemMutationOptions(options));
};

/**
 * @summary Phase 42 (TPRF-04) — validator rejects a done/N/A'd occurrence back
to the doer with a mandatory reason (mirrors N/A's mandatory
naReason). Un-ticks the occurrence (clears doneAt/doneByUserId/
naReason/proof/the validation clock) and returns it to the doer to
redo + re-attach proof. Reverses the Phase 44 deferral. The round's
rollup falls back to in_progress via the awaiting_validation ->
in_progress edge added in 42-02. Same validator predicate as
/validate (canValidateItem — doer ≠ validator stays enforced).

 */
export const getRejectTaskChecklistItemUrl = (itemId: number) => {
  return `/api/tasks/checklist-items/${itemId}/reject`;
};

export const rejectTaskChecklistItem = async (
  itemId: number,
  rejectTaskChecklistItemBody: RejectTaskChecklistItemBody,
  options?: RequestInit,
): Promise<TaskChecklistItem> => {
  return customFetch<TaskChecklistItem>(getRejectTaskChecklistItemUrl(itemId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rejectTaskChecklistItemBody),
  });
};

export const getRejectTaskChecklistItemMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectTaskChecklistItem>>,
    TError,
    { itemId: number; data: BodyType<RejectTaskChecklistItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectTaskChecklistItem>>,
  TError,
  { itemId: number; data: BodyType<RejectTaskChecklistItemBody> },
  TContext
> => {
  const mutationKey = ["rejectTaskChecklistItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectTaskChecklistItem>>,
    { itemId: number; data: BodyType<RejectTaskChecklistItemBody> }
  > = (props) => {
    const { itemId, data } = props ?? {};

    return rejectTaskChecklistItem(itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectTaskChecklistItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectTaskChecklistItem>>
>;
export type RejectTaskChecklistItemMutationBody =
  BodyType<RejectTaskChecklistItemBody>;
export type RejectTaskChecklistItemMutationError = ErrorType<
  UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Phase 42 (TPRF-04) — validator rejects a done/N/A'd occurrence back
to the doer with a mandatory reason (mirrors N/A's mandatory
naReason). Un-ticks the occurrence (clears doneAt/doneByUserId/
naReason/proof/the validation clock) and returns it to the doer to
redo + re-attach proof. Reverses the Phase 44 deferral. The round's
rollup falls back to in_progress via the awaiting_validation ->
in_progress edge added in 42-02. Same validator predicate as
/validate (canValidateItem — doer ≠ validator stays enforced).

 */
export const useRejectTaskChecklistItem = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectTaskChecklistItem>>,
    TError,
    { itemId: number; data: BodyType<RejectTaskChecklistItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectTaskChecklistItem>>,
  TError,
  { itemId: number; data: BodyType<RejectTaskChecklistItemBody> },
  TContext
> => {
  return useMutation(getRejectTaskChecklistItemMutationOptions(options));
};

/**
 * @summary Phase 42 (TPRF-01/02) — upload a proof photo/signature for a
checklist-item tick. Multipart/form-data, field name "file". Reuses
the EXISTING stock-in-invoices bucket under a new
"checklist-proofs/" folder — the service-role key cannot create new
buckets (this codebase has hit that twice already), so no new bucket
is introduced here. Returns the public Supabase Storage URL to
attach as proofUrls[]/signatureUrl on POST .../done. Same 503 as
every other /uploads/* route when SUPABASE_URL/
SUPABASE_SERVICE_ROLE_KEY are unset.

 */
export const getUploadChecklistProofUrl = () => {
  return `/api/uploads/checklist-proof`;
};

export const uploadChecklistProof = async (
  uploadChecklistProofBody: UploadChecklistProofBody,
  options?: RequestInit,
): Promise<ChecklistProofUploadResult> => {
  const formData = new FormData();
  formData.append(`file`, uploadChecklistProofBody.file);

  return customFetch<ChecklistProofUploadResult>(getUploadChecklistProofUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadChecklistProofMutationOptions = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadChecklistProof>>,
    TError,
    { data: BodyType<UploadChecklistProofBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadChecklistProof>>,
  TError,
  { data: BodyType<UploadChecklistProofBody> },
  TContext
> => {
  const mutationKey = ["uploadChecklistProof"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadChecklistProof>>,
    { data: BodyType<UploadChecklistProofBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadChecklistProof(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadChecklistProofMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadChecklistProof>>
>;
export type UploadChecklistProofMutationBody =
  BodyType<UploadChecklistProofBody>;
export type UploadChecklistProofMutationError = ErrorType<
  ErrorResponse | UnauthorizedResponse
>;

/**
 * @summary Phase 42 (TPRF-01/02) — upload a proof photo/signature for a
checklist-item tick. Multipart/form-data, field name "file". Reuses
the EXISTING stock-in-invoices bucket under a new
"checklist-proofs/" folder — the service-role key cannot create new
buckets (this codebase has hit that twice already), so no new bucket
is introduced here. Returns the public Supabase Storage URL to
attach as proofUrls[]/signatureUrl on POST .../done. Same 503 as
every other /uploads/* route when SUPABASE_URL/
SUPABASE_SERVICE_ROLE_KEY are unset.

 */
export const useUploadChecklistProof = <
  TError = ErrorType<ErrorResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadChecklistProof>>,
    TError,
    { data: BodyType<UploadChecklistProofBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadChecklistProof>>,
  TError,
  { data: BodyType<UploadChecklistProofBody> },
  TContext
> => {
  return useMutation(getUploadChecklistProofMutationOptions(options));
};

/**
 * @summary List vendor bills (paginated) — bodies land in 57-11
 */
export const getListVendorBillsUrl = (params?: ListVendorBillsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vendor-bills?${stringifiedParams}`
    : `/api/vendor-bills`;
};

export const listVendorBills = async (
  params?: ListVendorBillsParams,
  options?: RequestInit,
): Promise<VendorBillListResponse> => {
  return customFetch<VendorBillListResponse>(getListVendorBillsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListVendorBillsQueryKey = (params?: ListVendorBillsParams) => {
  return [`/api/vendor-bills`, ...(params ? [params] : [])] as const;
};

export const getListVendorBillsQueryOptions = <
  TData = Awaited<ReturnType<typeof listVendorBills>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListVendorBillsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorBills>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListVendorBillsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorBills>>> = ({
    signal,
  }) => listVendorBills(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVendorBills>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVendorBillsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVendorBills>>
>;
export type ListVendorBillsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List vendor bills (paginated) — bodies land in 57-11
 */

export function useListVendorBills<
  TData = Awaited<ReturnType<typeof listVendorBills>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListVendorBillsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorBills>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVendorBillsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a vendor bill (draft), header + lines, atomic — bodies land in 57-11
 */
export const getCreateVendorBillUrl = () => {
  return `/api/vendor-bills`;
};

export const createVendorBill = async (
  createVendorBillBody: CreateVendorBillBody,
  options?: RequestInit,
): Promise<VendorBillDetail> => {
  return customFetch<VendorBillDetail>(getCreateVendorBillUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createVendorBillBody),
  });
};

export const getCreateVendorBillMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorBill>>,
    TError,
    { data: BodyType<CreateVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVendorBill>>,
  TError,
  { data: BodyType<CreateVendorBillBody> },
  TContext
> => {
  const mutationKey = ["createVendorBill"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVendorBill>>,
    { data: BodyType<CreateVendorBillBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createVendorBill(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVendorBillMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVendorBill>>
>;
export type CreateVendorBillMutationBody = BodyType<CreateVendorBillBody>;
export type CreateVendorBillMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create a vendor bill (draft), header + lines, atomic — bodies land in 57-11
 */
export const useCreateVendorBill = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorBill>>,
    TError,
    { data: BodyType<CreateVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVendorBill>>,
  TError,
  { data: BodyType<CreateVendorBillBody> },
  TContext
> => {
  return useMutation(getCreateVendorBillMutationOptions(options));
};

/**
 * @summary Bill + lines + payments + linked journal entry summary — bodies land in 57-11
 */
export const getGetVendorBillUrl = (id: number) => {
  return `/api/vendor-bills/${id}`;
};

export const getVendorBill = async (
  id: number,
  options?: RequestInit,
): Promise<VendorBillDetail> => {
  return customFetch<VendorBillDetail>(getGetVendorBillUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVendorBillQueryKey = (id: number) => {
  return [`/api/vendor-bills/${id}`] as const;
};

export const getGetVendorBillQueryOptions = <
  TData = Awaited<ReturnType<typeof getVendorBill>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVendorBill>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVendorBillQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendorBill>>> = ({
    signal,
  }) => getVendorBill(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVendorBill>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVendorBillQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVendorBill>>
>;
export type GetVendorBillQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Bill + lines + payments + linked journal entry summary — bodies land in 57-11
 */

export function useGetVendorBill<
  TData = Awaited<ReturnType<typeof getVendorBill>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVendorBill>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVendorBillQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a DRAFT vendor bill (header + lines) — bodies land in 57-11
 */
export const getUpdateVendorBillUrl = (id: number) => {
  return `/api/vendor-bills/${id}`;
};

export const updateVendorBill = async (
  id: number,
  updateVendorBillBody: UpdateVendorBillBody,
  options?: RequestInit,
): Promise<VendorBillDetail> => {
  return customFetch<VendorBillDetail>(getUpdateVendorBillUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVendorBillBody),
  });
};

export const getUpdateVendorBillMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVendorBill>>,
    TError,
    { id: number; data: BodyType<UpdateVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVendorBill>>,
  TError,
  { id: number; data: BodyType<UpdateVendorBillBody> },
  TContext
> => {
  const mutationKey = ["updateVendorBill"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVendorBill>>,
    { id: number; data: BodyType<UpdateVendorBillBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVendorBill(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVendorBillMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVendorBill>>
>;
export type UpdateVendorBillMutationBody = BodyType<UpdateVendorBillBody>;
export type UpdateVendorBillMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Update a DRAFT vendor bill (header + lines) — bodies land in 57-11
 */
export const useUpdateVendorBill = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVendorBill>>,
    TError,
    { id: number; data: BodyType<UpdateVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVendorBill>>,
  TError,
  { id: number; data: BodyType<UpdateVendorBillBody> },
  TContext
> => {
  return useMutation(getUpdateVendorBillMutationOptions(options));
};

/**
 * @summary Draft -> pending_approval — bodies land in 57-11
 */
export const getSubmitVendorBillUrl = (id: number) => {
  return `/api/vendor-bills/${id}/submit`;
};

export const submitVendorBill = async (
  id: number,
  options?: RequestInit,
): Promise<VendorBill> => {
  return customFetch<VendorBill>(getSubmitVendorBillUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSubmitVendorBillMutationOptions = <
  TError = ErrorType<NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitVendorBill>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitVendorBill>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["submitVendorBill"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitVendorBill>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return submitVendorBill(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitVendorBillMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitVendorBill>>
>;

export type SubmitVendorBillMutationError = ErrorType<
  NotFoundResponse | ErrorResponse
>;

/**
 * @summary Draft -> pending_approval — bodies land in 57-11
 */
export const useSubmitVendorBill = <
  TError = ErrorType<NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitVendorBill>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitVendorBill>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSubmitVendorBillMutationOptions(options));
};

/**
 * @summary Approve a pending bill — posts the journal (D9 threshold gate) — bodies land in 57-11
 */
export const getApproveVendorBillUrl = (id: number) => {
  return `/api/vendor-bills/${id}/approve`;
};

export const approveVendorBill = async (
  id: number,
  approveVendorBillBody?: ApproveVendorBillBody,
  options?: RequestInit,
): Promise<VendorBillDetail> => {
  return customFetch<VendorBillDetail>(getApproveVendorBillUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(approveVendorBillBody),
  });
};

export const getApproveVendorBillMutationOptions = <
  TError = ErrorType<ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveVendorBill>>,
    TError,
    { id: number; data: BodyType<ApproveVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveVendorBill>>,
  TError,
  { id: number; data: BodyType<ApproveVendorBillBody> },
  TContext
> => {
  const mutationKey = ["approveVendorBill"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveVendorBill>>,
    { id: number; data: BodyType<ApproveVendorBillBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return approveVendorBill(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveVendorBillMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveVendorBill>>
>;
export type ApproveVendorBillMutationBody = BodyType<ApproveVendorBillBody>;
export type ApproveVendorBillMutationError = ErrorType<
  ErrorResponse | NotFoundResponse
>;

/**
 * @summary Approve a pending bill — posts the journal (D9 threshold gate) — bodies land in 57-11
 */
export const useApproveVendorBill = <
  TError = ErrorType<ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveVendorBill>>,
    TError,
    { id: number; data: BodyType<ApproveVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveVendorBill>>,
  TError,
  { id: number; data: BodyType<ApproveVendorBillBody> },
  TContext
> => {
  return useMutation(getApproveVendorBillMutationOptions(options));
};

/**
 * @summary Reject a pending bill (reason required) — bodies land in 57-11
 */
export const getRejectVendorBillUrl = (id: number) => {
  return `/api/vendor-bills/${id}/reject`;
};

export const rejectVendorBill = async (
  id: number,
  rejectVendorBillBody: RejectVendorBillBody,
  options?: RequestInit,
): Promise<VendorBill> => {
  return customFetch<VendorBill>(getRejectVendorBillUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rejectVendorBillBody),
  });
};

export const getRejectVendorBillMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectVendorBill>>,
    TError,
    { id: number; data: BodyType<RejectVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectVendorBill>>,
  TError,
  { id: number; data: BodyType<RejectVendorBillBody> },
  TContext
> => {
  const mutationKey = ["rejectVendorBill"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectVendorBill>>,
    { id: number; data: BodyType<RejectVendorBillBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return rejectVendorBill(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectVendorBillMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectVendorBill>>
>;
export type RejectVendorBillMutationBody = BodyType<RejectVendorBillBody>;
export type RejectVendorBillMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Reject a pending bill (reason required) — bodies land in 57-11
 */
export const useRejectVendorBill = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectVendorBill>>,
    TError,
    { id: number; data: BodyType<RejectVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectVendorBill>>,
  TError,
  { id: number; data: BodyType<RejectVendorBillBody> },
  TContext
> => {
  return useMutation(getRejectVendorBillMutationOptions(options));
};

/**
 * @summary FR-03 correction — posts a reversing entry referencing the original, never edits/deletes — bodies land in 57-11
 */
export const getReverseVendorBillUrl = (id: number) => {
  return `/api/vendor-bills/${id}/reverse`;
};

export const reverseVendorBill = async (
  id: number,
  reverseVendorBillBody: ReverseVendorBillBody,
  options?: RequestInit,
): Promise<VendorBillDetail> => {
  return customFetch<VendorBillDetail>(getReverseVendorBillUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reverseVendorBillBody),
  });
};

export const getReverseVendorBillMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reverseVendorBill>>,
    TError,
    { id: number; data: BodyType<ReverseVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reverseVendorBill>>,
  TError,
  { id: number; data: BodyType<ReverseVendorBillBody> },
  TContext
> => {
  const mutationKey = ["reverseVendorBill"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reverseVendorBill>>,
    { id: number; data: BodyType<ReverseVendorBillBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reverseVendorBill(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReverseVendorBillMutationResult = NonNullable<
  Awaited<ReturnType<typeof reverseVendorBill>>
>;
export type ReverseVendorBillMutationBody = BodyType<ReverseVendorBillBody>;
export type ReverseVendorBillMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary FR-03 correction — posts a reversing entry referencing the original, never edits/deletes — bodies land in 57-11
 */
export const useReverseVendorBill = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reverseVendorBill>>,
    TError,
    { id: number; data: BodyType<ReverseVendorBillBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reverseVendorBill>>,
  TError,
  { id: number; data: BodyType<ReverseVendorBillBody> },
  TContext
> => {
  return useMutation(getReverseVendorBillMutationOptions(options));
};

/**
 * @summary Payments recorded against a bill — bodies land in 57-12
 */
export const getListBillPaymentsUrl = (id: number) => {
  return `/api/vendor-bills/${id}/payments`;
};

export const listBillPayments = async (
  id: number,
  options?: RequestInit,
): Promise<BillPayment[]> => {
  return customFetch<BillPayment[]>(getListBillPaymentsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListBillPaymentsQueryKey = (id: number) => {
  return [`/api/vendor-bills/${id}/payments`] as const;
};

export const getListBillPaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillPayments>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBillPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillPaymentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBillPayments>>
  > = ({ signal }) => listBillPayments(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBillPayments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBillPaymentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillPayments>>
>;
export type ListBillPaymentsQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary Payments recorded against a bill — bodies land in 57-12
 */

export function useListBillPayments<
  TData = Awaited<ReturnType<typeof listBillPayments>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBillPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBillPaymentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Record a payment — A6, paymentAccountId is required, no default/fallback — bodies land in 57-12
 */
export const getCreateBillPaymentUrl = (id: number) => {
  return `/api/vendor-bills/${id}/payments`;
};

export const createBillPayment = async (
  id: number,
  createBillPaymentBody: CreateBillPaymentBody,
  options?: RequestInit,
): Promise<BillPayment> => {
  return customFetch<BillPayment>(getCreateBillPaymentUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBillPaymentBody),
  });
};

export const getCreateBillPaymentMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillPayment>>,
    TError,
    { id: number; data: BodyType<CreateBillPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillPayment>>,
  TError,
  { id: number; data: BodyType<CreateBillPaymentBody> },
  TContext
> => {
  const mutationKey = ["createBillPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillPayment>>,
    { id: number; data: BodyType<CreateBillPaymentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createBillPayment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBillPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillPayment>>
>;
export type CreateBillPaymentMutationBody = BodyType<CreateBillPaymentBody>;
export type CreateBillPaymentMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Record a payment — A6, paymentAccountId is required, no default/fallback — bodies land in 57-12
 */
export const useCreateBillPayment = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillPayment>>,
    TError,
    { id: number; data: BodyType<CreateBillPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBillPayment>>,
  TError,
  { id: number; data: BodyType<CreateBillPaymentBody> },
  TContext
> => {
  return useMutation(getCreateBillPaymentMutationOptions(options));
};

/**
 * @summary A1 — Dr Partner Current 30200, Cr the chosen funding account — bodies land in 57-12
 */
export const getCreatePartnerReimbursementUrl = () => {
  return `/api/ledger/partner-reimbursement`;
};

export const createPartnerReimbursement = async (
  createPartnerReimbursementBody: CreatePartnerReimbursementBody,
  options?: RequestInit,
): Promise<LedgerEntry> => {
  return customFetch<LedgerEntry>(getCreatePartnerReimbursementUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPartnerReimbursementBody),
  });
};

export const getCreatePartnerReimbursementMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPartnerReimbursement>>,
    TError,
    { data: BodyType<CreatePartnerReimbursementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPartnerReimbursement>>,
  TError,
  { data: BodyType<CreatePartnerReimbursementBody> },
  TContext
> => {
  const mutationKey = ["createPartnerReimbursement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPartnerReimbursement>>,
    { data: BodyType<CreatePartnerReimbursementBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPartnerReimbursement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePartnerReimbursementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPartnerReimbursement>>
>;
export type CreatePartnerReimbursementMutationBody =
  BodyType<CreatePartnerReimbursementBody>;
export type CreatePartnerReimbursementMutationError =
  ErrorType<BadRequestResponse>;

/**
 * @summary A1 — Dr Partner Current 30200, Cr the chosen funding account — bodies land in 57-12
 */
export const useCreatePartnerReimbursement = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPartnerReimbursement>>,
    TError,
    { data: BodyType<CreatePartnerReimbursementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPartnerReimbursement>>,
  TError,
  { data: BodyType<CreatePartnerReimbursementBody> },
  TContext
> => {
  return useMutation(getCreatePartnerReimbursementMutationOptions(options));
};

/**
 * @summary Dr RCM Payable, Cr the chosen funding account — bodies land in 57-12
 */
export const getCreateRcmDischargeUrl = () => {
  return `/api/ledger/rcm-discharge`;
};

export const createRcmDischarge = async (
  createRcmDischargeBody: CreateRcmDischargeBody,
  options?: RequestInit,
): Promise<LedgerEntry> => {
  return customFetch<LedgerEntry>(getCreateRcmDischargeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createRcmDischargeBody),
  });
};

export const getCreateRcmDischargeMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRcmDischarge>>,
    TError,
    { data: BodyType<CreateRcmDischargeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRcmDischarge>>,
  TError,
  { data: BodyType<CreateRcmDischargeBody> },
  TContext
> => {
  const mutationKey = ["createRcmDischarge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRcmDischarge>>,
    { data: BodyType<CreateRcmDischargeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createRcmDischarge(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRcmDischargeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRcmDischarge>>
>;
export type CreateRcmDischargeMutationBody = BodyType<CreateRcmDischargeBody>;
export type CreateRcmDischargeMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Dr RCM Payable, Cr the chosen funding account — bodies land in 57-12
 */
export const useCreateRcmDischarge = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRcmDischarge>>,
    TError,
    { data: BodyType<CreateRcmDischargeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRcmDischarge>>,
  TError,
  { data: BodyType<CreateRcmDischargeBody> },
  TContext
> => {
  return useMutation(getCreateRcmDischargeMutationOptions(options));
};

/**
 * @summary Dr TDS Payable, Cr the chosen funding account — bodies land in 57-12
 */
export const getCreateTdsDepositUrl = () => {
  return `/api/ledger/tds-deposit`;
};

export const createTdsDeposit = async (
  createTdsDepositBody: CreateTdsDepositBody,
  options?: RequestInit,
): Promise<LedgerEntry> => {
  return customFetch<LedgerEntry>(getCreateTdsDepositUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTdsDepositBody),
  });
};

export const getCreateTdsDepositMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTdsDeposit>>,
    TError,
    { data: BodyType<CreateTdsDepositBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTdsDeposit>>,
  TError,
  { data: BodyType<CreateTdsDepositBody> },
  TContext
> => {
  const mutationKey = ["createTdsDeposit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTdsDeposit>>,
    { data: BodyType<CreateTdsDepositBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTdsDeposit(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTdsDepositMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTdsDeposit>>
>;
export type CreateTdsDepositMutationBody = BodyType<CreateTdsDepositBody>;
export type CreateTdsDepositMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Dr TDS Payable, Cr the chosen funding account — bodies land in 57-12
 */
export const useCreateTdsDeposit = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTdsDeposit>>,
    TError,
    { data: BodyType<CreateTdsDepositBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTdsDeposit>>,
  TError,
  { data: BodyType<CreateTdsDepositBody> },
  TContext
> => {
  return useMutation(getCreateTdsDepositMutationOptions(options));
};

/**
 * @summary Dr Petty Cash, Cr the chosen funding account — bodies land in 57-12
 */
export const getIssuePettyCashUrl = () => {
  return `/api/ledger/petty-cash/issue`;
};

export const issuePettyCash = async (
  issuePettyCashBody: IssuePettyCashBody,
  options?: RequestInit,
): Promise<LedgerEntry> => {
  return customFetch<LedgerEntry>(getIssuePettyCashUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(issuePettyCashBody),
  });
};

export const getIssuePettyCashMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issuePettyCash>>,
    TError,
    { data: BodyType<IssuePettyCashBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issuePettyCash>>,
  TError,
  { data: BodyType<IssuePettyCashBody> },
  TContext
> => {
  const mutationKey = ["issuePettyCash"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issuePettyCash>>,
    { data: BodyType<IssuePettyCashBody> }
  > = (props) => {
    const { data } = props ?? {};

    return issuePettyCash(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssuePettyCashMutationResult = NonNullable<
  Awaited<ReturnType<typeof issuePettyCash>>
>;
export type IssuePettyCashMutationBody = BodyType<IssuePettyCashBody>;
export type IssuePettyCashMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Dr Petty Cash, Cr the chosen funding account — bodies land in 57-12
 */
export const useIssuePettyCash = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issuePettyCash>>,
    TError,
    { data: BodyType<IssuePettyCashBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof issuePettyCash>>,
  TError,
  { data: BodyType<IssuePettyCashBody> },
  TContext
> => {
  return useMutation(getIssuePettyCashMutationOptions(options));
};

/**
 * @summary Dr Expense (per line), Cr Petty Cash — bodies land in 57-12
 */
export const getSpendPettyCashUrl = () => {
  return `/api/ledger/petty-cash/spend`;
};

export const spendPettyCash = async (
  spendPettyCashBody: SpendPettyCashBody,
  options?: RequestInit,
): Promise<LedgerEntry> => {
  return customFetch<LedgerEntry>(getSpendPettyCashUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(spendPettyCashBody),
  });
};

export const getSpendPettyCashMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof spendPettyCash>>,
    TError,
    { data: BodyType<SpendPettyCashBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof spendPettyCash>>,
  TError,
  { data: BodyType<SpendPettyCashBody> },
  TContext
> => {
  const mutationKey = ["spendPettyCash"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof spendPettyCash>>,
    { data: BodyType<SpendPettyCashBody> }
  > = (props) => {
    const { data } = props ?? {};

    return spendPettyCash(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpendPettyCashMutationResult = NonNullable<
  Awaited<ReturnType<typeof spendPettyCash>>
>;
export type SpendPettyCashMutationBody = BodyType<SpendPettyCashBody>;
export type SpendPettyCashMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Dr Expense (per line), Cr Petty Cash — bodies land in 57-12
 */
export const useSpendPettyCash = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof spendPettyCash>>,
    TError,
    { data: BodyType<SpendPettyCashBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof spendPettyCash>>,
  TError,
  { data: BodyType<SpendPettyCashBody> },
  TContext
> => {
  return useMutation(getSpendPettyCashMutationOptions(options));
};

/**
 * @summary List recurring bill schedules — bodies land in 57-15
 */
export const getListVendorBillSchedulesUrl = (
  params?: ListVendorBillSchedulesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vendor-bill-schedules?${stringifiedParams}`
    : `/api/vendor-bill-schedules`;
};

export const listVendorBillSchedules = async (
  params?: ListVendorBillSchedulesParams,
  options?: RequestInit,
): Promise<VendorBillSchedule[]> => {
  return customFetch<VendorBillSchedule[]>(
    getListVendorBillSchedulesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListVendorBillSchedulesQueryKey = (
  params?: ListVendorBillSchedulesParams,
) => {
  return [`/api/vendor-bill-schedules`, ...(params ? [params] : [])] as const;
};

export const getListVendorBillSchedulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listVendorBillSchedules>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListVendorBillSchedulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorBillSchedules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVendorBillSchedulesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVendorBillSchedules>>
  > = ({ signal }) =>
    listVendorBillSchedules(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVendorBillSchedules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVendorBillSchedulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVendorBillSchedules>>
>;
export type ListVendorBillSchedulesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List recurring bill schedules — bodies land in 57-15
 */

export function useListVendorBillSchedules<
  TData = Awaited<ReturnType<typeof listVendorBillSchedules>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListVendorBillSchedulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorBillSchedules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVendorBillSchedulesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a recurring bill schedule — bodies land in 57-15
 */
export const getCreateVendorBillScheduleUrl = () => {
  return `/api/vendor-bill-schedules`;
};

export const createVendorBillSchedule = async (
  createVendorBillScheduleBody: CreateVendorBillScheduleBody,
  options?: RequestInit,
): Promise<VendorBillSchedule> => {
  return customFetch<VendorBillSchedule>(getCreateVendorBillScheduleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createVendorBillScheduleBody),
  });
};

export const getCreateVendorBillScheduleMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorBillSchedule>>,
    TError,
    { data: BodyType<CreateVendorBillScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVendorBillSchedule>>,
  TError,
  { data: BodyType<CreateVendorBillScheduleBody> },
  TContext
> => {
  const mutationKey = ["createVendorBillSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVendorBillSchedule>>,
    { data: BodyType<CreateVendorBillScheduleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createVendorBillSchedule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVendorBillScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVendorBillSchedule>>
>;
export type CreateVendorBillScheduleMutationBody =
  BodyType<CreateVendorBillScheduleBody>;
export type CreateVendorBillScheduleMutationError =
  ErrorType<BadRequestResponse>;

/**
 * @summary Create a recurring bill schedule — bodies land in 57-15
 */
export const useCreateVendorBillSchedule = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorBillSchedule>>,
    TError,
    { data: BodyType<CreateVendorBillScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVendorBillSchedule>>,
  TError,
  { data: BodyType<CreateVendorBillScheduleBody> },
  TContext
> => {
  return useMutation(getCreateVendorBillScheduleMutationOptions(options));
};

/**
 * @summary Update a bill schedule — bodies land in 57-15
 */
export const getUpdateVendorBillScheduleUrl = (id: number) => {
  return `/api/vendor-bill-schedules/${id}`;
};

export const updateVendorBillSchedule = async (
  id: number,
  updateVendorBillScheduleBody: UpdateVendorBillScheduleBody,
  options?: RequestInit,
): Promise<VendorBillSchedule> => {
  return customFetch<VendorBillSchedule>(getUpdateVendorBillScheduleUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVendorBillScheduleBody),
  });
};

export const getUpdateVendorBillScheduleMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVendorBillSchedule>>,
    TError,
    { id: number; data: BodyType<UpdateVendorBillScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVendorBillSchedule>>,
  TError,
  { id: number; data: BodyType<UpdateVendorBillScheduleBody> },
  TContext
> => {
  const mutationKey = ["updateVendorBillSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVendorBillSchedule>>,
    { id: number; data: BodyType<UpdateVendorBillScheduleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVendorBillSchedule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVendorBillScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVendorBillSchedule>>
>;
export type UpdateVendorBillScheduleMutationBody =
  BodyType<UpdateVendorBillScheduleBody>;
export type UpdateVendorBillScheduleMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Update a bill schedule — bodies land in 57-15
 */
export const useUpdateVendorBillSchedule = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVendorBillSchedule>>,
    TError,
    { id: number; data: BodyType<UpdateVendorBillScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVendorBillSchedule>>,
  TError,
  { id: number; data: BodyType<UpdateVendorBillScheduleBody> },
  TContext
> => {
  return useMutation(getUpdateVendorBillScheduleMutationOptions(options));
};

/**
 * @summary Delete a bill schedule — bodies land in 57-15
 */
export const getDeleteVendorBillScheduleUrl = (id: number) => {
  return `/api/vendor-bill-schedules/${id}`;
};

export const deleteVendorBillSchedule = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteVendorBillScheduleUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteVendorBillScheduleMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorBillSchedule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVendorBillSchedule>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteVendorBillSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVendorBillSchedule>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteVendorBillSchedule(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVendorBillScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVendorBillSchedule>>
>;

export type DeleteVendorBillScheduleMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Delete a bill schedule — bodies land in 57-15
 */
export const useDeleteVendorBillSchedule = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorBillSchedule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVendorBillSchedule>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteVendorBillScheduleMutationOptions(options));
};

/**
 * @summary Idempotent successor to POST /expenses/generate-dues — bodies land in 57-15
 */
export const getGenerateVendorBillsUrl = () => {
  return `/api/vendor-bill-schedules/generate-bills`;
};

export const generateVendorBills = async (
  options?: RequestInit,
): Promise<GenerateVendorBillsResult> => {
  return customFetch<GenerateVendorBillsResult>(getGenerateVendorBillsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getGenerateVendorBillsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateVendorBills>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateVendorBills>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["generateVendorBills"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateVendorBills>>,
    void
  > = () => {
    return generateVendorBills(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateVendorBillsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateVendorBills>>
>;

export type GenerateVendorBillsMutationError = ErrorType<unknown>;

/**
 * @summary Idempotent successor to POST /expenses/generate-dues — bodies land in 57-15
 */
export const useGenerateVendorBills = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateVendorBills>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateVendorBills>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getGenerateVendorBillsMutationOptions(options));
};

/**
 * @summary Trial balance, derived on read (FR-21) — never stored — bodies land in 57-13
 */
export const getGetLedgerTrialBalanceUrl = (
  params: GetLedgerTrialBalanceParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ledger/trial-balance?${stringifiedParams}`
    : `/api/ledger/trial-balance`;
};

export const getLedgerTrialBalance = async (
  params: GetLedgerTrialBalanceParams,
  options?: RequestInit,
): Promise<TrialBalanceResponse> => {
  return customFetch<TrialBalanceResponse>(
    getGetLedgerTrialBalanceUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLedgerTrialBalanceQueryKey = (
  params?: GetLedgerTrialBalanceParams,
) => {
  return [`/api/ledger/trial-balance`, ...(params ? [params] : [])] as const;
};

export const getGetLedgerTrialBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getLedgerTrialBalance>>,
  TError = ErrorType<unknown>,
>(
  params: GetLedgerTrialBalanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerTrialBalance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLedgerTrialBalanceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLedgerTrialBalance>>
  > = ({ signal }) =>
    getLedgerTrialBalance(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLedgerTrialBalance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLedgerTrialBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLedgerTrialBalance>>
>;
export type GetLedgerTrialBalanceQueryError = ErrorType<unknown>;

/**
 * @summary Trial balance, derived on read (FR-21) — never stored — bodies land in 57-13
 */

export function useGetLedgerTrialBalance<
  TData = Awaited<ReturnType<typeof getLedgerTrialBalance>>,
  TError = ErrorType<unknown>,
>(
  params: GetLedgerTrialBalanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerTrialBalance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLedgerTrialBalanceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary One account's ledger — every journal line posted to it in range — bodies land in 57-13
 */
export const getGetLedgerAccountEntriesUrl = (
  code: string,
  params?: GetLedgerAccountEntriesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ledger/accounts/${code}/entries?${stringifiedParams}`
    : `/api/ledger/accounts/${code}/entries`;
};

export const getLedgerAccountEntries = async (
  code: string,
  params?: GetLedgerAccountEntriesParams,
  options?: RequestInit,
): Promise<LedgerLine[]> => {
  return customFetch<LedgerLine[]>(
    getGetLedgerAccountEntriesUrl(code, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLedgerAccountEntriesQueryKey = (
  code: string,
  params?: GetLedgerAccountEntriesParams,
) => {
  return [
    `/api/ledger/accounts/${code}/entries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetLedgerAccountEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLedgerAccountEntries>>,
  TError = ErrorType<NotFoundResponse>,
>(
  code: string,
  params?: GetLedgerAccountEntriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerAccountEntries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLedgerAccountEntriesQueryKey(code, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLedgerAccountEntries>>
  > = ({ signal }) =>
    getLedgerAccountEntries(code, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!code,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLedgerAccountEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLedgerAccountEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLedgerAccountEntries>>
>;
export type GetLedgerAccountEntriesQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary One account's ledger — every journal line posted to it in range — bodies land in 57-13
 */

export function useGetLedgerAccountEntries<
  TData = Awaited<ReturnType<typeof getLedgerAccountEntries>>,
  TError = ErrorType<NotFoundResponse>,
>(
  code: string,
  params?: GetLedgerAccountEntriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerAccountEntries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLedgerAccountEntriesQueryOptions(
    code,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary SC-6 — AP per vendor, readable from the GL, equal to the bill sub-ledger — bodies land in 57-13
 */
export const getGetLedgerApByVendorUrl = (
  params?: GetLedgerApByVendorParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ledger/ap-by-vendor?${stringifiedParams}`
    : `/api/ledger/ap-by-vendor`;
};

export const getLedgerApByVendor = async (
  params?: GetLedgerApByVendorParams,
  options?: RequestInit,
): Promise<ApVendorRow[]> => {
  return customFetch<ApVendorRow[]>(getGetLedgerApByVendorUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetLedgerApByVendorQueryKey = (
  params?: GetLedgerApByVendorParams,
) => {
  return [`/api/ledger/ap-by-vendor`, ...(params ? [params] : [])] as const;
};

export const getGetLedgerApByVendorQueryOptions = <
  TData = Awaited<ReturnType<typeof getLedgerApByVendor>>,
  TError = ErrorType<unknown>,
>(
  params?: GetLedgerApByVendorParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerApByVendor>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLedgerApByVendorQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLedgerApByVendor>>
  > = ({ signal }) =>
    getLedgerApByVendor(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLedgerApByVendor>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLedgerApByVendorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLedgerApByVendor>>
>;
export type GetLedgerApByVendorQueryError = ErrorType<unknown>;

/**
 * @summary SC-6 — AP per vendor, readable from the GL, equal to the bill sub-ledger — bodies land in 57-13
 */

export function useGetLedgerApByVendor<
  TData = Awaited<ReturnType<typeof getLedgerApByVendor>>,
  TError = ErrorType<unknown>,
>(
  params?: GetLedgerApByVendorParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerApByVendor>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLedgerApByVendorQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary P&L grouped by cost centre, location, or account (FR-24, expense side) — bodies land in 57-13
 */
export const getGetLedgerPnlUrl = (params: GetLedgerPnlParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ledger/pnl?${stringifiedParams}`
    : `/api/ledger/pnl`;
};

export const getLedgerPnl = async (
  params: GetLedgerPnlParams,
  options?: RequestInit,
): Promise<PnlResponse> => {
  return customFetch<PnlResponse>(getGetLedgerPnlUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetLedgerPnlQueryKey = (params?: GetLedgerPnlParams) => {
  return [`/api/ledger/pnl`, ...(params ? [params] : [])] as const;
};

export const getGetLedgerPnlQueryOptions = <
  TData = Awaited<ReturnType<typeof getLedgerPnl>>,
  TError = ErrorType<unknown>,
>(
  params: GetLedgerPnlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerPnl>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLedgerPnlQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerPnl>>> = ({
    signal,
  }) => getLedgerPnl(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLedgerPnl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLedgerPnlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLedgerPnl>>
>;
export type GetLedgerPnlQueryError = ErrorType<unknown>;

/**
 * @summary P&L grouped by cost centre, location, or account (FR-24, expense side) — bodies land in 57-13
 */

export function useGetLedgerPnl<
  TData = Awaited<ReturnType<typeof getLedgerPnl>>,
  TError = ErrorType<unknown>,
>(
  params: GetLedgerPnlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerPnl>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLedgerPnlQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary One journal entry with its lines — drill-down target from the reads above — bodies land in 57-13
 */
export const getGetLedgerEntryUrl = (id: number) => {
  return `/api/ledger/entries/${id}`;
};

export const getLedgerEntry = async (
  id: number,
  options?: RequestInit,
): Promise<LedgerEntry> => {
  return customFetch<LedgerEntry>(getGetLedgerEntryUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetLedgerEntryQueryKey = (id: number) => {
  return [`/api/ledger/entries/${id}`] as const;
};

export const getGetLedgerEntryQueryOptions = <
  TData = Awaited<ReturnType<typeof getLedgerEntry>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerEntry>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLedgerEntryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerEntry>>> = ({
    signal,
  }) => getLedgerEntry(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLedgerEntry>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLedgerEntryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLedgerEntry>>
>;
export type GetLedgerEntryQueryError = ErrorType<NotFoundResponse>;

/**
 * @summary One journal entry with its lines — drill-down target from the reads above — bodies land in 57-13
 */

export function useGetLedgerEntry<
  TData = Awaited<ReturnType<typeof getLedgerEntry>>,
  TError = ErrorType<NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLedgerEntry>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLedgerEntryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary FR-04 — admin approval + a reason, required — bodies land in 57-13
 */
export const getCreateManualJournalUrl = () => {
  return `/api/ledger/manual-journals`;
};

export const createManualJournal = async (
  createManualJournalBody: CreateManualJournalBody,
  options?: RequestInit,
): Promise<LedgerEntry> => {
  return customFetch<LedgerEntry>(getCreateManualJournalUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createManualJournalBody),
  });
};

export const getCreateManualJournalMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createManualJournal>>,
    TError,
    { data: BodyType<CreateManualJournalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createManualJournal>>,
  TError,
  { data: BodyType<CreateManualJournalBody> },
  TContext
> => {
  const mutationKey = ["createManualJournal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createManualJournal>>,
    { data: BodyType<CreateManualJournalBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createManualJournal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateManualJournalMutationResult = NonNullable<
  Awaited<ReturnType<typeof createManualJournal>>
>;
export type CreateManualJournalMutationBody = BodyType<CreateManualJournalBody>;
export type CreateManualJournalMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary FR-04 — admin approval + a reason, required — bodies land in 57-13
 */
export const useCreateManualJournal = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createManualJournal>>,
    TError,
    { data: BodyType<CreateManualJournalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createManualJournal>>,
  TError,
  { data: BodyType<CreateManualJournalBody> },
  TContext
> => {
  return useMutation(getCreateManualJournalMutationOptions(options));
};

/**
 * @summary FR-11 — events with no matching posting rule — bodies land in 57-13
 */
export const getListPostingExceptionsUrl = (
  params?: ListPostingExceptionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ledger/quarantine?${stringifiedParams}`
    : `/api/ledger/quarantine`;
};

export const listPostingExceptions = async (
  params?: ListPostingExceptionsParams,
  options?: RequestInit,
): Promise<PostingException[]> => {
  return customFetch<PostingException[]>(getListPostingExceptionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPostingExceptionsQueryKey = (
  params?: ListPostingExceptionsParams,
) => {
  return [`/api/ledger/quarantine`, ...(params ? [params] : [])] as const;
};

export const getListPostingExceptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPostingExceptions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPostingExceptionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPostingExceptions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPostingExceptionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPostingExceptions>>
  > = ({ signal }) =>
    listPostingExceptions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPostingExceptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPostingExceptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPostingExceptions>>
>;
export type ListPostingExceptionsQueryError = ErrorType<unknown>;

/**
 * @summary FR-11 — events with no matching posting rule — bodies land in 57-13
 */

export function useListPostingExceptions<
  TData = Awaited<ReturnType<typeof listPostingExceptions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPostingExceptionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPostingExceptions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPostingExceptionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark a quarantined event resolved — bodies land in 57-13
 */
export const getResolvePostingExceptionUrl = (id: number) => {
  return `/api/ledger/quarantine/${id}/resolve`;
};

export const resolvePostingException = async (
  id: number,
  resolvePostingExceptionBody: ResolvePostingExceptionBody,
  options?: RequestInit,
): Promise<PostingException> => {
  return customFetch<PostingException>(getResolvePostingExceptionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resolvePostingExceptionBody),
  });
};

export const getResolvePostingExceptionMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolvePostingException>>,
    TError,
    { id: number; data: BodyType<ResolvePostingExceptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolvePostingException>>,
  TError,
  { id: number; data: BodyType<ResolvePostingExceptionBody> },
  TContext
> => {
  const mutationKey = ["resolvePostingException"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolvePostingException>>,
    { id: number; data: BodyType<ResolvePostingExceptionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return resolvePostingException(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolvePostingExceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolvePostingException>>
>;
export type ResolvePostingExceptionMutationBody =
  BodyType<ResolvePostingExceptionBody>;
export type ResolvePostingExceptionMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Mark a quarantined event resolved — bodies land in 57-13
 */
export const useResolvePostingException = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolvePostingException>>,
    TError,
    { id: number; data: BodyType<ResolvePostingExceptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolvePostingException>>,
  TError,
  { id: number; data: BodyType<ResolvePostingExceptionBody> },
  TContext
> => {
  return useMutation(getResolvePostingExceptionMutationOptions(options));
};

/**
 * @summary A6 — funding sources the payment screen lists: active accounts with a non-null paymentSourceKind — bodies land in 57-13
 */
export const getListLedgerPaymentAccountsUrl = () => {
  return `/api/ledger/payment-accounts`;
};

export const listLedgerPaymentAccounts = async (
  options?: RequestInit,
): Promise<PaymentAccount[]> => {
  return customFetch<PaymentAccount[]>(getListLedgerPaymentAccountsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListLedgerPaymentAccountsQueryKey = () => {
  return [`/api/ledger/payment-accounts`] as const;
};

export const getListLedgerPaymentAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLedgerPaymentAccounts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listLedgerPaymentAccounts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListLedgerPaymentAccountsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLedgerPaymentAccounts>>
  > = ({ signal }) => listLedgerPaymentAccounts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLedgerPaymentAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLedgerPaymentAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLedgerPaymentAccounts>>
>;
export type ListLedgerPaymentAccountsQueryError = ErrorType<unknown>;

/**
 * @summary A6 — funding sources the payment screen lists: active accounts with a non-null paymentSourceKind — bodies land in 57-13
 */

export function useListLedgerPaymentAccounts<
  TData = Awaited<ReturnType<typeof listLedgerPaymentAccounts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listLedgerPaymentAccounts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLedgerPaymentAccountsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Chart of accounts — bodies land in 57-13
 */
export const getListLedgerAccountsUrl = (params?: ListLedgerAccountsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ledger/accounts?${stringifiedParams}`
    : `/api/ledger/accounts`;
};

export const listLedgerAccounts = async (
  params?: ListLedgerAccountsParams,
  options?: RequestInit,
): Promise<LedgerAccount[]> => {
  return customFetch<LedgerAccount[]>(getListLedgerAccountsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListLedgerAccountsQueryKey = (
  params?: ListLedgerAccountsParams,
) => {
  return [`/api/ledger/accounts`, ...(params ? [params] : [])] as const;
};

export const getListLedgerAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLedgerAccounts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLedgerAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLedgerAccounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListLedgerAccountsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLedgerAccounts>>
  > = ({ signal }) => listLedgerAccounts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLedgerAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLedgerAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLedgerAccounts>>
>;
export type ListLedgerAccountsQueryError = ErrorType<unknown>;

/**
 * @summary Chart of accounts — bodies land in 57-13
 */

export function useListLedgerAccounts<
  TData = Awaited<ReturnType<typeof listLedgerAccounts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLedgerAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLedgerAccounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLedgerAccountsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Sachin-only. Rejects paymentSourceKind outside the permitted code ranges (A6 guard rail) — bodies land in 57-13
 */
export const getCreateLedgerAccountUrl = () => {
  return `/api/ledger/accounts`;
};

export const createLedgerAccount = async (
  createLedgerAccountBody: CreateLedgerAccountBody,
  options?: RequestInit,
): Promise<LedgerAccount> => {
  return customFetch<LedgerAccount>(getCreateLedgerAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLedgerAccountBody),
  });
};

export const getCreateLedgerAccountMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLedgerAccount>>,
    TError,
    { data: BodyType<CreateLedgerAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLedgerAccount>>,
  TError,
  { data: BodyType<CreateLedgerAccountBody> },
  TContext
> => {
  const mutationKey = ["createLedgerAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLedgerAccount>>,
    { data: BodyType<CreateLedgerAccountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createLedgerAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLedgerAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLedgerAccount>>
>;
export type CreateLedgerAccountMutationBody = BodyType<CreateLedgerAccountBody>;
export type CreateLedgerAccountMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Sachin-only. Rejects paymentSourceKind outside the permitted code ranges (A6 guard rail) — bodies land in 57-13
 */
export const useCreateLedgerAccount = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLedgerAccount>>,
    TError,
    { data: BodyType<CreateLedgerAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLedgerAccount>>,
  TError,
  { data: BodyType<CreateLedgerAccountBody> },
  TContext
> => {
  return useMutation(getCreateLedgerAccountMutationOptions(options));
};

/**
 * @summary Accounts are deactivatable, never deletable — no DELETE endpoint exists — bodies land in 57-13
 */
export const getUpdateLedgerAccountUrl = (id: number) => {
  return `/api/ledger/accounts/${id}`;
};

export const updateLedgerAccount = async (
  id: number,
  updateLedgerAccountBody: UpdateLedgerAccountBody,
  options?: RequestInit,
): Promise<LedgerAccount> => {
  return customFetch<LedgerAccount>(getUpdateLedgerAccountUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateLedgerAccountBody),
  });
};

export const getUpdateLedgerAccountMutationOptions = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLedgerAccount>>,
    TError,
    { id: number; data: BodyType<UpdateLedgerAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLedgerAccount>>,
  TError,
  { id: number; data: BodyType<UpdateLedgerAccountBody> },
  TContext
> => {
  const mutationKey = ["updateLedgerAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLedgerAccount>>,
    { id: number; data: BodyType<UpdateLedgerAccountBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLedgerAccount(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLedgerAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLedgerAccount>>
>;
export type UpdateLedgerAccountMutationBody = BodyType<UpdateLedgerAccountBody>;
export type UpdateLedgerAccountMutationError = ErrorType<
  BadRequestResponse | NotFoundResponse
>;

/**
 * @summary Accounts are deactivatable, never deletable — no DELETE endpoint exists — bodies land in 57-13
 */
export const useUpdateLedgerAccount = <
  TError = ErrorType<BadRequestResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLedgerAccount>>,
    TError,
    { id: number; data: BodyType<UpdateLedgerAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLedgerAccount>>,
  TError,
  { id: number; data: BodyType<UpdateLedgerAccountBody> },
  TContext
> => {
  return useMutation(getUpdateLedgerAccountMutationOptions(options));
};

/**
 * @summary A4 — seeded with only UNALLOC; operators curate real centres here — bodies land in 57-13
 */
export const getListCostCentresUrl = () => {
  return `/api/ledger/cost-centres`;
};

export const listCostCentres = async (
  options?: RequestInit,
): Promise<CostCentre[]> => {
  return customFetch<CostCentre[]>(getListCostCentresUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCostCentresQueryKey = () => {
  return [`/api/ledger/cost-centres`] as const;
};

export const getListCostCentresQueryOptions = <
  TData = Awaited<ReturnType<typeof listCostCentres>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCostCentres>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCostCentresQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCostCentres>>> = ({
    signal,
  }) => listCostCentres({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCostCentres>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCostCentresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCostCentres>>
>;
export type ListCostCentresQueryError = ErrorType<unknown>;

/**
 * @summary A4 — seeded with only UNALLOC; operators curate real centres here — bodies land in 57-13
 */

export function useListCostCentres<
  TData = Awaited<ReturnType<typeof listCostCentres>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCostCentres>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCostCentresQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a cost centre — bodies land in 57-13
 */
export const getCreateCostCentreUrl = () => {
  return `/api/ledger/cost-centres`;
};

export const createCostCentre = async (
  createCostCentreBody: CreateCostCentreBody,
  options?: RequestInit,
): Promise<CostCentre> => {
  return customFetch<CostCentre>(getCreateCostCentreUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCostCentreBody),
  });
};

export const getCreateCostCentreMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCostCentre>>,
    TError,
    { data: BodyType<CreateCostCentreBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCostCentre>>,
  TError,
  { data: BodyType<CreateCostCentreBody> },
  TContext
> => {
  const mutationKey = ["createCostCentre"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCostCentre>>,
    { data: BodyType<CreateCostCentreBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCostCentre(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCostCentreMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCostCentre>>
>;
export type CreateCostCentreMutationBody = BodyType<CreateCostCentreBody>;
export type CreateCostCentreMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Create a cost centre — bodies land in 57-13
 */
export const useCreateCostCentre = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCostCentre>>,
    TError,
    { data: BodyType<CreateCostCentreBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCostCentre>>,
  TError,
  { data: BodyType<CreateCostCentreBody> },
  TContext
> => {
  return useMutation(getCreateCostCentreMutationOptions(options));
};

/**
 * @summary Deactivatable, never deletable — no DELETE endpoint exists — bodies land in 57-13
 */
export const getUpdateCostCentreUrl = (id: number) => {
  return `/api/ledger/cost-centres/${id}`;
};

export const updateCostCentre = async (
  id: number,
  updateCostCentreBody: UpdateCostCentreBody,
  options?: RequestInit,
): Promise<CostCentre> => {
  return customFetch<CostCentre>(getUpdateCostCentreUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCostCentreBody),
  });
};

export const getUpdateCostCentreMutationOptions = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCostCentre>>,
    TError,
    { id: number; data: BodyType<UpdateCostCentreBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCostCentre>>,
  TError,
  { id: number; data: BodyType<UpdateCostCentreBody> },
  TContext
> => {
  const mutationKey = ["updateCostCentre"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCostCentre>>,
    { id: number; data: BodyType<UpdateCostCentreBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCostCentre(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCostCentreMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCostCentre>>
>;
export type UpdateCostCentreMutationBody = BodyType<UpdateCostCentreBody>;
export type UpdateCostCentreMutationError = ErrorType<NotFoundResponse>;

/**
 * @summary Deactivatable, never deletable — no DELETE endpoint exists — bodies land in 57-13
 */
export const useUpdateCostCentre = <
  TError = ErrorType<NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCostCentre>>,
    TError,
    { id: number; data: BodyType<UpdateCostCentreBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCostCentre>>,
  TError,
  { id: number; data: BodyType<UpdateCostCentreBody> },
  TContext
> => {
  return useMutation(getUpdateCostCentreMutationOptions(options));
};

/**
 * @summary D9 — the space-level bill-approval threshold, configurable, not hard-coded — bodies land in 57-13
 */
export const getGetLedgerConfigUrl = () => {
  return `/api/ledger/config`;
};

export const getLedgerConfig = async (
  options?: RequestInit,
): Promise<LedgerConfig> => {
  return customFetch<LedgerConfig>(getGetLedgerConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLedgerConfigQueryKey = () => {
  return [`/api/ledger/config`] as const;
};

export const getGetLedgerConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getLedgerConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLedgerConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLedgerConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerConfig>>> = ({
    signal,
  }) => getLedgerConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLedgerConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLedgerConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLedgerConfig>>
>;
export type GetLedgerConfigQueryError = ErrorType<unknown>;

/**
 * @summary D9 — the space-level bill-approval threshold, configurable, not hard-coded — bodies land in 57-13
 */

export function useGetLedgerConfig<
  TData = Awaited<ReturnType<typeof getLedgerConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLedgerConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLedgerConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the space-level bill-approval threshold — bodies land in 57-13
 */
export const getUpdateLedgerConfigUrl = () => {
  return `/api/ledger/config`;
};

export const updateLedgerConfig = async (
  updateLedgerConfigBody: UpdateLedgerConfigBody,
  options?: RequestInit,
): Promise<LedgerConfig> => {
  return customFetch<LedgerConfig>(getUpdateLedgerConfigUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateLedgerConfigBody),
  });
};

export const getUpdateLedgerConfigMutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLedgerConfig>>,
    TError,
    { data: BodyType<UpdateLedgerConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLedgerConfig>>,
  TError,
  { data: BodyType<UpdateLedgerConfigBody> },
  TContext
> => {
  const mutationKey = ["updateLedgerConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLedgerConfig>>,
    { data: BodyType<UpdateLedgerConfigBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateLedgerConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLedgerConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLedgerConfig>>
>;
export type UpdateLedgerConfigMutationBody = BodyType<UpdateLedgerConfigBody>;
export type UpdateLedgerConfigMutationError = ErrorType<BadRequestResponse>;

/**
 * @summary Update the space-level bill-approval threshold — bodies land in 57-13
 */
export const useUpdateLedgerConfig = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLedgerConfig>>,
    TError,
    { data: BodyType<UpdateLedgerConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLedgerConfig>>,
  TError,
  { data: BodyType<UpdateLedgerConfigBody> },
  TContext
> => {
  return useMutation(getUpdateLedgerConfigMutationOptions(options));
};

/**
 * @summary A2 — the queue: migrated bills with awaiting_posting = true — bodies land in 57-19
 */
export const getListBackfillOpenBillsUrl = () => {
  return `/api/ledger/backfill-open-bills`;
};

export const listBackfillOpenBills = async (
  options?: RequestInit,
): Promise<BackfillQueueRow[]> => {
  return customFetch<BackfillQueueRow[]>(getListBackfillOpenBillsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListBackfillOpenBillsQueryKey = () => {
  return [`/api/ledger/backfill-open-bills`] as const;
};

export const getListBackfillOpenBillsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBackfillOpenBills>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBackfillOpenBills>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBackfillOpenBillsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBackfillOpenBills>>
  > = ({ signal }) => listBackfillOpenBills({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBackfillOpenBills>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBackfillOpenBillsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBackfillOpenBills>>
>;
export type ListBackfillOpenBillsQueryError = ErrorType<unknown>;

/**
 * @summary A2 — the queue: migrated bills with awaiting_posting = true — bodies land in 57-19
 */

export function useListBackfillOpenBills<
  TData = Awaited<ReturnType<typeof listBackfillOpenBills>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBackfillOpenBills>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBackfillOpenBillsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Permitted ONLY while awaiting_posting = true — bodies land in 57-19
 */
export const getUpdateBackfillMappingUrl = (id: number) => {
  return `/api/ledger/backfill-open-bills/${id}/mapping`;
};

export const updateBackfillMapping = async (
  id: number,
  updateBackfillMappingBody: UpdateBackfillMappingBody,
  options?: RequestInit,
): Promise<BackfillQueueRow> => {
  return customFetch<BackfillQueueRow>(getUpdateBackfillMappingUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBackfillMappingBody),
  });
};

export const getUpdateBackfillMappingMutationOptions = <
  TError = ErrorType<NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBackfillMapping>>,
    TError,
    { id: number; data: BodyType<UpdateBackfillMappingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBackfillMapping>>,
  TError,
  { id: number; data: BodyType<UpdateBackfillMappingBody> },
  TContext
> => {
  const mutationKey = ["updateBackfillMapping"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBackfillMapping>>,
    { id: number; data: BodyType<UpdateBackfillMappingBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBackfillMapping(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBackfillMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBackfillMapping>>
>;
export type UpdateBackfillMappingMutationBody =
  BodyType<UpdateBackfillMappingBody>;
export type UpdateBackfillMappingMutationError = ErrorType<
  NotFoundResponse | ErrorResponse
>;

/**
 * @summary Permitted ONLY while awaiting_posting = true — bodies land in 57-19
 */
export const useUpdateBackfillMapping = <
  TError = ErrorType<NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBackfillMapping>>,
    TError,
    { id: number; data: BodyType<UpdateBackfillMappingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBackfillMapping>>,
  TError,
  { id: number; data: BodyType<UpdateBackfillMappingBody> },
  TContext
> => {
  return useMutation(getUpdateBackfillMappingMutationOptions(options));
};

/**
 * @summary Idempotent — posts OPEN migrated bills through postEvent() — bodies land in 57-19
 */
export const getRunBackfillOpenBillsUrl = () => {
  return `/api/ledger/backfill-open-bills/run`;
};

export const runBackfillOpenBills = async (
  options?: RequestInit,
): Promise<BackfillRunResult> => {
  return customFetch<BackfillRunResult>(getRunBackfillOpenBillsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRunBackfillOpenBillsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runBackfillOpenBills>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runBackfillOpenBills>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["runBackfillOpenBills"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runBackfillOpenBills>>,
    void
  > = () => {
    return runBackfillOpenBills(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunBackfillOpenBillsMutationResult = NonNullable<
  Awaited<ReturnType<typeof runBackfillOpenBills>>
>;

export type RunBackfillOpenBillsMutationError = ErrorType<unknown>;

/**
 * @summary Idempotent — posts OPEN migrated bills through postEvent() — bodies land in 57-19
 */
export const useRunBackfillOpenBills = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runBackfillOpenBills>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runBackfillOpenBills>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRunBackfillOpenBillsMutationOptions(options));
};

/**
 * @summary FR-14 — prepaid recognition schedules — bodies land in 57-14
 */
export const getListPrepaidSchedulesUrl = (
  params?: ListPrepaidSchedulesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ledger/prepaid-schedules?${stringifiedParams}`
    : `/api/ledger/prepaid-schedules`;
};

export const listPrepaidSchedules = async (
  params?: ListPrepaidSchedulesParams,
  options?: RequestInit,
): Promise<PrepaidSchedule[]> => {
  return customFetch<PrepaidSchedule[]>(getListPrepaidSchedulesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPrepaidSchedulesQueryKey = (
  params?: ListPrepaidSchedulesParams,
) => {
  return [
    `/api/ledger/prepaid-schedules`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListPrepaidSchedulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPrepaidSchedules>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPrepaidSchedulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPrepaidSchedules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPrepaidSchedulesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPrepaidSchedules>>
  > = ({ signal }) =>
    listPrepaidSchedules(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPrepaidSchedules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPrepaidSchedulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPrepaidSchedules>>
>;
export type ListPrepaidSchedulesQueryError = ErrorType<unknown>;

/**
 * @summary FR-14 — prepaid recognition schedules — bodies land in 57-14
 */

export function useListPrepaidSchedules<
  TData = Awaited<ReturnType<typeof listPrepaidSchedules>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPrepaidSchedulesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPrepaidSchedules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPrepaidSchedulesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Idempotent monthly recognition run — bodies land in 57-14
 */
export const getRecognisePrepaidSchedulesUrl = () => {
  return `/api/ledger/prepaid-schedules/recognise`;
};

export const recognisePrepaidSchedules = async (
  recognisePrepaidBody?: RecognisePrepaidBody,
  options?: RequestInit,
): Promise<PrepaidRecogniseResult> => {
  return customFetch<PrepaidRecogniseResult>(
    getRecognisePrepaidSchedulesUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(recognisePrepaidBody),
    },
  );
};

export const getRecognisePrepaidSchedulesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recognisePrepaidSchedules>>,
    TError,
    { data: BodyType<RecognisePrepaidBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recognisePrepaidSchedules>>,
  TError,
  { data: BodyType<RecognisePrepaidBody> },
  TContext
> => {
  const mutationKey = ["recognisePrepaidSchedules"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recognisePrepaidSchedules>>,
    { data: BodyType<RecognisePrepaidBody> }
  > = (props) => {
    const { data } = props ?? {};

    return recognisePrepaidSchedules(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecognisePrepaidSchedulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof recognisePrepaidSchedules>>
>;
export type RecognisePrepaidSchedulesMutationBody =
  BodyType<RecognisePrepaidBody>;
export type RecognisePrepaidSchedulesMutationError = ErrorType<unknown>;

/**
 * @summary Idempotent monthly recognition run — bodies land in 57-14
 */
export const useRecognisePrepaidSchedules = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recognisePrepaidSchedules>>,
    TError,
    { data: BodyType<RecognisePrepaidBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recognisePrepaidSchedules>>,
  TError,
  { data: BodyType<RecognisePrepaidBody> },
  TContext
> => {
  return useMutation(getRecognisePrepaidSchedulesMutationOptions(options));
};

/**
 * @summary Open days strictly before today (IST), plus gap-filled missing dates since the last real close — a missed day stays visible, not merely absent
 */
export const getGetStockDayCloseOverdueUrl = (
  params?: GetStockDayCloseOverdueParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/stock-day-close/overdue?${stringifiedParams}`
    : `/api/stock-day-close/overdue`;
};

export const getStockDayCloseOverdue = async (
  params?: GetStockDayCloseOverdueParams,
  options?: RequestInit,
): Promise<StockDayCloseOverdueResponse> => {
  return customFetch<StockDayCloseOverdueResponse>(
    getGetStockDayCloseOverdueUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetStockDayCloseOverdueQueryKey = (
  params?: GetStockDayCloseOverdueParams,
) => {
  return [`/api/stock-day-close/overdue`, ...(params ? [params] : [])] as const;
};

export const getGetStockDayCloseOverdueQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockDayCloseOverdue>>,
  TError = ErrorType<unknown>,
>(
  params?: GetStockDayCloseOverdueParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockDayCloseOverdue>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockDayCloseOverdueQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockDayCloseOverdue>>
  > = ({ signal }) =>
    getStockDayCloseOverdue(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockDayCloseOverdue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockDayCloseOverdueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockDayCloseOverdue>>
>;
export type GetStockDayCloseOverdueQueryError = ErrorType<unknown>;

/**
 * @summary Open days strictly before today (IST), plus gap-filled missing dates since the last real close — a missed day stays visible, not merely absent
 */

export function useGetStockDayCloseOverdue<
  TData = Awaited<ReturnType<typeof getStockDayCloseOverdue>>,
  TError = ErrorType<unknown>,
>(
  params?: GetStockDayCloseOverdueParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockDayCloseOverdue>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStockDayCloseOverdueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Lazily opens the day if it doesn't exist yet; returns per-(item,location) lines and the sheet-parity item rollup with a TOTAL row
 */
export const getGetStockDayCloseUrl = (
  date: string,
  params?: GetStockDayCloseParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/stock-day-close/${date}?${stringifiedParams}`
    : `/api/stock-day-close/${date}`;
};

export const getStockDayClose = async (
  date: string,
  params?: GetStockDayCloseParams,
  options?: RequestInit,
): Promise<StockDayCloseSheet> => {
  return customFetch<StockDayCloseSheet>(getGetStockDayCloseUrl(date, params), {
    ...options,
    method: "GET",
  });
};

export const getGetStockDayCloseQueryKey = (
  date: string,
  params?: GetStockDayCloseParams,
) => {
  return [`/api/stock-day-close/${date}`, ...(params ? [params] : [])] as const;
};

export const getGetStockDayCloseQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockDayClose>>,
  TError = ErrorType<void>,
>(
  date: string,
  params?: GetStockDayCloseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockDayClose>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockDayCloseQueryKey(date, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockDayClose>>
  > = ({ signal }) =>
    getStockDayClose(date, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!date,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockDayClose>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockDayCloseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockDayClose>>
>;
export type GetStockDayCloseQueryError = ErrorType<void>;

/**
 * @summary Lazily opens the day if it doesn't exist yet; returns per-(item,location) lines and the sheet-parity item rollup with a TOTAL row
 */

export function useGetStockDayClose<
  TData = Awaited<ReturnType<typeof getStockDayClose>>,
  TError = ErrorType<void>,
>(
  date: string,
  params?: GetStockDayCloseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockDayClose>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStockDayCloseQueryOptions(date, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save counted closes; response carries the recomputed Overflow/Underflow immediately, no reload needed
 */
export const getSaveStockDayCloseCountsUrl = (date: string) => {
  return `/api/stock-day-close/${date}/counts`;
};

export const saveStockDayCloseCounts = async (
  date: string,
  saveStockDayCountsBody: SaveStockDayCountsBody,
  options?: RequestInit,
): Promise<StockDayCloseSheet> => {
  return customFetch<StockDayCloseSheet>(getSaveStockDayCloseCountsUrl(date), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveStockDayCountsBody),
  });
};

export const getSaveStockDayCloseCountsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveStockDayCloseCounts>>,
    TError,
    { date: string; data: BodyType<SaveStockDayCountsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveStockDayCloseCounts>>,
  TError,
  { date: string; data: BodyType<SaveStockDayCountsBody> },
  TContext
> => {
  const mutationKey = ["saveStockDayCloseCounts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveStockDayCloseCounts>>,
    { date: string; data: BodyType<SaveStockDayCountsBody> }
  > = (props) => {
    const { date, data } = props ?? {};

    return saveStockDayCloseCounts(date, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveStockDayCloseCountsMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveStockDayCloseCounts>>
>;
export type SaveStockDayCloseCountsMutationBody =
  BodyType<SaveStockDayCountsBody>;
export type SaveStockDayCloseCountsMutationError = ErrorType<void>;

/**
 * @summary Save counted closes; response carries the recomputed Overflow/Underflow immediately, no reload needed
 */
export const useSaveStockDayCloseCounts = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveStockDayCloseCounts>>,
    TError,
    { date: string; data: BodyType<SaveStockDayCountsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveStockDayCloseCounts>>,
  TError,
  { date: string; data: BodyType<SaveStockDayCountsBody> },
  TContext
> => {
  return useMutation(getSaveStockDayCloseCountsMutationOptions(options));
};

/**
 * @summary Close the day (front_desk/ops_lead/admin/super_admin — never admin-only)
 */
export const getCloseStockDayUrl = (date: string) => {
  return `/api/stock-day-close/${date}/close`;
};

export const closeStockDay = async (
  date: string,
  closeStockDayBody?: CloseStockDayBody,
  options?: RequestInit,
): Promise<StockDayCloseSheet> => {
  return customFetch<StockDayCloseSheet>(getCloseStockDayUrl(date), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(closeStockDayBody),
  });
};

export const getCloseStockDayMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeStockDay>>,
    TError,
    { date: string; data: BodyType<CloseStockDayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeStockDay>>,
  TError,
  { date: string; data: BodyType<CloseStockDayBody> },
  TContext
> => {
  const mutationKey = ["closeStockDay"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeStockDay>>,
    { date: string; data: BodyType<CloseStockDayBody> }
  > = (props) => {
    const { date, data } = props ?? {};

    return closeStockDay(date, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseStockDayMutationResult = NonNullable<
  Awaited<ReturnType<typeof closeStockDay>>
>;
export type CloseStockDayMutationBody = BodyType<CloseStockDayBody>;
export type CloseStockDayMutationError = ErrorType<void>;

/**
 * @summary Close the day (front_desk/ops_lead/admin/super_admin — never admin-only)
 */
export const useCloseStockDay = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeStockDay>>,
    TError,
    { date: string; data: BodyType<CloseStockDayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof closeStockDay>>,
  TError,
  { date: string; data: BodyType<CloseStockDayBody> },
  TContext
> => {
  return useMutation(getCloseStockDayMutationOptions(options));
};

/**
 * @summary Reopen a closed day — requires a reason (front_desk/ops_lead/admin/super_admin)
 */
export const getReopenStockDayUrl = (date: string) => {
  return `/api/stock-day-close/${date}/reopen`;
};

export const reopenStockDay = async (
  date: string,
  reopenStockDayBody: ReopenStockDayBody,
  options?: RequestInit,
): Promise<StockDayPosition> => {
  return customFetch<StockDayPosition>(getReopenStockDayUrl(date), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reopenStockDayBody),
  });
};

export const getReopenStockDayMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenStockDay>>,
    TError,
    { date: string; data: BodyType<ReopenStockDayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reopenStockDay>>,
  TError,
  { date: string; data: BodyType<ReopenStockDayBody> },
  TContext
> => {
  const mutationKey = ["reopenStockDay"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reopenStockDay>>,
    { date: string; data: BodyType<ReopenStockDayBody> }
  > = (props) => {
    const { date, data } = props ?? {};

    return reopenStockDay(date, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReopenStockDayMutationResult = NonNullable<
  Awaited<ReturnType<typeof reopenStockDay>>
>;
export type ReopenStockDayMutationBody = BodyType<ReopenStockDayBody>;
export type ReopenStockDayMutationError = ErrorType<void>;

/**
 * @summary Reopen a closed day — requires a reason (front_desk/ops_lead/admin/super_admin)
 */
export const useReopenStockDay = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenStockDay>>,
    TError,
    { date: string; data: BodyType<ReopenStockDayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reopenStockDay>>,
  TError,
  { date: string; data: BodyType<ReopenStockDayBody> },
  TContext
> => {
  return useMutation(getReopenStockDayMutationOptions(options));
};

/**
 * @summary List stock locations for the space, including the Unassigned bucket
 */
export const getListStockLocationsUrl = (params?: ListStockLocationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/stock-locations?${stringifiedParams}`
    : `/api/stock-locations`;
};

export const listStockLocations = async (
  params?: ListStockLocationsParams,
  options?: RequestInit,
): Promise<StockLocation[]> => {
  return customFetch<StockLocation[]>(getListStockLocationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListStockLocationsQueryKey = (
  params?: ListStockLocationsParams,
) => {
  return [`/api/stock-locations`, ...(params ? [params] : [])] as const;
};

export const getListStockLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listStockLocations>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockLocationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockLocations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListStockLocationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStockLocations>>
  > = ({ signal }) => listStockLocations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStockLocations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStockLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStockLocations>>
>;
export type ListStockLocationsQueryError = ErrorType<unknown>;

/**
 * @summary List stock locations for the space, including the Unassigned bucket
 */

export function useListStockLocations<
  TData = Awaited<ReturnType<typeof listStockLocations>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockLocationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockLocations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStockLocationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a stock location (ops_lead/admin/super_admin)
 */
export const getCreateStockLocationUrl = () => {
  return `/api/stock-locations`;
};

export const createStockLocation = async (
  createStockLocationBody: CreateStockLocationBody,
  options?: RequestInit,
): Promise<StockLocation> => {
  return customFetch<StockLocation>(getCreateStockLocationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createStockLocationBody),
  });
};

export const getCreateStockLocationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockLocation>>,
    TError,
    { data: BodyType<CreateStockLocationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStockLocation>>,
  TError,
  { data: BodyType<CreateStockLocationBody> },
  TContext
> => {
  const mutationKey = ["createStockLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStockLocation>>,
    { data: BodyType<CreateStockLocationBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createStockLocation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStockLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStockLocation>>
>;
export type CreateStockLocationMutationBody = BodyType<CreateStockLocationBody>;
export type CreateStockLocationMutationError = ErrorType<void>;

/**
 * @summary Create a stock location (ops_lead/admin/super_admin)
 */
export const useCreateStockLocation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockLocation>>,
    TError,
    { data: BodyType<CreateStockLocationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStockLocation>>,
  TError,
  { data: BodyType<CreateStockLocationBody> },
  TContext
> => {
  return useMutation(getCreateStockLocationMutationOptions(options));
};

/**
 * @summary Rename / recategorize / deactivate a stock location (ops_lead/admin/super_admin)
 */
export const getUpdateStockLocationUrl = (id: number) => {
  return `/api/stock-locations/${id}`;
};

export const updateStockLocation = async (
  id: number,
  updateStockLocationBody: UpdateStockLocationBody,
  options?: RequestInit,
): Promise<StockLocation> => {
  return customFetch<StockLocation>(getUpdateStockLocationUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateStockLocationBody),
  });
};

export const getUpdateStockLocationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockLocation>>,
    TError,
    { id: number; data: BodyType<UpdateStockLocationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockLocation>>,
  TError,
  { id: number; data: BodyType<UpdateStockLocationBody> },
  TContext
> => {
  const mutationKey = ["updateStockLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockLocation>>,
    { id: number; data: BodyType<UpdateStockLocationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStockLocation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockLocation>>
>;
export type UpdateStockLocationMutationBody = BodyType<UpdateStockLocationBody>;
export type UpdateStockLocationMutationError = ErrorType<void>;

/**
 * @summary Rename / recategorize / deactivate a stock location (ops_lead/admin/super_admin)
 */
export const useUpdateStockLocation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockLocation>>,
    TError,
    { id: number; data: BodyType<UpdateStockLocationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStockLocation>>,
  TError,
  { id: number; data: BodyType<UpdateStockLocationBody> },
  TContext
> => {
  return useMutation(getUpdateStockLocationMutationOptions(options));
};

/**
 * @summary Per-location balance breakdown for one item, plus its total (the total equals the item's currentStock — the sum invariant, surfaced)
 */
export const getGetStockLocationBalancesUrl = (
  params: GetStockLocationBalancesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/stock-locations/balances?${stringifiedParams}`
    : `/api/stock-locations/balances`;
};

export const getStockLocationBalances = async (
  params: GetStockLocationBalancesParams,
  options?: RequestInit,
): Promise<StockLocationBalances> => {
  return customFetch<StockLocationBalances>(
    getGetStockLocationBalancesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetStockLocationBalancesQueryKey = (
  params?: GetStockLocationBalancesParams,
) => {
  return [
    `/api/stock-locations/balances`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStockLocationBalancesQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockLocationBalances>>,
  TError = ErrorType<void>,
>(
  params: GetStockLocationBalancesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockLocationBalances>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockLocationBalancesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockLocationBalances>>
  > = ({ signal }) =>
    getStockLocationBalances(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockLocationBalances>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockLocationBalancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockLocationBalances>>
>;
export type GetStockLocationBalancesQueryError = ErrorType<void>;

/**
 * @summary Per-location balance breakdown for one item, plus its total (the total equals the item's currentStock — the sum invariant, surfaced)
 */

export function useGetStockLocationBalances<
  TData = Awaited<ReturnType<typeof getStockLocationBalances>>,
  TError = ErrorType<void>,
>(
  params: GetStockLocationBalancesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStockLocationBalances>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStockLocationBalancesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Quantity + value still sitting in every Unassigned bucket visible to this actor
 */
export const getGetStockLocationsUnplacedUrl = () => {
  return `/api/stock-locations/unplaced`;
};

export const getStockLocationsUnplaced = async (
  options?: RequestInit,
): Promise<StockLocationsUnplaced> => {
  return customFetch<StockLocationsUnplaced>(
    getGetStockLocationsUnplacedUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetStockLocationsUnplacedQueryKey = () => {
  return [`/api/stock-locations/unplaced`] as const;
};

export const getGetStockLocationsUnplacedQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockLocationsUnplaced>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStockLocationsUnplaced>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockLocationsUnplacedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockLocationsUnplaced>>
  > = ({ signal }) => getStockLocationsUnplaced({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockLocationsUnplaced>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockLocationsUnplacedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockLocationsUnplaced>>
>;
export type GetStockLocationsUnplacedQueryError = ErrorType<unknown>;

/**
 * @summary Quantity + value still sitting in every Unassigned bucket visible to this actor
 */

export function useGetStockLocationsUnplaced<
  TData = Awaited<ReturnType<typeof getStockLocationsUnplaced>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStockLocationsUnplaced>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStockLocationsUnplacedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Paginated append-only inter-location transfer log
 */
export const getListStockLocationTransfersUrl = (
  params?: ListStockLocationTransfersParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/stock-locations/transfers?${stringifiedParams}`
    : `/api/stock-locations/transfers`;
};

export const listStockLocationTransfers = async (
  params?: ListStockLocationTransfersParams,
  options?: RequestInit,
): Promise<StockLocationTransferListResponse> => {
  return customFetch<StockLocationTransferListResponse>(
    getListStockLocationTransfersUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListStockLocationTransfersQueryKey = (
  params?: ListStockLocationTransfersParams,
) => {
  return [
    `/api/stock-locations/transfers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListStockLocationTransfersQueryOptions = <
  TData = Awaited<ReturnType<typeof listStockLocationTransfers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockLocationTransfersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockLocationTransfers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListStockLocationTransfersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStockLocationTransfers>>
  > = ({ signal }) =>
    listStockLocationTransfers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStockLocationTransfers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStockLocationTransfersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStockLocationTransfers>>
>;
export type ListStockLocationTransfersQueryError = ErrorType<unknown>;

/**
 * @summary Paginated append-only inter-location transfer log
 */

export function useListStockLocationTransfers<
  TData = Awaited<ReturnType<typeof listStockLocationTransfers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStockLocationTransfersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStockLocationTransfers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStockLocationTransfersQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Move quantity between two locations for one item (ops_lead/admin/super_admin) — conserves the item's current_stock exactly
 */
export const getCreateStockLocationTransferUrl = () => {
  return `/api/stock-locations/transfers`;
};

export const createStockLocationTransfer = async (
  createStockLocationTransferBody: CreateStockLocationTransferBody,
  options?: RequestInit,
): Promise<StockLocationTransferCreateResponse> => {
  return customFetch<StockLocationTransferCreateResponse>(
    getCreateStockLocationTransferUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createStockLocationTransferBody),
    },
  );
};

export const getCreateStockLocationTransferMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockLocationTransfer>>,
    TError,
    { data: BodyType<CreateStockLocationTransferBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStockLocationTransfer>>,
  TError,
  { data: BodyType<CreateStockLocationTransferBody> },
  TContext
> => {
  const mutationKey = ["createStockLocationTransfer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStockLocationTransfer>>,
    { data: BodyType<CreateStockLocationTransferBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createStockLocationTransfer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStockLocationTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStockLocationTransfer>>
>;
export type CreateStockLocationTransferMutationBody =
  BodyType<CreateStockLocationTransferBody>;
export type CreateStockLocationTransferMutationError = ErrorType<void>;

/**
 * @summary Move quantity between two locations for one item (ops_lead/admin/super_admin) — conserves the item's current_stock exactly
 */
export const useCreateStockLocationTransfer = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockLocationTransfer>>,
    TError,
    { data: BodyType<CreateStockLocationTransferBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStockLocationTransfer>>,
  TError,
  { data: BodyType<CreateStockLocationTransferBody> },
  TContext
> => {
  return useMutation(getCreateStockLocationTransferMutationOptions(options));
};
